// Copyright (C) Captor Fund Management AB - All Rights Reserved. Auto generated file, do not edit
/* eslint-disable */
import { ObjectId } from 'mongodb';
import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { ResolverContextType } from './resolver-context-type';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BIC: { input: any; output: any; }
  Date: { input: Date; output: Date; }
  DateStringOrTimestamp: { input: any; output: any; }
  DecimalString: { input: string; output: string; }
  EmailAddress: { input: string; output: string; }
  GraphQLCreditRating: { input: string; output: string; }
  GraphQLDateString: { input: string; output: string; }
  GraphQLLei: { input: string; output: string; }
  GraphQLObjectId: { input: ObjectId; output: ObjectId; }
  GraphQLPatchInstrumentDate: { input: Date; output: Date; }
  GraphQLSwedenDate: { input: Date; output: Date; }
  GraphQLSwedishLegalNumber: { input: string; output: string; }
  IBAN: { input: any; output: any; }
  ISIN: { input: string; output: string; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Max35CharString: { input: string; output: string; }
  Max140CharString: { input: any; output: any; }
  Min1Max70CharString: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
  TwoDecimalString: { input: string; output: string; }
  UriPartString: { input: any; output: any; }
};

export type AcceptTermsInput = {
  _id: Scalars['GraphQLObjectId']['input'];
  noteIds: Array<Scalars['GraphQLObjectId']['input']>;
};

export type AccountSwitchAllInput = {
  /** clientAccount to move the settled balance from */
  from: Scalars['String']['input'];
  /** clientAccount to move the settled balance to */
  to: Scalars['String']['input'];
};

export enum AccountingBatchType {
  /** Automated, similar to BVU but automatically added adjustment */
  A = 'A',
  /** Automated reverse, similar to BVI but closing previous A */
  AR = 'AR',
  /** Balance valuation ingoing, closing previous BVU */
  BVI = 'BVI',
  /** Balance valuation outgoing */
  BVU = 'BVU',
  /** Ingoing balance */
  IB = 'IB',
  /** Manual, similar to BVU but manually added */
  M = 'M',
  /** Manual reverse, similar to BVI but closing previous M */
  MR = 'MR',
  /** Transaction */
  T = 'T'
}

export enum AccountingCompanyTypeEnum {
  GeneralPortfolio = 'GeneralPortfolio',
  None = 'None',
  SwedishMutualFund = 'SwedishMutualFund',
  SwedishPensionTrust = 'SwedishPensionTrust'
}

export enum AccountingFrequencyEnum {
  Annually = 'Annually',
  Monthly = 'Monthly',
  None = 'None',
  Quarterly = 'Quarterly',
  SemiAnnually = 'SemiAnnually'
}

export enum AccountingLanguageEnum {
  Sv = 'Sv'
}

export type AccountingRun = {
  __typename?: 'AccountingRun';
  _id: Scalars['GraphQLObjectId']['output'];
  accountingPeriod: Scalars['String']['output'];
  client?: Maybe<Party>;
  clientId: Scalars['GraphQLObjectId']['output'];
  clientTAccountChart?: Maybe<TAccountChart>;
  clientTAccountChartId: Scalars['GraphQLObjectId']['output'];
  createTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  createUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  endDate: Scalars['GraphQLDateString']['output'];
  journalEntries?: Maybe<Array<Maybe<JournalEntry>>>;
  masterTAccountChart?: Maybe<TAccountChart>;
  masterTAccountChartId: Scalars['GraphQLObjectId']['output'];
  number: Scalars['Int']['output'];
  roundingDecimals?: Maybe<Scalars['Int']['output']>;
  status: AccountingRunStatusEnum;
  type: AccountingRunTypeEnum;
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
};

/** Accounting run in collection accountingrun2, journal entries in collection journalentry2 and t-account chart in collection taccountchart2 */
export type AccountingRun2 = {
  __typename?: 'AccountingRun2';
  _id: Scalars['GraphQLObjectId']['output'];
  /** Full year, e.g. "2026" */
  accountingPeriod: Scalars['String']['output'];
  client?: Maybe<Party>;
  clientId: Scalars['GraphQLObjectId']['output'];
  clientTAccountChart?: Maybe<UpsertTAccountChart>;
  /** 000000000000000000000000 when the default fund t-account chart is used */
  clientTAccountChartId: Scalars['GraphQLObjectId']['output'];
  createTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  createUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  endDate: Scalars['GraphQLDateString']['output'];
  journalEntries?: Maybe<Array<JournalEntry2>>;
  keepManualJournalEntries?: Maybe<Scalars['Boolean']['output']>;
  number: Scalars['Int']['output'];
  status: AccountingRunStatusEnum;
  type: AccountingRunTypeEnum;
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
};

export type AccountingRun2FilterInput = {
  clientIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  statusIn?: InputMaybe<Array<AccountingRunStatusEnum>>;
};

export enum AccountingRunStatusEnum {
  Confirmed = 'Confirmed',
  Deleted = 'Deleted',
  Pending = 'Pending',
  Preliminary = 'Preliminary'
}

export enum AccountingRunTypeEnum {
  Manual = 'Manual',
  Transaction = 'Transaction'
}

export type AccountingTransaction = {
  __typename?: 'AccountingTransaction';
  accountingAmount?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  instrument?: Maybe<Instrument>;
  instrumentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  localAmount?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  tAccountNumber?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccountingTransactionType>;
  valueDate?: Maybe<Scalars['GraphQLDateString']['output']>;
};

/** Amounts are stored as Decimal128 with a fixed number of decimals and returned as exact decimal strings */
export type AccountingTransaction2 = {
  __typename?: 'AccountingTransaction2';
  /** localAmount * fxRate in accounting currency, 18 decimals */
  accountingAmount?: Maybe<Scalars['DecimalString']['output']>;
  /** In accounting currency, 4 decimals */
  amount?: Maybe<Scalars['DecimalString']['output']>;
  instrument?: Maybe<Instrument>;
  instrumentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  /** In instrument currency, 4 decimals */
  localAmount?: Maybe<Scalars['DecimalString']['output']>;
  /** For position building types InitialCost, ForwardCash and ShareCapital, 9 decimals */
  quantity?: Maybe<Scalars['DecimalString']['output']>;
  tAccountNumber?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AccountingTransactionType>;
  valueDate?: Maybe<Scalars['GraphQLDateString']['output']>;
};

/**
 * Amounts are exact decimal strings, rounded half away from zero to the stored number of decimals.
 * The amounts of a journal entry must sum to exactly zero after rounding.
 */
export type AccountingTransaction2Input = {
  /** localAmount * fxRate in accounting currency, stored with 18 decimals */
  accountingAmount?: InputMaybe<Scalars['DecimalString']['input']>;
  /** In accounting currency, stored with 4 decimals */
  amount: Scalars['DecimalString']['input'];
  instrumentId: Scalars['GraphQLObjectId']['input'];
  /** In instrument currency, stored with 4 decimals */
  localAmount?: InputMaybe<Scalars['DecimalString']['input']>;
  /** For position building types InitialCost, ForwardCash and ShareCapital, stored with 9 decimals */
  quantity?: InputMaybe<Scalars['DecimalString']['input']>;
  tAccountNumber: Scalars['String']['input'];
  type: AccountingTransactionType;
  valueDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};

export type AccountingTransactionInput = {
  accountingAmount?: InputMaybe<Scalars['Float']['input']>;
  amount: Scalars['Float']['input'];
  instrumentId: Scalars['GraphQLObjectId']['input'];
  localAmount?: InputMaybe<Scalars['Float']['input']>;
  /** For position building types InitialCost, ForwardCash and ShareCapital */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  tAccountNumber: Scalars['String']['input'];
  type: AccountingTransactionType;
  valueDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};

export enum AccountingTransactionType {
  /**
   * AccruedInterest is the balance sheet accrued interest of a position at closing. Booked in batch BVU,
   * reversed in batch BVI. Counterpart of Interest.
   */
  AccruedInterest = 'AccruedInterest',
  /** Commission is cost from Commission transaction items. Booked in batch T. */
  Commission = 'Commission',
  /** CustodyFee is cost from CustodyFee transaction items. Booked in batch T. */
  CustodyFee = 'CustodyFee',
  /** Dividend is received dividend income. Booked in batch T from Dividend transaction items. */
  Dividend = 'Dividend',
  /** DividendPaid is dividend paid from fund classes. Booked in batch T from DividendPaid transaction items, no BVU/BVI. */
  DividendPaid = 'DividendPaid',
  /** Equity is the fund's equity. T-account taken from the Equity t-account mapping. */
  Equity = 'Equity',
  /** Fee is income or cost from fee type transaction items not covered by a more specific type. */
  Fee = 'Fee',
  /** ForeignTax is withholding tax from ForeignTax transaction items. Booked in batch T. */
  ForeignTax = 'ForeignTax',
  /**
   * ForwardCash is position building and books cash with value date after the accounting run date.
   * Created in batch A by moving the amount from the InitialCost t-account, only if a ForwardCash mapping exists.
   */
  ForwardCash = 'ForwardCash',
  /**
   * InitialCost is position building and books the acquisition cost of an instrument (cash accounts included)
   * on the balance sheet. Booked in batch T for position building transaction items and carried forward in batch IB.
   * Quantity, localAmount, accountingAmount and valueDate are only set for this type.
   */
  InitialCost = 'InitialCost',
  /**
   * Interest is interest income or cost. Booked in batch T from Interest and AccruedInterest transaction items
   * and in batch BVU as counterpart of AccruedInterest.
   */
  Interest = 'Interest',
  /** ManagementCost is cost from ManagementCost transaction items. Booked in batch T. */
  ManagementCost = 'ManagementCost',
  /** ManagementFee is cost from ManagementFee transaction items. Booked in batch T. */
  ManagementFee = 'ManagementFee',
  /**
   * OpeningBalance balances an opening balance journal entry (batch IB) that does not sum to zero.
   * T-account taken from the OpeningBalance t-account mapping.
   */
  OpeningBalance = 'OpeningBalance',
  /** Realized is realized profit or loss from price changes when a position is reduced. Booked in batch T. */
  Realized = 'Realized',
  /** RealizedFx is realized profit or loss from fx changes when a position is reduced. Booked in batch T. */
  RealizedFx = 'RealizedFx',
  /** Rebate is cash fund rebate income from Rebate transaction items. Booked in batch T. */
  Rebate = 'Rebate',
  /**
   * Rounding balances a journal entry that does not sum to zero due to rounding.
   * T-account taken from the Rounding t-account mapping.
   */
  Rounding = 'Rounding',
  /**
   * ShareCapital is position building and books creations and redemptions of fund units
   * (CreateRedeem, CreateRedeemAdjustmentAmount and CreateRedeemAdjustmentShares items). Only booked in batch T, no BVU/BVI.
   */
  ShareCapital = 'ShareCapital',
  /** StampDuty is cost from StampDuty transaction items. Booked in batch T. */
  StampDuty = 'StampDuty',
  /** Tax is tax from Tax transaction items. Booked in batch T. */
  Tax = 'Tax',
  /** TaxRestitution is restituted tax from TaxRestitution transaction items. Booked in batch T. */
  TaxRestitution = 'TaxRestitution',
  /** Unrealized is unrealized profit or loss from price changes. Booked in batch BVU, reversed in batch BVI. */
  Unrealized = 'Unrealized',
  /** UnrealizedFx is unrealized profit or loss from fx changes. Booked in batch BVU, reversed in batch BVI. */
  UnrealizedFx = 'UnrealizedFx',
  /**
   * ValueChange is the balance sheet revaluation of a position (price and fx) relative to initial cost.
   * Booked in batch BVU at closing and reversed in batch BVI. Counterpart of Unrealized and UnrealizedFx.
   */
  ValueChange = 'ValueChange'
}

export type Agreement = {
  __typename?: 'Agreement';
  _id: Scalars['GraphQLObjectId']['output'];
  approvedInfo?: Maybe<Array<ApprovedInfo>>;
  attachments: Array<Maybe<Attachment>>;
  client: PartyInfo;
  clientId: Scalars['GraphQLObjectId']['output'];
  counterParties: Array<PartyInfo>;
  counterPartyIds: Array<Scalars['GraphQLObjectId']['output']>;
  createTimestamp: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  parties?: Maybe<Array<Maybe<PartyInfo>>>;
  partyIds: Array<Scalars['GraphQLObjectId']['output']>;
  status: AgreementStatusEnum;
  type: AgreementTypeEnum;
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId: Scalars['GraphQLObjectId']['output'];
  updateUserInfo: UserInfo;
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type AgreementFilterInput = {
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  counterPartyIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  partyIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  statusIn?: InputMaybe<Array<AgreementStatusEnum>>;
  typeIn?: InputMaybe<Array<AgreementTypeEnum>>;
};

export type AgreementInput = {
  /** if _id is omitted, an agreement will be created */
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  approvedInfo?: InputMaybe<Array<ApprovedInfoInput>>;
  attachments?: InputMaybe<Array<AttachmentInput>>;
  clientId: Scalars['GraphQLObjectId']['input'];
  counterPartyIds: Array<Scalars['GraphQLObjectId']['input']>;
  description: Scalars['String']['input'];
  partyIds: Array<Scalars['GraphQLObjectId']['input']>;
  status: AgreementStatusEnum;
  type: AgreementTypeEnum;
};

export enum AgreementStatusEnum {
  Active = 'Active',
  Deleted = 'Deleted',
  Inactive = 'Inactive',
  Pending = 'Pending',
  Superseded = 'Superseded'
}

export enum AgreementType {
  ClearingAccount = 'ClearingAccount',
  CollateralisedLoan = 'CollateralisedLoan',
  Gmra = 'Gmra',
  Gmsla = 'Gmsla',
  Isda = 'Isda',
  OmnibusClearingAccount = 'OmnibusClearingAccount'
}

export enum AgreementTypeEnum {
  CashTrading = 'CashTrading',
  Cdea = 'Cdea',
  ClearingBroker = 'ClearingBroker',
  CustodyAgreement = 'CustodyAgreement',
  Emir = 'Emir',
  EquityDma = 'EquityDma',
  FxTrading = 'FxTrading',
  Gmra = 'Gmra',
  Gmsla = 'Gmsla',
  Gua = 'Gua',
  InvestmentManagement = 'InvestmentManagement',
  InvestmentPolicy = 'InvestmentPolicy',
  Isda = 'Isda',
  Mt101 = 'Mt101',
  ProcessAgent = 'ProcessAgent',
  Sftr = 'Sftr',
  Ssi = 'Ssi',
  SubscriptionRedemptionForm = 'SubscriptionRedemptionForm',
  TriParty = 'TriParty',
  UserAgreement = 'UserAgreement'
}

export type Alias = {
  __typename?: 'Alias';
  collection: CollectionNameEnum;
  /** Markdown comment */
  comment: Scalars['String']['output'];
  documentId: Scalars['GraphQLObjectId']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AliasInput = {
  collection: CollectionNameEnum;
  comment: Scalars['String']['input'];
  documentId: Scalars['GraphQLObjectId']['input'];
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type AmountData = {
  __typename?: 'AmountData';
  amount: Scalars['String']['output'];
  currency: Scalars['String']['output'];
};

export type AmountDataInput = {
  amount: Scalars['String']['input'];
  currency: Scalars['String']['input'];
};

export type AnnualReportType = {
  __typename?: 'AnnualReportType';
  /** Name, year, lastYear */
  balanceSheet: Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>;
  clientId: Scalars['GraphQLObjectId']['output'];
  /** Name, agreementType, netExposure(tkr), share(%) */
  derivativesSecurities: Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>;
  /** Name, year, lastYear */
  equityChange: Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>;
  /** Name, year, lastYear, secondLastYear, thirdLastYear, fourthLastYear... ninthLastYear */
  fundFigures?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  /** Name, weight(%) */
  issuers: Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>;
  /** Name, year, lastYear, secondLastYear, thirdLastYear, fourthLastYear */
  keyFigures: Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>;
  /** InstrumentName, country/category, quantity, exposure(tkr), share(%) */
  positions: Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>;
  /** Name, creditRating, share(%) */
  ratings: Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>;
  /** Name, year, lastYear */
  resultSheet: Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>;
};

export type ApprovedInfo = {
  __typename?: 'ApprovedInfo';
  comment?: Maybe<Scalars['String']['output']>;
  status: ApprovedStatusEnum;
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId: Scalars['GraphQLObjectId']['output'];
  updateUserInfo?: Maybe<UserInfo>;
};

export type ApprovedInfoInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  status: ApprovedStatusEnum;
  /** if updateTimestamp is omitted, it is seen as new info and updateTimestamp is added */
  updateTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  /** if updateUserId is omitted, it is seen as new info and updateUserId is added */
  updateUserId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
};

export enum ApprovedStatusEnum {
  Accepted = 'Accepted',
  Rejected = 'Rejected'
}

export type Attachment = {
  __typename?: 'Attachment';
  /**
   * base64 is a available on attachment but
   * not on attachments
   */
  base64?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  fileId: Scalars['GraphQLObjectId']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  mD5?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
};

export type AttachmentInput = {
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  fileId: Scalars['GraphQLObjectId']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  mD5?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  updateTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type BankAccountBalance = {
  __typename?: 'BankAccountBalance';
  balance: Scalars['TwoDecimalString']['output'];
  date: Scalars['GraphQLDateString']['output'];
  instrumentId: Scalars['GraphQLObjectId']['output'];
};

export type BankAccountBalanceFilterInput = {
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  instrumentIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  statusIn?: InputMaybe<Array<BankAccountTransactionStatusEnum>>;
};

export type BankAccountTransaction = {
  __typename?: 'BankAccountTransaction';
  _id: Scalars['GraphQLObjectId']['output'];
  additionalInformation: Scalars['String']['output'];
  amount: Scalars['TwoDecimalString']['output'];
  /**
   * Balance for instrument on "date". Calculated by adding all transactions from last two days to
   * balance position received from custodian two days prior to "date"
   */
  balance: Scalars['TwoDecimalString']['output'];
  client: PartyInfo;
  clientId: Scalars['GraphQLObjectId']['output'];
  createTimestamp: Scalars['Timestamp']['output'];
  date: Scalars['GraphQLDateString']['output'];
  description: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
  other?: Maybe<Scalars['JSON']['output']>;
  reference: Scalars['String']['output'];
  status: BankAccountTransactionStatusEnum;
  /**
   * Ids of transactionItems that the bankAccountTransaction amount has matched with, used for reconciliation
   * of bank accounts
   */
  transactionItemIds: Array<Scalars['GraphQLObjectId']['output']>;
  /** Array of matched transactionItems that the bankAccountTransaction amount has matched with */
  transactionItems: Array<TransactionItem>;
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type BankAccountTransactionFilterInput = {
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  ibanIn?: InputMaybe<Array<Scalars['String']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  instrumentIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  startDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  statusIn?: InputMaybe<Array<BankAccountTransactionStatusEnum>>;
};

export type BankAccountTransactionInput = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['TwoDecimalString']['input'];
  clientId: Scalars['GraphQLObjectId']['input'];
  date: Scalars['GraphQLDateString']['input'];
  description: Scalars['String']['input'];
  error?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  instrumentId: Scalars['GraphQLObjectId']['input'];
  other?: InputMaybe<Scalars['JSON']['input']>;
  reference: Scalars['String']['input'];
  status: BankAccountTransactionStatusEnum;
  transactionItemIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
};

export enum BankAccountTransactionStatusEnum {
  Deleted = 'Deleted',
  Pending = 'Pending',
  Settled = 'Settled'
}

export type BaseCalendar = {
  __typename?: 'BaseCalendar';
  _id: Scalars['GraphQLObjectId']['output'];
  baseEvents: Array<BaseCalendarEvent>;
  clientIds: Array<Scalars['GraphQLObjectId']['output']>;
  clients: Array<PartyInfo>;
  createTimestamp: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isBusinessDay?: Maybe<Scalars['Boolean']['output']>;
  isEarlyClose?: Maybe<Scalars['Boolean']['output']>;
  name: CalendarNameEnum;
  source?: Maybe<Scalars['String']['output']>;
  status: CalendarStatusEnum;
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId: Scalars['GraphQLObjectId']['output'];
  updateUserInfo?: Maybe<UserInfo>;
  year: Scalars['String']['output'];
};


export type BaseCalendarIsBusinessDayArgs = {
  date: Scalars['GraphQLDateString']['input'];
};


export type BaseCalendarIsEarlyCloseArgs = {
  date: Scalars['GraphQLDateString']['input'];
};

export type BaseCalendarEvent = {
  __typename?: 'BaseCalendarEvent';
  date: Scalars['GraphQLDateString']['output'];
  event: Scalars['String']['output'];
  state: CalendarStateEnum;
};

export type BaseCalendarEventInput = {
  date: Scalars['GraphQLDateString']['input'];
  event: Scalars['String']['input'];
  state: CalendarStateEnum;
};

export type BaseCalendarFilterInput = {
  clientIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  dates?: InputMaybe<Array<Scalars['GraphQLDateString']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  names?: InputMaybe<Array<CalendarNameEnum>>;
  statusIn?: InputMaybe<Array<CalendarStatusEnum>>;
  years?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BaseCalendarInput = {
  /** If _id is omitted, a Calendar will be created */
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  baseEvents: Array<BaseCalendarEventInput>;
  clientIds: Array<Scalars['GraphQLObjectId']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: CalendarNameEnum;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CalendarStatusEnum>;
};

export type Benchmark = {
  __typename?: 'Benchmark';
  currency?: Maybe<Scalars['String']['output']>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
  offset?: Maybe<Scalars['Float']['output']>;
};

export type BenchmarkInput = {
  currency?: InputMaybe<CurrencyEnum>;
  instrumentId: Scalars['GraphQLObjectId']['input'];
  offset?: InputMaybe<Scalars['Float']['input']>;
};

export type BeneficialOwner = {
  __typename?: 'BeneficialOwner';
  _id?: Maybe<Scalars['GraphQLObjectId']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BeneficialOwnerInput = {
  /** _id is a pointer to a document in a not yet implemented collection BeneficialOwner */
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum BestExecutionType {
  /**
   * Client denotes transactions entered by a client it self as
   * a part of an asset management agreement.
   */
  Client = 'Client',
  /**
   * Execution denotes a trade executed on behalf a client
   * outside an asset management agreement.
   */
  Execution = 'Execution',
  /**
   * Maintenance denotes transactions such as dividends, coupons etc.
   * that follows from positions held.
   */
  Maintenance = 'Maintenance',
  /**
   * Portfolio denotes a trade conducted as under an asset
   * management agreement.
   */
  Portfolio = 'Portfolio',
  /**
   * Transmission denotes a trade passed on to another broker on behalf
   * of a client outside an asset management agreement.
   */
  Transmission = 'Transmission'
}

export type BrokerTransaction = {
  __typename?: 'BrokerTransaction';
  _id: Scalars['GraphQLObjectId']['output'];
  broker?: Maybe<Party>;
  brokerId: Scalars['GraphQLObjectId']['output'];
  client?: Maybe<Party>;
  clientId: Scalars['GraphQLObjectId']['output'];
  commission: Scalars['Float']['output'];
  correspondingTransactionId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  createTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  currency: CurrencyEnum;
  description?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  instrument?: Maybe<Instrument>;
  isin: Scalars['ISIN']['output'];
  /** https://www.iso20022.org/market-identifier-codes */
  mic?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  reportId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  settlementAmount?: Maybe<Scalars['Float']['output']>;
  stampDuty: Scalars['Float']['output'];
  status?: Maybe<BrokerTransactionStatus>;
  tradeCurrency?: Maybe<CurrencyEnum>;
  tradeDate: Scalars['GraphQLDateString']['output'];
  type: BrokerTransactionType;
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  valueDate: Scalars['GraphQLDateString']['output'];
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type BrokerTransactionFilterInput = {
  clientIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  externalIdIn?: InputMaybe<Array<Scalars['String']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  startDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  statusIn?: InputMaybe<Array<BrokerTransactionStatus>>;
  tradeDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};

export enum BrokerTransactionStatus {
  Confirmed = 'Confirmed',
  Deleted = 'Deleted',
  Pending = 'Pending'
}

export enum BrokerTransactionType {
  Buy = 'Buy',
  Sell = 'Sell'
}

export type Calendar = {
  __typename?: 'Calendar';
  calendarEvents?: Maybe<Array<CalendarEvent>>;
  isBusinessDay?: Maybe<Scalars['Boolean']['output']>;
  isEarlyClose?: Maybe<Scalars['Boolean']['output']>;
  names?: Maybe<Array<CalendarNameEnum>>;
};


export type CalendarIsBusinessDayArgs = {
  date: Scalars['GraphQLDateString']['input'];
};


export type CalendarIsEarlyCloseArgs = {
  date: Scalars['GraphQLDateString']['input'];
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  date: Scalars['GraphQLDateString']['output'];
  events: Array<EventInfo>;
  state: CalendarStateEnum;
};

export enum CalendarNameEnum {
  SwedenFixedIncome = 'SwedenFixedIncome',
  UnitedKingdom = 'UnitedKingdom',
  UnitedStatesEquity = 'UnitedStatesEquity',
  UnitedStatesFixedIncome = 'UnitedStatesFixedIncome'
}

export enum CalendarStateEnum {
  Closed = 'Closed',
  EarlyClose = 'EarlyClose'
}

export enum CalendarStatusEnum {
  Active = 'Active',
  Deleted = 'Deleted'
}

export type CashAccountBalance = {
  __typename?: 'CashAccountBalance';
  balanceItems: Array<CashBalance>;
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
};

export type CashAccountLadder = {
  __typename?: 'CashAccountLadder';
  amounts: Array<Scalars['Float']['output']>;
  balances: Array<Scalars['Float']['output']>;
  client?: Maybe<Party>;
  clientId: Scalars['GraphQLObjectId']['output'];
  dates: Array<Scalars['GraphQLDateString']['output']>;
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
};

export type CashBalance = {
  __typename?: 'CashBalance';
  amount: Scalars['Float']['output'];
  balance: Scalars['Float']['output'];
  tradeDate: Scalars['GraphQLDateString']['output'];
  transaction?: Maybe<Transaction>;
  transactionId: Scalars['GraphQLObjectId']['output'];
  transactionItem?: Maybe<TransactionItem>;
  transactionItemId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  valueDate: Scalars['GraphQLDateString']['output'];
};

export enum CdsType {
  Basket = 'Basket',
  Index = 'Index'
}

export type ChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export enum CicAreaEnum {
  /** UnitedArabEmirates */
  AE = 'AE',
  /** Argentina */
  AR = 'AR',
  /** Austria */
  AT = 'AT',
  /** Australia */
  AU = 'AU',
  /** Belgium */
  BE = 'BE',
  /** Bulgaria */
  BG = 'BG',
  /** Bermuda */
  BM = 'BM',
  /** Canada */
  CA = 'CA',
  /** Switzerland */
  CH = 'CH',
  /** Chile */
  CL = 'CL',
  /** China */
  CN = 'CN',
  /** Cyprus */
  CY = 'CY',
  /** CzechRepublic */
  CZ = 'CZ',
  /** Germany */
  DE = 'DE',
  /** Denmark */
  DK = 'DK',
  /** Estonia */
  EE = 'EE',
  /** Spain */
  ES = 'ES',
  /** Finland */
  FI = 'FI',
  /** FaroeIslands */
  FO = 'FO',
  /** France */
  FR = 'FR',
  /** UnitedKingdom */
  GB = 'GB',
  /** Guernsey */
  GG = 'GG',
  /** Greece */
  GR = 'GR',
  /** HongKong */
  HK = 'HK',
  /** Croatia */
  HR = 'HR',
  /** Hungary */
  HU = 'HU',
  /** Ireland */
  IE = 'IE',
  /** Israel */
  IL = 'IL',
  /** IsleOfMan */
  IM = 'IM',
  /** Iran */
  IR = 'IR',
  /** Italy */
  IT = 'IT',
  /** Jersey */
  JE = 'JE',
  /** Jordan */
  JO = 'JO',
  /** Japan */
  JP = 'JP',
  /** CaymanIslands */
  KY = 'KY',
  /** Lithuania */
  LT = 'LT',
  /** Luxembourg */
  LU = 'LU',
  /** Latvia */
  LV = 'LV',
  /** Macao */
  MO = 'MO',
  /** Malta */
  MT = 'MT',
  /** Mexico */
  MX = 'MX',
  /** Netherlands */
  NL = 'NL',
  /** Norway */
  NO = 'NO',
  /** NewZealand */
  NZ = 'NZ',
  /** None */
  None = 'None',
  /** Poland */
  PL = 'PL',
  /** Portugal */
  PT = 'PT',
  /** Romania */
  RO = 'RO',
  /** Sweden */
  SE = 'SE',
  /** Singapore */
  SG = 'SG',
  /** Slovenia */
  SI = 'SI',
  /** Slovakia */
  SK = 'SK',
  /** UnitedStates */
  US = 'US',
  /** Assets that are not listed in a stock exchange */
  XL = 'XL',
  /** Assets that are not exchange tradable */
  XT = 'XT',
  /** SouthAfrica */
  ZA = 'ZA'
}

export enum CicTypeEnum {
  /** None */
  None = 'None',
  /** 00 Other investments */
  XX00 = 'XX00',
  /** 11 Central Government bonds */
  XX11 = 'XX11',
  /** 12 Supra-national bonds */
  XX12 = 'XX12',
  /** 13 Regional government bonds */
  XX13 = 'XX13',
  /** 14 Municipal government bonds */
  XX14 = 'XX14',
  /** 15 Treasury bonds */
  XX15 = 'XX15',
  /** 16 Covered bonds */
  XX16 = 'XX16',
  /** 17 National Central bank bonds */
  XX17 = 'XX17',
  /** 19 Government bonds Other */
  XX19 = 'XX19',
  /** 21 Corporate bonds */
  XX21 = 'XX21',
  /** 22 Convertible bonds */
  XX22 = 'XX22',
  /** 23 Commercial paper */
  XX23 = 'XX23',
  /** 24 Money market instruments */
  XX24 = 'XX24',
  /** 25 Hybrid bonds */
  XX25 = 'XX25',
  /** 26 Common covered bonds */
  XX26 = 'XX26',
  /** 27 Covered bonds subject to specific law */
  XX27 = 'XX27',
  /** 28 Subordinated bonds */
  XX28 = 'XX28',
  /** 29 Corporate bonds Other */
  XX29 = 'XX29',
  /** 31 Common equity */
  XX31 = 'XX31',
  /** 32 Equity of real estate related corporation */
  XX32 = 'XX32',
  /** 33 Equity rights */
  XX33 = 'XX33',
  /** 34 Preferred equity */
  XX34 = 'XX34',
  /** 39 Equity Other */
  XX39 = 'XX39',
  /** 41 Equity funds */
  XX41 = 'XX41',
  /** 42 Debt funds */
  XX42 = 'XX42',
  /** 43 Money market funds */
  XX43 = 'XX43',
  /** 44 Asset allocation funds */
  XX44 = 'XX44',
  /** 45 Real estate funds */
  XX45 = 'XX45',
  /** 46 Alternative funds */
  XX46 = 'XX46',
  /** 47 Private equity funds */
  XX47 = 'XX47',
  /** 48 Infrastructure funds */
  XX48 = 'XX48',
  /** 49 Collective Investment Undertakings (funds) other */
  XX49 = 'XX49',
  /** 51 Structured notes Equity risk */
  XX51 = 'XX51',
  /** 52 Structured notes Interest rate risk */
  XX52 = 'XX52',
  /** 53 Structured notes Currency risk */
  XX53 = 'XX53',
  /** 54 Structured notes Credit risk */
  XX54 = 'XX54',
  /** 55 Structured notes Real estate risk */
  XX55 = 'XX55',
  /** 56 Structured notes Commodity risk */
  XX56 = 'XX56',
  /** 57 Structured notes Catastrophe and Weather risk */
  XX57 = 'XX57',
  /** 58 Structured notes Mortality risk */
  XX58 = 'XX58',
  /** 59 Structured notes Structured notes Other */
  XX59 = 'XX59',
  /** 61 Collateralised securities Equity risk */
  XX61 = 'XX61',
  /** 62 Collateralised securities Interest rate risk */
  XX62 = 'XX62',
  /** 63 Collateralised securities Currency risk */
  XX63 = 'XX63',
  /** 64 Collateralised securities Credit risk */
  XX64 = 'XX64',
  /** 65 Collateralised securities Real estate risk */
  XX65 = 'XX65',
  /** 66 Collateralised securities Commodity risk */
  XX66 = 'XX66',
  /** 67 Collateralised securities Catastrophe and Weather risk */
  XX67 = 'XX67',
  /** 68 Collateralised securities Mortality risk */
  XX68 = 'XX68',
  /** 69 Collateralised securities Other */
  XX69 = 'XX69',
  /** 71 Cash */
  XX71 = 'XX71',
  /** 72 Cash Transferable deposits ,cash equivalents */
  XX72 = 'XX72',
  /** 73 Cash Other deposits short term ,less than or equal to one year */
  XX73 = 'XX73',
  /** 74 Cash Other deposits with term longer than one year */
  XX74 = 'XX74',
  /** 75 Cash Deposits to cedants */
  XX75 = 'XX75',
  /** 76 Captor Specific - Initial Margin Account */
  XX76 = 'XX76',
  /** 77 Captor Specific - Variation Margin Account */
  XX77 = 'XX77',
  /** 78 Captor Specific - Balance Account */
  XX78 = 'XX78',
  /** 79 Cash and deposits Other */
  XX79 = 'XX79',
  /** 81 Uncollateralized loans made */
  XX81 = 'XX81',
  /** 82 Loans made collateralized with securities */
  XX82 = 'XX82',
  /** 84 Mortgages */
  XX84 = 'XX84',
  /** 85 Other collateralized loans made */
  XX85 = 'XX85',
  /** 86 Loans on policies */
  XX86 = 'XX86',
  /** 89 Mortgages and loans Other */
  XX89 = 'XX89',
  /** 91 Property (office and commercial) */
  XX91 = 'XX91',
  /** 92 Property (residential) */
  XX92 = 'XX92',
  /** 93 Property (for own use) */
  XX93 = 'XX93',
  /** 94 Property (under construction) */
  XX94 = 'XX94',
  /** 95 Plant and equipment (for own use) */
  XX95 = 'XX95',
  /** 99 Property Other */
  XX99 = 'XX99',
  /** A1 Equity and index futures */
  XXA1 = 'XXA1',
  /** A2 Interest rate futures */
  XXA2 = 'XXA2',
  /** A3 Currency futures */
  XXA3 = 'XXA3',
  /** A5 Commodity futures */
  XXA5 = 'XXA5',
  /** A7 Catastrophe and Weather risk futures */
  XXA7 = 'XXA7',
  /** A8 Mortality risk futures */
  XXA8 = 'XXA8',
  /** A9 Futures Other */
  XXA9 = 'XXA9',
  /** B1 Equity and index call options */
  XXB1 = 'XXB1',
  /** B2 Bond call options */
  XXB2 = 'XXB2',
  /** B3 Currency call options */
  XXB3 = 'XXB3',
  /** B4 Call Warrants */
  XXB4 = 'XXB4',
  /** B5 Commodity call options */
  XXB5 = 'XXB5',
  /** B6 Swaptions call / receiver */
  XXB6 = 'XXB6',
  /** B7 Catastrophe and Weather risk call options */
  XXB7 = 'XXB7',
  /** B8 Mortality risk call options */
  XXB8 = 'XXB8',
  /** B9 Call Options Other */
  XXB9 = 'XXB9',
  /** C1 Equity and index put options */
  XXC1 = 'XXC1',
  /** C2 Bond put options */
  XXC2 = 'XXC2',
  /** C3 Currency put options */
  XXC3 = 'XXC3',
  /** C4 Put Warrants */
  XXC4 = 'XXC4',
  /** C5 Commodity put options */
  XXC5 = 'XXC5',
  /** C6 Swaptions put / payer */
  XXC6 = 'XXC6',
  /** C7 Catastrophe and Weather risk put options */
  XXC7 = 'XXC7',
  /** C8 Mortality risk put options */
  XXC8 = 'XXC8',
  /** C9 Put Options Other */
  XXC9 = 'XXC9',
  /** D1 Interest rate swaps */
  XXD1 = 'XXD1',
  /** D2 Currency swaps */
  XXD2 = 'XXD2',
  /** D3 Interest rate and currency swaps */
  XXD3 = 'XXD3',
  /** D5 Security swaps */
  XXD5 = 'XXD5',
  /** D7 Catastrophe and Weather risk swaps */
  XXD7 = 'XXD7',
  /** D8 Mortality risk swaps */
  XXD8 = 'XXD8',
  /** D9 Swaps Other */
  XXD9 = 'XXD9',
  /** E1 Forward interest rate agreement */
  XXE1 = 'XXE1',
  /** E2 Forward exchange rate agreement */
  XXE2 = 'XXE2',
  /** E7 Catastrophe and Weather risk forwards */
  XXE7 = 'XXE7',
  /** E8 Mortality risk forwards */
  XXE8 = 'XXE8',
  /** E9 Forwards Other */
  XXE9 = 'XXE9',
  /** F1 Credit default swap */
  XXF1 = 'XXF1',
  /** F2 Credit spread option */
  XXF2 = 'XXF2',
  /** F3 Credit spread swap */
  XXF3 = 'XXF3',
  /** F4 Total return swap */
  XXF4 = 'XXF4',
  /** F9 Credit derivatives other */
  XXF9 = 'XXF9',
  /** X1 Captor Specific - Equity */
  XXX1 = 'XXX1',
  /** X2 Captor Specific - Opening */
  XXX2 = 'XXX2',
  /** X3 Captor Specific - Rounding */
  XXX3 = 'XXX3'
}

export type ClientForAsset = {
  __typename?: 'ClientForAsset';
  asset: PermissionAssetEnum;
  clients: Array<ClientInfo>;
};

export type ClientInfo = {
  __typename?: 'ClientInfo';
  _id: Scalars['GraphQLObjectId']['output'];
  name: Scalars['String']['output'];
};

export enum CollectionNameEnum {
  BrokerTransaction = 'BrokerTransaction',
  CorporateAction = 'CorporateAction',
  Instrument = 'Instrument',
  IssuerProgram = 'IssuerProgram',
  None = 'None',
  OPConsent = 'OPConsent',
  Party = 'Party',
  Screen = 'Screen',
  Swift = 'Swift',
  Transaction = 'Transaction'
}

export type CorporateAction = {
  __typename?: 'CorporateAction';
  _id: Scalars['GraphQLObjectId']['output'];
  /** Gross amount */
  amount?: Maybe<Scalars['Float']['output']>;
  client?: Maybe<Party>;
  clientId: Scalars['GraphQLObjectId']['output'];
  corporateActionEvent: CorporateActionEvent;
  correspondingTransaction?: Maybe<Transaction>;
  correspondingTransactionId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  createTimestamp: Scalars['Timestamp']['output'];
  currency?: Maybe<CurrencyEnum>;
  error?: Maybe<Scalars['String']['output']>;
  exDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  externalId: Scalars['String']['output'];
  /** Tax amount */
  foreignTax?: Maybe<Scalars['Float']['output']>;
  instrument?: Maybe<Instrument>;
  instrumentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  messageType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  paymentDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  recordDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  reportIds?: Maybe<Array<Scalars['GraphQLObjectId']['output']>>;
  status: CorporateActionStatusEnum;
  swift?: Maybe<Swift>;
  swiftId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  /** A list of versions of the document */
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export enum CorporateActionEvent {
  /** Accumulation */
  ACCU = 'ACCU',
  /** Trading Status: Active */
  ACTV = 'ACTV',
  /** Attachment */
  ATTI = 'ATTI',
  /** Repurchase Offer */
  BIDS = 'BIDS',
  /** Bondholder Meeting */
  BMET = 'BMET',
  /** Bonus Issue */
  BONU = 'BONU',
  /** Put Redemption */
  BPUT = 'BPUT',
  /** Bankruptcy */
  BRUP = 'BRUP',
  /** Capital Distribution */
  CAPD = 'CAPD',
  /** Capital Gains Distribution */
  CAPG = 'CAPG',
  /** Capitalisation */
  CAPI = 'CAPI',
  /** Non-US TEFRA D Certification */
  CERT = 'CERT',
  /** Change */
  CHAN = 'CHAN',
  /** Class Action */
  CLSA = 'CLSA',
  /** Court Meeting */
  CMET = 'CMET',
  /** Consent */
  CONS = 'CONS',
  /** Conversion */
  CONV = 'CONV',
  /** Company Option */
  COOP = 'COOP',
  /** Credit Event */
  CREV = 'CREV',
  /** Decrease in Value */
  DECR = 'DECR',
  /** Detachment */
  DETI = 'DETI',
  /** Bond Default */
  DFLT = 'DFLT',
  /** Trading Status: Delisted */
  DLST = 'DLST',
  /** Drawing */
  DRAW = 'DRAW',
  /** Cash Distribution from Non-Eligible Securities Sales */
  DRCA = 'DRCA',
  /** Dividend Reinvestment */
  DRIP = 'DRIP',
  /** Disclosure */
  DSCL = 'DSCL',
  /** Dutch Auction */
  DTCH = 'DTCH',
  /** Cash Dividend */
  DVCA = 'DVCA',
  /** Dividend Option */
  DVOP = 'DVOP',
  /** Scrip Dividend */
  DVSC = 'DVSC',
  /** Stock Dividend */
  DVSE = 'DVSE',
  /** Exchange */
  EXOF = 'EXOF',
  /** Call on Intermediate Securities */
  EXRI = 'EXRI',
  /** Maturity Extension */
  EXTM = 'EXTM',
  /** Warrant Exercise */
  EXWA = 'EXWA',
  /** Increase in Value */
  INCR = 'INCR',
  /** Information */
  INFO = 'INFO',
  /** Interest Payment */
  INTR = 'INTR',
  /** Liquidation Dividend */
  LIQU = 'LIQU',
  /** Full Call */
  MCAL = 'MCAL',
  /** Annual General Meeting */
  MEET = 'MEET',
  /** Merger */
  MRGR = 'MRGR',
  /** New Offer */
  NOOF = 'NOOF',
  /** Odd Lot Offer */
  ODLT = 'ODLT',
  /** Other Event */
  OTHR = 'OTHR',
  /** Parity Adjustment */
  PARI = 'PARI',
  /** Partial Defeasance */
  PDEF = 'PDEF',
  /** Pink Sheet Trading */
  PINK = 'PINK',
  /** Placement */
  PLAC = 'PLAC',
  /** Partial Redemption with Pool Factor Reduction */
  PPUB = 'PPUB',
  /** Prime Rate Interest Payment */
  PRII = 'PRII',
  /** Priority Issue */
  PRIO = 'PRIO',
  /** Redemption */
  REDM = 'REDM',
  /** Remarketing */
  REMK = 'REMK',
  /** Rights Distribution */
  RHDI = 'RHDI',
  /** Rights Issue */
  RHTS = 'RHTS',
  /** Spin-Off */
  SDRV = 'SDRV',
  /** Shareholders' Meeting */
  SHPR = 'SHPR',
  /** Smallest Negotiable Unit */
  SMAL = 'SMAL',
  /** Stock Offering */
  SOFF = 'SOFF',
  /** Stock Split */
  SPLF = 'SPLF',
  /** Reverse Stock Split */
  SPLR = 'SPLR',
  /** Tender Offer */
  TEND = 'TEND',
  /** Transaction Reclassification */
  TREC = 'TREC',
  /** Worthless Security */
  WRTH = 'WRTH'
}

export type CorporateActionFilterInput = {
  clientIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  corporateActionEventIn?: InputMaybe<Array<CorporateActionEvent>>;
  /** Corresponding transaction */
  correspondingTransactionIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  /** Corporate action event reference */
  externalIdIn?: InputMaybe<Array<Scalars['String']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  messageTypeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Record date, format: YYYY-MM-DD */
  recordDateEnd?: InputMaybe<Scalars['String']['input']>;
  /** Record date, format: YYYY-MM-DD */
  recordDateStart?: InputMaybe<Scalars['String']['input']>;
  reportIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  statusIn?: InputMaybe<Array<CorporateActionStatusEnum>>;
  swiftIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
};

export type CorporateActionInput = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  /** Gross amount */
  amount?: InputMaybe<Scalars['Float']['input']>;
  clientId: Scalars['GraphQLObjectId']['input'];
  /** Required for create */
  corporateActionEvent?: InputMaybe<CorporateActionEvent>;
  correspondingTransactionId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  exDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  /** Required for create */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Tax amount */
  foreignTax?: InputMaybe<Scalars['Float']['input']>;
  instrumentId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  /** Required for create */
  messageType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  recordDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  /** reportIds or swiftId required for create */
  reportIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  status?: InputMaybe<CorporateActionStatusEnum>;
  /** reportIds or swiftId required for create */
  swiftId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  /** Required for create */
  text?: InputMaybe<Scalars['String']['input']>;
  /** Required for create */
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum CorporateActionStatusEnum {
  Confirmed = 'Confirmed',
  Deleted = 'Deleted',
  Pending = 'Pending',
  Preliminary = 'Preliminary',
  /** Messages of type 566 gets status settled when matched */
  Settled = 'Settled',
  /** Used for messageType 566 when original coacs(swift) of messageType 564 has been updated and coacs(swift) of messageType is insignificant */
  UpdatedPrevious = 'UpdatedPrevious',
  /**
   * Used for messages with corporateActionEvent: DRIP/DVOP, theese are received earlier (not received two days after ex-date
   * like other corporateActionEvents)
   */
  Waiting = 'Waiting'
}

export type Cost = {
  __typename?: 'Cost';
  _id: Scalars['GraphQLObjectId']['output'];
  amount?: Maybe<Scalars['Float']['output']>;
  attachments?: Maybe<Array<Attachment>>;
  client: PartyInfo;
  clientId: Scalars['GraphQLObjectId']['output'];
  createTimestamp: Scalars['Timestamp']['output'];
  creator: UserInfo;
  creatorId: Scalars['GraphQLObjectId']['output'];
  currency?: Maybe<CurrencyEnum>;
  date: Scalars['GraphQLDateString']['output'];
  debtorIds: Array<Scalars['GraphQLObjectId']['output']>;
  debtors: Array<PartyInfo>;
  description: Scalars['String']['output'];
  endDate: Scalars['GraphQLDateString']['output'];
  startDate: Scalars['GraphQLDateString']['output'];
  status: CostStatusEnum;
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  /** A list of versions of the document */
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type CostFilterInput = {
  clientIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  statusIn?: InputMaybe<Array<CostStatusEnum>>;
};

export type CostInput = {
  /** if _id is omitted, a Cost will be created */
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  attachments?: InputMaybe<Array<AttachmentInput>>;
  clientId: Scalars['GraphQLObjectId']['input'];
  currency?: InputMaybe<CurrencyEnum>;
  date: Scalars['GraphQLDateString']['input'];
  debtorIds: Array<Scalars['GraphQLObjectId']['input']>;
  description: Scalars['String']['input'];
  endDate: Scalars['GraphQLDateString']['input'];
  startDate: Scalars['GraphQLDateString']['input'];
  status: CostStatusEnum;
  /** A list of versions of the document */
  versions?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export enum CostStatusEnum {
  Active = 'Active',
  Deleted = 'Deleted'
}

export enum CountryCodeEnum {
  /** UnitedArabEmirates */
  AE = 'AE',
  /** Argentina */
  AR = 'AR',
  /** Austria */
  AT = 'AT',
  /** Australia */
  AU = 'AU',
  /** Belgium */
  BE = 'BE',
  /** Bulgaria */
  BG = 'BG',
  /** Bermuda */
  BM = 'BM',
  /** Canada */
  CA = 'CA',
  /** Switzerland */
  CH = 'CH',
  /** Chile */
  CL = 'CL',
  /** China */
  CN = 'CN',
  /** Cyprus */
  CY = 'CY',
  /** CzechRepublic */
  CZ = 'CZ',
  /** Germany */
  DE = 'DE',
  /** Denmark */
  DK = 'DK',
  /** Estonia */
  EE = 'EE',
  /** Spain */
  ES = 'ES',
  /** Finland */
  FI = 'FI',
  /** FaroeIslands */
  FO = 'FO',
  /** France */
  FR = 'FR',
  /** UnitedKingdom */
  GB = 'GB',
  /** Guernsey */
  GG = 'GG',
  /** Greece */
  GR = 'GR',
  /** HongKong */
  HK = 'HK',
  /** Croatia */
  HR = 'HR',
  /** Hungary */
  HU = 'HU',
  /** Ireland */
  IE = 'IE',
  /** Israel */
  IL = 'IL',
  /** IsleOfMan */
  IM = 'IM',
  /** Iran */
  IR = 'IR',
  /** Iceland */
  IS = 'IS',
  /** Italy */
  IT = 'IT',
  /** Jersey */
  JE = 'JE',
  /** Jordan */
  JO = 'JO',
  /** Japan */
  JP = 'JP',
  /** CaymanIslands */
  KY = 'KY',
  /** Lithuania */
  LT = 'LT',
  /** Luxembourg */
  LU = 'LU',
  /** Latvia */
  LV = 'LV',
  /** Macao */
  MO = 'MO',
  /** Malta */
  MT = 'MT',
  /** Mexico */
  MX = 'MX',
  /** Netherlands */
  NL = 'NL',
  /** Norway */
  NO = 'NO',
  /** NewZealand */
  NZ = 'NZ',
  /** Poland */
  PL = 'PL',
  /** Portugal */
  PT = 'PT',
  /** Romania */
  RO = 'RO',
  /** Sweden */
  SE = 'SE',
  /** Singapore */
  SG = 'SG',
  /** Slovenia */
  SI = 'SI',
  /** Slovakia */
  SK = 'SK',
  /** UnitedStates */
  US = 'US',
  /** Unknown */
  Unknown = 'Unknown',
  /** SouthAfrica */
  ZA = 'ZA'
}

export type CreateAccountingRunInput = {
  clientId: Scalars['GraphQLObjectId']['input'];
  clientTAccountChartId: Scalars['GraphQLObjectId']['input'];
  endDate: Scalars['GraphQLDateString']['input'];
  masterTAccountChartId: Scalars['GraphQLObjectId']['input'];
  type: AccountingRunTypeEnum;
};

export type CreateAttachmentInput = {
  base64: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type CreateCurveDefinitionInput = {
  clientId: Scalars['GraphQLObjectId']['input'];
  definition?: InputMaybe<CurveDefinitionDefinitionInput>;
  name: Scalars['String']['input'];
  type: CurveDefinitionType;
};

export type CreateInstrumentInput = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  accountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  aliases?: InputMaybe<Array<AliasInput>>;
  benchmarkId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  bloombergDailyDownload?: InputMaybe<Scalars['Boolean']['input']>;
  bloombergQuoteMultiplier?: InputMaybe<Scalars['Float']['input']>;
  bloombergTicker?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<InstrumentCategory>;
  cicArea?: InputMaybe<CicAreaEnum>;
  cicType?: InputMaybe<CicTypeEnum>;
  clientIds: Array<Scalars['GraphQLObjectId']['input']>;
  creditRatings?: InputMaybe<Array<InputMaybe<CreditRatingInput>>>;
  currency?: InputMaybe<CurrencyEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  exchange?: InputMaybe<Scalars['String']['input']>;
  externalAccountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  isin?: InputMaybe<Scalars['ISIN']['input']>;
  issuerId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  issuerProgramId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  longName?: InputMaybe<Scalars['String']['input']>;
  /** https://www.iso20022.org/market-identifier-codes */
  mic?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<InstrumentModelInput>;
  name: Scalars['String']['input'];
  placeOfSettlementId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  productType?: InputMaybe<InstrumentProductTypeEnum>;
  quantityDecimals?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<InstrumentStatusEnum>;
  /** type defaults to Instrument */
  type?: InputMaybe<InstrumentTypeEnum>;
};

/**
 * Only allowed to create manual journal entries. All other batches created automatically by accounting logic.
 * Thus batch M and number will be calculated in resolver.
 */
export type CreateJournalEntry2Input = {
  accountingRunId: Scalars['GraphQLObjectId']['input'];
  clientId: Scalars['GraphQLObjectId']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalNumber?: InputMaybe<Scalars['Int']['input']>;
  transactions: Array<AccountingTransaction2Input>;
};

/**
 * Only allowed to create manual journal entries. All other batches created automatically by accounting logic.
 * Thus batch M and number will be calculated in resolver.
 */
export type CreateJournalEntryInput = {
  accountingRunId: Scalars['GraphQLObjectId']['input'];
  clientId: Scalars['GraphQLObjectId']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalNumber?: InputMaybe<Scalars['Int']['input']>;
  transactions: Array<AccountingTransactionInput>;
};

export type CreateMiniTransactionInput = {
  accountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  accruedInterest?: InputMaybe<Scalars['Float']['input']>;
  agreementType?: InputMaybe<AgreementType>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  attachments?: InputMaybe<Array<AttachmentInput>>;
  bestExecutionType?: InputMaybe<BestExecutionType>;
  bonusShares?: InputMaybe<Scalars['Float']['input']>;
  brokerId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  brokerTradeId?: InputMaybe<Scalars['String']['input']>;
  carryOwnCostDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  clearingBrokerId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clearingHouseId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  close?: InputMaybe<Scalars['Boolean']['input']>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<CurrencyEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  dividendPaid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only for fxSwap atm */
  expiry?: InputMaybe<Scalars['Boolean']['input']>;
  externalAccountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  foreignTax?: InputMaybe<Scalars['Float']['input']>;
  fxRate?: InputMaybe<Scalars['Float']['input']>;
  initialMargin?: InputMaybe<Scalars['Boolean']['input']>;
  instrumentId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  itemType?: InputMaybe<FeeInterestItemType>;
  loan?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  reinvestedDividend?: InputMaybe<Scalars['Boolean']['input']>;
  reinvestedRebate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reverts + open a new transaction from input, available for dividend/interest in gui only */
  revertTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  rounding?: InputMaybe<Scalars['Float']['input']>;
  secondAccountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  secondAmount?: InputMaybe<Scalars['Float']['input']>;
  secondCurrency?: InputMaybe<CurrencyEnum>;
  secondInstrumentId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  source?: InputMaybe<SourceType>;
  stampDuty?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<TransactionStatus>;
  taxRestitution?: InputMaybe<Scalars['Boolean']['input']>;
  tradeTimestamp?: InputMaybe<Scalars['DateStringOrTimestamp']['input']>;
  type: TransactionType;
  uniqueTradeId?: InputMaybe<Scalars['String']['input']>;
  valueDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};

export type CreatePartyInput = {
  accountant?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  approval?: InputMaybe<Scalars['String']['input']>;
  bloombergEquityTicker?: InputMaybe<Scalars['String']['input']>;
  businessIdentifierCode?: InputMaybe<Scalars['String']['input']>;
  ceo?: InputMaybe<Scalars['String']['input']>;
  complaintsManager?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCodeEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  inLedgerTradeDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  legalEntityIdentifier?: InputMaybe<Scalars['String']['input']>;
  legalNumber?: InputMaybe<Scalars['String']['input']>;
  longName?: InputMaybe<Scalars['String']['input']>;
  nace?: InputMaybe<NaceClass>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  regulator?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PartyStatusEnum>;
  sustainalyticsId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<TimezoneEnum>;
  types: Array<PartyType>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReportInput = {
  base64?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['GraphQLObjectId']['input'];
  data?: InputMaybe<Scalars['JSON']['input']>;
  date: Scalars['GraphQLDateString']['input'];
  name: Scalars['String']['input'];
  sourceId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  status?: InputMaybe<ReportStatusEnum>;
  type: Scalars['String']['input'];
};

export type CreateRoleInput = {
  assets: Array<InputMaybe<PermissionAssetEnum>>;
  clientIds: Array<InputMaybe<Scalars['GraphQLObjectId']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  permissionType: PermissionTypeEnum;
  roleType: RoleTypeEnum;
  status: DocumentStatusEnum;
};

export type CreateSwiftInput = {
  clientId: Scalars['GraphQLObjectId']['input'];
  name: Scalars['String']['input'];
  parsed: Scalars['JSON']['input'];
  reportIds: Array<Scalars['GraphQLObjectId']['input']>;
  status: SwiftStatusEnum;
  text: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreateTAccountChartInput = {
  clientId: Scalars['GraphQLObjectId']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tAccountMappings?: InputMaybe<Array<TAccountMappingInput>>;
  tAccounts?: InputMaybe<Array<TAccountInput>>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTransactionInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  bestExecutionType: BestExecutionType;
  brokerId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  brokerTradeId?: InputMaybe<Scalars['String']['input']>;
  carryOwnCostDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  clearingHouseId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientId: Scalars['GraphQLObjectId']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  items: Array<CreateTransactionItemInput>;
  number?: InputMaybe<Scalars['Int']['input']>;
  status: TransactionStatus;
  tradeTimestamp: Scalars['Timestamp']['input'];
  type: TransactionType;
  uniqueTradeId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTransactionItemInput = {
  accountId: Scalars['GraphQLObjectId']['input'];
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<CurrencyEnum>;
  externalAccountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  fxRate?: InputMaybe<Scalars['Float']['input']>;
  instrumentId: Scalars['GraphQLObjectId']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type: TransactionItemType;
  valueDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};

export type CreateUpdateCashInstrumentInput = {
  /** Create: Not included Update: Required */
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  /** Create: Optional Update: Optional */
  accountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  create: Scalars['Boolean']['input'];
  /** Create: Required Update: Optional */
  currency?: InputMaybe<CurrencyEnum>;
  /** Create: Required Update: Optional */
  externalAccountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  /** Account number, Create: Optional Update: Optional */
  isin?: InputMaybe<Scalars['String']['input']>;
  longName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantityDecimals?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateUpdateExternalAccountInput = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  attachments?: InputMaybe<Array<AttachmentInput>>;
  baseCurrency?: InputMaybe<CurrencyEnum>;
  /** only for omnibusClearingAccount + clearingAccount */
  clearingBrokerId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  /** only for omnibusClearingAccounts */
  clearingHousesIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  create: Scalars['Boolean']['input'];
  custodianAccountNumber?: InputMaybe<Scalars['String']['input']>;
  custodianId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  emirReporting?: InputMaybe<Scalars['Boolean']['input']>;
  initialMarginCurrencies?: InputMaybe<Array<CurrencyEnum>>;
  minimumTransferAmount?: InputMaybe<Scalars['Float']['input']>;
  noCollateralRequirement?: InputMaybe<Scalars['Boolean']['input']>;
  principalCurrencies?: InputMaybe<Array<CurrencyEnum>>;
  reconcile?: InputMaybe<Scalars['Boolean']['input']>;
  roundingAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Need to be able to separate collateral securities posted as IM from what's posted as VM */
  separatedInitialMargin?: InputMaybe<Scalars['Boolean']['input']>;
  settlementOnVMInstrument?: InputMaybe<Scalars['Boolean']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
  type: PartyExternalAccountType;
  variationMarginCurrencies?: InputMaybe<Array<CurrencyEnum>>;
};

export type CreateUpdatePartyCashOrBalanceInstrumentInput = {
  /** Create: Not included Update: Required */
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  /** Create: Optional Update: Optional */
  accountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  aliases?: InputMaybe<Array<AliasInput>>;
  bic?: InputMaybe<Scalars['String']['input']>;
  cicArea?: InputMaybe<CicAreaEnum>;
  cicType?: InputMaybe<CicTypeEnum>;
  /** Create: Required Update: Not included */
  clientIds: Array<Scalars['GraphQLObjectId']['input']>;
  create: Scalars['Boolean']['input'];
  /** Create: Required Update: Optional */
  currency?: InputMaybe<CurrencyEnum>;
  /** Create: Required Update: Optional */
  externalAccountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  /** Account number, Create: Optional Update: Optional */
  isin?: InputMaybe<Scalars['String']['input']>;
  longName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Only acceptable options are CashAccount or BalanceAccount */
  productType: InstrumentProductTypeEnum;
  quantityDecimals?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateUserInput = {
  bidExpiration: Scalars['Int']['input'];
  /** If a serviceUser, this is the clientId (INTEGRATOR party) the user is associated with. */
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientIds: Array<Scalars['GraphQLObjectId']['input']>;
  company: Scalars['String']['input'];
  description: Scalars['String']['input'];
  email: Scalars['EmailAddress']['input'];
  frontendRoleId: Scalars['GraphQLObjectId']['input'];
  /** If true, this user is allowed to use the GraphQL API. */
  graphqlApi?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * List of IP addresses allowed to use this service user.
   * When set and non-empty, requests for this user are only allowed from these IPs.
   */
  ipWhitelist?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  noteIds: Array<Scalars['GraphQLObjectId']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  personalNumber: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** If true, this user is allowed to use the REST API. */
  restApi?: InputMaybe<Scalars['Boolean']['input']>;
  roleIds: Array<Scalars['GraphQLObjectId']['input']>;
  /** serviceUser denotes non human user */
  serviceUser?: InputMaybe<Scalars['Boolean']['input']>;
  status: UserStatusEnum;
};

export type CreateValuationInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  bloombergTicker?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['GraphQLSwedenDate']['input'];
  instrumentId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  instrumentName?: InputMaybe<Scalars['String']['input']>;
  prices: Array<ValuationPriceInput>;
  source?: InputMaybe<Scalars['String']['input']>;
  writeUser?: InputMaybe<Scalars['String']['input']>;
};

export type CreditRatingInput = {
  creditRatingAgencyId: Scalars['GraphQLObjectId']['input'];
  grade: Scalars['GraphQLCreditRating']['input'];
};

export type CreditStatus = {
  pariPassu: TrueFalseNone;
  secured: TrueFalseNone;
  senior: TrueFalseNone;
};

export type CreditStatusType = {
  __typename?: 'CreditStatusType';
  pariPassu: TrueFalseNone;
  secured: TrueFalseNone;
  senior: TrueFalseNone;
};

export enum CurrencyEnum {
  AUD = 'AUD',
  BRL = 'BRL',
  CAD = 'CAD',
  CHF = 'CHF',
  CNY = 'CNY',
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  HKD = 'HKD',
  ILS = 'ILS',
  INR = 'INR',
  ISK = 'ISK',
  JPY = 'JPY',
  KRW = 'KRW',
  MXN = 'MXN',
  NOK = 'NOK',
  NZD = 'NZD',
  RUB = 'RUB',
  SEK = 'SEK',
  SGD = 'SGD',
  TRY = 'TRY',
  USD = 'USD',
  ZAR = 'ZAR'
}

export type CurveDefinition = {
  __typename?: 'CurveDefinition';
  _id: Scalars['GraphQLObjectId']['output'];
  client: PartyInfo;
  clientId: Scalars['GraphQLObjectId']['output'];
  definition?: Maybe<CurveDefinitionDefinition>;
  name: Scalars['String']['output'];
  type: CurveDefinitionType;
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type CurveDefinitionDefinition = {
  __typename?: 'CurveDefinitionDefinition';
  currency: CurrencyEnum;
  dayCount: Scalars['String']['output'];
  forwardPeriod: Scalars['String']['output'];
  instruments: Array<CurveDefinitionInstrument>;
  issuerProgram?: Maybe<IssuerProgram>;
  issuerProgramId: Scalars['GraphQLObjectId']['output'];
  type: CurveDefinitionType2;
};

export type CurveDefinitionDefinitionInput = {
  currency: CurrencyEnum;
  dayCount: Scalars['String']['input'];
  forwardPeriod: Scalars['String']['input'];
  instruments: Array<CurveDefinitionInstrumentInput>;
  issuerProgramId: Scalars['GraphQLObjectId']['input'];
  type: CurveDefinitionType2;
};

export type CurveDefinitionInstrument = {
  __typename?: 'CurveDefinitionInstrument';
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
};

export type CurveDefinitionInstrumentInput = {
  instrumentId: Scalars['GraphQLObjectId']['input'];
};

export enum CurveDefinitionType {
  BasisCurve = 'BasisCurve',
  CreditCurve = 'CreditCurve',
  FixingCurve = 'FixingCurve',
  FxCurve = 'FxCurve',
  YieldCurve = 'YieldCurve'
}

export enum CurveDefinitionType2 {
  YieldCurveDefinition = 'YieldCurveDefinition'
}

export type CustodianApiPosition = {
  __typename?: 'CustodianApiPosition';
  _id: Scalars['GraphQLObjectId']['output'];
  accountNumber: Scalars['String']['output'];
  attachments: Array<Attachment>;
  cashAccountNumber: Scalars['String']['output'];
  client: PartyInfo;
  clientId: Scalars['GraphQLObjectId']['output'];
  createTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  currency: CurrencyEnum;
  custodian: PartyInfo;
  custodianId: Scalars['GraphQLObjectId']['output'];
  date: Scalars['GraphQLDateString']['output'];
  description: Scalars['String']['output'];
  externalAccount?: Maybe<PartyExternalAccount>;
  externalAccountId: Scalars['GraphQLObjectId']['output'];
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
  isin: Scalars['ISIN']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  status: StatusEnum;
  type: CustodianPositionType;
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type CustodianApiPositionInput = {
  /** if _id is omitted, a document will be created */
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  accountNumber: Scalars['String']['input'];
  attachments?: InputMaybe<Array<AttachmentInput>>;
  cashAccountNumber: Scalars['String']['input'];
  clientId: Scalars['GraphQLObjectId']['input'];
  currency: CurrencyEnum;
  custodianId: Scalars['GraphQLObjectId']['input'];
  date: Scalars['GraphQLDateString']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalAccountId: Scalars['GraphQLObjectId']['input'];
  instrumentId: Scalars['GraphQLObjectId']['input'];
  isin: Scalars['ISIN']['input'];
  price: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
  status: StatusEnum;
  type: CustodianPositionType;
};

export type CustodianPosition = {
  __typename?: 'CustodianPosition';
  amount?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<CurrencyEnum>;
  custodianAccountNumber?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['GraphQLDateString']['output']>;
  isin?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

export enum CustodianPositionType {
  Automatic = 'Automatic',
  Manual = 'Manual'
}

export type Customer = {
  __typename?: 'Customer';
  _id: Scalars['GraphQLObjectId']['output'];
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  clientAccount: Scalars['String']['output'];
  clientAccountLabel: Scalars['String']['output'];
  /** clientIds are used for access control */
  clientIds: Array<Scalars['GraphQLObjectId']['output']>;
  clientNumber: Scalars['String']['output'];
  clients: Array<PartyInfo>;
  country: Scalars['String']['output'];
  /** string with comma separated values */
  emails: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  swedishFinancialAuthorityCategory: SwedishFinancialAuthorityCategoryEnum;
  swedishFinancialAuthorityCategoryString: Scalars['String']['output'];
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
};

export type CustomerFilterInput = {
  categoryIn?: InputMaybe<Array<SwedishFinancialAuthorityCategoryEnum>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
};

export type CustomerInput = {
  /** if _id is omitted, a document will be created */
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clientAccount: Scalars['String']['input'];
  clientAccountLabel: Scalars['String']['input'];
  clientIds: Array<Scalars['GraphQLObjectId']['input']>;
  clientNumber: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  /** string with comma separated values */
  emails?: InputMaybe<Scalars['String']['input']>;
  organizationName: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
  swedishFinancialAuthorityCategory?: InputMaybe<SwedishFinancialAuthorityCategoryEnum>;
};

export type DartBasic = {
  __typename?: 'DartBasic';
  analysisFeeDaily?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  fund?: Maybe<Scalars['String']['output']>;
  fundFigureAttribute?: Maybe<Scalars['String']['output']>;
  fundName?: Maybe<Scalars['String']['output']>;
  isin?: Maybe<Scalars['String']['output']>;
  managementFeeDaily?: Maybe<Scalars['Float']['output']>;
  navAfterManagementFee?: Maybe<Scalars['Float']['output']>;
  navBeforeManagementFee?: Maybe<Scalars['Float']['output']>;
  /**
   * // DART data reporting requirements SLA 20 Appendix 2
   * // NAV basic data description
   */
  navDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  navPerUnit?: Maybe<Scalars['Float']['output']>;
  numberOfFundUnits?: Maybe<Scalars['Float']['output']>;
  organisationNo?: Maybe<Scalars['String']['output']>;
  portfolio?: Maybe<Scalars['String']['output']>;
  taxRestitutions?: Maybe<Scalars['Float']['output']>;
};

export type DartHolding = {
  __typename?: 'DartHolding';
  accruedInterestLocalCurrency?: Maybe<Scalars['Float']['output']>;
  accruedInterestSek?: Maybe<Scalars['Float']['output']>;
  balanceNominal?: Maybe<Scalars['Float']['output']>;
  bloombergTicker?: Maybe<Scalars['String']['output']>;
  cfi?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  fundName?: Maybe<Scalars['String']['output']>;
  /**
   * // DART data reporting requirements SLA 20 Appendix 2
   * // Holdings, cash and other assets & liabilities
   */
  fundOrganisationNumber?: Maybe<Scalars['String']['output']>;
  fundShort?: Maybe<Scalars['String']['output']>;
  fxRate?: Maybe<Scalars['Float']['output']>;
  instrumentId?: Maybe<Scalars['String']['output']>;
  instrumentType?: Maybe<Scalars['String']['output']>;
  isin?: Maybe<Scalars['String']['output']>;
  marketValueLocalCurrency?: Maybe<Scalars['Float']['output']>;
  marketValueSek?: Maybe<Scalars['Float']['output']>;
  navDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  priceFuture?: Maybe<Scalars['Float']['output']>;
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  priceType?: Maybe<Scalars['String']['output']>;
  quotation?: Maybe<Scalars['String']['output']>;
  securityGroup?: Maybe<Scalars['String']['output']>;
  securityName?: Maybe<Scalars['String']['output']>;
  securityShort?: Maybe<Scalars['String']['output']>;
  securityType?: Maybe<Scalars['String']['output']>;
  tradingCurrency?: Maybe<Scalars['String']['output']>;
  unsettledAmountIncomingLocalCurrency?: Maybe<Scalars['Float']['output']>;
  unsettledAmountIncomingSek?: Maybe<Scalars['Float']['output']>;
  unsettledAmountOutgoingLocalCurrency?: Maybe<Scalars['Float']['output']>;
  unsettledAmountOutgoingSek?: Maybe<Scalars['Float']['output']>;
  unsettledQuantity?: Maybe<Scalars['Float']['output']>;
};

export type DartReport = {
  __typename?: 'DartReport';
  /** // NAV basic data description */
  basics?: Maybe<Array<Maybe<DartBasic>>>;
  holdings?: Maybe<Array<Maybe<DartHolding>>>;
  transactions?: Maybe<Array<Maybe<DartTransaction>>>;
};

export type DartTransaction = {
  __typename?: 'DartTransaction';
  cashAccount?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  grossAmount?: Maybe<Scalars['Float']['output']>;
  investor?: Maybe<Scalars['String']['output']>;
  isin?: Maybe<Scalars['String']['output']>;
  shareClassInternalCode?: Maybe<Scalars['String']['output']>;
  shareClassName?: Maybe<Scalars['String']['output']>;
  /**
   * // DART data reporting requirements SLA 20 Appendix 2
   * // Fund unit transactions
   */
  transactionId?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['Float']['output']>;
  valuationDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  valueDate?: Maybe<Scalars['GraphQLDateString']['output']>;
};

export type DateQuote = {
  __typename?: 'DateQuote';
  date: Scalars['GraphQLDateString']['output'];
  type: QuoteTypeEnum;
  value: Scalars['Float']['output'];
};

export type DateValue = {
  __typename?: 'DateValue';
  date?: Maybe<Scalars['GraphQLDateString']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum DayAdjustmentEnum {
  FixedPeriods = 'FixedPeriods',
  Following = 'Following',
  ModifiedFollowing = 'ModifiedFollowing'
}

export type DefaultCashInstrument = {
  __typename?: 'DefaultCashInstrument';
  currency: CurrencyEnum;
  partyInstrument?: Maybe<Instrument>;
  partyInstrumentId: Scalars['GraphQLObjectId']['output'];
};

export type DefaultCashInstrumentInput = {
  currency?: InputMaybe<CurrencyEnum>;
  partyInstrumentId: Scalars['GraphQLObjectId']['input'];
};

export enum DocumentStatusEnum {
  Active = 'Active',
  Deleted = 'Deleted'
}

export enum EngagementMethod {
  Dialog = 'Dialog',
  Voting = 'Voting'
}

export enum EsgActivityEnum {
  ApprovedScreen = 'ApprovedScreen',
  Dialogue = 'Dialogue',
  Divestment = 'Divestment',
  Investment = 'Investment',
  Other = 'Other',
  OtherActivity = 'OtherActivity',
  ProxyVoting = 'ProxyVoting',
  RatingEvent = 'RatingEvent',
  ShareholderMeeting = 'ShareholderMeeting',
  Voting = 'Voting'
}

export enum EsgAreaEnum {
  BusinessEthics = 'BusinessEthics',
  Climate = 'Climate',
  Environment = 'Environment',
  HumanRights = 'HumanRights',
  LabourRights = 'LabourRights',
  Other = 'Other',
  Ratings = 'Ratings',
  Social = 'Social'
}

export type EsgComment = {
  __typename?: 'EsgComment';
  comment: Scalars['String']['output'];
  date: Scalars['GraphQLDateString']['output'];
};

export type EsgCommentInput = {
  comment: Scalars['String']['input'];
  date: Scalars['GraphQLDateString']['input'];
};

export enum EsgComponentEnum {
  CdsIndexEsgScreenings = 'CdsIndexEsgScreenings',
  EsgCategory = 'EsgCategory',
  GlobalStandardScreen = 'GlobalStandardScreen',
  KeySector = 'KeySector',
  ProductInvolvement = 'ProductInvolvement',
  ProductInvolvementRanges = 'ProductInvolvementRanges',
  ScreeningInformation = 'ScreeningInformation',
  SpoProviders = 'SpoProviders',
  SustainableDevelopmentGoals = 'SustainableDevelopmentGoals',
  TransitionCompanies = 'TransitionCompanies',
  UseOfProceeds = 'UseOfProceeds'
}

export enum EuTaxonomyEnvironmentalObjective {
  /** Climate change adaptation */
  ClimateChangeAdaption = 'ClimateChangeAdaption',
  /** Climate change mitigation */
  ClimateChangeMitigation = 'ClimateChangeMitigation',
  /** Pollution prevention and control */
  PollutionPreventionAndControl = 'PollutionPreventionAndControl',
  /** Protection and restoration of biodiversity and ecosystems */
  ProtectionAndRestorationBioDiversityAndEcosystems = 'ProtectionAndRestorationBioDiversityAndEcosystems',
  /** Sustainable use and protection of water and marine resources */
  SustainableUseAndProtectionWaterAndMarineResources = 'SustainableUseAndProtectionWaterAndMarineResources',
  /** Transition to a circular economy */
  TransitionToCircularEconomy = 'TransitionToCircularEconomy'
}

export type EventInfo = {
  __typename?: 'EventInfo';
  event: Scalars['String']['output'];
  name: CalendarNameEnum;
  state: CalendarStateEnum;
};

export type ExposureCollateral = {
  __typename?: 'ExposureCollateral';
  _id: Scalars['GraphQLObjectId']['output'];
  agreementType: AgreementType;
  /** Exposure/Collateral (agreement currency), from sources perspective. */
  amount: Scalars['Float']['output'];
  client: Party;
  clientId: Scalars['GraphQLObjectId']['output'];
  createTimestamp: Scalars['Timestamp']['output'];
  /** Exposure/Collateral agreement currency */
  currency: CurrencyEnum;
  /** Can be used to find client, we store this number on externalAccount */
  custodianAccountNumber?: Maybe<Scalars['String']['output']>;
  /** Valuation date. */
  date: Scalars['GraphQLDateString']['output'];
  /** The reference used by the source. */
  externalId: Scalars['String']['output'];
  haircut?: Maybe<Scalars['Float']['output']>;
  instrument?: Maybe<Instrument>;
  /** Can be either RED code or instrumentId */
  instrumentAlias?: Maybe<Scalars['String']['output']>;
  isin?: Maybe<Scalars['ISIN']['output']>;
  /** Required for type CollateralCash/CollateralSecurity */
  marginType?: Maybe<MarginType>;
  /** Exposure/Collateral quantity, from sources perspective. */
  quantity: Scalars['Float']['output'];
  /** database id of original document. Only used internally */
  reportId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  source: Party;
  sourceId: Scalars['GraphQLObjectId']['output'];
  type: ExposureCollateralType;
  uniqueTransactionIdentifier?: Maybe<Scalars['String']['output']>;
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  /** A list of versions of the document */
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type ExposureCollateralInput = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  agreementType: AgreementType;
  /** Exposure (local), from sources perspective. */
  amount: Scalars['Float']['input'];
  clientId: Scalars['GraphQLObjectId']['input'];
  /** Exposure/Collateral agreement currency */
  currency: CurrencyEnum;
  /** Can be used to find client, we store this number on externalAccount */
  custodianAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Valuation date. */
  date: Scalars['GraphQLDateString']['input'];
  /** The reference used by the source. */
  externalId: Scalars['String']['input'];
  /** Only for initial margin collateral securities */
  haircut?: InputMaybe<Scalars['Float']['input']>;
  /** Can be either RED code or instrumentId */
  instrumentAlias?: InputMaybe<Scalars['String']['input']>;
  isin?: InputMaybe<Scalars['ISIN']['input']>;
  /** Required for type CollateralCash/CollateralSecurity */
  marginType?: InputMaybe<MarginType>;
  /** Exposure/Collateral quantity, from sources perspective. */
  quantity: Scalars['Float']['input'];
  /** database id of original document. Only used internally */
  reportId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  sourceId: Scalars['GraphQLObjectId']['input'];
  type: ExposureCollateralType;
  uniqueTransactionIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export enum ExposureCollateralType {
  CollateralCash = 'CollateralCash',
  CollateralSecurity = 'CollateralSecurity',
  Exposure = 'Exposure'
}

export type Extension = {
  __typename?: 'Extension';
  _id: Scalars['GraphQLObjectId']['output'];
  client: PartyInfo;
  clientId: Scalars['GraphQLObjectId']['output'];
  collection: CollectionNameEnum;
  /** Markdown comment */
  comment: Scalars['String']['output'];
  createTimestamp: Scalars['Timestamp']['output'];
  documentId: Scalars['GraphQLObjectId']['output'];
  key: Scalars['String']['output'];
  status: DocumentStatusEnum;
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId: Scalars['GraphQLObjectId']['output'];
  updateUserInfo: UserInfo;
  value: Scalars['String']['output'];
  versions: Array<Scalars['JSON']['output']>;
};

export type ExtensionInput = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientId: Scalars['GraphQLObjectId']['input'];
  collection: CollectionNameEnum;
  /** Markdown comment */
  comment: Scalars['String']['input'];
  documentId: Scalars['GraphQLObjectId']['input'];
  key: Scalars['String']['input'];
  status: DocumentStatusEnum;
  value: Scalars['String']['input'];
};

export type ExtensionsFilterInput = {
  clientIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  documentIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
};

export enum FeeInterestItemType {
  AccruedInterest = 'AccruedInterest',
  Commission = 'Commission',
  CustodyFee = 'CustodyFee',
  Fee = 'Fee',
  ForeignTax = 'ForeignTax',
  Interest = 'Interest',
  /** ManagementCost is an type used for costs due to management of funds, e.g. Bloomberg license. */
  ManagementCost = 'ManagementCost',
  ManagementFee = 'ManagementFee',
  Rebate = 'Rebate',
  TaxRestitution = 'TaxRestitution'
}

export type FieldDataItem = {
  __typename?: 'FieldDataItem';
  field?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type FilterInput = {
  clientIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  statusIn?: InputMaybe<Array<DocumentStatusEnum>>;
};

export type FredObservation = {
  __typename?: 'FredObservation';
  date?: Maybe<Scalars['Date']['output']>;
  realtime_end?: Maybe<Scalars['Date']['output']>;
  realtime_start?: Maybe<Scalars['Date']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FredQueryArgs = {
  retries?: InputMaybe<Scalars['Int']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
};

export type FredSeries = {
  __typename?: 'FredSeries';
  frequency?: Maybe<Scalars['String']['output']>;
  frequency_short?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_updated?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  observation_end?: Maybe<Scalars['Date']['output']>;
  observation_start?: Maybe<Scalars['Date']['output']>;
  popularity?: Maybe<Scalars['Int']['output']>;
  realtime_end?: Maybe<Scalars['Date']['output']>;
  realtime_start?: Maybe<Scalars['Date']['output']>;
  seasonal_adjustment?: Maybe<Scalars['String']['output']>;
  seasonal_adjustment_short?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  units?: Maybe<Scalars['String']['output']>;
  units_short?: Maybe<Scalars['String']['output']>;
};

export type FundPerformance = {
  __typename?: 'FundPerformance';
  cashFlows?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  currency?: Maybe<CurrencyEnum>;
  dates?: Maybe<Array<Maybe<Scalars['GraphQLDateString']['output']>>>;
  endValue?: Maybe<Scalars['Float']['output']>;
  fund?: Maybe<Party>;
  fundId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  instrumentPerformances?: Maybe<Array<Maybe<InstrumentPerformance>>>;
  performanceItems?: Maybe<Array<Maybe<PortfolioPerformanceItem>>>;
  series?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type FundPortfolioPerformance = {
  __typename?: 'FundPortfolioPerformance';
  cashFlows?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  currency?: Maybe<CurrencyEnum>;
  dates?: Maybe<Array<Maybe<Scalars['GraphQLDateString']['output']>>>;
  endValue?: Maybe<Scalars['Float']['output']>;
  fundPerformances?: Maybe<Array<Maybe<FundPerformance>>>;
  id: Scalars['GraphQLObjectId']['output'];
  instrumentPerformances?: Maybe<Array<Maybe<InstrumentPerformance>>>;
  performanceItems?: Maybe<Array<Maybe<PortfolioPerformanceItem>>>;
  series?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export enum FundReportComponentEnum {
  AttributionMonth = 'AttributionMonth',
  AtttributionTotal = 'AtttributionTotal',
  BarReturnsMonth = 'BarReturnsMonth',
  BarReturnsYearly = 'BarReturnsYearly',
  CdsIndexComponents = 'CdsIndexComponents',
  CdsIndexEsgScreenings = 'CdsIndexEsgScreenings',
  CdsIndexHYComponents = 'CdsIndexHYComponents',
  CdsIndexIGComponents = 'CdsIndexIGComponents',
  CountryPieChart = 'CountryPieChart',
  CreditRating = 'CreditRating',
  CreditSpreadRisk = 'CreditSpreadRisk',
  CurrencyBarChart = 'CurrencyBarChart',
  CurrencyPieChart = 'CurrencyPieChart',
  EsgCategory = 'EsgCategory',
  InterestRateBuckets = 'InterestRateBuckets',
  KeyNumbers = 'KeyNumbers',
  ReturnVsVolatility = 'ReturnVsVolatility',
  Sectors = 'Sectors',
  SustainableDevelopmentGoals = 'SustainableDevelopmentGoals',
  TopHoldings = 'TopHoldings',
  TopIssuers = 'TopIssuers',
  TransitionCompanies = 'TransitionCompanies',
  UseOfProceeds = 'UseOfProceeds'
}

export enum FundReportEnum {
  Benchmark = 'Benchmark',
  Bonds = 'Bonds',
  Derivatives = 'Derivatives',
  Equities = 'Equities',
  Leverage = 'Leverage'
}

export enum FundTypeEnum {
  AIF = 'AIF',
  UCITS = 'UCITS'
}

export type FundUnit = {
  __typename?: 'FundUnit';
  instrument: Instrument;
  instrumentId: Scalars['GraphQLObjectId']['output'];
  totalUnits?: Maybe<Scalars['Float']['output']>;
};

export type FundUnitReconciliationType = {
  __typename?: 'FundUnitReconciliationType';
  calculatedNbr?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  custodianAccountNumber?: Maybe<Scalars['String']['output']>;
  date: Scalars['GraphQLDateString']['output'];
  diff?: Maybe<Scalars['Float']['output']>;
  instrument?: Maybe<Instrument>;
  instrumentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  isin?: Maybe<Scalars['String']['output']>;
  party?: Maybe<PartyInfo>;
  partyId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  reportedId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  reportedNbr?: Maybe<Scalars['Float']['output']>;
  reporter?: Maybe<PartyInfo>;
  reporterId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  shareRegisterDiff?: Maybe<Scalars['Float']['output']>;
  shareRegisterNbr?: Maybe<Scalars['Float']['output']>;
  unitsAfterOrders?: Maybe<Scalars['String']['output']>;
};

export type FxValuation = {
  __typename?: 'FxValuation';
  currency?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  instrumentId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

export type GlobalStandardScreen = {
  __typename?: 'GlobalStandardScreen';
  comment: Scalars['String']['output'];
  date: Scalars['GraphQLDateString']['output'];
  norm: StandardScreenNorm;
  principle: StandardScreenPrinciple;
  status: StandardScreenStatus;
};

export type GlobalStandardScreenInput = {
  comment: Scalars['String']['input'];
  date: Scalars['GraphQLDateString']['input'];
  norm: StandardScreenNorm;
  principle: StandardScreenPrinciple;
  status: StandardScreenStatus;
};

export type HistoricalData = {
  __typename?: 'HistoricalData';
  dates?: Maybe<Array<Maybe<Scalars['GraphQLDateString']['output']>>>;
  eidDataArray?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  field?: Maybe<Scalars['String']['output']>;
  fieldExceptionsArray?: Maybe<Array<RefDataFieldExceptionsArray>>;
  id?: Maybe<Scalars['GraphQLObjectId']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  security?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  securityError?: Maybe<Array<RefDataError>>;
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export enum HistoricalFieldsEnum {
  PX_LAST = 'PX_LAST',
  PX_VOLUME = 'PX_VOLUME'
}

export type ImportBondTradeInput = {
  /** Name or _id */
  accountAlias: Scalars['String']['input'];
  accruedInterest?: InputMaybe<Scalars['Float']['input']>;
  bestExecutionType: BestExecutionType;
  /** Name/LEI/_id */
  brokerAlias: Scalars['String']['input'];
  carryOwnCostDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  currency: CurrencyEnum;
  externalId: Scalars['String']['input'];
  /** Name/ISIN/BloombergTicker/_id */
  instrumentAlias: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
  source: SourceType;
  status?: InputMaybe<TransactionStatus>;
  /** String on format YYYY-MM-DD or timeStamp */
  tradeTimestamp: Scalars['DateStringOrTimestamp']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};

export type ImportCloseDerivativeTradeInput = {
  amount: Scalars['Float']['input'];
  carryOwnCostDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  externalId: Scalars['String']['input'];
  source: SourceType;
  status?: InputMaybe<TransactionStatus>;
  /** String on format YYYY-MM-DD or timeStamp */
  tradeTimestamp: Scalars['DateStringOrTimestamp']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};

export type ImportCollateralInput = {
  /** Name or _id */
  accountAlias: Scalars['String']['input'];
  agreementType: AgreementType;
  /** Counterparty - Name/LEI/_id */
  brokerAlias: Scalars['String']['input'];
  currency: CurrencyEnum;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** To determine if variation margin/initial margin collateral */
  initialMargin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name/ISIN/BloombergTicker/_id */
  instrumentAlias: Scalars['String']['input'];
  /** To determine if loan -> itemType SecurityLoan or collateral -> itemType CollateralPledge */
  loan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Collateral quantity */
  quantity: Scalars['Float']['input'];
  status?: InputMaybe<TransactionStatus>;
  /** String on format YYYY-MM-DD or timeStamp */
  tradeTimestamp: Scalars['DateStringOrTimestamp']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};

export type ImportCouponInput = {
  /** Name or _id */
  accountAlias: Scalars['String']['input'];
  agreementType?: InputMaybe<AgreementType>;
  amount: Scalars['Float']['input'];
  /** Name/LEI/_id */
  brokerAlias?: InputMaybe<Scalars['String']['input']>;
  currency: CurrencyEnum;
  externalId: Scalars['String']['input'];
  foreignTax?: InputMaybe<Scalars['Float']['input']>;
  /** Name/ISIN/BloombergTicker/_id */
  instrumentAlias: Scalars['String']['input'];
  source: SourceType;
  status?: InputMaybe<TransactionStatus>;
  /** String on format YYYY-MM-DD or timeStamp */
  tradeTimestamp: Scalars['DateStringOrTimestamp']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};

export type ImportCreateRedeemInput = {
  /** Name or _id */
  accountAlias: Scalars['String']['input'];
  accountSwitchOrder?: InputMaybe<Scalars['Boolean']['input']>;
  accountingAmount: Scalars['Float']['input'];
  adjustmentAmount?: InputMaybe<Scalars['Float']['input']>;
  adjustmentShares?: InputMaybe<Scalars['Float']['input']>;
  amount: Scalars['Float']['input'];
  currency: CurrencyEnum;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  /** Name/ISIN/BloombergTicker/_id */
  instrumentAlias: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
  status?: InputMaybe<TransactionStatus>;
  /** String on format YYYY-MM-DD or timeStamp */
  tradeTimestamp: Scalars['GraphQLDateString']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};

export type ImportDerivativeTradeInput = {
  /** Name or _id */
  accountAlias: Scalars['String']['input'];
  accruedInterest?: InputMaybe<Scalars['Float']['input']>;
  agreementType: AgreementType;
  bestExecutionType: BestExecutionType;
  /** Name/LEI/_id */
  brokerAlias: Scalars['String']['input'];
  carryOwnCostDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  /** Name/LEI/_id(only necessary for agreementType: ClearingAccount and OmnibusClearingAccount) */
  clearingBrokerAlias?: InputMaybe<Scalars['String']['input']>;
  /** Name/LEI/_id (only necessary for agreementType: ClearingAccount and OmnibusClearingAccount) */
  clearingHouseAlias?: InputMaybe<Scalars['String']['input']>;
  currency: CurrencyEnum;
  externalId: Scalars['String']['input'];
  /** Name/ISIN/BloombergTicker/_id */
  instrumentAlias: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Float']['input'];
  source: SourceType;
  status?: InputMaybe<TransactionStatus>;
  /** String on format YYYY-MM-DD or timeStamp */
  tradeTimestamp: Scalars['DateStringOrTimestamp']['input'];
  uniqueTradeId: Scalars['String']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};

export type ImportDividendInput = {
  /** Name or _id */
  accountAlias: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  currency: CurrencyEnum;
  /** Default: False */
  dividendPaid?: InputMaybe<Scalars['Boolean']['input']>;
  externalId: Scalars['String']['input'];
  /** ForeignTax amount */
  foreignTax?: InputMaybe<Scalars['Float']['input']>;
  /** Name/ISIN/BloombergTicker/_id */
  instrumentAlias: Scalars['String']['input'];
  source: SourceType;
  status?: InputMaybe<TransactionStatus>;
  /** Default: False */
  taxRestitution?: InputMaybe<Scalars['Boolean']['input']>;
  /** String on format YYYY-MM-DD or timeStamp */
  tradeTimestamp: Scalars['DateStringOrTimestamp']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};

export type ImportExpiryDerivativeTradeInput = {
  carryOwnCostDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  externalId: Scalars['String']['input'];
  source: SourceType;
  status?: InputMaybe<TransactionStatus>;
};

export type ImportFeeInterestInput = {
  /** Name or _id */
  accountAlias: Scalars['String']['input'];
  agreementType?: InputMaybe<AgreementType>;
  amount: Scalars['Float']['input'];
  /** Name/LEI/_id */
  brokerAlias?: InputMaybe<Scalars['String']['input']>;
  currency: CurrencyEnum;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  foreignTax?: InputMaybe<Scalars['Float']['input']>;
  /** Name/ISIN/BloombergTicker/_id */
  instrumentAlias: Scalars['String']['input'];
  itemType: FeeInterestItemType;
  rounding?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<TransactionStatus>;
  /** String on format YYYY-MM-DD or timeStamp */
  tradeTimestamp: Scalars['DateStringOrTimestamp']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};

export type ImportFundTradeInput = {
  /** Name or _id, will use default if not stated */
  accountAlias?: InputMaybe<Scalars['String']['input']>;
  /** Need to state amount + quantity or quantity + price */
  amount?: InputMaybe<Scalars['Float']['input']>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  currency: CurrencyEnum;
  /** Name or _id, will use default security external account if not stated */
  externalAccountAlias?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** If set, settle in accounting currency */
  fxRate?: InputMaybe<Scalars['Float']['input']>;
  /** Name/ISIN/BloombergTicker/_id */
  instrumentAlias: Scalars['String']['input'];
  /** Need to state amount + quantity or quantity + price */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Need to state amount + quantity or quantity + price */
  quantity: Scalars['Float']['input'];
  reinvestedDividend?: InputMaybe<Scalars['Boolean']['input']>;
  reinvestedRebate?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<TransactionStatus>;
  /** String on format YYYY-MM-DD or timeStamp */
  tradeTimestamp: Scalars['DateStringOrTimestamp']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};

export type ImportFxSpotInput = {
  /** Name or _id */
  accountAlias: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  bestExecutionType: BestExecutionType;
  /** Name/LEI/_id */
  brokerAlias: Scalars['String']['input'];
  brokerTradeId?: InputMaybe<Scalars['String']['input']>;
  carryOwnCostDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  currency: CurrencyEnum;
  externalId: Scalars['String']['input'];
  /** If related to fxSwap, should be set to the fxSwap derivativeTrade */
  parentId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  /** Name or _id, if not stated, will be set to accountAlias or default on party instrument */
  secondAccountAlias?: InputMaybe<Scalars['String']['input']>;
  secondAmount: Scalars['Float']['input'];
  secondCurrency: CurrencyEnum;
  source: SourceType;
  status?: InputMaybe<TransactionStatus>;
  /** String on format YYYY-MM-DD or timeStamp */
  tradeTimestamp: Scalars['DateStringOrTimestamp']['input'];
  uniqueTradeId?: InputMaybe<Scalars['String']['input']>;
  valueDate: Scalars['GraphQLDateString']['input'];
};

export type ImportInsertCashInput = {
  /** Name or _id */
  accountAlias: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  currency: CurrencyEnum;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Name/ISIN/BloombergTicker/_id */
  instrumentAlias: Scalars['String']['input'];
  status?: InputMaybe<TransactionStatus>;
  /** String on format YYYY-MM-DD or timeStamp */
  tradeTimestamp: Scalars['DateStringOrTimestamp']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};

export type ImportInsertDerivativeTradeInput = {
  /** Name or _id */
  accountAlias: Scalars['String']['input'];
  agreementType: AgreementType;
  /** Name/LEI/_id */
  brokerAlias: Scalars['String']['input'];
  /** Name/LEI/_id (only necessary for agreementType: ClearingAccount and OmnibusClearingAccount) */
  clearingBrokerAlias?: InputMaybe<Scalars['String']['input']>;
  /** Name/LEI/_id (only necessary for agreementType: ClearingAccount and OmnibusClearingAccount) */
  clearingHouseAlias?: InputMaybe<Scalars['String']['input']>;
  currency: CurrencyEnum;
  /** Name/ISIN/BloombergTicker/_id */
  instrumentAlias: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
  status?: InputMaybe<TransactionStatus>;
  /** String on format YYYY-MM-DD or timeStamp */
  tradeTimestamp: Scalars['DateStringOrTimestamp']['input'];
  uniqueTradeId: Scalars['String']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};

export type ImportInsertSecurityInput = {
  /** Name or _id */
  accountAlias: Scalars['String']['input'];
  /** Need to state amount + quantity or quantity + price */
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency: CurrencyEnum;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Name/ISIN/BloombergTicker/_id */
  instrumentAlias: Scalars['String']['input'];
  /** Need to state amount + quantity or quantity + price */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Need to state amount + quantity or quantity + price */
  quantity: Scalars['Float']['input'];
  status?: InputMaybe<TransactionStatus>;
  /** String on format YYYY-MM-DD or timeStamp */
  tradeTimestamp: Scalars['DateStringOrTimestamp']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};

export type ImportStockTradeInput = {
  /** Name or _id */
  accountAlias: Scalars['String']['input'];
  bestExecutionType: BestExecutionType;
  /** Name/LEI/_id */
  brokerAlias?: InputMaybe<Scalars['String']['input']>;
  carryOwnCostDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  currency: CurrencyEnum;
  externalId: Scalars['String']['input'];
  /** Name/ISIN/BloombergTicker/_id */
  instrumentAlias: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  quantity: Scalars['Float']['input'];
  source: SourceType;
  stampDuty?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<TransactionStatus>;
  /** String on format YYYY-MM-DD or timeStamp */
  tradeTimestamp: Scalars['DateStringOrTimestamp']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};

export type ImportTransferInput = {
  /** Name or _id */
  accountAlias: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  bestExecutionType: BestExecutionType;
  /** Name/LEI/_id */
  brokerAlias?: InputMaybe<Scalars['String']['input']>;
  carryOwnCostDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  currency: CurrencyEnum;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Name/ISIN/BloombergTicker/_id */
  instrumentAlias: Scalars['String']['input'];
  /** Name or _id, if not stated, will be set to accountAlias or default on party instrument */
  secondAccountAlias?: InputMaybe<Scalars['String']['input']>;
  secondAmount: Scalars['Float']['input'];
  secondCurrency: CurrencyEnum;
  /** Name/ISIN/BloombergTicker/_id */
  secondInstrumentAlias: Scalars['String']['input'];
  status?: InputMaybe<TransactionStatus>;
  /** String on format YYYY-MM-DD or timeStamp */
  tradeTimestamp: Scalars['DateStringOrTimestamp']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};

export type Instrument = {
  __typename?: 'Instrument';
  _id: Scalars['GraphQLObjectId']['output'];
  account?: Maybe<PartyAccount>;
  accountId: Scalars['GraphQLObjectId']['output'];
  accruedInterest?: Maybe<Scalars['Float']['output']>;
  /**
   * Accrued interest using only model cash-flows and thus much quicker than
   * bootstrapping all curves needed for risk parameters above
   */
  accruedInterestOnly?: Maybe<Scalars['Float']['output']>;
  aliases: Array<Alias>;
  benchmark?: Maybe<Instrument>;
  benchmarkId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  bic: Scalars['String']['output'];
  bloombergDailyDownload: Scalars['Boolean']['output'];
  bloombergQuoteMultiplier: Scalars['Float']['output'];
  bloombergTicker?: Maybe<Scalars['String']['output']>;
  category?: Maybe<InstrumentCategory>;
  /** cic is computed from cicArea and cicType, or guessed */
  cic?: Maybe<Scalars['String']['output']>;
  cicArea?: Maybe<CicAreaEnum>;
  cicType?: Maybe<CicTypeEnum>;
  cleanPrice?: Maybe<Scalars['Float']['output']>;
  clientIds: Array<Scalars['GraphQLObjectId']['output']>;
  clients: Array<Party>;
  /** Calculated country of listing */
  countryOfListing?: Maybe<Scalars['String']['output']>;
  couponFrequency?: Maybe<Scalars['Int']['output']>;
  couponRate?: Maybe<Scalars['Float']['output']>;
  creditQualityStep?: Maybe<Scalars['Int']['output']>;
  /** Calculated credit ratings */
  creditRating?: Maybe<Scalars['String']['output']>;
  creditRatings?: Maybe<Array<PartyCreditRating>>;
  creditYieldDelta?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<CurrencyEnum>;
  description?: Maybe<Scalars['String']['output']>;
  exchange?: Maybe<Scalars['String']['output']>;
  extensions: Array<Extension>;
  externalAccount?: Maybe<PartyExternalAccount>;
  externalAccountId: Scalars['GraphQLObjectId']['output'];
  /** First trade date if traded */
  firstTradeDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  /** First external account id if traded */
  firstTradeExternalAccountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  /** First transaction id if traded */
  firstTradeTransactionId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  iban: Scalars['String']['output'];
  id: Scalars['GraphQLObjectId']['output'];
  interestRateYieldDelta?: Maybe<Scalars['Float']['output']>;
  isin?: Maybe<Scalars['String']['output']>;
  issuer?: Maybe<Party>;
  issuerId: Scalars['GraphQLObjectId']['output'];
  issuerProgram?: Maybe<IssuerProgram>;
  issuerProgramId: Scalars['GraphQLObjectId']['output'];
  longName?: Maybe<Scalars['String']['output']>;
  /** Always true after first margin call transaction has been created */
  marginCallsMade?: Maybe<Scalars['Boolean']['output']>;
  maturityDate?: Maybe<Scalars['String']['output']>;
  /** https://www.iso20022.org/market-identifier-codes */
  mic?: Maybe<Scalars['String']['output']>;
  model?: Maybe<InstrumentModel>;
  /** For derivative models where we trade one unit and notional is on model, modelNotionalScaling can be used to match counterparty notional */
  modelNotionalScaling?: Maybe<Scalars['Float']['output']>;
  modelSubType?: Maybe<InstrumentModelSubTypeEnum>;
  /** Calculated fields from model */
  modelType?: Maybe<InstrumentModelTypeEnum>;
  name?: Maybe<Scalars['String']['output']>;
  placeOfSettlementId: Scalars['GraphQLObjectId']['output'];
  /**
   * Swaplab2 calculated properties. If no date given default to yesterday.
   * Not optimal but for now. Should be last business day but hard without
   * calendars
   */
  presentValue?: Maybe<Scalars['Float']['output']>;
  productType?: Maybe<InstrumentProductTypeEnum>;
  /** Time series value at date - null if no quote found for that date */
  px?: Maybe<DateValue>;
  /** Last available time series value */
  pxLast?: Maybe<DateValue>;
  quantityDecimals?: Maybe<Scalars['Int']['output']>;
  /** Quote at date - null if no quote found for that date */
  quote?: Maybe<DateQuote>;
  /** Last available time series value */
  quoteLast?: Maybe<DateQuote>;
  /** Used as issueDate */
  startDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  /** If exchanged is asked for, only exchanged is returned */
  timeSeries?: Maybe<Array<TimeSeries>>;
  type: InstrumentTypeEnum;
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  /** Id of the user that updated/created */
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  valuations?: Maybe<InstrumentValuation>;
  /** A list of versions of the document */
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
  /**
   * Yield to maturity (YTM) is the discount rate y that makes the present
   * value of all future cash flows equal to the bond's current price using
   * Bonds Day Count Convention
   */
  yield?: Maybe<Scalars['Float']['output']>;
  /**
   * Yield to maturity (YTM) Actual/360 is the discount rate y that makes the present
   * value of all future cash flows equal to the bond's current price using
   * Actual/360 day count convention
   */
  yieldActual360?: Maybe<Scalars['Float']['output']>;
  zeroSpread?: Maybe<Scalars['Float']['output']>;
};


export type InstrumentAccruedInterestArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type InstrumentAccruedInterestOnlyArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type InstrumentCleanPriceArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type InstrumentCreditYieldDeltaArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type InstrumentFirstTradeDateArgs = {
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
};


export type InstrumentFirstTradeExternalAccountIdArgs = {
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
};


export type InstrumentFirstTradeTransactionIdArgs = {
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
};


export type InstrumentInterestRateYieldDeltaArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type InstrumentPresentValueArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type InstrumentPxArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type InstrumentPxLastArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type InstrumentQuoteArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type InstrumentQuoteLastArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type InstrumentTimeSeriesArgs = {
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  exchanged?: InputMaybe<CurrencyEnum>;
  fxHedged?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  typeIn?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type InstrumentValuationsArgs = {
  currency?: InputMaybe<CurrencyEnum>;
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type InstrumentYieldArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type InstrumentYieldActual360Args = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type InstrumentZeroSpreadArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};

export type InstrumentAccountPosition = {
  __typename?: 'InstrumentAccountPosition';
  account?: Maybe<PartyAccount>;
  accountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  client?: Maybe<Party>;
  clientId: Scalars['GraphQLObjectId']['output'];
  currency: CurrencyEnum;
  externalAccount?: Maybe<PartyExternalAccount>;
  externalAccountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
  quantity: Scalars['Float']['output'];
};

export enum InstrumentCategory {
  Alternative = 'Alternative',
  CashAccount = 'CashAccount',
  Equity = 'Equity',
  Fx = 'Fx',
  HedgeFund = 'HedgeFund',
  Interest = 'Interest',
  InterestRate = 'InterestRate',
  Liability = 'Liability',
  Margin = 'Margin',
  None = 'None',
  RealEstate = 'RealEstate',
  System = 'System'
}

export type InstrumentFilterInput = {
  bloombergDailyDownload?: InputMaybe<Scalars['Boolean']['input']>;
  bloombergTickerIn?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryIn?: InputMaybe<Array<InstrumentCategory>>;
  categoryNotIn?: InputMaybe<Array<InstrumentCategory>>;
  currencyIn?: InputMaybe<Array<CurrencyEnum>>;
  currencyNotIn?: InputMaybe<Array<CurrencyEnum>>;
  exchangeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  exchangeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  isinIn?: InputMaybe<Array<Scalars['ISIN']['input']>>;
  isinNotIn?: InputMaybe<Array<Scalars['ISIN']['input']>>;
  issuerIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  issuerProgramIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  modelTypeIn?: InputMaybe<Array<InstrumentModelTypeEnum>>;
  modelTypeNotIn?: InputMaybe<Array<InstrumentModelTypeEnum>>;
  productTypeIn?: InputMaybe<Array<InstrumentProductTypeEnum>>;
  productTypeNotIn?: InputMaybe<Array<InstrumentProductTypeEnum>>;
  statusIn?: InputMaybe<Array<InstrumentStatusEnum>>;
  typeIn?: InputMaybe<Array<InstrumentTypeEnum>>;
  updatedAfter?: InputMaybe<Scalars['Timestamp']['input']>;
  updatedBefore?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type InstrumentModel = {
  __typename?: 'InstrumentModel';
  _t: InstrumentModelTypeEnum;
  accountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  clientId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  expiryDate?: Maybe<Scalars['GraphQLPatchInstrumentDate']['output']>;
  legs?: Maybe<Array<InstrumentModelLegsItem>>;
  notionalScaling?: Maybe<Scalars['Float']['output']>;
  objectId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  objectType?: Maybe<InstrumentModelObjectTypeEnum>;
  quoteCurrency: CurrencyEnum;
  quoteType: Scalars['String']['output'];
  startDate?: Maybe<Scalars['GraphQLPatchInstrumentDate']['output']>;
  type: InstrumentModelTypeEnum;
};

export type InstrumentModelInput = {
  _t: InstrumentModelTypeEnum;
  accountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  expiryDate?: InputMaybe<Scalars['GraphQLPatchInstrumentDate']['input']>;
  legs?: InputMaybe<Array<InstrumentModelLegsItemInput>>;
  notionalScaling?: InputMaybe<Scalars['Float']['input']>;
  objectId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  objectType?: InputMaybe<InstrumentModelObjectTypeEnum>;
  quoteCurrency: CurrencyEnum;
  quoteType: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['GraphQLPatchInstrumentDate']['input']>;
};

export enum InstrumentModelLegFixingTypesEnum {
  Compound = 'Compound',
  Single = 'Single'
}

export enum InstrumentModelLegTypesEnum {
  CashFlowLeg = 'CashFlowLeg',
  EquityBasketOptionLeg = 'EquityBasketOptionLeg',
  EquityUnitOptionLeg = 'EquityUnitOptionLeg',
  FixedAmountLeg = 'FixedAmountLeg',
  FixedRateLeg = 'FixedRateLeg',
  FloatRateLeg = 'FloatRateLeg',
  FtaLeg = 'FtaLeg',
  GenericFixedAmountLeg = 'GenericFixedAmountLeg',
  GenericFixedRateLeg = 'GenericFixedRateLeg',
  GenericFloatRateLeg = 'GenericFloatRateLeg',
  SwaptionLeg = 'SwaptionLeg'
}

export type InstrumentModelLegsItem = {
  __typename?: 'InstrumentModelLegsItem';
  _t: InstrumentModelLegTypesEnum;
  calendars: Array<Scalars['String']['output']>;
  call?: Maybe<Scalars['Boolean']['output']>;
  cashFlows?: Maybe<Array<InstrumentModelLegsItemCashFlowsItem>>;
  creditSpread?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<CurrencyEnum>;
  dayAdjustment: DayAdjustmentEnum;
  dayCount?: Maybe<Scalars['String']['output']>;
  exercise?: Maybe<Scalars['String']['output']>;
  expiry?: Maybe<Scalars['GraphQLPatchInstrumentDate']['output']>;
  fixingType?: Maybe<Scalars['String']['output']>;
  flatAdjustment?: Maybe<Scalars['Float']['output']>;
  issuerId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  longStub?: Maybe<Scalars['Boolean']['output']>;
  maturityDate?: Maybe<Scalars['GraphQLPatchInstrumentDate']['output']>;
  maturityPeriod?: Maybe<Scalars['String']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
  notional?: Maybe<Scalars['Int']['output']>;
  payLeg: Scalars['Boolean']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  rateIndexId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  recoveryRate?: Maybe<Scalars['Float']['output']>;
  relativeAdjustment?: Maybe<Scalars['Float']['output']>;
  rollingDate?: Maybe<Scalars['GraphQLPatchInstrumentDate']['output']>;
  rollingPeriod?: Maybe<Scalars['String']['output']>;
  settlementType?: Maybe<Scalars['String']['output']>;
  spread?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['GraphQLPatchInstrumentDate']['output']>;
  startDateOffset?: Maybe<Scalars['Int']['output']>;
  startPeriod?: Maybe<Scalars['String']['output']>;
  strike?: Maybe<Scalars['Float']['output']>;
  type: InstrumentModelLegTypesEnum;
  ultimateForwardRate?: Maybe<Scalars['Float']['output']>;
  underlyingId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  underlyingInstrument?: Maybe<Instrument>;
  underlyings?: Maybe<Array<InstrumentModelLegsItemUnderlyingsItem>>;
  volatility?: Maybe<Scalars['Float']['output']>;
  zeroFloor?: Maybe<Scalars['Boolean']['output']>;
};

export type InstrumentModelLegsItemCashFlowsItem = {
  __typename?: 'InstrumentModelLegsItemCashFlowsItem';
  endDate?: Maybe<Scalars['GraphQLPatchInstrumentDate']['output']>;
  exDate: Scalars['GraphQLPatchInstrumentDate']['output'];
  fixings?: Maybe<Array<InstrumentModelLegsItemCashFlowsItemFixingsItem>>;
  notional: Scalars['Float']['output'];
  payDate: Scalars['GraphQLPatchInstrumentDate']['output'];
  startDate?: Maybe<Scalars['GraphQLPatchInstrumentDate']['output']>;
};

export type InstrumentModelLegsItemCashFlowsItemFixingsItem = {
  __typename?: 'InstrumentModelLegsItemCashFlowsItemFixingsItem';
  date: Scalars['GraphQLPatchInstrumentDate']['output'];
  endDate: Scalars['GraphQLPatchInstrumentDate']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  startDate: Scalars['GraphQLPatchInstrumentDate']['output'];
};

export type InstrumentModelLegsItemCashFlowsItemFixingsItemInput = {
  date: Scalars['GraphQLPatchInstrumentDate']['input'];
  endDate: Scalars['GraphQLPatchInstrumentDate']['input'];
  rate?: InputMaybe<Scalars['Float']['input']>;
  startDate: Scalars['GraphQLPatchInstrumentDate']['input'];
};

export type InstrumentModelLegsItemCashFlowsItemInput = {
  endDate?: InputMaybe<Scalars['GraphQLPatchInstrumentDate']['input']>;
  exDate: Scalars['GraphQLPatchInstrumentDate']['input'];
  fixings?: InputMaybe<Array<InstrumentModelLegsItemCashFlowsItemFixingsItemInput>>;
  notional: Scalars['Float']['input'];
  payDate: Scalars['GraphQLPatchInstrumentDate']['input'];
  startDate?: InputMaybe<Scalars['GraphQLPatchInstrumentDate']['input']>;
};

export type InstrumentModelLegsItemInput = {
  _t: InstrumentModelLegTypesEnum;
  calendars: Array<Scalars['String']['input']>;
  call?: InputMaybe<Scalars['Boolean']['input']>;
  cashFlows?: InputMaybe<Array<InstrumentModelLegsItemCashFlowsItemInput>>;
  creditSpread?: InputMaybe<Scalars['Float']['input']>;
  currency: CurrencyEnum;
  dayAdjustment: DayAdjustmentEnum;
  dayCount?: InputMaybe<Scalars['String']['input']>;
  exercise?: InputMaybe<Scalars['String']['input']>;
  expiry?: InputMaybe<Scalars['GraphQLPatchInstrumentDate']['input']>;
  fixingType?: InputMaybe<Scalars['String']['input']>;
  flatAdjustment?: InputMaybe<Scalars['Float']['input']>;
  issuerId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  longStub?: InputMaybe<Scalars['Boolean']['input']>;
  maturityDate?: InputMaybe<Scalars['GraphQLPatchInstrumentDate']['input']>;
  maturityPeriod?: InputMaybe<Scalars['String']['input']>;
  multiplier?: InputMaybe<Scalars['Float']['input']>;
  notional?: InputMaybe<Scalars['Int']['input']>;
  payLeg: Scalars['Boolean']['input'];
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateIndexId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  recoveryRate?: InputMaybe<Scalars['Float']['input']>;
  relativeAdjustment?: InputMaybe<Scalars['Float']['input']>;
  rollingDate?: InputMaybe<Scalars['GraphQLPatchInstrumentDate']['input']>;
  rollingPeriod?: InputMaybe<Scalars['String']['input']>;
  settlementType?: InputMaybe<Scalars['String']['input']>;
  spread?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['GraphQLPatchInstrumentDate']['input']>;
  startDateOffset?: InputMaybe<Scalars['Int']['input']>;
  startPeriod?: InputMaybe<Scalars['String']['input']>;
  strike?: InputMaybe<Scalars['Float']['input']>;
  ultimateForwardRate?: InputMaybe<Scalars['Float']['input']>;
  underlyingId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  underlyings?: InputMaybe<Array<InstrumentModelLegsItemUnderlyingsItemInput>>;
  volatility?: InputMaybe<Scalars['Float']['input']>;
  zeroFloor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InstrumentModelLegsItemUnderlyingsItem = {
  __typename?: 'InstrumentModelLegsItemUnderlyingsItem';
  instrumentId: Scalars['String']['output'];
  quanto: Scalars['Boolean']['output'];
  startPrice: Scalars['Float']['output'];
  weight: Scalars['Float']['output'];
};

export type InstrumentModelLegsItemUnderlyingsItemInput = {
  instrumentId: Scalars['String']['input'];
  quanto: Scalars['Boolean']['input'];
  startPrice: Scalars['Float']['input'];
  weight: Scalars['Float']['input'];
};

export enum InstrumentModelObjectTypeEnum {
  Account = 'Account',
  Client = 'Client',
  Instrument = 'Instrument',
  Portfolio = 'Portfolio'
}

export enum InstrumentModelSubTypeEnum {
  Fixed = 'Fixed',
  Float = 'Float',
  Payer = 'Payer',
  PayerSwaption = 'PayerSwaption',
  Receiver = 'Receiver',
  ReceiverSwaption = 'ReceiverSwaption'
}

export enum InstrumentModelTypeEnum {
  /** Balance model is used for bank accounts and such, a placeholder for a currency position. */
  Balance = 'Balance',
  /**
   * Bond model is used for fixed coupon bonds, floating rate bonds and zero coupon bonds.
   * The model needs one fixed amount leg for principal and one coupon leg for coupons.
   * For zero coupon bonds, use fixed rate leg type and 0 coupon.
   */
  Bond = 'Bond',
  /**
   * DO NOT USE! CashFlowEngineering is not implemented.
   * @deprecated DO NOT USE! CashFlowEngineering is not implemented.
   */
  CashFlowEngineering = 'CashFlowEngineering',
  /**
   * CdsBasket model is used for valuation of a custom CDS Basket traded as a warrant, i.e.
   * as a transferable security.
   */
  CdsBasket = 'CdsBasket',
  /** CdsIndex model is used for standard CDS index instruments cleared at a CCP. */
  CdsIndex = 'CdsIndex',
  /**
   * DO NOT USE! NOT IMPLEMENTED IN SWAPLAB2! EquityBasketOption model is used for valuations of
   * equity basket options. Volatility surfaces are stored in system.
   * @deprecated DO NOT USE! NOT IMPLEMENTED IN SWAPLAB2!
   */
  EquityBasketOption = 'EquityBasketOption',
  /**
   * DO NOT USE! NOT IMPLEMENTED IN SWAPLAB2! EquityUnitOption model is used for valuations of
   * single underlying equity options. Volatility surfaces are stored in system.
   * @deprecated DO NOT USE! NOT IMPLEMENTED IN SWAPLAB2!
   */
  EquityUnitOption = 'EquityUnitOption',
  /** Etf model is a spot valuation model used for all Exchange-Traded Funds. */
  Etf = 'Etf',
  /**
   * DO NOT USE! NOT IMPLEMENTED IN SWAPLAB2! Fta model is used for liability valuation.
   * @deprecated DO NOT USE! NOT IMPLEMENTED IN SWAPLAB2!
   */
  Fta = 'Fta',
  /**
   * FundExternal model is used for fund instruments not connected to their own portfolio within the system.
   * The valuation has to be provided from external source.
   */
  FundExternal = 'FundExternal',
  /**
   * FundInternal model is used for fund instruments linked to their own portfolio within the system. The issuerId field
   * serves as a link to the portfolio and can be used for more advanced calculations.
   */
  FundInternal = 'FundInternal',
  /**
   * FXSwap model is used for the outright leg of an FX Swap position. Model uses a set of FixedAmountLegs
   * in different currencies.
   */
  FxSwap = 'FxSwap',
  /**
   * GenericDeposit model is used for generic deposit instruments used in curve building.
   * This instrument type should never be connected to a traded position.
   */
  GenericDeposit = 'GenericDeposit',
  /**
   * GenericFxSpot model is used for generic swap instruments used in curve building.
   * This instrument type should never be connected to a traded position.
   */
  GenericFxSpot = 'GenericFxSpot',
  /**
   * GenericFxSwap model is used for generic swap instruments used in curve building.
   * This instrument type should never be connected to a traded position.
   */
  GenericFxSwap = 'GenericFxSwap',
  /**
   * GenericSwap model is used for generic swap instruments used in curve building.
   * This instrument type should never be connected to a traded position.
   */
  GenericSwap = 'GenericSwap',
  /** Loan model is used for loans. Valuation is a clean price of one an accrued interest */
  Loan = 'Loan',
  /** LoanCollateral model is used for collateralized loans. Valuation is a sum of collateral for a specific loan int he loans currency */
  LoanCollateral = 'LoanCollateral',
  /**
   * SHOULD NEVER BE SET MANUALLY! Pending model is set for trades uploaded where no instrument exists in system. A fund can not be valued
   * while an instrument with model type Pending exists in the underlying portfolio.
   */
  Pending = 'Pending',
  /**
   * DEPRECATED! PortfolioSwap model is the OLD Portfolio Swap model based on keeping positions
   * using swap counterparty as owner of portfolio in system.
   * @deprecated PortfolioSwap is deprecated, use PortfolioSwapX instead
   */
  PortfolioSwap = 'PortfolioSwap',
  /** PortfolioSwapX model is the new Portfolio Swap model. */
  PortfolioSwapX = 'PortfolioSwapX',
  /**
   * RealEstate model is a spot valuation model which differentiates Real Estate
   * risk factor instruments from other spot valuation models.
   */
  PrivateEquity = 'PrivateEquity',
  /**
   * PrivateEquity model is, for now a spot valuation model which differentiates Private Equity
   * risk factor instruments from other spot valuation models.
   */
  RealEstate = 'RealEstate',
  /**
   * DO NOT USE! NOT IMPLEMENTED IN SWAPLAB2! Spot model is a generic spot model, please use Stock or RealEstate models instead.
   * @deprecated DO NOT USE! NOT IMPLEMENTED IN SWAPLAB2!
   */
  Spot = 'Spot',
  /**
   * Stock model is a spot valuation model used for all normal equity like instruments, including stock, dividend rights and such.
   * All valuations are done T+0 i.e. no T+2 discounting.
   */
  Stock = 'Stock',
  /** Swap model is used for interest rate swaps. Currently the model does not support OIS-swaps. */
  Swap = 'Swap',
  /**
   * Swaption model is used for valuation of swaptions. Using the call/put and pay/recieve properties
   * of the SwaptionLeg gives call: false = Payer Swaption, payleg: false = sold (short) position.
   */
  Swaption = 'Swaption',
  /**
   * ZeroCouponLinear model is used as an amortizing model for not marked valued corporate certificates
   * and other not market valued zero coupon structures. Valuation is a linear amortizing model towards par.
   */
  ZeroCouponLinear = 'ZeroCouponLinear'
}

export type InstrumentPerformance = {
  __typename?: 'InstrumentPerformance';
  account?: Maybe<PartyAccount>;
  accountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  cashFlows?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  currency?: Maybe<CurrencyEnum>;
  dates?: Maybe<Array<Maybe<Scalars['GraphQLDateString']['output']>>>;
  firstTradeDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  instrument?: Maybe<Instrument>;
  instrumentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  localCurrency?: Maybe<CurrencyEnum>;
  positions?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  series?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type InstrumentPosition = {
  __typename?: 'InstrumentPosition';
  clientIds: Array<Scalars['GraphQLObjectId']['output']>;
  clients?: Maybe<Array<Maybe<Party>>>;
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
};

export enum InstrumentPositionType {
  All = 'All',
  CashAccounts = 'CashAccounts',
  Securities = 'Securities'
}

export enum InstrumentProductTypeEnum {
  Account = 'Account',
  /** For PayableReceivable transactions just a balance since no cash involved */
  BalanceAccount = 'BalanceAccount',
  Bond = 'Bond',
  Cash = 'Cash',
  CashAccount = 'CashAccount',
  Fund = 'Fund',
  FutureForward = 'FutureForward',
  FxPair = 'FxPair',
  Index = 'Index',
  InitialMarginAccount = 'InitialMarginAccount',
  Liability = 'Liability',
  None = 'None',
  Option = 'Option',
  PrincipalAccount = 'PrincipalAccount',
  RealEstate = 'RealEstate',
  Shares = 'Shares',
  Swap = 'Swap',
  System = 'System',
  VariationMarginAccount = 'VariationMarginAccount'
}

export type InstrumentSelector = {
  __typename?: 'InstrumentSelector';
  alias?: Maybe<Scalars['String']['output']>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
};

export type InstrumentSelectorInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  instrumentId: Scalars['GraphQLObjectId']['input'];
};

export enum InstrumentStatusEnum {
  Confirmed = 'Confirmed',
  Deleted = 'Deleted',
  Pending = 'Pending'
}

export enum InstrumentTypeEnum {
  Instrument = 'Instrument',
  PartyInstrument = 'PartyInstrument'
}

export type InstrumentValuation = {
  __typename?: 'InstrumentValuation';
  accruedInterest?: Maybe<Scalars['Float']['output']>;
  cleanPrice?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<CurrencyEnum>;
  date?: Maybe<Scalars['GraphQLDateString']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** Accounting inventory per instrument, built from transaction items up to and including endDate */
export type Inventory = {
  __typename?: 'Inventory';
  /** rounded to 2 decimal places */
  initialCost: Scalars['Float']['output'];
  initialFxRate: Scalars['Float']['output'];
  initialPrice: Scalars['Float']['output'];
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
  localAmount: Scalars['Float']['output'];
  /** rounded to 6 decimal places */
  quantity: Scalars['Float']['output'];
};

export enum IorpEnum {
  None = 'None',
  RiskFree = 'RiskFree',
  SOBL = 'SOBL'
}

export type IssuerProgram = {
  __typename?: 'IssuerProgram';
  _id: Scalars['GraphQLObjectId']['output'];
  attachments: Array<Attachment>;
  category?: Maybe<IssuerProgramCategory>;
  client?: Maybe<Party>;
  clientId: Scalars['GraphQLObjectId']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  covered: TrueFalseNone;
  createTimestamp: Scalars['Timestamp']['output'];
  creditStatus: CreditStatusType;
  crossDefault: TrueFalseNone;
  euTaxonomyEnvironmentalObjectives: Array<EuTaxonomyEnvironmentalObjective>;
  guarantor?: Maybe<Party>;
  guarantorId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  instruments: Array<Instrument>;
  issuer?: Maybe<Party>;
  issuerId: Scalars['GraphQLObjectId']['output'];
  name?: Maybe<Scalars['String']['output']>;
  negativePledge: TrueFalseNone;
  /** A list of screens for program */
  screens?: Maybe<Array<Maybe<Screen>>>;
  spoProvider?: Maybe<Party>;
  spoProviderId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  status?: Maybe<DocumentStatusEnum>;
  sustainableDevelopmentGoals?: Maybe<Array<SustainableDevelopmentGoal>>;
  updateTimestamp: Scalars['Timestamp']['output'];
  /** Id of the user that updated/created */
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  useOfProceeds?: Maybe<Array<UseOfProceed>>;
  /** A list of versions of the document */
  versions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
};

export enum IssuerProgramCategory {
  Green = 'Green',
  None = 'None',
  Social = 'Social',
  SustainabilityLinked = 'SustainabilityLinked',
  Sustainable = 'Sustainable',
  Transition = 'Transition'
}

export type IssuerProgramInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  category?: InputMaybe<IssuerProgramCategory>;
  clientId: Scalars['GraphQLObjectId']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  covered?: InputMaybe<TrueFalseNone>;
  creditRatings?: InputMaybe<Array<CreditRatingInput>>;
  creditStatus?: InputMaybe<CreditStatus>;
  crossDefault?: InputMaybe<TrueFalseNone>;
  euTaxonomyEnvironmentalObjectives?: InputMaybe<Array<EuTaxonomyEnvironmentalObjective>>;
  guarantorId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  issuerId: Scalars['GraphQLObjectId']['input'];
  name: Scalars['String']['input'];
  negativePledge?: InputMaybe<TrueFalseNone>;
  spoProviderId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  status?: InputMaybe<DocumentStatusEnum>;
  sustainableDevelopmentGoals?: InputMaybe<Array<SustainableDevelopmentGoal>>;
  useOfProceeds?: InputMaybe<Array<UseOfProceed>>;
};

export type IssuerProgramsFilterInput = {
  clientIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  issuerIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  statusIn?: InputMaybe<Array<DocumentStatusEnum>>;
};

export enum IssuerTypeEnum {
  CreditInstitution = 'CreditInstitution',
  EuCovered = 'EuCovered',
  Government = 'Government',
  None = 'None'
}

export type JournalEntry = {
  __typename?: 'JournalEntry';
  _id: Scalars['GraphQLObjectId']['output'];
  /** Accounting period of the accounting run, e.g. "2026". Set when written, not derived from effectiveDate */
  accountingPeriod?: Maybe<Scalars['String']['output']>;
  accountingRunId: Scalars['GraphQLObjectId']['output'];
  batch?: Maybe<AccountingBatchType>;
  clientId: Scalars['GraphQLObjectId']['output'];
  description?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  /** External verification number */
  externalNumber?: Maybe<Scalars['Int']['output']>;
  /** Batch specific verification number */
  number?: Maybe<Scalars['Int']['output']>;
  portfolioTransaction?: Maybe<Transaction>;
  portfolioTransactionId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  transactions?: Maybe<Array<AccountingTransaction>>;
};

/** Journal entry of an accounting run in collection accountingrun2 */
export type JournalEntry2 = {
  __typename?: 'JournalEntry2';
  _id: Scalars['GraphQLObjectId']['output'];
  /** Accounting period of the accounting run, e.g. "2026". Set when written, not derived from effectiveDate */
  accountingPeriod?: Maybe<Scalars['String']['output']>;
  accountingRunId: Scalars['GraphQLObjectId']['output'];
  batch?: Maybe<AccountingBatchType>;
  clientId: Scalars['GraphQLObjectId']['output'];
  description?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  /** External verification number */
  externalNumber?: Maybe<Scalars['Int']['output']>;
  /** Batch specific verification number */
  number?: Maybe<Scalars['Int']['output']>;
  portfolioTransaction?: Maybe<Transaction>;
  portfolioTransactionId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  transactions?: Maybe<Array<AccountingTransaction2>>;
};

export type JournalEntryInput = {
  batch?: InputMaybe<AccountingBatchType>;
  clientId: Scalars['GraphQLObjectId']['input'];
  createTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  createUserId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  externalNumber?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  portfolioTransactionId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  transactions?: InputMaybe<Array<AccountingTransactionInput>>;
};

export type KleerAccountMetadata = {
  __typename?: 'KleerAccountMetadata';
  accountNr?: Maybe<Scalars['Int']['output']>;
  creditCount?: Maybe<Scalars['Int']['output']>;
  debitCount?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  inBalance?: Maybe<Scalars['Float']['output']>;
  outBalance?: Maybe<Scalars['Float']['output']>;
};

export type KleerAccountingYear = {
  __typename?: 'KleerAccountingYear';
  endDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['GraphQLDateString']['output']>;
};

export type KleerAmount = {
  __typename?: 'KleerAmount';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

export type KleerCompanyInfo = {
  __typename?: 'KleerCompanyInfo';
  accountingCurrency?: Maybe<Scalars['String']['output']>;
  bankgiro?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orgno?: Maybe<Scalars['String']['output']>;
  supplierInvoiceEmail?: Maybe<Scalars['String']['output']>;
};

export type KleerIdRef = {
  __typename?: 'KleerIdRef';
  id?: Maybe<Scalars['Int']['output']>;
};

export type KleerPeriod = {
  __typename?: 'KleerPeriod';
  end?: Maybe<Scalars['GraphQLDateString']['output']>;
  start?: Maybe<Scalars['GraphQLDateString']['output']>;
};

export type KleerRevenue = {
  __typename?: 'KleerRevenue';
  countryCode?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ledger?: Maybe<KleerIdRef>;
  rows?: Maybe<Array<Maybe<KleerRevenueRow>>>;
  transactionDate?: Maybe<Scalars['GraphQLDateString']['output']>;
};

export type KleerRevenueLedger = {
  __typename?: 'KleerRevenueLedger';
  accountNr?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type KleerRevenueRow = {
  __typename?: 'KleerRevenueRow';
  accountingAmount?: Maybe<KleerAmount>;
  dimensions?: Maybe<Scalars['JSON']['output']>;
  originalAmount?: Maybe<KleerAmount>;
  period?: Maybe<KleerPeriod>;
  product?: Maybe<KleerIdRef>;
};

export type KleerVoucher = {
  __typename?: 'KleerVoucher';
  date?: Maybe<Scalars['GraphQLDateString']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  serie?: Maybe<Scalars['String']['output']>;
  transactions?: Maybe<Array<Maybe<KleerVoucherTransaction>>>;
  turnover?: Maybe<Scalars['Float']['output']>;
};

export type KleerVoucherTransaction = {
  __typename?: 'KleerVoucherTransaction';
  accountNr?: Maybe<Scalars['Int']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  currencyAmounts?: Maybe<Scalars['JSON']['output']>;
  dimensionEntries?: Maybe<Scalars['JSON']['output']>;
  vatCode?: Maybe<Scalars['String']['output']>;
};

export type LimitData = {
  __typename?: 'LimitData';
  /** // Risk data */
  creditYieldDelta?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  custodian?: Maybe<Scalars['String']['output']>;
  /** // Exposure */
  exposure?: Maybe<Scalars['Float']['output']>;
  externalAccountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  externalAccountName?: Maybe<Scalars['String']['output']>;
  externalAccountType?: Maybe<PartyExternalAccountType>;
  fxRate?: Maybe<Scalars['Float']['output']>;
  instrumentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  instrumentLongName?: Maybe<Scalars['String']['output']>;
  instrumentName?: Maybe<Scalars['String']['output']>;
  interestRateYieldDelta?: Maybe<Scalars['Float']['output']>;
  /** // Eligible asset categories under UCITS */
  isAncillaryLiquidAsset?: Maybe<Scalars['Boolean']['output']>;
  isCashAccount?: Maybe<Scalars['Boolean']['output']>;
  /** // Position type */
  isCollateral?: Maybe<Scalars['Boolean']['output']>;
  isCollateralInitialMargin?: Maybe<Scalars['Boolean']['output']>;
  isCreditInstitution?: Maybe<Scalars['Boolean']['output']>;
  isDeposit?: Maybe<Scalars['Boolean']['output']>;
  isDerivative?: Maybe<Scalars['Boolean']['output']>;
  isEquity?: Maybe<Scalars['Boolean']['output']>;
  isEuCovered?: Maybe<Scalars['Boolean']['output']>;
  isFinancialIndex?: Maybe<Scalars['Boolean']['output']>;
  isFund?: Maybe<Scalars['Boolean']['output']>;
  isGovernment?: Maybe<Scalars['Boolean']['output']>;
  isGreenBond?: Maybe<Scalars['Boolean']['output']>;
  isInterestBearing?: Maybe<Scalars['Boolean']['output']>;
  isKeySector?: Maybe<Scalars['Boolean']['output']>;
  isLookThrough?: Maybe<Scalars['Boolean']['output']>;
  isMoneyMarket?: Maybe<Scalars['Boolean']['output']>;
  isNonGuaranteed?: Maybe<Scalars['Boolean']['output']>;
  isNonVoting?: Maybe<Scalars['Boolean']['output']>;
  isOtc?: Maybe<Scalars['Boolean']['output']>;
  isSecurity?: Maybe<Scalars['Boolean']['output']>;
  isTransferableSecurity?: Maybe<Scalars['Boolean']['output']>;
  isTsmmEmbeddedDerivative?: Maybe<Scalars['Boolean']['output']>;
  isUcitsFund?: Maybe<Scalars['Boolean']['output']>;
  /** // Instrument properties */
  isUnlisted?: Maybe<Scalars['Boolean']['output']>;
  isin?: Maybe<Scalars['String']['output']>;
  /** // Issuer data */
  issuerId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  issuerName?: Maybe<Scalars['String']['output']>;
  localExposure?: Maybe<Scalars['Float']['output']>;
  localValue?: Maybe<Scalars['Float']['output']>;
  parentIssuerId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  portfolioCurrency?: Maybe<Scalars['String']['output']>;
  /** // Meta data - For visibility */
  portfolioName?: Maybe<Scalars['String']['output']>;
  positionType?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  separatedInitialMargin?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type LimitedUserFilterInput = {
  roleAsset?: InputMaybe<PermissionAssetEnum>;
  status?: InputMaybe<UserStatusEnum>;
};

export enum MappingCollectionNameEnum {
  CurveDefinition = 'CurveDefinition'
}

export enum MappingParameterEnum {
  CreditCurve = 'CreditCurve',
  DiscountCurve = 'DiscountCurve',
  FixingCurve = 'FixingCurve',
  ForwardCurve = 'ForwardCurve',
  FxCurve = 'FxCurve'
}

export enum MappingTypeEnum {
  Currency = 'Currency',
  Instrument = 'Instrument',
  IssuerProgram = 'IssuerProgram',
  Model = 'Model'
}

export type MarginRequirement = {
  __typename?: 'MarginRequirement';
  _id: Scalars['GraphQLObjectId']['output'];
  agreementType: AgreementType;
  amount: Scalars['Float']['output'];
  client: Party;
  clientId: Scalars['GraphQLObjectId']['output'];
  createTimestamp: Scalars['Timestamp']['output'];
  currency: CurrencyEnum;
  date: Scalars['GraphQLDateString']['output'];
  externalId: Scalars['String']['output'];
  source: Party;
  sourceId: Scalars['GraphQLObjectId']['output'];
  type: MarginRequirementType;
  updateTimestamp: Scalars['Timestamp']['output'];
};

export enum MarginRequirementType {
  InitialMarginRequirement = 'InitialMarginRequirement',
  VariationMarginRequirement = 'VariationMarginRequirement'
}

export enum MarginType {
  InitialMargin = 'InitialMargin',
  VariationMargin = 'VariationMargin'
}

export type MatchBankAccountTransactionsInput = {
  bankAccountTransactionError?: InputMaybe<Scalars['String']['input']>;
  bankAccountTransactionIds: Array<Scalars['GraphQLObjectId']['input']>;
  matchingStatus: MatchingStatus;
  transactionIdentifierIds: Array<TransactionIdentifier>;
  transactionItemError?: InputMaybe<Scalars['String']['input']>;
};

export type MatchCoacsTransactionsInput = {
  corporateActionError?: InputMaybe<Scalars['String']['input']>;
  corporateActionExternalId?: InputMaybe<Scalars['String']['input']>;
  corporateActionId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  matchingStatus?: InputMaybe<MatchingCoacsStatus>;
  transactionError?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
};

export type MatchTransactionsInput = {
  brokerExternalId?: InputMaybe<Scalars['String']['input']>;
  brokerTransactionError?: InputMaybe<Scalars['String']['input']>;
  brokerTransactionId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  matchingStatus?: InputMaybe<MatchingStatus>;
  transactionError?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
};

export type MatchedBankAccountTransaction = {
  __typename?: 'MatchedBankAccountTransaction';
  bankAccountTransactionIds?: Maybe<Array<Scalars['GraphQLObjectId']['output']>>;
  bankAccountTransactions?: Maybe<Array<BankAccountTransaction>>;
  transactionItemIds?: Maybe<Array<Scalars['GraphQLObjectId']['output']>>;
  transactionItems?: Maybe<Array<TransactionItem>>;
};

export type MatchedCoacsTransaction = {
  __typename?: 'MatchedCoacsTransaction';
  corporateAction?: Maybe<CorporateAction>;
  corporateActionId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  transaction?: Maybe<Transaction>;
  transactionId?: Maybe<Scalars['GraphQLObjectId']['output']>;
};

export type MatchedTransaction = {
  __typename?: 'MatchedTransaction';
  brokerTransaction?: Maybe<BrokerTransaction>;
  transaction?: Maybe<Transaction>;
};

export enum MatchingCoacsStatus {
  Confirmed = 'Confirmed',
  /** Matched with a transaction but found at least on error */
  Matched = 'Matched',
  Mismatch = 'Mismatch',
  Preliminary = 'Preliminary',
  /** Messages of type 566 gets status settled when matched */
  Settled = 'Settled'
}

export enum MatchingStatus {
  Confirmed = 'Confirmed',
  Deleted = 'Deleted',
  /** Matched with a transaction but found at least on error */
  Matched = 'Matched',
  Mismatch = 'Mismatch'
}

export type Me = {
  __typename?: 'Me';
  _id: Scalars['GraphQLObjectId']['output'];
  bidExpiration?: Maybe<Scalars['Int']['output']>;
  clientIds: Array<Scalars['GraphQLObjectId']['output']>;
  clients: Array<PartyInfo>;
  company: Scalars['String']['output'];
  createTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  frontendRole: Role;
  frontendRoleId: Scalars['GraphQLObjectId']['output'];
  lastBankIdLoginTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  lastLoginTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  lastPasswordUpdate?: Maybe<Scalars['Timestamp']['output']>;
  name: Scalars['String']['output'];
  noteIds: Array<Scalars['GraphQLObjectId']['output']>;
  notes: Array<Note>;
  personalNumber: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  roleIds: Array<Scalars['GraphQLObjectId']['output']>;
  roles?: Maybe<Array<Role>>;
  status: UserStatusEnum;
  /** Latest terms of service from notes collection */
  termsOfService?: Maybe<Note>;
  unreadTicketsCount?: Maybe<Scalars['Int']['output']>;
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
};

export type MiniTransaction = {
  __typename?: 'MiniTransaction';
  _id: Scalars['GraphQLObjectId']['output'];
  account?: Maybe<PartyAccount>;
  /** For partyInstruments with accountId set on the instrument, that accountId is used otherwise the accountId in input is used */
  accountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  /** For BondTrade */
  accruedInterest?: Maybe<Scalars['Float']['output']>;
  /** For DerivativeTrade/ Collateral */
  agreementType?: Maybe<AgreementType>;
  /**
   * Amount is used for all types except:
   * collateral, stockTrade, bondTrade, derivativeTrade
   */
  amount?: Maybe<Scalars['Float']['output']>;
  attachments?: Maybe<Array<Attachment>>;
  bestExecutionType?: Maybe<BestExecutionType>;
  /** For CreateRedeem/FundTrade */
  bonusShares?: Maybe<Scalars['Float']['output']>;
  broker?: Maybe<Party>;
  brokerId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  brokerTradeId?: Maybe<Scalars['String']['output']>;
  brokerTransaction?: Maybe<BrokerTransaction>;
  carryOwnCostDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  clearingBroker?: Maybe<Party>;
  /** For agreementTypes OmnibusClearingAccount and ClearingAccount */
  clearingBrokerId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  clearingHouse?: Maybe<Party>;
  clearingHouseId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  client?: Maybe<Party>;
  clientId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  /** For StockTrade / BondTrade / FundTrade */
  commission?: Maybe<Scalars['Float']['output']>;
  corporateAction?: Maybe<CorporateAction>;
  createTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  currency?: Maybe<CurrencyEnum>;
  description?: Maybe<Scalars['String']['output']>;
  dividendPaid?: Maybe<Scalars['Boolean']['output']>;
  effectiveDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  externalAccountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  /** For Dividend */
  foreignTax?: Maybe<Scalars['Float']['output']>;
  fxRate?: Maybe<Scalars['Float']['output']>;
  /** For Collateral */
  initialMargin?: Maybe<Scalars['Boolean']['output']>;
  instrument?: Maybe<Instrument>;
  instrumentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  /** For Fee/Interest */
  itemType?: Maybe<FeeInterestItemType>;
  loan?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  /** Read only for now, related to portfolio swap (stockTrade) */
  payableReceivable?: Maybe<Scalars['Float']['output']>;
  /** For StockTrade / BondTrade / DerivativeTrade */
  price?: Maybe<Scalars['Float']['output']>;
  /** For StockTrade / BondTrade / DerivativeTrade/ Collateral */
  quantity?: Maybe<Scalars['Float']['output']>;
  reinvestedDividend?: Maybe<Scalars['Boolean']['output']>;
  reinvestedRebate?: Maybe<Scalars['Boolean']['output']>;
  /** Used for when counterparties round settlementAmount */
  rounding?: Maybe<Scalars['Float']['output']>;
  /** If not stated, will be set to accountId or default on party instrument */
  secondAccountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  secondAmount?: Maybe<Scalars['Float']['output']>;
  secondCurrency?: Maybe<Scalars['String']['output']>;
  secondExternalAccountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  /** For Transfer */
  secondInstrumentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  /** SettlementAmount is used for all types except collateral and transfer */
  settlementAmount?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<SourceType>;
  /** For StockTrade / BondTrade */
  stampDuty?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<TransactionStatus>;
  taxRestitution?: Maybe<Scalars['Boolean']['output']>;
  tradeDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  tradeTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  type?: Maybe<TransactionType>;
  uniqueTradeId?: Maybe<Scalars['String']['output']>;
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  valueDate?: Maybe<Scalars['GraphQLDateString']['output']>;
};

/**
 * ModelIndexBenchmark calculated within the Party.accounts computed property.
 * Uses introspection to decide calculation and parameter. Thus if type name
 * or parameters to timeSeries are altered this must be mirrored under
 * Party.accounts
 */
export type ModelIndexBenchmark = {
  __typename?: 'ModelIndexBenchmark';
  currency?: Maybe<CurrencyEnum>;
  name: Scalars['String']['output'];
  timeSeries?: Maybe<TimeSeries>;
};


/**
 * ModelIndexBenchmark calculated within the Party.accounts computed property.
 * Uses introspection to decide calculation and parameter. Thus if type name
 * or parameters to timeSeries are altered this must be mirrored under
 * Party.accounts
 */
export type ModelIndexBenchmarkTimeSeriesArgs = {
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};

export type ModelIndexBenchmarkInput = {
  name: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptTerms?: Maybe<User>;
  addTimeSerieItems?: Maybe<TimeSeries>;
  /**
   * Move the settled share-register balance of a client account to another client account.
   * Used when changing transfer agent.
   *
   * `input` is one or more account pairs. For each pair and each ISIN, looks up the balance of `from`
   * on orders with tradeDate on or before `tradeDate` and creates a Settled SELL on `from` and a Settled BUY on `to`
   * (ACCOUNT_SWITCH), both with tradeDate and valueDate set to `tradeDate`. A negative balance is rejected.
   * Every client account must already exist. `input` and `isins` are required and must not be empty. Each ISIN must already exist.
   * Nothing is written if any pair fails.
   *
   * SuperAdmin only. When `dryRun` is true, returns the orders that would be created and does not write them.
   */
  adminAccountSwitchAll: Array<TransferAgentOrder>;
  changePassword?: Maybe<UserInfo>;
  cleanPerformanceCacheRedis?: Maybe<Scalars['Boolean']['output']>;
  cloneTAccountChart?: Maybe<TAccountChart>;
  createAccountingRun?: Maybe<AccountingRun>;
  createAttachment?: Maybe<Attachment>;
  createCdsValuations?: Maybe<Array<Maybe<Valuation>>>;
  createCurveDefinition?: Maybe<CurveDefinition>;
  createDerivativeValuations?: Maybe<Array<Maybe<Valuation>>>;
  createExposureCollateral: ExposureCollateral;
  createInstrument?: Maybe<Instrument>;
  createIssuerProgram?: Maybe<IssuerProgram>;
  createJournalEntry?: Maybe<JournalEntry>;
  createJournalEntry2?: Maybe<JournalEntry2>;
  createManagementCostTransactions?: Maybe<Array<Maybe<MiniTransaction>>>;
  createMiniTransactions?: Maybe<Array<Maybe<MiniTransaction>>>;
  createNav?: Maybe<Nav>;
  createPartyAccount?: Maybe<Party>;
  createPartyBase?: Maybe<Party>;
  createReport?: Maybe<Report>;
  createRole?: Maybe<Role>;
  createScreen?: Maybe<Screen>;
  /** Creates swifts and corresponding corporateActions */
  createSwifts?: Maybe<Array<Swift>>;
  createTAccountChart?: Maybe<TAccountChart>;
  createTransaction?: Maybe<Transaction>;
  /** createUpdateExternalAccount also creates partyInstruments */
  createUpdateExternalAccount?: Maybe<PartyExternalAccount>;
  createUpdatePartyCashOrBalanceInstrument?: Maybe<Instrument>;
  createUser?: Maybe<User>;
  createValuation?: Maybe<Valuation>;
  databaseMigration?: Maybe<Scalars['Boolean']['output']>;
  defaultMutation?: Maybe<Scalars['String']['output']>;
  deleteAttachment?: Maybe<Scalars['Boolean']['output']>;
  deleteCurveDefinition?: Maybe<Scalars['Boolean']['output']>;
  deleteInstrument?: Maybe<Scalars['Boolean']['output']>;
  deleteIssuerProgram?: Maybe<Scalars['Boolean']['output']>;
  deleteJournalEntry?: Maybe<Scalars['Boolean']['output']>;
  deleteJournalEntry2?: Maybe<Scalars['Boolean']['output']>;
  deleteManagementCostTransactions?: Maybe<Scalars['Boolean']['output']>;
  deleteNav?: Maybe<Scalars['Boolean']['output']>;
  deleteParty?: Maybe<Scalars['Boolean']['output']>;
  deletePartyAccount?: Maybe<Scalars['Boolean']['output']>;
  deletePartyExternalAccount?: Maybe<Scalars['Boolean']['output']>;
  deleteRedisKey?: Maybe<Scalars['Boolean']['output']>;
  deleteReport?: Maybe<Scalars['Boolean']['output']>;
  deleteReports?: Maybe<Scalars['Boolean']['output']>;
  deleteScreen?: Maybe<Scalars['Boolean']['output']>;
  deleteTAccountChart?: Maybe<Scalars['Boolean']['output']>;
  deleteTimeSerie?: Maybe<Scalars['Boolean']['output']>;
  deleteTransaction?: Maybe<Scalars['Boolean']['output']>;
  deleteTransferAgentOrder?: Maybe<Scalars['Boolean']['output']>;
  deleteValuation?: Maybe<Scalars['Boolean']['output']>;
  derivativesToPrices?: Maybe<Scalars['Boolean']['output']>;
  derivativesToValuations?: Maybe<Scalars['Boolean']['output']>;
  fxPricesToValuations?: Maybe<Scalars['Boolean']['output']>;
  /** fxQuotesToPrices mutation converts fx-quotes to prices and calculates relevant fx-crosses */
  fxQuotesToPrices?: Maybe<Scalars['Boolean']['output']>;
  /** If aggregated amount the created transaction amount will be from current position to input amount */
  importAccruedInterestPortfolioSwapX?: Maybe<Array<Maybe<MiniTransaction>>>;
  importBondTrade?: Maybe<MiniTransaction>;
  importCloseDerivativeTrade?: Maybe<MiniTransaction>;
  importCloseResetPortfolioSwapX?: Maybe<Array<Maybe<MiniTransaction>>>;
  /** NOT creating default valuations if none exists for Insert transactions + Collateral transactions */
  importCollateral?: Maybe<MiniTransaction>;
  importCoupon?: Maybe<MiniTransaction>;
  importCreateRedeems?: Maybe<Array<Maybe<MiniTransaction>>>;
  importDerivativeTrade?: Maybe<MiniTransaction>;
  importDividend?: Maybe<MiniTransaction>;
  importDividendPortfolioSwapX?: Maybe<Array<Maybe<MiniTransaction>>>;
  /** Only for fxSwap atm */
  importExpiryDerivativeTrade?: Maybe<MiniTransaction>;
  importFeeInterests?: Maybe<Array<Maybe<MiniTransaction>>>;
  importFundTrades?: Maybe<Array<Maybe<MiniTransaction>>>;
  importFxSpot?: Maybe<MiniTransaction>;
  importInsertCash?: Maybe<MiniTransaction>;
  importInsertCloseDerivativeTrade?: Maybe<MiniTransaction>;
  importInsertDerivativeTrade?: Maybe<MiniTransaction>;
  importInsertSecurity?: Maybe<MiniTransaction>;
  importInterestPortfolioSwapX?: Maybe<Array<Maybe<MiniTransaction>>>;
  /** Portfolio swap transactions */
  importOpenPortfolioSwapX?: Maybe<Array<Maybe<MiniTransaction>>>;
  importStockTradePortfolioSwapX?: Maybe<Array<Maybe<MiniTransaction>>>;
  importStockTrades?: Maybe<Array<Maybe<MiniTransaction>>>;
  importTAccountChartAccounts?: Maybe<TAccountChart>;
  importTAccountChartMappings?: Maybe<TAccountChart>;
  importTransfers?: Maybe<Array<Maybe<MiniTransaction>>>;
  manuallyMatchBankAccountTransactions: Array<MatchedBankAccountTransaction>;
  matchBankAccountTransactions: Array<MatchedBankAccountTransaction>;
  matchCoacsTransactions: Array<MatchedCoacsTransaction>;
  matchTransactions: Array<MatchedTransaction>;
  opCreatePayments?: Maybe<Array<OpPayment>>;
  opCreateSigningBasket?: Maybe<OpSigningBasketData>;
  opCreateSigningBasketToken?: Maybe<Array<OpPayment>>;
  opCreateToken?: Maybe<OpConsent>;
  opDeleteConsent?: Maybe<Scalars['Boolean']['output']>;
  opDeletePayments?: Maybe<Array<OpPayment>>;
  opGetRedirectLink?: Maybe<RedirectLinkInfo>;
  opUpdateConsent?: Maybe<OpConsent>;
  opUpdatePayments?: Maybe<Array<OpPayment>>;
  pricesToValuations?: Maybe<Scalars['Boolean']['output']>;
  /** quotesToPrices mutation converts quotes to prices using specified logic for each QuoteTypeEnum */
  quotesToPrices?: Maybe<Scalars['Boolean']['output']>;
  roundTransaction?: Maybe<MiniTransaction>;
  setRedisKey?: Maybe<Scalars['JSON']['output']>;
  updateAccountingRun?: Maybe<AccountingRun>;
  updateAccountingRunStatus?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Allowed changes are Pending to Preliminary or Deleted, and Preliminary to Confirmed or Deleted.
   * Preliminary locks the client t-account chart, Confirmed must be done by another user than the one setting Preliminary
   * and Deleted deletes the journal entries of the run and unlocks the chart when no other Preliminary or Confirmed run uses it.
   */
  updateAccountingRunStatus2?: Maybe<Scalars['Boolean']['output']>;
  updateBrokerTransaction: BrokerTransaction;
  updateCurveDefinition?: Maybe<CurveDefinition>;
  updateExposureCollateral: ExposureCollateral;
  updateExternalNumbers?: Maybe<Array<Maybe<JournalEntry>>>;
  updateExternalNumbers2?: Maybe<Array<Maybe<JournalEntry2>>>;
  updateInstrument?: Maybe<Instrument>;
  updateIssuerProgram?: Maybe<IssuerProgram>;
  updateJournalEntry?: Maybe<JournalEntry>;
  updateJournalEntry2?: Maybe<JournalEntry2>;
  updateMiniTransaction?: Maybe<MiniTransaction>;
  updateNavsPublishedTo?: Maybe<Array<Maybe<Nav>>>;
  updateParty?: Maybe<Party>;
  updatePartyAccount?: Maybe<Party>;
  updatePartyBase?: Maybe<Party>;
  updatePartyExternalAccount?: Maybe<Party>;
  updatePartyFundInfo?: Maybe<Party>;
  updatePartyIssuer?: Maybe<Party>;
  updateReport?: Maybe<Report>;
  updateRole?: Maybe<Role>;
  updateScreen?: Maybe<Screen>;
  updateTAccountChart?: Maybe<TAccountChart>;
  updateTimeSerie?: Maybe<TimeSeries>;
  updateTransactions?: Maybe<Array<Maybe<Transaction>>>;
  updateTransferAgentOrderAttachments?: Maybe<TransferAgentOrder>;
  updateUser?: Maybe<User>;
  upsertAccountingRun?: Maybe<AccountingRun2>;
  upsertAgreements?: Maybe<Array<Maybe<Agreement>>>;
  upsertArrayOfTimeSerieItems: Array<Scalars['Boolean']['output']>;
  upsertBankAccountTransactions: Array<BankAccountTransaction>;
  upsertBaseCalendars?: Maybe<Array<Maybe<BaseCalendar>>>;
  upsertCorporateActions?: Maybe<Array<CorporateAction>>;
  upsertCosts?: Maybe<Array<Maybe<Cost>>>;
  upsertCustodianPositions: Array<CustodianApiPosition>;
  upsertCustomers?: Maybe<Array<Maybe<Customer>>>;
  upsertExtensions?: Maybe<Array<Maybe<Extension>>>;
  upsertNotes?: Maybe<Array<Maybe<Note>>>;
  upsertPrices?: Maybe<Array<Maybe<Price>>>;
  upsertQuotes?: Maybe<Array<Maybe<Quote>>>;
  upsertRegisterExtracts?: Maybe<Array<RegisterExtract>>;
  upsertTAccountChart2?: Maybe<UpsertTAccountChart>;
  upsertTickets?: Maybe<Array<Maybe<Ticket>>>;
  upsertTimeSerieItems?: Maybe<TimeSeries>;
  upsertTransferAgentOrders?: Maybe<Array<Maybe<TransferAgentOrder>>>;
  upsertValuationAttachments?: Maybe<Valuation>;
  upsertValuationMappings?: Maybe<Array<Maybe<ValuationMapping>>>;
  upsertValuations?: Maybe<Array<Maybe<Price>>>;
  valuationsToPrices?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAcceptTermsArgs = {
  input: AcceptTermsInput;
};


export type MutationAddTimeSerieItemsArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
  items: Array<TimeSeriesItemInput>;
};


export type MutationAdminAccountSwitchAllArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: Array<AccountSwitchAllInput>;
  isins: Array<Scalars['ISIN']['input']>;
  tradeDate: Scalars['GraphQLDateString']['input'];
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationCleanPerformanceCacheRedisArgs = {
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
};


export type MutationCloneTAccountChartArgs = {
  clientId: Scalars['GraphQLObjectId']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateAccountingRunArgs = {
  input: CreateAccountingRunInput;
};


export type MutationCreateAttachmentArgs = {
  clientId: Scalars['GraphQLObjectId']['input'];
  input: CreateAttachmentInput;
};


export type MutationCreateCdsValuationsArgs = {
  cdsTypes?: InputMaybe<Array<CdsType>>;
};


export type MutationCreateCurveDefinitionArgs = {
  input: CreateCurveDefinitionInput;
};


export type MutationCreateDerivativeValuationsArgs = {
  allowLastPrice?: InputMaybe<Scalars['Boolean']['input']>;
  date: Scalars['GraphQLDateString']['input'];
  instrumentIdIn: Array<Scalars['GraphQLObjectId']['input']>;
};


export type MutationCreateExposureCollateralArgs = {
  input: ExposureCollateralInput;
};


export type MutationCreateInstrumentArgs = {
  input: CreateInstrumentInput;
};


export type MutationCreateIssuerProgramArgs = {
  input: IssuerProgramInput;
};


export type MutationCreateJournalEntryArgs = {
  input: CreateJournalEntryInput;
};


export type MutationCreateJournalEntry2Args = {
  input: CreateJournalEntry2Input;
};


export type MutationCreateManagementCostTransactionsArgs = {
  clientId: Scalars['GraphQLObjectId']['input'];
  date: Scalars['GraphQLDateString']['input'];
  valueDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type MutationCreateMiniTransactionsArgs = {
  input: Array<CreateMiniTransactionInput>;
};


export type MutationCreateNavArgs = {
  input: NavInput;
};


export type MutationCreatePartyAccountArgs = {
  input: PartyAccountInput;
  partyId: Scalars['GraphQLObjectId']['input'];
};


export type MutationCreatePartyBaseArgs = {
  input: PartyBaseInput;
  partyId: Scalars['GraphQLObjectId']['input'];
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateScreenArgs = {
  input: ScreenInput;
};


export type MutationCreateSwiftsArgs = {
  input: Array<CreateSwiftInput>;
};


export type MutationCreateTAccountChartArgs = {
  input?: InputMaybe<CreateTAccountChartInput>;
};


export type MutationCreateTransactionArgs = {
  input: CreateTransactionInput;
};


export type MutationCreateUpdateExternalAccountArgs = {
  input: CreateUpdateExternalAccountInput;
  partyId: Scalars['GraphQLObjectId']['input'];
};


export type MutationCreateUpdatePartyCashOrBalanceInstrumentArgs = {
  input: CreateUpdatePartyCashOrBalanceInstrumentInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateValuationArgs = {
  input: CreateValuationInput;
};


export type MutationDeleteAttachmentArgs = {
  fileId: Scalars['GraphQLObjectId']['input'];
};


export type MutationDeleteCurveDefinitionArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type MutationDeleteInstrumentArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type MutationDeleteIssuerProgramArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type MutationDeleteJournalEntryArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type MutationDeleteJournalEntry2Args = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type MutationDeleteManagementCostTransactionsArgs = {
  clientId: Scalars['GraphQLObjectId']['input'];
  date: Scalars['GraphQLDateString']['input'];
};


export type MutationDeleteNavArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type MutationDeletePartyArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type MutationDeletePartyAccountArgs = {
  accountId: Scalars['GraphQLObjectId']['input'];
  partyId: Scalars['GraphQLObjectId']['input'];
};


export type MutationDeletePartyExternalAccountArgs = {
  externalAccountId: Scalars['GraphQLObjectId']['input'];
  partyId: Scalars['GraphQLObjectId']['input'];
};


export type MutationDeleteRedisKeyArgs = {
  key: Scalars['String']['input'];
};


export type MutationDeleteReportArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type MutationDeleteReportsArgs = {
  hard?: InputMaybe<Scalars['Boolean']['input']>;
  idIn: Array<Scalars['GraphQLObjectId']['input']>;
};


export type MutationDeleteScreenArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type MutationDeleteTAccountChartArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type MutationDeleteTimeSerieArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type MutationDeleteTransactionArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type MutationDeleteTransferAgentOrderArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type MutationDeleteValuationArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type MutationDerivativesToPricesArgs = {
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  date: Scalars['GraphQLDateString']['input'];
  instrumentIdIn: Array<Scalars['GraphQLObjectId']['input']>;
};


export type MutationDerivativesToValuationsArgs = {
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  date: Scalars['GraphQLDateString']['input'];
  instrumentIdIn: Array<Scalars['GraphQLObjectId']['input']>;
};


export type MutationFxPricesToValuationsArgs = {
  baseCurrency: CurrencyEnum;
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  date: Scalars['GraphQLDateString']['input'];
  instrumentIdIn: Array<Scalars['GraphQLObjectId']['input']>;
};


export type MutationFxQuotesToPricesArgs = {
  baseCurrency: CurrencyEnum;
  date: Scalars['GraphQLDateString']['input'];
  instrumentIdIn: Array<Scalars['GraphQLObjectId']['input']>;
};


export type MutationImportAccruedInterestPortfolioSwapXArgs = {
  aggregatedAmount: Scalars['Boolean']['input'];
  portfolioInterestInput: ImportFeeInterestInput;
};


export type MutationImportBondTradeArgs = {
  input: ImportBondTradeInput;
};


export type MutationImportCloseDerivativeTradeArgs = {
  input: ImportCloseDerivativeTradeInput;
};


export type MutationImportCloseResetPortfolioSwapXArgs = {
  accountAlias: Scalars['String']['input'];
  date: Scalars['GraphQLDateString']['input'];
  portfolioSwapAlias: Scalars['String']['input'];
  reset: Scalars['Boolean']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};


export type MutationImportCollateralArgs = {
  input: ImportCollateralInput;
};


export type MutationImportCouponArgs = {
  input: ImportCouponInput;
};


export type MutationImportCreateRedeemsArgs = {
  input?: InputMaybe<Array<ImportCreateRedeemInput>>;
};


export type MutationImportDerivativeTradeArgs = {
  input: ImportDerivativeTradeInput;
};


export type MutationImportDividendArgs = {
  input: ImportDividendInput;
};


export type MutationImportDividendPortfolioSwapXArgs = {
  portfolioSwapAlias: Scalars['String']['input'];
  stockDividendInput: ImportDividendInput;
};


export type MutationImportExpiryDerivativeTradeArgs = {
  input: ImportExpiryDerivativeTradeInput;
};


export type MutationImportFeeInterestsArgs = {
  input: Array<ImportFeeInterestInput>;
};


export type MutationImportFundTradesArgs = {
  input: Array<ImportFundTradeInput>;
};


export type MutationImportFxSpotArgs = {
  input: ImportFxSpotInput;
};


export type MutationImportInsertCashArgs = {
  input: ImportInsertCashInput;
};


export type MutationImportInsertCloseDerivativeTradeArgs = {
  input: ImportCloseDerivativeTradeInput;
};


export type MutationImportInsertDerivativeTradeArgs = {
  input: ImportInsertDerivativeTradeInput;
};


export type MutationImportInsertSecurityArgs = {
  input: ImportInsertSecurityInput;
};


export type MutationImportInterestPortfolioSwapXArgs = {
  portfolioInterestInput: ImportFeeInterestInput;
};


export type MutationImportOpenPortfolioSwapXArgs = {
  stockInput: Array<ImportStockTradeInput>;
  swapInput: ImportDerivativeTradeInput;
};


export type MutationImportStockTradePortfolioSwapXArgs = {
  portfolioSwapAlias: Scalars['String']['input'];
  settlementAmount?: InputMaybe<Scalars['Float']['input']>;
  stockInput: ImportStockTradeInput;
};


export type MutationImportStockTradesArgs = {
  input: Array<ImportStockTradeInput>;
};


export type MutationImportTAccountChartAccountsArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
  csv: Scalars['String']['input'];
  delimiter?: InputMaybe<Scalars['String']['input']>;
};


export type MutationImportTAccountChartMappingsArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
  csv: Scalars['String']['input'];
  delimiter?: InputMaybe<Scalars['String']['input']>;
};


export type MutationImportTransfersArgs = {
  input: Array<ImportTransferInput>;
};


export type MutationManuallyMatchBankAccountTransactionsArgs = {
  input: Array<MatchBankAccountTransactionsInput>;
};


export type MutationMatchBankAccountTransactionsArgs = {
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
};


export type MutationMatchCoacsTransactionsArgs = {
  input: Array<MatchCoacsTransactionsInput>;
};


export type MutationMatchTransactionsArgs = {
  input: Array<MatchTransactionsInput>;
};


export type MutationOpCreatePaymentsArgs = {
  payments: Array<OpPaymentInput>;
};


export type MutationOpCreateSigningBasketArgs = {
  idIn: Array<Scalars['GraphQLObjectId']['input']>;
};


export type MutationOpCreateSigningBasketTokenArgs = {
  code: Scalars['String']['input'];
  legalNumber: Scalars['String']['input'];
  signingBasketAuthId: Scalars['String']['input'];
  signingBasketId: Scalars['String']['input'];
};


export type MutationOpCreateTokenArgs = {
  code: Scalars['String']['input'];
  consentAuthId: Scalars['String']['input'];
  consentId: Scalars['String']['input'];
  legalNumber: Scalars['String']['input'];
  scope: Scalars['String']['input'];
};


export type MutationOpDeleteConsentArgs = {
  consentId: Scalars['String']['input'];
};


export type MutationOpDeletePaymentsArgs = {
  idIn: Array<Scalars['GraphQLObjectId']['input']>;
};


export type MutationOpGetRedirectLinkArgs = {
  bic: Scalars['String']['input'];
  clientId: Scalars['GraphQLObjectId']['input'];
  legalNumber: Scalars['String']['input'];
};


export type MutationOpUpdateConsentArgs = {
  consentId: Scalars['String']['input'];
};


export type MutationOpUpdatePaymentsArgs = {
  idIn: Array<Scalars['GraphQLObjectId']['input']>;
};


export type MutationPricesToValuationsArgs = {
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  date: Scalars['GraphQLDateString']['input'];
  instrumentIdIn: Array<Scalars['GraphQLObjectId']['input']>;
};


export type MutationQuotesToPricesArgs = {
  date: Scalars['GraphQLDateString']['input'];
  instrumentIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
};


export type MutationRoundTransactionArgs = {
  input: RoundTransactionInput;
};


export type MutationSetRedisKeyArgs = {
  data: Scalars['JSON']['input'];
  key: Scalars['String']['input'];
};


export type MutationUpdateAccountingRunArgs = {
  input: UpdateAccountingRunInput;
};


export type MutationUpdateAccountingRunStatusArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
  status: AccountingRunStatusEnum;
};


export type MutationUpdateAccountingRunStatus2Args = {
  _id: Scalars['GraphQLObjectId']['input'];
  status: AccountingRunStatusEnum;
};


export type MutationUpdateBrokerTransactionArgs = {
  input: UpdateBrokerTransactionInput;
};


export type MutationUpdateCurveDefinitionArgs = {
  input: UpdateCurveDefinitionInput;
};


export type MutationUpdateExposureCollateralArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
  input: ExposureCollateralInput;
};


export type MutationUpdateExternalNumbersArgs = {
  input: Array<UpdateExternalNumberInput>;
};


export type MutationUpdateExternalNumbers2Args = {
  input: Array<UpdateExternalNumberInput>;
};


export type MutationUpdateInstrumentArgs = {
  input: UpdateInstrumentInput;
};


export type MutationUpdateIssuerProgramArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
  input: IssuerProgramInput;
};


export type MutationUpdateJournalEntryArgs = {
  input: UpdateJournalEntryInput;
};


export type MutationUpdateJournalEntry2Args = {
  input: UpdateJournalEntry2Input;
};


export type MutationUpdateMiniTransactionArgs = {
  input: UpdateMiniTransactionInput;
};


export type MutationUpdateNavsPublishedToArgs = {
  publishedToInput: Array<InputMaybe<PublishedToInput>>;
};


export type MutationUpdatePartyArgs = {
  input: UpdatePartyInput;
};


export type MutationUpdatePartyAccountArgs = {
  input: PartyAccountInput;
  partyId: Scalars['GraphQLObjectId']['input'];
};


export type MutationUpdatePartyBaseArgs = {
  input: PartyBaseInput;
  partyId: Scalars['GraphQLObjectId']['input'];
};


export type MutationUpdatePartyExternalAccountArgs = {
  input: PartyExternalAccountInput;
  partyId: Scalars['GraphQLObjectId']['input'];
};


export type MutationUpdatePartyFundInfoArgs = {
  input: PartyFundInfoInput;
  partyId: Scalars['GraphQLObjectId']['input'];
};


export type MutationUpdatePartyIssuerArgs = {
  input: PartyIssuerInput;
  partyId: Scalars['GraphQLObjectId']['input'];
};


export type MutationUpdateReportArgs = {
  input: UpdateReportInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateScreenArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
  input: ScreenInput;
};


export type MutationUpdateTAccountChartArgs = {
  input?: InputMaybe<UpdateTAccountChartInput>;
};


export type MutationUpdateTimeSerieArgs = {
  input: TimeSeriesInput;
};


export type MutationUpdateTransactionsArgs = {
  input: Array<UpdateTransactionInput>;
};


export type MutationUpdateTransferAgentOrderAttachmentsArgs = {
  input: TransferAgentOrderAttachmentsInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpsertAccountingRunArgs = {
  input: UpsertAccountingRunInput;
};


export type MutationUpsertAgreementsArgs = {
  input: Array<AgreementInput>;
};


export type MutationUpsertArrayOfTimeSerieItemsArgs = {
  data: Array<TimeSeriesUpsertInput>;
};


export type MutationUpsertBankAccountTransactionsArgs = {
  input: Array<BankAccountTransactionInput>;
};


export type MutationUpsertBaseCalendarsArgs = {
  input: Array<BaseCalendarInput>;
};


export type MutationUpsertCorporateActionsArgs = {
  input: Array<CorporateActionInput>;
};


export type MutationUpsertCostsArgs = {
  input: Array<CostInput>;
};


export type MutationUpsertCustodianPositionsArgs = {
  input: Array<CustodianApiPositionInput>;
};


export type MutationUpsertCustomersArgs = {
  input: Array<CustomerInput>;
};


export type MutationUpsertExtensionsArgs = {
  input: Array<ExtensionInput>;
};


export type MutationUpsertNotesArgs = {
  input: Array<NoteInput>;
};


export type MutationUpsertPricesArgs = {
  input: Array<PriceInput>;
};


export type MutationUpsertQuotesArgs = {
  input: Array<QuoteInput>;
};


export type MutationUpsertRegisterExtractsArgs = {
  input: Array<RegisterExtractInput>;
};


export type MutationUpsertTAccountChart2Args = {
  input?: InputMaybe<UpsertTAccountChartInput>;
};


export type MutationUpsertTicketsArgs = {
  input: Array<TicketInput>;
};


export type MutationUpsertTimeSerieItemsArgs = {
  instrumentId: Scalars['GraphQLObjectId']['input'];
  items: Array<TimeSeriesItemInput>;
  type: Scalars['String']['input'];
};


export type MutationUpsertTransferAgentOrdersArgs = {
  input: Array<TransferAgentOrderInput>;
};


export type MutationUpsertValuationAttachmentsArgs = {
  attachments: Array<AttachmentInput>;
  valuationId: Scalars['GraphQLObjectId']['input'];
};


export type MutationUpsertValuationMappingsArgs = {
  input: Array<ValuationMappingInput>;
};


export type MutationUpsertValuationsArgs = {
  input: Array<PriceInput>;
};

/**
 * NACE is the European Standard for the Classification of Economic Activities.
 * Extracted from https://showvoc.op.europa.eu/#/datasets/ESTAT_Statistical_Classification_of_Economic_Activities_in_the_European_Community_Rev._2.1._%28NACE_2.1%29/downloads
 */
export enum NaceClass {
  /** (A) AGRICULTURE, FORESTRY AND FISHING */
  A = 'A',
  /** (01) Crop and animal production, hunting and related service activities */
  A01 = 'A01',
  /** (02) Forestry and logging */
  A02 = 'A02',
  /** (03) Fishing and aquaculture */
  A03 = 'A03',
  /** (01.1) Growing of non-perennial crops */
  A011 = 'A011',
  /** (01.2) Growing of perennial crops */
  A012 = 'A012',
  /** (01.3) Plant propagation */
  A013 = 'A013',
  /** (01.4) Animal production */
  A014 = 'A014',
  /** (01.5) Mixed farming */
  A015 = 'A015',
  /** (01.6) Support activities to agriculture and post-harvest crop activities */
  A016 = 'A016',
  /** (01.7) Hunting, trapping and related service activities */
  A017 = 'A017',
  /** (02.1) Silviculture and other forestry activities */
  A021 = 'A021',
  /** (02.2) Logging */
  A022 = 'A022',
  /** (02.3) Gathering of wild growing non-wood products */
  A023 = 'A023',
  /** (02.4) Support services to forestry */
  A024 = 'A024',
  /** (03.1) Fishing */
  A031 = 'A031',
  /** (03.2) Aquaculture */
  A032 = 'A032',
  /** (03.3) Support activities for fishing and aquaculture */
  A033 = 'A033',
  /** (01.11) Growing of cereals, other than rice, leguminous crops and oil seeds */
  A0111 = 'A0111',
  /** (01.12) Growing of rice */
  A0112 = 'A0112',
  /** (01.13) Growing of vegetables and melons, roots and tubers */
  A0113 = 'A0113',
  /** (01.14) Growing of sugar cane */
  A0114 = 'A0114',
  /** (01.15) Growing of tobacco */
  A0115 = 'A0115',
  /** (01.16) Growing of fibre crops */
  A0116 = 'A0116',
  /** (01.19) Growing of other non-perennial crops */
  A0119 = 'A0119',
  /** (01.21) Growing of grapes */
  A0121 = 'A0121',
  /** (01.22) Growing of tropical and subtropical fruits */
  A0122 = 'A0122',
  /** (01.23) Growing of citrus fruits */
  A0123 = 'A0123',
  /** (01.24) Growing of pome fruits and stone fruits */
  A0124 = 'A0124',
  /** (01.25) Growing of other tree and bush fruits and nuts */
  A0125 = 'A0125',
  /** (01.26) Growing of oleaginous fruits */
  A0126 = 'A0126',
  /** (01.27) Growing of beverage crops */
  A0127 = 'A0127',
  /** (01.28) Growing of spices, aromatic, drug and pharmaceutical crops */
  A0128 = 'A0128',
  /** (01.29) Growing of other perennial crops */
  A0129 = 'A0129',
  /** (01.30) Plant propagation */
  A0130 = 'A0130',
  /** (01.41) Raising of dairy cattle */
  A0141 = 'A0141',
  /** (01.42) Raising of other cattle and buffaloes */
  A0142 = 'A0142',
  /** (01.43) Raising of horses and other equines */
  A0143 = 'A0143',
  /** (01.44) Raising of camels and camelids */
  A0144 = 'A0144',
  /** (01.45) Raising of sheep and goats */
  A0145 = 'A0145',
  /** (01.46) Raising of swine and pigs */
  A0146 = 'A0146',
  /** (01.47) Raising of poultry */
  A0147 = 'A0147',
  /** (01.48) Raising of other animals */
  A0148 = 'A0148',
  /** (01.50) Mixed farming */
  A0150 = 'A0150',
  /** (01.61) Support activities for crop production */
  A0161 = 'A0161',
  /** (01.62) Support activities for animal production */
  A0162 = 'A0162',
  /** (01.63) Post-harvest crop activities and seed processing for propagation */
  A0163 = 'A0163',
  /** (01.70) Hunting, trapping and related service activities */
  A0170 = 'A0170',
  /** (02.10) Silviculture and other forestry activities */
  A0210 = 'A0210',
  /** (02.20) Logging */
  A0220 = 'A0220',
  /** (02.30) Gathering of wild growing non-wood products */
  A0230 = 'A0230',
  /** (02.40) Support services to forestry */
  A0240 = 'A0240',
  /** (03.11) Marine fishing */
  A0311 = 'A0311',
  /** (03.12) Freshwater fishing */
  A0312 = 'A0312',
  /** (03.21) Marine aquaculture */
  A0321 = 'A0321',
  /** (03.22) Freshwater aquaculture */
  A0322 = 'A0322',
  /** (03.30) Support activities for fishing and aquaculture */
  A0330 = 'A0330',
  /** (B) MINING AND QUARRYING */
  B = 'B',
  /** (05) Mining of coal and lignite */
  B05 = 'B05',
  /** (06) Extraction of crude petroleum and natural gas */
  B06 = 'B06',
  /** (07) Mining of metal ores */
  B07 = 'B07',
  /** (08) Other mining and quarrying */
  B08 = 'B08',
  /** (09) Mining support service activities */
  B09 = 'B09',
  /** (05.1) Mining of hard coal */
  B051 = 'B051',
  /** (05.2) Mining of lignite */
  B052 = 'B052',
  /** (06.1) Extraction of crude petroleum */
  B061 = 'B061',
  /** (06.2) Extraction of natural gas */
  B062 = 'B062',
  /** (07.1) Mining of iron ores */
  B071 = 'B071',
  /** (07.2) Mining of non-ferrous metal ores */
  B072 = 'B072',
  /** (08.1) Quarrying of stone, sand and clay */
  B081 = 'B081',
  /** (08.9) Mining and quarrying n.e.c. */
  B089 = 'B089',
  /** (09.1) Support activities for petroleum and natural gas extraction */
  B091 = 'B091',
  /** (09.9) Support activities for other mining and quarrying */
  B099 = 'B099',
  /** (05.10) Mining of hard coal */
  B0510 = 'B0510',
  /** (05.20) Mining of lignite */
  B0520 = 'B0520',
  /** (06.10) Extraction of crude petroleum */
  B0610 = 'B0610',
  /** (06.20) Extraction of natural gas */
  B0620 = 'B0620',
  /** (07.10) Mining of iron ores */
  B0710 = 'B0710',
  /** (07.21) Mining of uranium and thorium ores */
  B0721 = 'B0721',
  /** (07.29) Mining of other non-ferrous metal ores */
  B0729 = 'B0729',
  /** (08.11) Quarrying of ornamental stone, limestone, gypsum, slate and other stone */
  B0811 = 'B0811',
  /** (08.12) Operation of gravel and sand pits and mining of clay and kaolin */
  B0812 = 'B0812',
  /** (08.91) Mining of chemical and fertiliser minerals */
  B0891 = 'B0891',
  /** (08.92) Extraction of peat */
  B0892 = 'B0892',
  /** (08.93) Extraction of salt */
  B0893 = 'B0893',
  /** (08.99) Other mining and quarrying n.e.c. */
  B0899 = 'B0899',
  /** (09.10) Support activities for petroleum and natural gas extraction */
  B0910 = 'B0910',
  /** (09.90) Support activities for other mining and quarrying */
  B0990 = 'B0990',
  /** (C) MANUFACTURING */
  C = 'C',
  /** (10) Manufacture of food products */
  C10 = 'C10',
  /** (11) Manufacture of beverages */
  C11 = 'C11',
  /** (12) Manufacture of tobacco products */
  C12 = 'C12',
  /** (13) Manufacture of textiles */
  C13 = 'C13',
  /** (14) Manufacture of wearing apparel */
  C14 = 'C14',
  /** (15) Manufacture of leather and related products of other materials */
  C15 = 'C15',
  /** (16) Manufacture of wood and of products of wood and cork, except furniture; manufacture of articles of straw and plaiting materials */
  C16 = 'C16',
  /** (17) Manufacture of paper and paper products */
  C17 = 'C17',
  /** (18) Printing and reproduction of recorded media */
  C18 = 'C18',
  /** (19) Manufacture of coke and refined petroleum products */
  C19 = 'C19',
  /** (20) Manufacture of chemicals and chemical products */
  C20 = 'C20',
  /** (21) Manufacture of basic pharmaceutical products and pharmaceutical preparations */
  C21 = 'C21',
  /** (22) Manufacture of rubber and plastic products */
  C22 = 'C22',
  /** (23) Manufacture of other non-metallic mineral products */
  C23 = 'C23',
  /** (24) Manufacture of basic metals */
  C24 = 'C24',
  /** (25) Manufacture of fabricated metal products, except machinery and equipment */
  C25 = 'C25',
  /** (26) Manufacture of computer, electronic and optical products */
  C26 = 'C26',
  /** (27) Manufacture of electrical equipment */
  C27 = 'C27',
  /** (28) Manufacture of machinery and equipment n.e.c. */
  C28 = 'C28',
  /** (29) Manufacture of motor vehicles, trailers and semi-trailers */
  C29 = 'C29',
  /** (30) Manufacture of other transport equipment */
  C30 = 'C30',
  /** (31) Manufacture of furniture */
  C31 = 'C31',
  /** (32) Other manufacturing */
  C32 = 'C32',
  /** (33) Repair, maintenance and installation of machinery and equipment */
  C33 = 'C33',
  /** (10.1) Processing and preserving of meat and production of meat products */
  C101 = 'C101',
  /** (10.2) Processing and preserving of fish, crustaceans and molluscs */
  C102 = 'C102',
  /** (10.3) Processing and preserving of fruit and vegetables */
  C103 = 'C103',
  /** (10.4) Manufacture of vegetable and animal oils and fats */
  C104 = 'C104',
  /** (10.5) Manufacture of dairy products and edible ice */
  C105 = 'C105',
  /** (10.6) Manufacture of grain mill products, starches and starch products */
  C106 = 'C106',
  /** (10.7) Manufacture of bakery and farinaceous products */
  C107 = 'C107',
  /** (10.8) Manufacture of other food products */
  C108 = 'C108',
  /** (10.9) Manufacture of prepared animal feeds */
  C109 = 'C109',
  /** (11.0) Manufacture of beverages */
  C110 = 'C110',
  /** (12.0) Manufacture of tobacco products */
  C120 = 'C120',
  /** (13.1) Preparation and spinning of textile fibres */
  C131 = 'C131',
  /** (13.2) Weaving of textiles */
  C132 = 'C132',
  /** (13.3) Finishing of textiles */
  C133 = 'C133',
  /** (13.9) Manufacture of other textiles */
  C139 = 'C139',
  /** (14.1) Manufacture of knitted and crocheted apparel */
  C141 = 'C141',
  /** (14.2) Manufacture of other wearing apparel and accessories */
  C142 = 'C142',
  /** (15.1) Tanning, dyeing, dressing of leather and fur; manufacture of luggage, handbags, saddlery and harness */
  C151 = 'C151',
  /** (15.2) Manufacture of footwear */
  C152 = 'C152',
  /** (16.1) Sawmilling and planing of wood; processing and finishing of wood */
  C161 = 'C161',
  /** (16.2) Manufacture of products of wood, cork, straw and plaiting materials */
  C162 = 'C162',
  /** (17.1) Manufacture of pulp, paper and paperboard */
  C171 = 'C171',
  /** (17.2) Manufacture of articles of paper and paperboard */
  C172 = 'C172',
  /** (18.1) Printing and service activities related to printing */
  C181 = 'C181',
  /** (18.2) Reproduction of recorded media */
  C182 = 'C182',
  /** (19.1) Manufacture of coke oven products */
  C191 = 'C191',
  /** (19.2) Manufacture of refined petroleum products and fossil fuel products */
  C192 = 'C192',
  /** (20.1) Manufacture of basic chemicals, fertilisers and nitrogen compounds, plastics and synthetic rubber in primary forms */
  C201 = 'C201',
  /** (20.2) Manufacture of pesticides, disinfectants and other agrochemical products */
  C202 = 'C202',
  /** (20.3) Manufacture of paints, varnishes and similar coatings, printing ink and mastics */
  C203 = 'C203',
  /** (20.4) Manufacture of washing, cleaning and polishing preparations */
  C204 = 'C204',
  /** (20.5) Manufacture of other chemical products */
  C205 = 'C205',
  /** (20.6) Manufacture of man-made fibres */
  C206 = 'C206',
  /** (21.1) Manufacture of basic pharmaceutical products */
  C211 = 'C211',
  /** (21.2) Manufacture of pharmaceutical preparations */
  C212 = 'C212',
  /** (22.1) Manufacture of rubber products */
  C221 = 'C221',
  /** (22.2) Manufacture of plastic products */
  C222 = 'C222',
  /** (23.1) Manufacture of glass and glass products */
  C231 = 'C231',
  /** (23.2) Manufacture of refractory products */
  C232 = 'C232',
  /** (23.3) Manufacture of clay building materials */
  C233 = 'C233',
  /** (23.4) Manufacture of other porcelain and ceramic products */
  C234 = 'C234',
  /** (23.5) Manufacture of cement, lime and plaster */
  C235 = 'C235',
  /** (23.6) Manufacture of articles of concrete, cement and plaster */
  C236 = 'C236',
  /** (23.7) Cutting, shaping and finishing of stone */
  C237 = 'C237',
  /** (23.9) Manufacture of abrasive products and non-metallic mineral products n.e.c. */
  C239 = 'C239',
  /** (24.1) Manufacture of basic iron and steel and of ferro-alloys */
  C241 = 'C241',
  /** (24.2) Manufacture of tubes, pipes, hollow profiles and related fittings, of steel */
  C242 = 'C242',
  /** (24.3) Manufacture of other products of first processing of steel */
  C243 = 'C243',
  /** (24.4) Manufacture of basic precious and other non-ferrous metals */
  C244 = 'C244',
  /** (24.5) Casting of metals */
  C245 = 'C245',
  /** (25.1) Manufacture of structural metal products */
  C251 = 'C251',
  /** (25.2) Manufacture of tanks, reservoirs and containers of metal */
  C252 = 'C252',
  /** (25.3) Manufacture of weapons and ammunition */
  C253 = 'C253',
  /** (25.4) Forging and shaping metal and powder metallurgy */
  C254 = 'C254',
  /** (25.5) Treatment and coating of metals; machining */
  C255 = 'C255',
  /** (25.6) Manufacture of cutlery, tools and general hardware */
  C256 = 'C256',
  /** (25.9) Manufacture of other fabricated metal products */
  C259 = 'C259',
  /** (26.1) Manufacture of electronic components and boards */
  C261 = 'C261',
  /** (26.2) Manufacture of computers and peripheral equipment */
  C262 = 'C262',
  /** (26.3) Manufacture of communication equipment */
  C263 = 'C263',
  /** (26.4) Manufacture of consumer electronics */
  C264 = 'C264',
  /** (26.5) Manufacture of measuring testing instruments, clocks and watches */
  C265 = 'C265',
  /** (26.6) Manufacture of irradiation, electromedical and electrotherapeutic equipment */
  C266 = 'C266',
  /** (26.7) Manufacture of optical instruments, magnetic and optical media and photographic equipment */
  C267 = 'C267',
  /** (27.1) Manufacture of electric motors, generators, transformers and electricity distribution and control apparatus */
  C271 = 'C271',
  /** (27.2) Manufacture of batteries and accumulators */
  C272 = 'C272',
  /** (27.3) Manufacture of wiring and wiring devices */
  C273 = 'C273',
  /** (27.4) Manufacture of lighting equipment */
  C274 = 'C274',
  /** (27.5) Manufacture of domestic appliances */
  C275 = 'C275',
  /** (27.9) Manufacture of other electrical equipment */
  C279 = 'C279',
  /** (28.1) Manufacture of general-purpose machinery */
  C281 = 'C281',
  /** (28.2) Manufacture of other general-purpose machinery */
  C282 = 'C282',
  /** (28.3) Manufacture of agricultural and forestry machinery */
  C283 = 'C283',
  /** (28.4) Manufacture of metal forming machinery and machine tools */
  C284 = 'C284',
  /** (28.9) Manufacture of other special-purpose machinery */
  C289 = 'C289',
  /** (29.1) Manufacture of motor vehicles */
  C291 = 'C291',
  /** (29.2) Manufacture of bodies and coachwork for motor vehicles; manufacture of trailers and semi-trailers */
  C292 = 'C292',
  /** (29.3) Manufacture of motor vehicle parts and accessories */
  C293 = 'C293',
  /** (30.1) Building of ships and boats */
  C301 = 'C301',
  /** (30.2) Manufacture of railway locomotives and rolling stock */
  C302 = 'C302',
  /** (30.3) Manufacture of air and spacecraft and related machinery */
  C303 = 'C303',
  /** (30.4) Manufacture of military fighting vehicles */
  C304 = 'C304',
  /** (30.9) Manufacture of transport equipment n.e.c. */
  C309 = 'C309',
  /** (31.0) Manufacture of furniture */
  C310 = 'C310',
  /** (32.1) Manufacture of jewellery, bijouterie and related articles */
  C321 = 'C321',
  /** (32.2) Manufacture of musical instruments */
  C322 = 'C322',
  /** (32.3) Manufacture of sports goods */
  C323 = 'C323',
  /** (32.4) Manufacture of games and toys */
  C324 = 'C324',
  /** (32.5) Manufacture of medical and dental instruments and supplies */
  C325 = 'C325',
  /** (32.9) Manufacturing n.e.c. */
  C329 = 'C329',
  /** (33.1) Repair and maintenance of fabricated metal products, machinery and equipment */
  C331 = 'C331',
  /** (33.2) Installation of industrial machinery and equipment */
  C332 = 'C332',
  /** (10.11) Processing and preserving of meat, except of poultry meat */
  C1011 = 'C1011',
  /** (10.12) Processing and preserving of poultry meat */
  C1012 = 'C1012',
  /** (10.13) Production of meat and poultry meat products */
  C1013 = 'C1013',
  /** (10.20) Processing and preserving of fish, crustaceans and molluscs */
  C1020 = 'C1020',
  /** (10.31) Processing and preserving of potatoes */
  C1031 = 'C1031',
  /** (10.32) Manufacture of fruit and vegetable juice */
  C1032 = 'C1032',
  /** (10.39) Other processing and preserving of fruit and vegetables */
  C1039 = 'C1039',
  /** (10.41) Manufacture of oils and fats */
  C1041 = 'C1041',
  /** (10.42) Manufacture of margarine and similar edible fats */
  C1042 = 'C1042',
  /** (10.51) Manufacture of dairy products */
  C1051 = 'C1051',
  /** (10.52) Manufacture of ice cream and other edible ice */
  C1052 = 'C1052',
  /** (10.61) Manufacture of grain mill products */
  C1061 = 'C1061',
  /** (10.62) Manufacture of starches and starch products */
  C1062 = 'C1062',
  /** (10.71) Manufacture of bread; manufacture of fresh pastry goods and cakes */
  C1071 = 'C1071',
  /** (10.72) Manufacture of rusks, biscuits, preserved pastries and cakes */
  C1072 = 'C1072',
  /** (10.73) Manufacture of farinaceous products */
  C1073 = 'C1073',
  /** (10.81) Manufacture of sugar */
  C1081 = 'C1081',
  /** (10.82) Manufacture of cocoa, chocolate and sugar confectionery */
  C1082 = 'C1082',
  /** (10.83) Processing of tea and coffee */
  C1083 = 'C1083',
  /** (10.84) Manufacture of condiments and seasonings */
  C1084 = 'C1084',
  /** (10.85) Manufacture of prepared meals and dishes */
  C1085 = 'C1085',
  /** (10.86) Manufacture of homogenised food preparations and dietetic food */
  C1086 = 'C1086',
  /** (10.89) Manufacture of other food products n.e.c. */
  C1089 = 'C1089',
  /** (10.91) Manufacture of prepared feeds for farm animals */
  C1091 = 'C1091',
  /** (10.92) Manufacture of prepared pet foods */
  C1092 = 'C1092',
  /** (11.01) Distilling, rectifying and blending of spirits */
  C1101 = 'C1101',
  /** (11.02) Manufacture of wine from grape */
  C1102 = 'C1102',
  /** (11.03) Manufacture of cider and other fruit fermented beverages */
  C1103 = 'C1103',
  /** (11.04) Manufacture of other non-distilled fermented beverages */
  C1104 = 'C1104',
  /** (11.05) Manufacture of beer */
  C1105 = 'C1105',
  /** (11.06) Manufacture of malt */
  C1106 = 'C1106',
  /** (11.07) Manufacture of soft drinks and bottled waters */
  C1107 = 'C1107',
  /** (12.00) Manufacture of tobacco products */
  C1200 = 'C1200',
  /** (13.10) Preparation and spinning of textile fibres */
  C1310 = 'C1310',
  /** (13.20) Weaving of textiles */
  C1320 = 'C1320',
  /** (13.30) Finishing of textiles */
  C1330 = 'C1330',
  /** (13.91) Manufacture of knitted and crocheted fabrics */
  C1391 = 'C1391',
  /** (13.92) Manufacture of household textiles and made-up furnishing articles */
  C1392 = 'C1392',
  /** (13.93) Manufacture of carpets and rugs */
  C1393 = 'C1393',
  /** (13.94) Manufacture of cordage, rope, twine and netting */
  C1394 = 'C1394',
  /** (13.95) Manufacture of non-wovens and non-woven articles */
  C1395 = 'C1395',
  /** (13.96) Manufacture of other technical and industrial textiles */
  C1396 = 'C1396',
  /** (13.99) Manufacture of other textiles n.e.c. */
  C1399 = 'C1399',
  /** (14.10) Manufacture of knitted and crocheted apparel */
  C1410 = 'C1410',
  /** (14.21) Manufacture of outerwear */
  C1421 = 'C1421',
  /** (14.22) Manufacture of underwear */
  C1422 = 'C1422',
  /** (14.23) Manufacture of workwear */
  C1423 = 'C1423',
  /** (14.24) Manufacture of leather clothes and fur apparel */
  C1424 = 'C1424',
  /** (14.29) Manufacture of other wearing apparel and accessories n.e.c. */
  C1429 = 'C1429',
  /** (15.11) Tanning, dressing, dyeing of leather and fur */
  C1511 = 'C1511',
  /** (15.12) Manufacture of luggage, handbags, saddlery and harness of any material */
  C1512 = 'C1512',
  /** (15.20) Manufacture of footwear */
  C1520 = 'C1520',
  /** (16.11) Sawmilling and planing of wood */
  C1611 = 'C1611',
  /** (16.12) Processing and finishing of wood */
  C1612 = 'C1612',
  /** (16.21) Manufacture of veneer sheets and wood-based panels */
  C1621 = 'C1621',
  /** (16.22) Manufacture of assembled parquet floors */
  C1622 = 'C1622',
  /** (16.23) Manufacture of other builders' carpentry and joinery */
  C1623 = 'C1623',
  /** (16.24) Manufacture of wooden containers */
  C1624 = 'C1624',
  /** (16.25) Manufacture of doors and windows of wood */
  C1625 = 'C1625',
  /** (16.26) Manufacture of solid fuels from vegetable biomass */
  C1626 = 'C1626',
  /** (16.27) Finishing of wooden products */
  C1627 = 'C1627',
  /** (16.28) Manufacture of other products of wood and articles of cork, straw and plaiting materials */
  C1628 = 'C1628',
  /** (17.11) Manufacture of pulp */
  C1711 = 'C1711',
  /** (17.12) Manufacture of paper and paperboard */
  C1712 = 'C1712',
  /** (17.21) Manufacture of corrugated paper, paperboard and containers of paper and paperboard */
  C1721 = 'C1721',
  /** (17.22) Manufacture of household and sanitary goods and of toilet requisites */
  C1722 = 'C1722',
  /** (17.23) Manufacture of paper stationery */
  C1723 = 'C1723',
  /** (17.24) Manufacture of wallpaper */
  C1724 = 'C1724',
  /** (17.25) Manufacture of other articles of paper and paperboard */
  C1725 = 'C1725',
  /** (18.11) Printing of newspapers */
  C1811 = 'C1811',
  /** (18.12) Other printing */
  C1812 = 'C1812',
  /** (18.13) Pre-press and pre-media services */
  C1813 = 'C1813',
  /** (18.14) Binding and related services */
  C1814 = 'C1814',
  /** (18.20) Reproduction of recorded media */
  C1820 = 'C1820',
  /** (19.10) Manufacture of coke oven products */
  C1910 = 'C1910',
  /** (19.20) Manufacture of refined petroleum products and fossil fuel products */
  C1920 = 'C1920',
  /** (20.11) Manufacture of industrial gases */
  C2011 = 'C2011',
  /** (20.12) Manufacture of dyes and pigments */
  C2012 = 'C2012',
  /** (20.13) Manufacture of other inorganic basic chemicals */
  C2013 = 'C2013',
  /** (20.14) Manufacture of other organic basic chemicals */
  C2014 = 'C2014',
  /** (20.15) Manufacture of fertilisers and nitrogen compounds */
  C2015 = 'C2015',
  /** (20.16) Manufacture of plastics in primary forms */
  C2016 = 'C2016',
  /** (20.17) Manufacture of synthetic rubber in primary forms */
  C2017 = 'C2017',
  /** (20.20) Manufacture of pesticides, disinfectants and other agrochemical products */
  C2020 = 'C2020',
  /** (20.30) Manufacture of paints, varnishes and similar coatings, printing ink and mastics */
  C2030 = 'C2030',
  /** (20.41) Manufacture of soap and detergents, cleaning and polishing preparations */
  C2041 = 'C2041',
  /** (20.42) Manufacture of perfumes and toilet preparations */
  C2042 = 'C2042',
  /** (20.51) Manufacture of liquid biofuels */
  C2051 = 'C2051',
  /** (20.59) Manufacture of other chemical products n.e.c. */
  C2059 = 'C2059',
  /** (20.60) Manufacture of man-made fibres */
  C2060 = 'C2060',
  /** (21.10) Manufacture of basic pharmaceutical products */
  C2110 = 'C2110',
  /** (21.20) Manufacture of pharmaceutical preparations */
  C2120 = 'C2120',
  /** (22.11) Manufacture, retreading and rebuilding of rubber tyres and manufacture of tubes */
  C2211 = 'C2211',
  /** (22.12) Manufacture of other rubber products */
  C2212 = 'C2212',
  /** (22.21) Manufacture of plastic plates, sheets, tubes and profiles */
  C2221 = 'C2221',
  /** (22.22) Manufacture of plastic packing goods */
  C2222 = 'C2222',
  /** (22.23) Manufacture of doors and windows of plastic */
  C2223 = 'C2223',
  /** (22.24) Manufacture of builders’ ware of plastic */
  C2224 = 'C2224',
  /** (22.25) Processing and finishing of plastic products */
  C2225 = 'C2225',
  /** (22.26) Manufacture of other plastic products */
  C2226 = 'C2226',
  /** (23.11) Manufacture of flat glass */
  C2311 = 'C2311',
  /** (23.12) Shaping and processing of flat glass */
  C2312 = 'C2312',
  /** (23.13) Manufacture of hollow glass */
  C2313 = 'C2313',
  /** (23.14) Manufacture of glass fibres */
  C2314 = 'C2314',
  /** (23.15) Manufacture and processing of other glass, including technical glassware */
  C2315 = 'C2315',
  /** (23.20) Manufacture of refractory products */
  C2320 = 'C2320',
  /** (23.31) Manufacture of ceramic tiles and flags */
  C2331 = 'C2331',
  /** (23.32) Manufacture of bricks, tiles and construction products, in baked clay */
  C2332 = 'C2332',
  /** (23.41) Manufacture of ceramic household and ornamental articles */
  C2341 = 'C2341',
  /** (23.42) Manufacture of ceramic sanitary fixtures */
  C2342 = 'C2342',
  /** (23.43) Manufacture of ceramic insulators and insulating fittings */
  C2343 = 'C2343',
  /** (23.44) Manufacture of other technical ceramic products */
  C2344 = 'C2344',
  /** (23.45) Manufacture of other ceramic products */
  C2345 = 'C2345',
  /** (23.51) Manufacture of cement */
  C2351 = 'C2351',
  /** (23.52) Manufacture of lime and plaster */
  C2352 = 'C2352',
  /** (23.61) Manufacture of concrete products for construction purposes */
  C2361 = 'C2361',
  /** (23.62) Manufacture of plaster products for construction purposes */
  C2362 = 'C2362',
  /** (23.63) Manufacture of ready-mixed concrete */
  C2363 = 'C2363',
  /** (23.64) Manufacture of mortars */
  C2364 = 'C2364',
  /** (23.65) Manufacture of fibre cement */
  C2365 = 'C2365',
  /** (23.66) Manufacture of other articles of concrete, cement and plaster */
  C2366 = 'C2366',
  /** (23.70) Cutting, shaping and finishing of stone */
  C2370 = 'C2370',
  /** (23.91) Manufacture of abrasive products */
  C2391 = 'C2391',
  /** (23.99) Manufacture of other non-metallic mineral products n.e.c. */
  C2399 = 'C2399',
  /** (24.10) Manufacture of basic iron and steel and of ferro-alloys */
  C2410 = 'C2410',
  /** (24.20) Manufacture of tubes, pipes, hollow profiles and related fittings, of steel */
  C2420 = 'C2420',
  /** (24.31) Cold drawing of bars */
  C2431 = 'C2431',
  /** (24.32) Cold rolling of narrow strip */
  C2432 = 'C2432',
  /** (24.33) Cold forming or folding */
  C2433 = 'C2433',
  /** (24.34) Cold drawing of wire */
  C2434 = 'C2434',
  /** (24.41) Precious metals production */
  C2441 = 'C2441',
  /** (24.42) Aluminium production */
  C2442 = 'C2442',
  /** (24.43) Lead, zinc and tin production */
  C2443 = 'C2443',
  /** (24.44) Copper production */
  C2444 = 'C2444',
  /** (24.45) Other non-ferrous metal production */
  C2445 = 'C2445',
  /** (24.46) Processing of nuclear fuel */
  C2446 = 'C2446',
  /** (24.51) Casting of iron */
  C2451 = 'C2451',
  /** (24.52) Casting of steel */
  C2452 = 'C2452',
  /** (24.53) Casting of light metals */
  C2453 = 'C2453',
  /** (24.54) Casting of other non-ferrous metals */
  C2454 = 'C2454',
  /** (25.11) Manufacture of metal structures and parts of structures */
  C2511 = 'C2511',
  /** (25.12) Manufacture of doors and windows of metal */
  C2512 = 'C2512',
  /** (25.21) Manufacture of central heating radiators, steam generators and boilers */
  C2521 = 'C2521',
  /** (25.22) Manufacture of other tanks, reservoirs and containers of metal */
  C2522 = 'C2522',
  /** (25.30) Manufacture of weapons and ammunition */
  C2530 = 'C2530',
  /** (25.40) Forging and shaping metal and powder metallurgy */
  C2540 = 'C2540',
  /** (25.51) Coating of metals */
  C2551 = 'C2551',
  /** (25.52) Heat treatment of metals */
  C2552 = 'C2552',
  /** (25.53) Machining of metals */
  C2553 = 'C2553',
  /** (25.61) Manufacture of cutlery */
  C2561 = 'C2561',
  /** (25.62) Manufacture of locks and hinges */
  C2562 = 'C2562',
  /** (25.63) Manufacture of tools */
  C2563 = 'C2563',
  /** (25.91) Manufacture of steel drums and similar containers */
  C2591 = 'C2591',
  /** (25.92) Manufacture of light metal packaging */
  C2592 = 'C2592',
  /** (25.93) Manufacture of wire products, chain and springs */
  C2593 = 'C2593',
  /** (25.94) Manufacture of fasteners and screw machine products */
  C2594 = 'C2594',
  /** (25.99) Manufacture of other fabricated metal products n.e.c. */
  C2599 = 'C2599',
  /** (26.11) Manufacture of electronic components */
  C2611 = 'C2611',
  /** (26.12) Manufacture of loaded electronic boards */
  C2612 = 'C2612',
  /** (26.20) Manufacture of computers and peripheral equipment */
  C2620 = 'C2620',
  /** (26.30) Manufacture of communication equipment */
  C2630 = 'C2630',
  /** (26.40) Manufacture of consumer electronics */
  C2640 = 'C2640',
  /** (26.51) Manufacture of instruments and appliances for measuring, testing and navigation */
  C2651 = 'C2651',
  /** (26.52) Manufacture of watches and clocks */
  C2652 = 'C2652',
  /** (26.60) Manufacture of irradiation, electromedical and electrotherapeutic equipment */
  C2660 = 'C2660',
  /** (26.70) Manufacture of optical instruments, magnetic and optical media and photographic equipment */
  C2670 = 'C2670',
  /** (27.11) Manufacture of electric motors, generators and transformers */
  C2711 = 'C2711',
  /** (27.12) Manufacture of electricity distribution and control apparatus */
  C2712 = 'C2712',
  /** (27.20) Manufacture of batteries and accumulators */
  C2720 = 'C2720',
  /** (27.31) Manufacture of fibre optic cables */
  C2731 = 'C2731',
  /** (27.32) Manufacture of other electronic and electric wires and cables */
  C2732 = 'C2732',
  /** (27.33) Manufacture of wiring devices */
  C2733 = 'C2733',
  /** (27.40) Manufacture of lighting equipment */
  C2740 = 'C2740',
  /** (27.51) Manufacture of electric domestic appliances */
  C2751 = 'C2751',
  /** (27.52) Manufacture of non-electric domestic appliances */
  C2752 = 'C2752',
  /** (27.90) Manufacture of other electrical equipment */
  C2790 = 'C2790',
  /** (28.11) Manufacture of engines and turbines, except aircraft, vehicle and cycle engines */
  C2811 = 'C2811',
  /** (28.12) Manufacture of fluid power equipment */
  C2812 = 'C2812',
  /** (28.13) Manufacture of other pumps and compressors */
  C2813 = 'C2813',
  /** (28.14) Manufacture of other taps and valves */
  C2814 = 'C2814',
  /** (28.15) Manufacture of bearings, gears, gearing and driving elements */
  C2815 = 'C2815',
  /** (28.21) Manufacture of ovens, furnaces and permanent household heating equipment */
  C2821 = 'C2821',
  /** (28.22) Manufacture of lifting and handling equipment */
  C2822 = 'C2822',
  /** (28.23) Manufacture of office machinery and equipment, except computers and peripheral equipment */
  C2823 = 'C2823',
  /** (28.24) Manufacture of power-driven hand tools */
  C2824 = 'C2824',
  /** (28.25) Manufacture of non-domestic air conditioning equipment */
  C2825 = 'C2825',
  /** (28.29) Manufacture of other general-purpose machinery n.e.c. */
  C2829 = 'C2829',
  /** (28.30) Manufacture of agricultural and forestry machinery */
  C2830 = 'C2830',
  /** (28.41) Manufacture of metal forming machinery and machine tools for metal work */
  C2841 = 'C2841',
  /** (28.42) Manufacture of other machine tools */
  C2842 = 'C2842',
  /** (28.91) Manufacture of machinery for metallurgy */
  C2891 = 'C2891',
  /** (28.92) Manufacture of machinery for mining, quarrying and construction */
  C2892 = 'C2892',
  /** (28.93) Manufacture of machinery for food, beverage and tobacco processing */
  C2893 = 'C2893',
  /** (28.94) Manufacture of machinery for textile, apparel and leather production */
  C2894 = 'C2894',
  /** (28.95) Manufacture of machinery for paper and paperboard production */
  C2895 = 'C2895',
  /** (28.96) Manufacture of plastics and rubber machinery */
  C2896 = 'C2896',
  /** (28.97) Manufacture of additive manufacturing machinery */
  C2897 = 'C2897',
  /** (28.99) Manufacture of other special-purpose machinery n.e.c. */
  C2899 = 'C2899',
  /** (29.10) Manufacture of motor vehicles */
  C2910 = 'C2910',
  /** (29.20) Manufacture of bodies and coachwork for motor vehicles; manufacture of trailers and semi-trailers */
  C2920 = 'C2920',
  /** (29.31) Manufacture of electrical and electronic equipment for motor vehicles */
  C2931 = 'C2931',
  /** (29.32) Manufacture of other parts and accessories for motor vehicles */
  C2932 = 'C2932',
  /** (30.11) Building of civilian ships and floating structures */
  C3011 = 'C3011',
  /** (30.12) Building of pleasure and sporting boats */
  C3012 = 'C3012',
  /** (30.13) Building of military ships and vessels */
  C3013 = 'C3013',
  /** (30.20) Manufacture of railway locomotives and rolling stock */
  C3020 = 'C3020',
  /** (30.31) Manufacture of civilian air and spacecraft and related machinery */
  C3031 = 'C3031',
  /** (30.32) Manufacture of military air and spacecraft and related machinery */
  C3032 = 'C3032',
  /** (30.40) Manufacture of military fighting vehicles */
  C3040 = 'C3040',
  /** (30.91) Manufacture of motorcycles */
  C3091 = 'C3091',
  /** (30.92) Manufacture of bicycles and invalid carriages */
  C3092 = 'C3092',
  /** (30.99) Manufacture of other transport equipment n.e.c. */
  C3099 = 'C3099',
  /** (31.00) Manufacture of furniture */
  C3100 = 'C3100',
  /** (32.11) Striking of coins */
  C3211 = 'C3211',
  /** (32.12) Manufacture of jewellery and related articles */
  C3212 = 'C3212',
  /** (32.13) Manufacture of imitation jewellery and related articles */
  C3213 = 'C3213',
  /** (32.20) Manufacture of musical instruments */
  C3220 = 'C3220',
  /** (32.30) Manufacture of sports goods */
  C3230 = 'C3230',
  /** (32.40) Manufacture of games and toys */
  C3240 = 'C3240',
  /** (32.50) Manufacture of medical and dental instruments and supplies */
  C3250 = 'C3250',
  /** (32.91) Manufacture of brooms and brushes */
  C3291 = 'C3291',
  /** (32.99) Other manufacturing n.e.c. */
  C3299 = 'C3299',
  /** (33.11) Repair and maintenance of fabricated metal products */
  C3311 = 'C3311',
  /** (33.12) Repair and maintenance of machinery */
  C3312 = 'C3312',
  /** (33.13) Repair and maintenance of electronic and optical equipment */
  C3313 = 'C3313',
  /** (33.14) Repair and maintenance of electrical equipment */
  C3314 = 'C3314',
  /** (33.15) Repair and maintenance of civilian ships and boats */
  C3315 = 'C3315',
  /** (33.16) Repair and maintenance of civilian air and spacecraft */
  C3316 = 'C3316',
  /** (33.17) Repair and maintenance of other civilian transport equipment */
  C3317 = 'C3317',
  /** (33.18) Repair and maintenance of military fighting vehicles, ships, boats, air and spacecraft */
  C3318 = 'C3318',
  /** (33.19) Repair and maintenance of other equipment */
  C3319 = 'C3319',
  /** (33.20) Installation of industrial machinery and equipment */
  C3320 = 'C3320',
  /** (D) ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY */
  D = 'D',
  /** (35) Electricity, gas, steam and air conditioning supply */
  D35 = 'D35',
  /** (35.1) Electric power generation, transmission and distribution */
  D351 = 'D351',
  /** (35.2) Manufacture of gas, and distribution of gaseous fuels through mains */
  D352 = 'D352',
  /** (35.3) Steam and air conditioning supply */
  D353 = 'D353',
  /** (35.4) Activities of brokers and agents for electric power and natural gas */
  D354 = 'D354',
  /** (35.11) Production of electricity from non-renewable sources */
  D3511 = 'D3511',
  /** (35.12) Production of electricity from renewable sources */
  D3512 = 'D3512',
  /** (35.13) Transmission of electricity */
  D3513 = 'D3513',
  /** (35.14) Distribution of electricity */
  D3514 = 'D3514',
  /** (35.15) Trade of electricity */
  D3515 = 'D3515',
  /** (35.16) Storage of electricity */
  D3516 = 'D3516',
  /** (35.21) Manufacture of gas */
  D3521 = 'D3521',
  /** (35.22) Distribution of gaseous fuels through mains */
  D3522 = 'D3522',
  /** (35.23) Trade of gas through mains */
  D3523 = 'D3523',
  /** (35.24) Storage of gas as part of network supply services */
  D3524 = 'D3524',
  /** (35.30) Steam and air conditioning supply */
  D3530 = 'D3530',
  /** (35.40) Activities of brokers and agents for electric power and natural gas */
  D3540 = 'D3540',
  /** (E) WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES */
  E = 'E',
  /** (36) Water collection, treatment and supply */
  E36 = 'E36',
  /** (37) Sewerage */
  E37 = 'E37',
  /** (38) Waste collection, recovery and disposal activities */
  E38 = 'E38',
  /** (39) Remediation activities and other waste management service activities */
  E39 = 'E39',
  /** (36.0) Water collection, treatment and supply */
  E360 = 'E360',
  /** (37.0) Sewerage */
  E370 = 'E370',
  /** (38.1) Waste collection */
  E381 = 'E381',
  /** (38.2) Waste recovery */
  E382 = 'E382',
  /** (38.3) Waste disposal without recovery */
  E383 = 'E383',
  /** (39.0) Remediation activities and other waste management service activities */
  E390 = 'E390',
  /** (36.00) Water collection, treatment and supply */
  E3600 = 'E3600',
  /** (37.00) Sewerage */
  E3700 = 'E3700',
  /** (38.11) Collection of non-hazardous waste */
  E3811 = 'E3811',
  /** (38.12) Collection of hazardous waste */
  E3812 = 'E3812',
  /** (38.21) Materials recovery */
  E3821 = 'E3821',
  /** (38.22) Energy recovery */
  E3822 = 'E3822',
  /** (38.23) Other waste recovery */
  E3823 = 'E3823',
  /** (38.31) Incineration without energy recovery */
  E3831 = 'E3831',
  /** (38.32) Landfilling or permanent storage */
  E3832 = 'E3832',
  /** (38.33) Other waste disposal */
  E3833 = 'E3833',
  /** (39.00) Remediation activities and other waste management service activities */
  E3900 = 'E3900',
  /** (F) CONSTRUCTION */
  F = 'F',
  /** (41) Construction of residential and non-residential buildings */
  F41 = 'F41',
  /** (42) Civil engineering */
  F42 = 'F42',
  /** (43) Specialised construction activities */
  F43 = 'F43',
  /** (41.0) Construction of residential and non-residential buildings */
  F410 = 'F410',
  /** (42.1) Construction of roads and railways */
  F421 = 'F421',
  /** (42.2) Construction of utility projects */
  F422 = 'F422',
  /** (42.9) Construction of other civil engineering projects */
  F429 = 'F429',
  /** (43.1) Demolition and site preparation */
  F431 = 'F431',
  /** (43.2) Electrical, plumbing and other construction installation activities */
  F432 = 'F432',
  /** (43.3) Building completion and finishing */
  F433 = 'F433',
  /** (43.4) Specialised construction activities in construction of buildings */
  F434 = 'F434',
  /** (43.5) Specialised construction activities in civil engineering */
  F435 = 'F435',
  /** (43.6) Intermediation service activities for specialised construction services */
  F436 = 'F436',
  /** (43.9) Other specialised construction activities */
  F439 = 'F439',
  /** (41.00) Construction of residential and non-residential buildings */
  F4100 = 'F4100',
  /** (42.11) Construction of roads and motorways */
  F4211 = 'F4211',
  /** (42.12) Construction of railways and underground railways */
  F4212 = 'F4212',
  /** (42.13) Construction of bridges and tunnels */
  F4213 = 'F4213',
  /** (42.21) Construction of utility projects for fluids */
  F4221 = 'F4221',
  /** (42.22) Construction of utility projects for electricity and telecommunications */
  F4222 = 'F4222',
  /** (42.91) Construction of water projects */
  F4291 = 'F4291',
  /** (42.99) Construction of other civil engineering projects n.e.c. */
  F4299 = 'F4299',
  /** (43.11) Demolition */
  F4311 = 'F4311',
  /** (43.12) Site preparation */
  F4312 = 'F4312',
  /** (43.13) Test drilling and boring */
  F4313 = 'F4313',
  /** (43.21) Electrical installation */
  F4321 = 'F4321',
  /** (43.22) Plumbing, heat and air-conditioning installation */
  F4322 = 'F4322',
  /** (43.23) Installation of insulation */
  F4323 = 'F4323',
  /** (43.24) Other construction installation */
  F4324 = 'F4324',
  /** (43.31) Plastering */
  F4331 = 'F4331',
  /** (43.32) Joinery installation */
  F4332 = 'F4332',
  /** (43.33) Floor and wall covering */
  F4333 = 'F4333',
  /** (43.34) Painting and glazing */
  F4334 = 'F4334',
  /** (43.35) Other building completion and finishing */
  F4335 = 'F4335',
  /** (43.41) Roofing activities */
  F4341 = 'F4341',
  /** (43.42) Other specialised construction activities in construction of buildings */
  F4342 = 'F4342',
  /** (43.50) Specialised construction activities in civil engineering */
  F4350 = 'F4350',
  /** (43.60) Intermediation service activities for specialised construction services */
  F4360 = 'F4360',
  /** (43.91) Masonry and bricklaying activities */
  F4391 = 'F4391',
  /** (43.99) Other specialised construction activities n.e.c. */
  F4399 = 'F4399',
  /** (G) WHOLESALE AND RETAIL TRADE */
  G = 'G',
  /** (46) Wholesale trade */
  G46 = 'G46',
  /** (47) Retail trade */
  G47 = 'G47',
  /** (46.1) Wholesale on a fee or contract basis */
  G461 = 'G461',
  /** (46.2) Wholesale of agricultural raw materials and live animals */
  G462 = 'G462',
  /** (46.3) Wholesale of food, beverages and tobacco */
  G463 = 'G463',
  /** (46.4) Wholesale of household goods */
  G464 = 'G464',
  /** (46.5) Wholesale of information and communication equipment */
  G465 = 'G465',
  /** (46.6) Wholesale of other machinery, equipment and supplies */
  G466 = 'G466',
  /** (46.7) Wholesale of motor vehicles, motorcycles and related parts and accessories */
  G467 = 'G467',
  /** (46.8) Other specialised wholesale */
  G468 = 'G468',
  /** (46.9) Non-specialised wholesale trade */
  G469 = 'G469',
  /** (47.1) Non-specialised retail sale */
  G471 = 'G471',
  /** (47.2) Retail sale of food, beverages and tobacco */
  G472 = 'G472',
  /** (47.3) Retail sale of automotive fuel */
  G473 = 'G473',
  /** (47.4) Retail sale of information and communication equipment */
  G474 = 'G474',
  /** (47.5) Retail sale of other household equipment */
  G475 = 'G475',
  /** (47.6) Retail sale of cultural and recreational goods */
  G476 = 'G476',
  /** (47.7) Retail sale of other goods, except motor vehicles and motorcycles */
  G477 = 'G477',
  /** (47.8) Retail sale of motor vehicles, motorcycles and related parts and accessories */
  G478 = 'G478',
  /** (47.9) Intermediation service activities for retail sale */
  G479 = 'G479',
  /** (46.11) Activities of agents involved in the wholesale of agricultural raw materials, live animals, textile raw materials and semi-finished goods */
  G4611 = 'G4611',
  /** (46.12) Activities of agents involved in the wholesale of fuels, ores, metals and industrial chemicals */
  G4612 = 'G4612',
  /** (46.13) Activities of agents involved in the wholesale of timber and building materials */
  G4613 = 'G4613',
  /** (46.14) Activities of agents involved in the wholesale of machinery, industrial equipment, ships and aircraft */
  G4614 = 'G4614',
  /** (46.15) Activities of agents involved in the wholesale of furniture, household goods, hardware and ironmongery */
  G4615 = 'G4615',
  /** (46.16) Activities of agents involved in the wholesale of textiles, clothing, fur, footwear and leather goods */
  G4616 = 'G4616',
  /** (46.17) Activities of agents involved in the wholesale of food, beverages and tobacco */
  G4617 = 'G4617',
  /** (46.18) Activities of agents involved in the wholesale of other particular products */
  G4618 = 'G4618',
  /** (46.19) Activities of agents involved in non-specialised wholesale */
  G4619 = 'G4619',
  /** (46.21) Wholesale of grain, unmanufactured tobacco, seeds and animal feeds */
  G4621 = 'G4621',
  /** (46.22) Wholesale of flowers and plants */
  G4622 = 'G4622',
  /** (46.23) Wholesale of live animals */
  G4623 = 'G4623',
  /** (46.24) Wholesale of hides, skins and leather */
  G4624 = 'G4624',
  /** (46.31) Wholesale of fruit and vegetables */
  G4631 = 'G4631',
  /** (46.32) Wholesale of meat, meat products, fish and fish products */
  G4632 = 'G4632',
  /** (46.33) Wholesale of dairy products, eggs and edible oils and fats */
  G4633 = 'G4633',
  /** (46.34) Wholesale of beverages */
  G4634 = 'G4634',
  /** (46.35) Wholesale of tobacco products */
  G4635 = 'G4635',
  /** (46.36) Wholesale of sugar, chocolate and sugar confectionery */
  G4636 = 'G4636',
  /** (46.37) Wholesale of coffee, tea, cocoa and spices */
  G4637 = 'G4637',
  /** (46.38) Wholesale of other food */
  G4638 = 'G4638',
  /** (46.39) Non-specialised wholesale of food, beverages and tobacco */
  G4639 = 'G4639',
  /** (46.41) Wholesale of textiles */
  G4641 = 'G4641',
  /** (46.42) Wholesale of clothing and footwear */
  G4642 = 'G4642',
  /** (46.43) Wholesale of electrical household appliances */
  G4643 = 'G4643',
  /** (46.44) Wholesale of china and glassware and cleaning materials */
  G4644 = 'G4644',
  /** (46.45) Wholesale of perfume and cosmetics */
  G4645 = 'G4645',
  /** (46.46) Wholesale of pharmaceutical and medical goods */
  G4646 = 'G4646',
  /** (46.47) Wholesale of household, office and shop furniture, carpets and lighting equipment */
  G4647 = 'G4647',
  /** (46.48) Wholesale of watches and jewellery */
  G4648 = 'G4648',
  /** (46.49) Wholesale of other household goods */
  G4649 = 'G4649',
  /** (46.50) Wholesale of information and communication equipment */
  G4650 = 'G4650',
  /** (46.61) Wholesale of agricultural machinery, equipment and supplies */
  G4661 = 'G4661',
  /** (46.62) Wholesale of machine tools */
  G4662 = 'G4662',
  /** (46.63) Wholesale of mining, construction and civil engineering machinery */
  G4663 = 'G4663',
  /** (46.64) Wholesale of other machinery and equipment */
  G4664 = 'G4664',
  /** (46.71) Wholesale of motor vehicles */
  G4671 = 'G4671',
  /** (46.72) Wholesale of motor vehicle parts and accessories */
  G4672 = 'G4672',
  /** (46.73) Wholesale of motorcycles, motorcycle parts and accessories */
  G4673 = 'G4673',
  /** (46.81) Wholesale of solid, liquid and gaseous fuels and related products */
  G4681 = 'G4681',
  /** (46.82) Wholesale of metals and metal ores */
  G4682 = 'G4682',
  /** (46.83) Wholesale of wood, construction materials and sanitary equipment */
  G4683 = 'G4683',
  /** (46.84) Wholesale of hardware, plumbing and heating equipment and supplies */
  G4684 = 'G4684',
  /** (46.85) Wholesale of chemical products */
  G4685 = 'G4685',
  /** (46.86) Wholesale of other intermediate products */
  G4686 = 'G4686',
  /** (46.87) Wholesale of waste and scrap */
  G4687 = 'G4687',
  /** (46.89) Other specialised wholesale n.e.c. */
  G4689 = 'G4689',
  /** (46.90) Non-specialised wholesale trade */
  G4690 = 'G4690',
  /** (47.11) Non-specialised retail sale of predominately food, beverages or tobacco */
  G4711 = 'G4711',
  /** (47.12) Other non-specialised retail sale */
  G4712 = 'G4712',
  /** (47.21) Retail sale of fruit and vegetables */
  G4721 = 'G4721',
  /** (47.22) Retail sale of meat and meat products */
  G4722 = 'G4722',
  /** (47.23) Retail sale of fish, crustaceans and molluscs */
  G4723 = 'G4723',
  /** (47.24) Retail sale of bread, cake and confectionery */
  G4724 = 'G4724',
  /** (47.25) Retail sale of beverages */
  G4725 = 'G4725',
  /** (47.26) Retail sale of tobacco products */
  G4726 = 'G4726',
  /** (47.27) Retail sale of other food */
  G4727 = 'G4727',
  /** (47.30) Retail sale of automotive fuel */
  G4730 = 'G4730',
  /** (47.40) Retail sale of information and communication equipment */
  G4740 = 'G4740',
  /** (47.51) Retail sale of textiles */
  G4751 = 'G4751',
  /** (47.52) Retail sale of hardware, building materials, paints and glass */
  G4752 = 'G4752',
  /** (47.53) Retail sale of carpets, rugs, wall and floor coverings */
  G4753 = 'G4753',
  /** (47.54) Retail sale of electrical household appliances */
  G4754 = 'G4754',
  /** (47.55) Retail sale of furniture, lighting equipment, tableware and other household goods */
  G4755 = 'G4755',
  /** (47.61) Retail sale of books */
  G4761 = 'G4761',
  /** (47.62) Retail sale of newspapers, and other periodical publications and stationery */
  G4762 = 'G4762',
  /** (47.63) Retail sale of sporting equipment */
  G4763 = 'G4763',
  /** (47.64) Retail sale of games and toys */
  G4764 = 'G4764',
  /** (47.69) Retail sale of cultural and recreational goods n.e.c. */
  G4769 = 'G4769',
  /** (47.71) Retail sale of clothing */
  G4771 = 'G4771',
  /** (47.72) Retail sale of footwear and leather goods */
  G4772 = 'G4772',
  /** (47.73) Retail sale of pharmaceutical products */
  G4773 = 'G4773',
  /** (47.74) Retail sale of medical and orthopaedic goods */
  G4774 = 'G4774',
  /** (47.75) Retail sale of cosmetic and toilet articles */
  G4775 = 'G4775',
  /** (47.76) Retail sale of flowers, plants, fertilisers, pets and pet food */
  G4776 = 'G4776',
  /** (47.77) Retail sale of watches and jewellery */
  G4777 = 'G4777',
  /** (47.78) Retail sale of other new goods */
  G4778 = 'G4778',
  /** (47.79) Retail sale of second-hand goods */
  G4779 = 'G4779',
  /** (47.81) Retail sale of motor vehicles */
  G4781 = 'G4781',
  /** (47.82) Retail sale of motor vehicle parts and accessories */
  G4782 = 'G4782',
  /** (47.83) Retail sale of motorcycles, motorcycle parts and accessories */
  G4783 = 'G4783',
  /** (47.91) Intermediation service activities for non-specialised retail sale */
  G4791 = 'G4791',
  /** (47.92) Intermediation service activities for specialised retail sale */
  G4792 = 'G4792',
  /** (H) TRANSPORTATION AND STORAGE */
  H = 'H',
  /** (49) Land transport and transport via pipelines */
  H49 = 'H49',
  /** (50) Water transport */
  H50 = 'H50',
  /** (51) Air transport */
  H51 = 'H51',
  /** (52) Warehousing, storage and support activities for transportation */
  H52 = 'H52',
  /** (53) Postal and courier activities */
  H53 = 'H53',
  /** (49.1) Passenger rail transport */
  H491 = 'H491',
  /** (49.2) Freight rail transport */
  H492 = 'H492',
  /** (49.3) Other passenger land transport */
  H493 = 'H493',
  /** (49.4) Freight transport by road and removal services */
  H494 = 'H494',
  /** (49.5) Transport via pipeline */
  H495 = 'H495',
  /** (50.1) Sea and coastal passenger water transport */
  H501 = 'H501',
  /** (50.2) Sea and coastal freight water transport */
  H502 = 'H502',
  /** (50.3) Inland passenger water transport */
  H503 = 'H503',
  /** (50.4) Inland freight water transport */
  H504 = 'H504',
  /** (51.1) Passenger air transport */
  H511 = 'H511',
  /** (51.2) Freight air transport and space transport */
  H512 = 'H512',
  /** (52.1) Warehousing and storage */
  H521 = 'H521',
  /** (52.2) Support activities for transportation */
  H522 = 'H522',
  /** (52.3) Intermediation service activities for transportation */
  H523 = 'H523',
  /** (53.1) Postal activities under universal service obligation */
  H531 = 'H531',
  /** (53.2) Other postal and courier activities */
  H532 = 'H532',
  /** (53.3) Intermediation service activities for postal and courier activities */
  H533 = 'H533',
  /** (49.11) Passenger heavy rail transport */
  H4911 = 'H4911',
  /** (49.12) Other passenger rail transport */
  H4912 = 'H4912',
  /** (49.20) Freight rail transport */
  H4920 = 'H4920',
  /** (49.31) Scheduled passenger transport by road */
  H4931 = 'H4931',
  /** (49.32) Non-scheduled passenger transport by road */
  H4932 = 'H4932',
  /** (49.33) On-demand passenger transport service activities by vehicle with driver */
  H4933 = 'H4933',
  /** (49.34) Passenger transport by cableways and ski lifts */
  H4934 = 'H4934',
  /** (49.39) Other passenger land transport n.e.c. */
  H4939 = 'H4939',
  /** (49.41) Freight transport by road */
  H4941 = 'H4941',
  /** (49.42) Removal services */
  H4942 = 'H4942',
  /** (49.50) Transport via pipeline */
  H4950 = 'H4950',
  /** (50.10) Sea and coastal passenger water transport */
  H5010 = 'H5010',
  /** (50.20) Sea and coastal freight water transport */
  H5020 = 'H5020',
  /** (50.30) Inland passenger water transport */
  H5030 = 'H5030',
  /** (50.40) Inland freight water transport */
  H5040 = 'H5040',
  /** (51.10) Passenger air transport */
  H5110 = 'H5110',
  /** (51.21) Freight air transport */
  H5121 = 'H5121',
  /** (51.22) Space transport */
  H5122 = 'H5122',
  /** (52.10) Warehousing and storage */
  H5210 = 'H5210',
  /** (52.21) Service activities incidental to land transportation */
  H5221 = 'H5221',
  /** (52.22) Service activities incidental to water transportation */
  H5222 = 'H5222',
  /** (52.23) Service activities incidental to air transportation */
  H5223 = 'H5223',
  /** (52.24) Cargo handling */
  H5224 = 'H5224',
  /** (52.25) Logistics service activities */
  H5225 = 'H5225',
  /** (52.26) Other support activities for transportation */
  H5226 = 'H5226',
  /** (52.31) Intermediation service activities for freight transportation */
  H5231 = 'H5231',
  /** (52.32) Intermediation service activities for passenger transportation */
  H5232 = 'H5232',
  /** (53.10) Postal activities under universal service obligation */
  H5310 = 'H5310',
  /** (53.20) Other postal and courier activities */
  H5320 = 'H5320',
  /** (53.30) Intermediation service activities for postal and courier activities */
  H5330 = 'H5330',
  /** (I) ACCOMMODATION AND FOOD SERVICE ACTIVITIES */
  I = 'I',
  /** (55) Accommodation */
  I55 = 'I55',
  /** (56) Food and beverage service activities */
  I56 = 'I56',
  /** (55.1) Hotels and similar accommodation */
  I551 = 'I551',
  /** (55.2) Holiday and other short-stay accommodation */
  I552 = 'I552',
  /** (55.3) Camping grounds and recreational vehicle parks */
  I553 = 'I553',
  /** (55.4) Intermediation service activities for accommodation */
  I554 = 'I554',
  /** (55.9) Other accommodation */
  I559 = 'I559',
  /** (56.1) Restaurants and mobile food service activities */
  I561 = 'I561',
  /** (56.2) Event catering, contract catering service activities and other food service activities */
  I562 = 'I562',
  /** (56.3) Beverage serving activities */
  I563 = 'I563',
  /** (56.4) Intermediation service activities for food and beverage services activities */
  I564 = 'I564',
  /** (55.10) Hotels and similar accommodation */
  I5510 = 'I5510',
  /** (55.20) Holiday and other short-stay accommodation */
  I5520 = 'I5520',
  /** (55.30) Camping grounds and recreational vehicle parks */
  I5530 = 'I5530',
  /** (55.40) Intermediation service activities for accommodation */
  I5540 = 'I5540',
  /** (55.90) Other accommodation */
  I5590 = 'I5590',
  /** (56.11) Restaurant activities */
  I5611 = 'I5611',
  /** (56.12) Mobile food service activities */
  I5612 = 'I5612',
  /** (56.21) Event catering activities */
  I5621 = 'I5621',
  /** (56.22) Contract catering service activities and other food service activities */
  I5622 = 'I5622',
  /** (56.30) Beverage serving activities */
  I5630 = 'I5630',
  /** (56.40) Intermediation service activities for food and beverage services activities */
  I5640 = 'I5640',
  /** (J) PUBLISHING, BROADCASTING, AND CONTENT PRODUCTION AND DISTRIBUTION ACTIVITIES */
  J = 'J',
  /** (58) Publishing activities */
  J58 = 'J58',
  /** (59) Motion picture, video and television programme production, sound recording and music publishing activities */
  J59 = 'J59',
  /** (60) Programming, broadcasting, news agency and other content distribution activities */
  J60 = 'J60',
  /** (58.1) Publishing of books, newspapers and other publishing activities, except software publishing */
  J581 = 'J581',
  /** (58.2) Software publishing */
  J582 = 'J582',
  /** (59.1) Motion picture, video and television programme activities */
  J591 = 'J591',
  /** (59.2) Sound recording and music publishing activities */
  J592 = 'J592',
  /** (60.1) Radio broadcasting and audio distribution activities */
  J601 = 'J601',
  /** (60.2) Television programming, broadcasting and video distribution activities */
  J602 = 'J602',
  /** (60.3) News agency and other content distribution activities */
  J603 = 'J603',
  /** (58.11) Publishing of books */
  J5811 = 'J5811',
  /** (58.12) Publishing of newspapers */
  J5812 = 'J5812',
  /** (58.13) Publishing of journals and periodicals */
  J5813 = 'J5813',
  /** (58.19) Other publishing activities, except software publishing */
  J5819 = 'J5819',
  /** (58.21) Publishing of video games */
  J5821 = 'J5821',
  /** (58.29) Other software publishing */
  J5829 = 'J5829',
  /** (59.11) Motion picture, video and television programme production activities */
  J5911 = 'J5911',
  /** (59.12) Motion picture, video and television programme post-production activities */
  J5912 = 'J5912',
  /** (59.13) Motion picture and video distribution activities */
  J5913 = 'J5913',
  /** (59.14) Motion picture projection activities */
  J5914 = 'J5914',
  /** (59.20) Sound recording and music publishing activities */
  J5920 = 'J5920',
  /** (60.10) Radio broadcasting and audio distribution activities */
  J6010 = 'J6010',
  /** (60.20) Television programming, broadcasting and video distribution activities */
  J6020 = 'J6020',
  /** (60.31) News agency activities */
  J6031 = 'J6031',
  /** (60.39) Other content distribution activities */
  J6039 = 'J6039',
  /** (K) TELECOMMUNICATION, COMPUTER PROGRAMMING, CONSULTING, COMPUTING INFRASTRUCTURE AND OTHER INFORMATION SERVICE ACTIVITIES */
  K = 'K',
  /** (61) Telecommunication */
  K61 = 'K61',
  /** (62) Computer programming, consultancy and related activities */
  K62 = 'K62',
  /** (63) Computing infrastructure, data processing, hosting and other information service activities */
  K63 = 'K63',
  /** (61.1) Wired, wireless, and satellite telecommunication activities */
  K611 = 'K611',
  /** (61.2) Telecommunication reselling activities and intermediation service activities for telecommunication */
  K612 = 'K612',
  /** (61.9) Other telecommunication activities */
  K619 = 'K619',
  /** (62.1) Computer programming activities */
  K621 = 'K621',
  /** (62.2) Computer consultancy and computer facilities management activities */
  K622 = 'K622',
  /** (62.9) Other information technology and computer service activities */
  K629 = 'K629',
  /** (63.1) Computing infrastructure, data processing, hosting and related activities */
  K631 = 'K631',
  /** (63.9) Web search portal activities and other information service activities */
  K639 = 'K639',
  /** (61.10) Wired, wireless, and satellite telecommunication activities */
  K6110 = 'K6110',
  /** (61.20) Telecommunication reselling activities and intermediation service activities for telecommunication */
  K6120 = 'K6120',
  /** (61.90) Other telecommunication activities */
  K6190 = 'K6190',
  /** (62.10) Computer programming activities */
  K6210 = 'K6210',
  /** (62.20) Computer consultancy and computer facilities management activities */
  K6220 = 'K6220',
  /** (62.90) Other information technology and computer service activities */
  K6290 = 'K6290',
  /** (63.10) Computing infrastructure, data processing, hosting and related activities */
  K6310 = 'K6310',
  /** (63.91) Web search portal activities */
  K6391 = 'K6391',
  /** (63.92) Other information service activities */
  K6392 = 'K6392',
  /** (L) FINANCIAL AND INSURANCE ACTIVITIES */
  L = 'L',
  /** (64) Financial service activities, except insurance and pension funding */
  L64 = 'L64',
  /** (65) Insurance, reinsurance and pension funding, except compulsory social security */
  L65 = 'L65',
  /** (66) Activities auxiliary to financial services and insurance activities */
  L66 = 'L66',
  /** (64.1) Monetary intermediation */
  L641 = 'L641',
  /** (64.2) Activities of holding companies and financing conduits */
  L642 = 'L642',
  /** (64.3) Activities of trusts, funds and similar financial entities */
  L643 = 'L643',
  /** (64.9) Other financial service activities, except insurance and pension funding */
  L649 = 'L649',
  /** (65.1) Insurance */
  L651 = 'L651',
  /** (65.2) Reinsurance */
  L652 = 'L652',
  /** (65.3) Pension funding */
  L653 = 'L653',
  /** (66.1) Activities auxiliary to financial services, except insurance and pension funding */
  L661 = 'L661',
  /** (66.2) Activities auxiliary to insurance and pension funding */
  L662 = 'L662',
  /** (66.3) Fund management activities */
  L663 = 'L663',
  /** (64.11) Central banking */
  L6411 = 'L6411',
  /** (64.19) Other monetary intermediation */
  L6419 = 'L6419',
  /** (64.21) Activities of holding companies */
  L6421 = 'L6421',
  /** (64.22) Activities of financing conduits */
  L6422 = 'L6422',
  /** (64.31) Activities of money market and non-money market investments funds */
  L6431 = 'L6431',
  /** (64.32) Activities of trust, estate and agency accounts */
  L6432 = 'L6432',
  /** (64.91) Financial leasing */
  L6491 = 'L6491',
  /** (64.92) Other credit granting */
  L6492 = 'L6492',
  /** (64.99) Other financial service activities, except insurance and pension funding n.e.c. */
  L6499 = 'L6499',
  /** (65.11) Life insurance */
  L6511 = 'L6511',
  /** (65.12) Non-life insurance */
  L6512 = 'L6512',
  /** (65.20) Reinsurance */
  L6520 = 'L6520',
  /** (65.30) Pension funding */
  L6530 = 'L6530',
  /** (66.11) Administration of financial markets */
  L6611 = 'L6611',
  /** (66.12) Security and commodity contracts brokerage */
  L6612 = 'L6612',
  /** (66.19) Other activities auxiliary to financial services, except insurance and pension funding */
  L6619 = 'L6619',
  /** (66.21) Risk and damage evaluation */
  L6621 = 'L6621',
  /** (66.22) Activities of insurance agents and brokers */
  L6622 = 'L6622',
  /** (66.29) Activities auxiliary to insurance and pension funding n.e.c. */
  L6629 = 'L6629',
  /** (66.30) Fund management activities */
  L6630 = 'L6630',
  /** (M) REAL ESTATE ACTIVITIES */
  M = 'M',
  /** (68) Real estate activities */
  M68 = 'M68',
  /** (68.1) Real estate activities with own property and development of building projects */
  M681 = 'M681',
  /** (68.2) Rental and operating of own or leased real estate */
  M682 = 'M682',
  /** (68.3) Real estate activities on a fee or contract basis */
  M683 = 'M683',
  /** (68.11) Buying and selling of own real estate */
  M6811 = 'M6811',
  /** (68.12) Development of building projects */
  M6812 = 'M6812',
  /** (68.20) Rental and operating of own or leased real estate */
  M6820 = 'M6820',
  /** (68.31) Intermediation service activities for real estate activities */
  M6831 = 'M6831',
  /** (68.32) Other real estate activities on a fee or contract basis */
  M6832 = 'M6832',
  /** (N) PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES */
  N = 'N',
  /** (69) Legal and accounting activities */
  N69 = 'N69',
  /** (70) Activities of head offices and management consultancy */
  N70 = 'N70',
  /** (71) Architectural and engineering activities; technical testing and analysis */
  N71 = 'N71',
  /** (72) Scientific research and development */
  N72 = 'N72',
  /** (73) Activities of advertising, market research and public relations */
  N73 = 'N73',
  /** (74) Other professional, scientific and technical activities */
  N74 = 'N74',
  /** (75) Veterinary activities */
  N75 = 'N75',
  /** (69.1) Legal activities */
  N691 = 'N691',
  /** (69.2) Accounting, bookkeeping and auditing activities; tax consultancy */
  N692 = 'N692',
  /** (70.1) Activities of head offices */
  N701 = 'N701',
  /** (70.2) Business and other management consultancy activities */
  N702 = 'N702',
  /** (71.1) Architectural and engineering activities and related technical consultancy */
  N711 = 'N711',
  /** (71.2) Technical testing and analysis */
  N712 = 'N712',
  /** (72.1) Research and experimental development on natural sciences and engineering */
  N721 = 'N721',
  /** (72.2) Research and experimental development on social sciences and humanities */
  N722 = 'N722',
  /** (73.1) Advertising */
  N731 = 'N731',
  /** (73.2) Market research and public opinion polling */
  N732 = 'N732',
  /** (73.3) Public relations and communication activities */
  N733 = 'N733',
  /** (74.1) Specialised design activities */
  N741 = 'N741',
  /** (74.2) Photographic activities */
  N742 = 'N742',
  /** (74.3) Translation and interpretation activities */
  N743 = 'N743',
  /** (74.9) Other professional, scientific and technical activities n.e.c. */
  N749 = 'N749',
  /** (75.0) Veterinary activities */
  N750 = 'N750',
  /** (69.10) Legal activities */
  N6910 = 'N6910',
  /** (69.20) Accounting, bookkeeping and auditing activities; tax consultancy */
  N6920 = 'N6920',
  /** (70.10) Activities of head offices */
  N7010 = 'N7010',
  /** (70.20) Business and other management consultancy activities */
  N7020 = 'N7020',
  /** (71.11) Architectural activities */
  N7111 = 'N7111',
  /** (71.12) Engineering activities and related technical consultancy */
  N7112 = 'N7112',
  /** (71.20) Technical testing and analysis */
  N7120 = 'N7120',
  /** (72.10) Research and experimental development on natural sciences and engineering */
  N7210 = 'N7210',
  /** (72.20) Research and experimental development on social sciences and humanities */
  N7220 = 'N7220',
  /** (73.11) Activities of advertising agencies */
  N7311 = 'N7311',
  /** (73.12) Media representation */
  N7312 = 'N7312',
  /** (73.20) Market research and public opinion polling */
  N7320 = 'N7320',
  /** (73.30) Public relations and communication activities */
  N7330 = 'N7330',
  /** (74.11) Industrial product and fashion design activities */
  N7411 = 'N7411',
  /** (74.12) Graphic design and visual communication activities */
  N7412 = 'N7412',
  /** (74.13) Interior design activities */
  N7413 = 'N7413',
  /** (74.14) Other specialised design activities */
  N7414 = 'N7414',
  /** (74.20) Photographic activities */
  N7420 = 'N7420',
  /** (74.30) Translation and interpretation activities */
  N7430 = 'N7430',
  /** (74.91) Patent brokering and marketing service activities */
  N7491 = 'N7491',
  /** (74.99) All other professional, scientific and technical activities n.e.c. */
  N7499 = 'N7499',
  /** (75.00) Veterinary activities */
  N7500 = 'N7500',
  /** None */
  None = 'None',
  /** (O) ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES */
  O = 'O',
  /** (77) Rental and leasing activities */
  O77 = 'O77',
  /** (78) Employment activities */
  O78 = 'O78',
  /** (79) Travel agency, tour operator and other reservation service and related activities */
  O79 = 'O79',
  /** (80) Investigation and security activities */
  O80 = 'O80',
  /** (81) Services to buildings and landscape activities */
  O81 = 'O81',
  /** (82) Office administrative, office support and other business support activities */
  O82 = 'O82',
  /** (77.1) Rental and leasing of motor vehicles */
  O771 = 'O771',
  /** (77.2) Rental and leasing of personal and household goods */
  O772 = 'O772',
  /** (77.3) Rental and leasing of other machinery, equipment and tangible goods */
  O773 = 'O773',
  /** (77.4) Leasing of intellectual property and similar products, except copyrighted works */
  O774 = 'O774',
  /** (77.5) Intermediation service activities for rental and leasing of tangible goods and non-financial intangible assets */
  O775 = 'O775',
  /** (78.1) Activities of employment placement agencies */
  O781 = 'O781',
  /** (78.2) Temporary employment agency activities and other human resource provisions */
  O782 = 'O782',
  /** (79.1) Travel agency and tour operator activities */
  O791 = 'O791',
  /** (79.9) Other reservation service and related activities */
  O799 = 'O799',
  /** (80.0) Investigation and security activities */
  O800 = 'O800',
  /** (81.1) Combined facilities support activities */
  O811 = 'O811',
  /** (81.2) Cleaning activities */
  O812 = 'O812',
  /** (81.3) Landscape service activities */
  O813 = 'O813',
  /** (82.1) Office administrative and support activities */
  O821 = 'O821',
  /** (82.2) Activities of call centres */
  O822 = 'O822',
  /** (82.3) Organisation of conventions and trade shows */
  O823 = 'O823',
  /** (82.4) Intermediation service activities for business support service activities n.e.c. */
  O824 = 'O824',
  /** (82.9) Business support service activities n.e.c. */
  O829 = 'O829',
  /** (77.11) Rental and leasing of cars and light motor vehicles */
  O7711 = 'O7711',
  /** (77.12) Rental and leasing of trucks */
  O7712 = 'O7712',
  /** (77.21) Rental and leasing of recreational and sports goods */
  O7721 = 'O7721',
  /** (77.22) Rental and leasing of other personal and household goods */
  O7722 = 'O7722',
  /** (77.31) Rental and leasing of agricultural machinery and equipment */
  O7731 = 'O7731',
  /** (77.32) Rental and leasing of construction and civil engineering machinery and equipment */
  O7732 = 'O7732',
  /** (77.33) Rental and leasing of office machinery, equipment and computers */
  O7733 = 'O7733',
  /** (77.34) Rental and leasing of water transport equipment */
  O7734 = 'O7734',
  /** (77.35) Rental and leasing of air transport equipment */
  O7735 = 'O7735',
  /** (77.39) Rental and leasing of other machinery, equipment and tangible goods n.e.c. */
  O7739 = 'O7739',
  /** (77.40) Leasing of intellectual property and similar products, except copyrighted works */
  O7740 = 'O7740',
  /** (77.51) Intermediation service activities for rental and leasing of cars, motorhomes and trailers */
  O7751 = 'O7751',
  /** (77.52) Intermediation service activities for rental and leasing of other tangible goods and non-financial intangible assets */
  O7752 = 'O7752',
  /** (78.10) Activities of employment placement agencies */
  O7810 = 'O7810',
  /** (78.20) Temporary employment agency activities and other human resource provisions */
  O7820 = 'O7820',
  /** (79.11) Travel agency activities */
  O7911 = 'O7911',
  /** (79.12) Tour operator activities */
  O7912 = 'O7912',
  /** (79.90) Other reservation service and related activities */
  O7990 = 'O7990',
  /** (80.01) Investigation and private security activities */
  O8001 = 'O8001',
  /** (80.09) Security activities n.e.c. */
  O8009 = 'O8009',
  /** (81.10) Combined facilities support activities */
  O8110 = 'O8110',
  /** (81.21) General cleaning of buildings */
  O8121 = 'O8121',
  /** (81.22) Other building and industrial cleaning activities */
  O8122 = 'O8122',
  /** (81.23) Other cleaning activities */
  O8123 = 'O8123',
  /** (81.30) Landscape service activities */
  O8130 = 'O8130',
  /** (82.10) Office administrative and support activities */
  O8210 = 'O8210',
  /** (82.20) Activities of call centres */
  O8220 = 'O8220',
  /** (82.30) Organisation of conventions and trade shows */
  O8230 = 'O8230',
  /** (82.40) Intermediation service activities for business support service activities n.e.c. */
  O8240 = 'O8240',
  /** (82.91) Activities of collection agencies and credit bureaus */
  O8291 = 'O8291',
  /** (82.92) Packaging activities */
  O8292 = 'O8292',
  /** (82.99) Other business support service activities n.e.c. */
  O8299 = 'O8299',
  /** (P) PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY */
  P = 'P',
  /** (84) Public administration and defence; compulsory social security */
  P84 = 'P84',
  /** (84.1) Administration of the State and the economic, social and environmental policies of the community */
  P841 = 'P841',
  /** (84.2) Provision of services to the community as a whole */
  P842 = 'P842',
  /** (84.3) Compulsory social security activities */
  P843 = 'P843',
  /** (84.11) General public administration activities */
  P8411 = 'P8411',
  /** (84.12) Regulation of health care, education, cultural services and other social services */
  P8412 = 'P8412',
  /** (84.13) Regulation of and contribution to more efficient operation of businesses */
  P8413 = 'P8413',
  /** (84.21) Foreign affairs */
  P8421 = 'P8421',
  /** (84.22) Defence activities */
  P8422 = 'P8422',
  /** (84.23) Justice and judicial activities */
  P8423 = 'P8423',
  /** (84.24) Public order and safety activities */
  P8424 = 'P8424',
  /** (84.25) Fire service activities */
  P8425 = 'P8425',
  /** (84.30) Compulsory social security activities */
  P8430 = 'P8430',
  /** (Q) EDUCATION */
  Q = 'Q',
  /** (85) Education */
  Q85 = 'Q85',
  /** (85.1) Pre-primary education */
  Q851 = 'Q851',
  /** (85.2) Primary education */
  Q852 = 'Q852',
  /** (85.3) Secondary and post-secondary non-tertiary education */
  Q853 = 'Q853',
  /** (85.4) Tertiary education */
  Q854 = 'Q854',
  /** (85.5) Other education */
  Q855 = 'Q855',
  /** (85.6) Educational support activities */
  Q856 = 'Q856',
  /** (85.10) Pre-primary education */
  Q8510 = 'Q8510',
  /** (85.20) Primary education */
  Q8520 = 'Q8520',
  /** (85.31) General secondary education */
  Q8531 = 'Q8531',
  /** (85.32) Vocational secondary education */
  Q8532 = 'Q8532',
  /** (85.33) Post-secondary non-tertiary education */
  Q8533 = 'Q8533',
  /** (85.40) Tertiary education */
  Q8540 = 'Q8540',
  /** (85.51) Sports and recreation education */
  Q8551 = 'Q8551',
  /** (85.52) Cultural education */
  Q8552 = 'Q8552',
  /** (85.53) Driving school activities */
  Q8553 = 'Q8553',
  /** (85.59) Other education n.e.c. */
  Q8559 = 'Q8559',
  /** (85.61) Intermediation service activities for courses and tutors */
  Q8561 = 'Q8561',
  /** (85.69) Educational support activities n.e.c. */
  Q8569 = 'Q8569',
  /** (R) HUMAN HEALTH AND SOCIAL WORK ACTIVITIES */
  R = 'R',
  /** (86) Human health activities */
  R86 = 'R86',
  /** (87) Residential care activities */
  R87 = 'R87',
  /** (88) Social work activities without accommodation */
  R88 = 'R88',
  /** (86.1) Hospital activities */
  R861 = 'R861',
  /** (86.2) Medical and dental practice activities */
  R862 = 'R862',
  /** (86.9) Other human health activities */
  R869 = 'R869',
  /** (87.1) Residential nursing care activities */
  R871 = 'R871',
  /** (87.2) Residential care activities for persons living with or having a diagnosis of a mental illness or substance abuse */
  R872 = 'R872',
  /** (87.3) Residential care activities for older persons or persons with physical disabilities */
  R873 = 'R873',
  /** (87.9) Other residential care activities */
  R879 = 'R879',
  /** (88.1) Social work activities without accommodation for older persons or persons with disabilities */
  R881 = 'R881',
  /** (88.9) Other social work activities without accommodation */
  R889 = 'R889',
  /** (86.10) Hospital activities */
  R8610 = 'R8610',
  /** (86.21) General medical practice activities */
  R8621 = 'R8621',
  /** (86.22) Medical specialists activities */
  R8622 = 'R8622',
  /** (86.23) Dental practice care activities */
  R8623 = 'R8623',
  /** (86.91) Diagnostic imaging services and medical laboratory activities */
  R8691 = 'R8691',
  /** (86.92) Patient transportation by ambulance */
  R8692 = 'R8692',
  /** (86.93) Activities of psychologists and psychotherapists, except medical doctors */
  R8693 = 'R8693',
  /** (86.94) Nursing and midwifery activities */
  R8694 = 'R8694',
  /** (86.95) Physiotherapy activities */
  R8695 = 'R8695',
  /** (86.96) Traditional, complementary and alternative medicine activities */
  R8696 = 'R8696',
  /** (86.97) Intermediation service activities for medical, dental and other human health services */
  R8697 = 'R8697',
  /** (86.99) Other human health activities n.e.c. */
  R8699 = 'R8699',
  /** (87.10) Residential nursing care activities */
  R8710 = 'R8710',
  /** (87.20) Residential care activities for persons living with or having a diagnosis of a mental illness or substance abuse */
  R8720 = 'R8720',
  /** (87.30) Residential care activities for older persons or persons with physical disabilities */
  R8730 = 'R8730',
  /** (87.91) Intermediation service activities for residential care activities */
  R8791 = 'R8791',
  /** (87.99) Other residential care activities n.e.c. */
  R8799 = 'R8799',
  /** (88.10) Social work activities without accommodation for older persons or persons with disabilities */
  R8810 = 'R8810',
  /** (88.91) Child day-care activities */
  R8891 = 'R8891',
  /** (88.99) Other social work activities without accommodation n.e.c. */
  R8899 = 'R8899',
  /** (S) ARTS, SPORTS AND RECREATION */
  S = 'S',
  /** (90) Arts creation and performing arts activities */
  S90 = 'S90',
  /** (91) Libraries, archives, museums and other cultural activities */
  S91 = 'S91',
  /** (92) Gambling and betting activities */
  S92 = 'S92',
  /** (93) Sports activities and amusement and recreation activities */
  S93 = 'S93',
  /** (90.1) Arts creation activities */
  S901 = 'S901',
  /** (90.2) Activities of performing arts */
  S902 = 'S902',
  /** (90.3) Support activities to arts creation and performing arts */
  S903 = 'S903',
  /** (91.1) Library and archive activities */
  S911 = 'S911',
  /** (91.2) Museum, collection, historical site and monument activities */
  S912 = 'S912',
  /** (91.3) Conservation, restoration and other support activities for cultural heritage */
  S913 = 'S913',
  /** (91.4) Botanical and zoological garden and nature reserve activities */
  S914 = 'S914',
  /** (92.0) Gambling and betting activities */
  S920 = 'S920',
  /** (93.1) Sports activities */
  S931 = 'S931',
  /** (93.2) Amusement and recreation activities */
  S932 = 'S932',
  /** (90.11) Literary creation and musical composition activities */
  S9011 = 'S9011',
  /** (90.12) Visual arts creation activities */
  S9012 = 'S9012',
  /** (90.13) Other arts creation activities */
  S9013 = 'S9013',
  /** (90.20) Activities of performing arts */
  S9020 = 'S9020',
  /** (90.31) Operation of arts facilities and sites */
  S9031 = 'S9031',
  /** (90.39) Other support activities to arts and performing arts */
  S9039 = 'S9039',
  /** (91.11) Library activities */
  S9111 = 'S9111',
  /** (91.12) Archive activities */
  S9112 = 'S9112',
  /** (91.21) Museum and collection activities */
  S9121 = 'S9121',
  /** (91.22) Historical site and monument activities */
  S9122 = 'S9122',
  /** (91.30) Conservation, restoration and other support activities for cultural heritage */
  S9130 = 'S9130',
  /** (91.41) Botanical and zoological garden activities */
  S9141 = 'S9141',
  /** (91.42) Nature reserve activities */
  S9142 = 'S9142',
  /** (92.00) Gambling and betting activities */
  S9200 = 'S9200',
  /** (93.11) Operation of sports facilities */
  S9311 = 'S9311',
  /** (93.12) Activities of sports clubs */
  S9312 = 'S9312',
  /** (93.13) Activities of fitness centres */
  S9313 = 'S9313',
  /** (93.19) Sports activities n.e.c. */
  S9319 = 'S9319',
  /** (93.21) Activities of amusement parks and theme parks */
  S9321 = 'S9321',
  /** (93.29) Amusement and recreation activities n.e.c. */
  S9329 = 'S9329',
  /** (T) OTHER SERVICE ACTIVITIES */
  T = 'T',
  /** (94) Activities of membership organisations */
  T94 = 'T94',
  /** (95) Repair and maintenance of computers, personal and household goods, and motor vehicles and motorcycles */
  T95 = 'T95',
  /** (96) Personal service activities */
  T96 = 'T96',
  /** (94.1) Activities of business, employers and professional membership organisations */
  T941 = 'T941',
  /** (94.2) Activities of trade unions */
  T942 = 'T942',
  /** (94.9) Activities of other membership organisations */
  T949 = 'T949',
  /** (95.1) Repair and maintenance of computers and communication equipment */
  T951 = 'T951',
  /** (95.2) Repair and maintenance of personal and household goods */
  T952 = 'T952',
  /** (95.3) Repair and maintenance of motor vehicles and motorcycles */
  T953 = 'T953',
  /** (95.4) Intermediation service activities for repair and maintenance of computers, personal and household goods, and motor vehicles and motorcycles */
  T954 = 'T954',
  /** (96.1) Washing and cleaning of textile and fur products */
  T961 = 'T961',
  /** (96.2) Hairdressing, beauty treatment, day spa and similar activities */
  T962 = 'T962',
  /** (96.3) Funeral and related activities */
  T963 = 'T963',
  /** (96.4) Intermediation service activities for personal services */
  T964 = 'T964',
  /** (96.9) Other personal service activities */
  T969 = 'T969',
  /** (94.11) Activities of business and employers membership organisations */
  T9411 = 'T9411',
  /** (94.12) Activities of professional membership organisations */
  T9412 = 'T9412',
  /** (94.20) Activities of trade unions */
  T9420 = 'T9420',
  /** (94.91) Activities of religious organisations */
  T9491 = 'T9491',
  /** (94.92) Activities of political organisations */
  T9492 = 'T9492',
  /** (94.99) Activities of other membership organisations n.e.c. */
  T9499 = 'T9499',
  /** (95.10) Repair and maintenance of computers and communication equipment */
  T9510 = 'T9510',
  /** (95.21) Repair and maintenance of consumer electronics */
  T9521 = 'T9521',
  /** (95.22) Repair and maintenance of household appliances and home and garden equipment */
  T9522 = 'T9522',
  /** (95.23) Repair and maintenance of footwear and leather goods */
  T9523 = 'T9523',
  /** (95.24) Repair and maintenance of furniture and home furnishings */
  T9524 = 'T9524',
  /** (95.25) Repair and maintenance of watches, clocks and jewellery */
  T9525 = 'T9525',
  /** (95.29) Repair and maintenance of personal and household goods n.e.c. */
  T9529 = 'T9529',
  /** (95.31) Repair and maintenance of motor vehicles */
  T9531 = 'T9531',
  /** (95.32) Repair and maintenance of motorcycles */
  T9532 = 'T9532',
  /** (95.40) Intermediation service activities for repair and maintenance of computers, personal and household goods, and motor vehicles and motorcycles */
  T9540 = 'T9540',
  /** (96.10) Washing and cleaning of textile and fur products */
  T9610 = 'T9610',
  /** (96.21) Hairdressing and barber activities */
  T9621 = 'T9621',
  /** (96.22) Beauty care and other beauty treatment activities */
  T9622 = 'T9622',
  /** (96.23) Day spa, sauna and steam bath activities */
  T9623 = 'T9623',
  /** (96.30) Funeral and related activities */
  T9630 = 'T9630',
  /** (96.40) Intermediation service activities for personal services */
  T9640 = 'T9640',
  /** (96.91) Provision of domestic personal service activities */
  T9691 = 'T9691',
  /** (96.99) Other personal service activities n.e.c. */
  T9699 = 'T9699',
  /** (U) ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS AND UNDIFFERENTIATED GOODS - AND SERVICE-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE */
  U = 'U',
  /** (97) Activities of households as employers of domestic personnel */
  U97 = 'U97',
  /** (98) Undifferentiated goods- and service-producing activities of private households for own use */
  U98 = 'U98',
  /** (97.0) Activities of households as employers of domestic personnel */
  U970 = 'U970',
  /** (98.1) Undifferentiated goods-producing activities of private households for own use */
  U981 = 'U981',
  /** (98.2) Undifferentiated service-producing activities of private households for own use */
  U982 = 'U982',
  /** (97.00) Activities of households as employers of domestic personnel */
  U9700 = 'U9700',
  /** (98.10) Undifferentiated goods-producing activities of private households for own use */
  U9810 = 'U9810',
  /** (98.20) Undifferentiated service-producing activities of private households for own use */
  U9820 = 'U9820',
  /** (V) ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES */
  V = 'V',
  /** (99) Activities of extraterritorial organisations and bodies */
  V99 = 'V99',
  /** (99.0) Activities of extraterritorial organisations and bodies */
  V990 = 'V990',
  /** (99.00) Activities of extraterritorial organisations and bodies */
  V9900 = 'V9900'
}

export type NameAndId = {
  __typename?: 'NameAndId';
  _id: Scalars['GraphQLObjectId']['output'];
  name: Scalars['String']['output'];
};

export type Nav = {
  __typename?: 'Nav';
  _id: Scalars['GraphQLObjectId']['output'];
  /** totalNavBeforeAdjustmentsBeforeOrders must differ less from frontOfficeNav than absHighTolerancePercent */
  absHighTolerancePercent?: Maybe<Scalars['String']['output']>;
  /** if totalNavBeforeAdjustmentsBeforeOrders differs more from frontOfficeNav than absLowTolerancePercent, a comment is required */
  absLowTolerancePercent?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Party>;
  clientId: Scalars['GraphQLObjectId']['output'];
  comment: Scalars['String']['output'];
  createTimestamp: Scalars['Timestamp']['output'];
  data: NavData;
  date: Scalars['GraphQLDateString']['output'];
  frontOfficeNav: Scalars['String']['output'];
  /** Copied from Party.fundInfo.riskLevel when calculating NAV */
  fundRiskLevel?: Maybe<Scalars['String']['output']>;
  /** Added when jobs send out navs to external parties */
  publishedTo?: Maybe<Array<PublishedToType>>;
  status: ReportStatusEnum;
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  updateUserId: Scalars['GraphQLObjectId']['output'];
  updateUserInfo?: Maybe<UserInfo>;
};

export type NavData = {
  __typename?: 'NavData';
  adjustmentAmountPositions: Array<NavPosition>;
  classes: Array<NavFundClass>;
  orders: Array<NavOrder>;
  positions: Array<NavPosition>;
  transactions: Array<NavTransaction>;
};

export type NavDataInput = {
  adjustmentAmountPositions: Array<NavPositionInput>;
  classes: Array<NavFundClassInput>;
  orders: Array<NavOrderInput>;
  positions: Array<NavPositionInput>;
  transactions: Array<NavTransactionInput>;
};

export type NavFundClass = {
  __typename?: 'NavFundClass';
  adjustmentAmount: Scalars['String']['output'];
  dividendPaid: Scalars['String']['output'];
  fxHedge: Scalars['String']['output'];
  fxRate: Scalars['String']['output'];
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
  managementFee: Scalars['String']['output'];
  name: Scalars['String']['output'];
  navAfterAdjustmentsAfterOrders: Scalars['String']['output'];
  navAfterAdjustmentsBeforeOrders: Scalars['String']['output'];
  navBeforeAdjustmentsBeforeOrders: Scalars['String']['output'];
  navCurrency: CurrencyEnum;
  navPerUnit: Scalars['String']['output'];
  navPerUnitReturn1D: Scalars['String']['output'];
  unitsAfterOrders: Scalars['String']['output'];
  unitsBeforeOrders: Scalars['String']['output'];
  weight: Scalars['String']['output'];
};

export type NavFundClassInput = {
  adjustmentAmount: Scalars['String']['input'];
  dividendPaid: Scalars['String']['input'];
  fxHedge: Scalars['String']['input'];
  fxRate: Scalars['String']['input'];
  instrumentId: Scalars['GraphQLObjectId']['input'];
  managementFee: Scalars['String']['input'];
  name: Scalars['String']['input'];
  navAfterAdjustmentsAfterOrders: Scalars['String']['input'];
  navAfterAdjustmentsBeforeOrders: Scalars['String']['input'];
  navBeforeAdjustmentsBeforeOrders: Scalars['String']['input'];
  navCurrency: CurrencyEnum;
  navPerUnit: Scalars['String']['input'];
  navPerUnitReturn1D: Scalars['String']['input'];
  unitsAfterOrders: Scalars['String']['input'];
  unitsBeforeOrders: Scalars['String']['input'];
  weight: Scalars['String']['input'];
};

export type NavInput = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  /** totalNavBeforeAdjustmentsBeforeOrders must differ less from frontOfficeNav than absHighTolerancePercent */
  absHighTolerancePercent?: InputMaybe<Scalars['String']['input']>;
  /** if totalNavBeforeAdjustmentsBeforeOrders differs more from frontOfficeNav than absLowTolerancePercent, a comment is required */
  absLowTolerancePercent?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['GraphQLObjectId']['input'];
  comment: Scalars['String']['input'];
  data: NavDataInput;
  date: Scalars['GraphQLDateString']['input'];
  frontOfficeNav: Scalars['String']['input'];
  /** Copied from Party.fundInfo.riskLevel when calculating NAV */
  fundRiskLevel?: InputMaybe<Scalars['String']['input']>;
  status: ReportStatusEnum;
};

export type NavOrder = {
  __typename?: 'NavOrder';
  amount: Scalars['String']['output'];
  carryOwnTransactionCost: Scalars['Boolean']['output'];
  currency: CurrencyEnum;
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
  isin: Scalars['ISIN']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<TransferAgentOrder>;
  orderId: Scalars['GraphQLObjectId']['output'];
  transactionType: TransferAgentOrderEnum;
  units: Scalars['String']['output'];
  valueDate: Scalars['GraphQLDateString']['output'];
};

export type NavOrderInput = {
  amount: Scalars['String']['input'];
  carryOwnTransactionCost: Scalars['Boolean']['input'];
  currency: CurrencyEnum;
  instrumentId: Scalars['GraphQLObjectId']['input'];
  isin: Scalars['ISIN']['input'];
  name: Scalars['String']['input'];
  orderId: Scalars['GraphQLObjectId']['input'];
  transactionType: TransferAgentOrderEnum;
  units: Scalars['String']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};

export type NavPosition = {
  __typename?: 'NavPosition';
  account?: Maybe<PartyAccount>;
  accountId: Scalars['GraphQLObjectId']['output'];
  currency: CurrencyEnum;
  fxRate: Scalars['String']['output'];
  fxValuationDate: Scalars['GraphQLDateString']['output'];
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['String']['output'];
  valuationDate: Scalars['GraphQLDateString']['output'];
  value: Scalars['String']['output'];
};

export type NavPositionInput = {
  accountId: Scalars['GraphQLObjectId']['input'];
  currency: CurrencyEnum;
  fxRate: Scalars['String']['input'];
  fxValuationDate: Scalars['GraphQLDateString']['input'];
  instrumentId: Scalars['GraphQLObjectId']['input'];
  name: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
  valuationDate: Scalars['GraphQLDateString']['input'];
  value: Scalars['String']['input'];
};

export type NavTransaction = {
  __typename?: 'NavTransaction';
  account?: Maybe<PartyAccount>;
  accountId: Scalars['GraphQLObjectId']['output'];
  accountSwitchOrder: Scalars['Boolean']['output'];
  accountingAmount?: Maybe<Scalars['String']['output']>;
  accountingCurrency?: Maybe<CurrencyEnum>;
  accountingPrice?: Maybe<Scalars['String']['output']>;
  adjustmentAmount: Scalars['String']['output'];
  adjustmentShares: Scalars['String']['output'];
  amount: Scalars['String']['output'];
  currency: CurrencyEnum;
  externalId: Scalars['String']['output'];
  fxRate?: Maybe<Scalars['String']['output']>;
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
  isin: Scalars['ISIN']['output'];
  name: Scalars['String']['output'];
  price: Scalars['String']['output'];
  transactionType: NavTransactionType;
  units: Scalars['String']['output'];
  valueDate: Scalars['GraphQLDateString']['output'];
};

export type NavTransactionInput = {
  accountId: Scalars['GraphQLObjectId']['input'];
  accountSwitchOrder: Scalars['Boolean']['input'];
  accountingAmount: Scalars['String']['input'];
  accountingCurrency: CurrencyEnum;
  accountingPrice: Scalars['String']['input'];
  adjustmentAmount: Scalars['String']['input'];
  adjustmentShares: Scalars['String']['input'];
  amount: Scalars['String']['input'];
  currency: CurrencyEnum;
  externalId: Scalars['String']['input'];
  fxRate: Scalars['String']['input'];
  instrumentId: Scalars['GraphQLObjectId']['input'];
  isin: Scalars['ISIN']['input'];
  name: Scalars['String']['input'];
  price: Scalars['String']['input'];
  transactionType: NavTransactionType;
  units: Scalars['String']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};

export enum NavTransactionType {
  CreateRedeemAmount = 'CreateRedeemAmount',
  CreateRedeemUnits = 'CreateRedeemUnits',
  FxSpot = 'FxSpot',
  ManagementFee = 'ManagementFee',
  Transfer = 'Transfer'
}

export enum NonTradingDayFillMethodEnum {
  NIL_VALUE = 'NIL_VALUE',
  PREVIOUS_VALUE = 'PREVIOUS_VALUE'
}

export enum NonTradingDayFillOptionEnum {
  ACTIVE_DAYS_ONLY = 'ACTIVE_DAYS_ONLY',
  ALL_CALENDAR_DAYS = 'ALL_CALENDAR_DAYS',
  NON_TRADING_WEEKDAYS = 'NON_TRADING_WEEKDAYS'
}

export type Note = {
  __typename?: 'Note';
  _id: Scalars['GraphQLObjectId']['output'];
  asset: NoteAssetEnum;
  clientIds?: Maybe<Array<Scalars['GraphQLObjectId']['output']>>;
  clients: Array<PartyInfo>;
  createTimestamp: Scalars['Timestamp']['output'];
  creator: UserInfo;
  creatorId: Scalars['GraphQLObjectId']['output'];
  /** Markdown or JSON */
  data: Scalars['String']['output'];
  refs: Array<NoteReference>;
  status: NoteStatusEnum;
  tags: Array<NoteTag>;
  title: Scalars['UriPartString']['output'];
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
};

export enum NoteAssetEnum {
  Admin = 'Admin',
  Base = 'Base',
  Esg = 'Esg'
}

export type NoteFilterInput = {
  assetIn?: InputMaybe<Array<NoteAssetEnum>>;
  clientIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  collectionIn?: InputMaybe<Array<CollectionNameEnum>>;
  creatorIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  documentIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  statusIn?: InputMaybe<Array<NoteStatusEnum>>;
  typeIn?: InputMaybe<Array<Scalars['String']['input']>>;
  valueIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NoteInput = {
  /** if _id is omitted, a Note will be created */
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  asset: NoteAssetEnum;
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  data: Scalars['String']['input'];
  refs: Array<NoteReferenceInput>;
  status: NoteStatusEnum;
  tags: Array<NoteTagInput>;
  title: Scalars['String']['input'];
};

export type NoteReference = {
  __typename?: 'NoteReference';
  collection: CollectionNameEnum;
  documentId: Scalars['GraphQLObjectId']['output'];
};

export type NoteReferenceInput = {
  collection: CollectionNameEnum;
  documentId: Scalars['GraphQLObjectId']['input'];
};

export enum NoteStatusEnum {
  Active = 'Active',
  Deleted = 'Deleted'
}

export type NoteTag = {
  __typename?: 'NoteTag';
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type NoteTagFilter = {
  collection?: InputMaybe<CollectionNameEnum>;
  documentId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type NoteTagInput = {
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type OpAccess = {
  __typename?: 'OPAccess';
  accounts?: Maybe<Array<OpAccessItem>>;
  balances?: Maybe<Array<OpAccessItem>>;
  transactions?: Maybe<Array<OpAccessItem>>;
};

export type OpAccessItem = {
  __typename?: 'OPAccessItem';
  iban: Scalars['String']['output'];
};

export type OpAccessItemInput = {
  iban: Scalars['IBAN']['input'];
};

export type OpConsent = {
  __typename?: 'OPConsent';
  _id: Scalars['GraphQLObjectId']['output'];
  access: OpAccess;
  bic: Scalars['String']['output'];
  client?: Maybe<NameAndId>;
  clientId: Scalars['GraphQLObjectId']['output'];
  consentId: Scalars['String']['output'];
  consentStatus: OpConsentStatus;
  createTimestamp: Scalars['Timestamp']['output'];
  createUserId: Scalars['GraphQLObjectId']['output'];
  createUserInfo?: Maybe<NameAndId>;
  frequencyPerDay: Scalars['Int']['output'];
  lastActionDate: Scalars['GraphQLDateString']['output'];
  /** Personal number of the consent create user. Used as PSU-ID in Open Payments API calls. */
  psuId: Scalars['String']['output'];
  recurringIndicator: Scalars['Boolean']['output'];
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId: Scalars['GraphQLObjectId']['output'];
  updateUserInfo?: Maybe<NameAndId>;
  validUntil: Scalars['GraphQLDateString']['output'];
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type OpConsentFilter = {
  bicIn?: InputMaybe<Array<Scalars['String']['input']>>;
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  consentIdIn?: InputMaybe<Array<Scalars['String']['input']>>;
  ibanIn?: InputMaybe<Array<Scalars['String']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  statusIn?: InputMaybe<Array<OpConsentStatus>>;
  validFrom?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};

export enum OpConsentStatus {
  /** deleted, is not from open payments, only for internal use */
  deleted = 'deleted',
  expired = 'expired',
  partiallyAuthorised = 'partiallyAuthorised',
  received = 'received',
  rejected = 'rejected',
  revokedByPsu = 'revokedByPsu',
  terminatedByTpp = 'terminatedByTpp',
  valid = 'valid'
}

export type OpPayment = {
  __typename?: 'OPPayment';
  _id: Scalars['GraphQLObjectId']['output'];
  _links: OpenPaymentLinkData;
  authorizationId?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Party>;
  clientId: Scalars['GraphQLObjectId']['output'];
  createTimestamp: Scalars['Timestamp']['output'];
  createUserId: Scalars['GraphQLObjectId']['output'];
  createUserInfo?: Maybe<NameAndId>;
  creditorAccount?: Maybe<OpAccessItem>;
  /** BIC */
  creditorAgent?: Maybe<Scalars['String']['output']>;
  creditorName?: Maybe<Scalars['String']['output']>;
  debtorAccount?: Maybe<OpAccessItem>;
  debtorAccountMessage?: Maybe<Scalars['String']['output']>;
  endToEndIdentification?: Maybe<Scalars['Max35CharString']['output']>;
  instructedAmount?: Maybe<AmountData>;
  paymentId: Scalars['String']['output'];
  remittanceInformationStructured?: Maybe<RemittanceInformationStructured>;
  remittanceInformationUnstructured?: Maybe<Scalars['Max140CharString']['output']>;
  requestedExecutionDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  signingBasketId?: Maybe<Scalars['String']['output']>;
  tppMessages?: Maybe<Array<TppMessage>>;
  transactionFees?: Maybe<AmountData>;
  transactionStatus: OpPaymentStatusEnum;
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId: Scalars['GraphQLObjectId']['output'];
  updateUserInfo?: Maybe<NameAndId>;
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type OpPaymentFilter = {
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  paymentIdIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  statusIn?: InputMaybe<Array<OpPaymentStatusEnum>>;
};

export type OpPaymentInput = {
  creditorAccount: OpAccessItemInput;
  creditorAgent: Scalars['BIC']['input'];
  creditorName: Scalars['Min1Max70CharString']['input'];
  debtorAccount: OpAccessItemInput;
  debtorAccountMessage?: InputMaybe<Scalars['Max140CharString']['input']>;
  endToEndIdentification?: InputMaybe<Scalars['Max35CharString']['input']>;
  instructedAmount: AmountDataInput;
  remittanceInformationUnstructured: Scalars['Max140CharString']['input'];
  /** Must be between 1 day and 12 months into the future */
  requestedExecutionDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};

export enum OpPaymentStatusEnum {
  /** Accepted Completed */
  ACCC = 'ACCC',
  /** Accepted Pending */
  ACCP = 'ACCP',
  /** Accepted For Completion */
  ACFC = 'ACFC',
  /** Accepted Scheduled */
  ACSC = 'ACSC',
  /** Accepted Suspended */
  ACSP = 'ACSP',
  /** Active */
  ACTC = 'ACTC',
  /** Accepted With Conditions */
  ACWC = 'ACWC',
  /** Accepted With Pending */
  ACWP = 'ACWP',
  /** Cancelled */
  CANC = 'CANC',
  /** Partial */
  PART = 'PART',
  /** Partially Accepted */
  PATC = 'PATC',
  /** Pending */
  PDNG = 'PDNG',
  /** Received */
  RCVD = 'RCVD',
  /** Rejected */
  RJCT = 'RJCT'
}

export type OpSigningBasketData = {
  __typename?: 'OPSigningBasketData';
  payments: Array<OpPayment>;
  /** Only returned if scaFlow = REDIRECT */
  redirectLink?: Maybe<Scalars['String']['output']>;
};

export type OpenPaymentLink = {
  __typename?: 'OpenPaymentLink';
  href?: Maybe<Scalars['String']['output']>;
};

export type OpenPaymentLinkData = {
  __typename?: 'OpenPaymentLinkData';
  href?: Maybe<Scalars['String']['output']>;
  scaOAuth?: Maybe<OpenPaymentLink>;
  scaRedirect?: Maybe<OpenPaymentLink>;
  scaStatus?: Maybe<OpenPaymentLink>;
  self?: Maybe<OpenPaymentLink>;
  startAuthorisation?: Maybe<OpenPaymentLink>;
  startAuthorisationWithAuthenticationMethodSelection?: Maybe<OpenPaymentLink>;
  startAuthorisationWithEncryptedPsuAuthentication?: Maybe<OpenPaymentLink>;
  startAuthorisationWithPsuAuthentication?: Maybe<OpenPaymentLink>;
  startAuthorisationWithPsuIdentification?: Maybe<OpenPaymentLink>;
  startAuthorisationWithTransactionAuthorisation?: Maybe<OpenPaymentLink>;
  status?: Maybe<OpenPaymentLink>;
};

export type OrderFilterInput = {
  carryOwnTransactionCost?: InputMaybe<Scalars['Boolean']['input']>;
  clientAccountIn?: InputMaybe<Array<Scalars['String']['input']>>;
  clientIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  clientNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  isinIn?: InputMaybe<Array<Scalars['ISIN']['input']>>;
  sourceIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  statusIn?: InputMaybe<Array<TransactionStatus>>;
  tradeDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  tradeDateEnd?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  tradeDateStart?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};

export enum OverrideOptionEnum {
  OVERRIDE_OPTION_CLOSE = 'OVERRIDE_OPTION_CLOSE',
  OVERRIDE_OPTION_GPA = 'OVERRIDE_OPTION_GPA'
}

export type Party = {
  __typename?: 'Party';
  _id: Scalars['GraphQLObjectId']['output'];
  accountant?: Maybe<Scalars['String']['output']>;
  accountingCompanyType?: Maybe<AccountingCompanyTypeEnum>;
  accountingCurrency?: Maybe<CurrencyEnum>;
  accountingFrequency?: Maybe<AccountingFrequencyEnum>;
  accounts: Array<PartyAccount>;
  address?: Maybe<Scalars['String']['output']>;
  aliases: Array<Alias>;
  approval?: Maybe<Scalars['String']['output']>;
  beneficialOwner?: Maybe<BeneficialOwner>;
  bloombergEquityTicker?: Maybe<Scalars['String']['output']>;
  businessIdentifierCode?: Maybe<Scalars['String']['output']>;
  ceo?: Maybe<Scalars['String']['output']>;
  complaintsManager?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryCodeEnum>;
  creditRatingScale: Array<Scalars['String']['output']>;
  creditRatings: Array<PartyCreditRating>;
  dashName: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalAccounts: Array<PartyExternalAccount>;
  firstTradeDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  fundInfo?: Maybe<PartyFundInfo>;
  inLedgerNumber?: Maybe<Scalars['Int']['output']>;
  inLedgerTradeDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  industryCode?: Maybe<Scalars['String']['output']>;
  instrumentIds: Array<Scalars['GraphQLObjectId']['output']>;
  instruments: Array<Instrument>;
  issuer?: Maybe<PartyIssuerType>;
  issuerType?: Maybe<IssuerTypeEnum>;
  legalEntityIdentifier?: Maybe<Scalars['String']['output']>;
  legalNumber?: Maybe<Scalars['String']['output']>;
  limitSlackChannel?: Maybe<Scalars['String']['output']>;
  limitStartDate?: Maybe<Scalars['Date']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  nace?: Maybe<NaceClass>;
  naceDescription?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  parentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  regulator?: Maybe<Scalars['String']['output']>;
  standardSettlementInstructions: Array<PartyStandardSettlementInstruction>;
  status?: Maybe<PartyStatusEnum>;
  sustainalyticsData?: Maybe<SustainalyticsDataModelWithStatus>;
  sustainalyticsId?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<TimezoneEnum>;
  topAccount?: Maybe<PartyAccount>;
  types: Array<Maybe<PartyType>>;
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
  website?: Maybe<Scalars['String']['output']>;
};

export type PartyAccount = {
  __typename?: 'PartyAccount';
  _id: Scalars['GraphQLObjectId']['output'];
  benchmarks: Array<PartyBenchmark>;
  childrenAccounts: Array<PartyAccount>;
  childrenAccountsIds: Array<Scalars['GraphQLObjectId']['output']>;
  clientId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  defaultAccount: Scalars['Boolean']['output'];
  defaultAccruedInstruments?: Maybe<Array<DefaultCashInstrument>>;
  defaultCashInstruments: Array<DefaultCashInstrument>;
  defaultDebtInstruments: Array<DefaultCashInstrument>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * ModelIndexBenchmark calculated within the Party.accounts computed property.
   * Uses introspection to decide calculation and parameter. Thus if type name
   * or parameters to timeSeries are altered this must be mirrored under
   * Party.accounts
   */
  modelIndexBenchmark?: Maybe<ModelIndexBenchmark>;
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  parentAccountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  securityExternalAccountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  transientCashInstruments: Array<DefaultCashInstrument>;
  type: PartyAccountType;
  weights: Array<PartyAccountWeight>;
};

export type PartyAccountInput = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  benchmarks?: InputMaybe<Array<PartyBenchmarkInput>>;
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  defaultAccount?: InputMaybe<Scalars['Boolean']['input']>;
  defaultAccruedInstruments?: InputMaybe<Array<DefaultCashInstrumentInput>>;
  defaultCashInstruments?: InputMaybe<Array<DefaultCashInstrumentInput>>;
  defaultDebtInstruments?: InputMaybe<Array<DefaultCashInstrumentInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  modelIndexBenchmark?: InputMaybe<ModelIndexBenchmarkInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  parentAccountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  securityExternalAccountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  transientCashInstruments?: InputMaybe<Array<DefaultCashInstrumentInput>>;
  type: PartyAccountType;
  weights?: InputMaybe<Array<PartyAccountWeightInput>>;
};

export enum PartyAccountType {
  Physical = 'Physical',
  PortfolioInstrument = 'PortfolioInstrument',
  Sum = 'Sum'
}

export type PartyAccountWeight = {
  __typename?: 'PartyAccountWeight';
  date: Scalars['GraphQLDateString']['output'];
  expectedReturn: Scalars['Float']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  model: Scalars['Float']['output'];
};

export type PartyAccountWeightInput = {
  date: Scalars['GraphQLDateString']['input'];
  expectedReturn: Scalars['Float']['input'];
  max: Scalars['Float']['input'];
  min: Scalars['Float']['input'];
  model: Scalars['Float']['input'];
};

export type PartyBaseInput = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  accountant?: InputMaybe<Scalars['String']['input']>;
  accountingCompanyType?: InputMaybe<AccountingCompanyTypeEnum>;
  accountingCurrency?: InputMaybe<Scalars['String']['input']>;
  accountingFrequency?: InputMaybe<AccountingFrequencyEnum>;
  address?: InputMaybe<Scalars['String']['input']>;
  aliases?: InputMaybe<Array<AliasInput>>;
  approval?: InputMaybe<Scalars['String']['input']>;
  beneficialOwner?: InputMaybe<BeneficialOwnerInput>;
  bloombergEquityTicker?: InputMaybe<Scalars['String']['input']>;
  businessIdentifierCode?: InputMaybe<Scalars['String']['input']>;
  ceo?: InputMaybe<Scalars['String']['input']>;
  complaintsManager?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCodeEnum>;
  creditRatingScale?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditRatings?: InputMaybe<Array<InputMaybe<CreditRatingInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  inLedgerNumber?: InputMaybe<Scalars['Int']['input']>;
  inLedgerTradeDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  industryCode?: InputMaybe<Scalars['String']['input']>;
  issuerType?: InputMaybe<IssuerTypeEnum>;
  legalEntityIdentifier?: InputMaybe<Scalars['String']['input']>;
  legalNumber?: InputMaybe<Scalars['String']['input']>;
  longName?: InputMaybe<Scalars['String']['input']>;
  nace?: InputMaybe<NaceClass>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  regulator?: InputMaybe<Scalars['String']['input']>;
  standardSettlementInstructions?: InputMaybe<Array<PartyStandardSettlementInstructionInput>>;
  status?: InputMaybe<PartyStatusEnum>;
  sustainalyticsId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<TimezoneEnum>;
  types: Array<PartyType>;
  updateTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type PartyBenchmark = {
  __typename?: 'PartyBenchmark';
  comment: Scalars['String']['output'];
  currency: CurrencyEnum;
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
  mainBenchmark: Scalars['Boolean']['output'];
  /** Offset real number, i.e. 0.01 = 1% */
  offset: Scalars['Float']['output'];
  showBenchmark: Scalars['Boolean']['output'];
  showExternal: Scalars['Boolean']['output'];
};

export type PartyBenchmarkInput = {
  comment: Scalars['String']['input'];
  currency: CurrencyEnum;
  instrumentId: Scalars['GraphQLObjectId']['input'];
  mainBenchmark?: InputMaybe<Scalars['Boolean']['input']>;
  offset: Scalars['Float']['input'];
  showBenchmark: Scalars['Boolean']['input'];
  showExternal: Scalars['Boolean']['input'];
};

export type PartyCreditRating = {
  __typename?: 'PartyCreditRating';
  creditRatingAgencyId: Scalars['GraphQLObjectId']['output'];
  grade: Scalars['GraphQLCreditRating']['output'];
};

export type PartyEsg = {
  __typename?: 'PartyEsg';
  attachments?: Maybe<Array<Attachment>>;
  comments: Array<EsgComment>;
  globalStandardScreen: Array<GlobalStandardScreen>;
  productInvolvement: Array<ProductInvolvement>;
  shareholderEngagement: Array<ShareholderEngagement>;
};

export type PartyEsgInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  comments: Array<EsgCommentInput>;
  globalStandardScreen: Array<GlobalStandardScreenInput>;
  productInvolvement: Array<ProductInvolvementInput>;
  shareholderEngagement: Array<ShareholderEngagementInput>;
};

export type PartyExternalAccount = {
  __typename?: 'PartyExternalAccount';
  _id: Scalars['GraphQLObjectId']['output'];
  agreement?: Maybe<Agreement>;
  attachments: Array<Attachment>;
  baseCurrency?: Maybe<CurrencyEnum>;
  clearingBroker?: Maybe<Party>;
  /** only for omnibusClearingAccount + clearingAccount */
  clearingBrokerId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  clearingHouses?: Maybe<Array<Party>>;
  /** only for omnibusClearingAccounts */
  clearingHousesIds?: Maybe<Array<Scalars['GraphQLObjectId']['output']>>;
  custodian?: Maybe<Party>;
  custodianAccountId?: Maybe<Scalars['String']['output']>;
  custodianAccountNumber?: Maybe<Scalars['String']['output']>;
  custodianId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  emirReporting: Scalars['Boolean']['output'];
  initialMarginCurrencies?: Maybe<Array<CurrencyEnum>>;
  minimumTransferAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  noCollateralRequirement?: Maybe<Scalars['Boolean']['output']>;
  number: Scalars['Int']['output'];
  partyInstrumentIds?: Maybe<Array<Scalars['GraphQLObjectId']['output']>>;
  partyInstruments?: Maybe<Array<Instrument>>;
  principalCurrencies?: Maybe<Array<CurrencyEnum>>;
  reconcile?: Maybe<Scalars['Boolean']['output']>;
  roundingAmount?: Maybe<Scalars['Float']['output']>;
  /** Need to be able to separate collateral securities posted as IM from what's posted as VM */
  separatedInitialMargin?: Maybe<Scalars['Boolean']['output']>;
  settlementOnVMInstrument?: Maybe<Scalars['Boolean']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<PartyExternalAccountType>;
  variationMarginCurrencies?: Maybe<Array<CurrencyEnum>>;
};

export type PartyExternalAccountInput = {
  _id: Scalars['GraphQLObjectId']['input'];
  attachments?: InputMaybe<Array<AttachmentInput>>;
  baseCurrency?: InputMaybe<CurrencyEnum>;
  /** only for omnibusClearingAccount + clearingAccount */
  clearingBrokerId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  /** only for omnibusClearingAccounts */
  clearingHousesIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  custodianAccountId?: InputMaybe<Scalars['String']['input']>;
  custodianAccountNumber?: InputMaybe<Scalars['String']['input']>;
  custodianId: Scalars['GraphQLObjectId']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  emirReporting?: InputMaybe<Scalars['Boolean']['input']>;
  minimumTransferAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  noCollateralRequirement?: InputMaybe<Scalars['Boolean']['input']>;
  number: Scalars['Int']['input'];
  reconcile?: InputMaybe<Scalars['Boolean']['input']>;
  roundingAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Need to be able to separate collateral securities posted as IM from what's posted as VM */
  separatedInitialMargin?: InputMaybe<Scalars['Boolean']['input']>;
  settlementOnVMInstrument?: InputMaybe<Scalars['Boolean']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<PartyExternalAccountType>;
};

export enum PartyExternalAccountType {
  CashAccount = 'CashAccount',
  ClearingAccount = 'ClearingAccount',
  CollateralisedLoan = 'CollateralisedLoan',
  Equity = 'Equity',
  FundAccount = 'FundAccount',
  Gmra = 'Gmra',
  Gmsla = 'Gmsla',
  Isda = 'Isda',
  OmnibusClearingAccount = 'OmnibusClearingAccount',
  SecuritiesAccount = 'SecuritiesAccount',
  ShareRegistry = 'ShareRegistry'
}

export type PartyFilterInput = {
  countryIn?: InputMaybe<Array<CountryCodeEnum>>;
  custodianAccountNumberIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fundInfoClassInstrumentIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  fundTypeIn?: InputMaybe<Array<FundTypeEnum>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  legalEntityIdentifierIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  statusIn?: InputMaybe<Array<PartyStatusEnum>>;
  typeIn?: InputMaybe<Array<PartyType>>;
  withEnabledFundClasses?: InputMaybe<Scalars['Boolean']['input']>;
  withTransactions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyFundInfo = {
  __typename?: 'PartyFundInfo';
  calendar?: Maybe<Calendar>;
  calendarNames?: Maybe<Array<CalendarNameEnum>>;
  classes: Array<Maybe<PartyFundInfoClass>>;
  createRedeemInstrument?: Maybe<Instrument>;
  createRedeemInstrumentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  custodian?: Maybe<PartyInfo>;
  custodianId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  depositary?: Maybe<PartyInfo>;
  /** A depositary verifies that a fund's assets exist on behalf of shareholders */
  depositaryId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  endDate: Scalars['GraphQLDateString']['output'];
  esgComponents?: Maybe<Array<EsgComponentEnum>>;
  fundCompany?: Maybe<Party>;
  fundCompanyId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  fundDescription?: Maybe<Scalars['String']['output']>;
  fundManager?: Maybe<Scalars['String']['output']>;
  fundReportComponents?: Maybe<Array<FundReportComponentEnum>>;
  fundReportTypes: Array<FundReportEnum>;
  fundType?: Maybe<FundTypeEnum>;
  portfolio?: Maybe<Scalars['String']['output']>;
  riskLevel?: Maybe<Scalars['Int']['output']>;
  ta?: Maybe<PartyInfo>;
  taId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  tradeFrequency?: Maybe<Scalars['String']['output']>;
};


export type PartyFundInfoCalendarArgs = {
  years?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PartyFundInfoClass = {
  __typename?: 'PartyFundInfoClass';
  carryOwnCostPossible?: Maybe<Scalars['Boolean']['output']>;
  cleanClass?: Maybe<Scalars['Boolean']['output']>;
  dividendPaying?: Maybe<Scalars['Boolean']['output']>;
  earlyCloseTradeCutOff?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fxHedgeAccount?: Maybe<PartyAccount>;
  fxHedgeAccountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  fxHedged?: Maybe<Scalars['Boolean']['output']>;
  instrument?: Maybe<Instrument>;
  instrumentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  mainClass?: Maybe<Scalars['Boolean']['output']>;
  managementFee?: Maybe<Scalars['String']['output']>;
  managementFeeStruct?: Maybe<Scalars['String']['output']>;
  minimumInitialSubscription?: Maybe<Scalars['String']['output']>;
  minimumSubscriptionAdded?: Maybe<Scalars['String']['output']>;
  numberOfDecimalsNAVPerUnit?: Maybe<Scalars['Int']['output']>;
  numberOfDecimalsUnits?: Maybe<Scalars['Int']['output']>;
  redemptionFee?: Maybe<Scalars['String']['output']>;
  sIFA_ID?: Maybe<Scalars['String']['output']>;
  sIFA_UNIT?: Maybe<Scalars['String']['output']>;
  sfdr?: Maybe<Scalars['String']['output']>;
  shareClass?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  startNAVPerUnit?: Maybe<Scalars['String']['output']>;
  subscriptionFee?: Maybe<Scalars['String']['output']>;
  tradeCutOff?: Maybe<Scalars['String']['output']>;
};

export type PartyFundInfoClassInput = {
  carryOwnCostPossible?: InputMaybe<Scalars['Boolean']['input']>;
  cleanClass?: InputMaybe<Scalars['Boolean']['input']>;
  dividendPaying?: InputMaybe<Scalars['Boolean']['input']>;
  earlyCloseTradeCutOff?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fxHedgeAccountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  fxHedged?: InputMaybe<Scalars['Boolean']['input']>;
  instrumentId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  mainClass?: InputMaybe<Scalars['Boolean']['input']>;
  managementFee?: InputMaybe<Scalars['String']['input']>;
  managementFeeStruct?: InputMaybe<Scalars['String']['input']>;
  minimumInitialSubscription?: InputMaybe<Scalars['String']['input']>;
  minimumSubscriptionAdded?: InputMaybe<Scalars['String']['input']>;
  numberOfDecimalsNAVPerUnit?: InputMaybe<Scalars['Int']['input']>;
  numberOfDecimalsUnits?: InputMaybe<Scalars['Int']['input']>;
  redemptionFee?: InputMaybe<Scalars['String']['input']>;
  sIFA_ID?: InputMaybe<Scalars['String']['input']>;
  sIFA_UNIT?: InputMaybe<Scalars['String']['input']>;
  sfdr?: InputMaybe<Scalars['String']['input']>;
  shareClass?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  startNAVPerUnit?: InputMaybe<Scalars['String']['input']>;
  subscriptionFee?: InputMaybe<Scalars['String']['input']>;
  tradeCutOff?: InputMaybe<Scalars['String']['input']>;
};

export type PartyFundInfoInput = {
  calendarNames: Array<CalendarNameEnum>;
  classes: Array<InputMaybe<PartyFundInfoClassInput>>;
  createRedeemInstrumentId: Scalars['GraphQLObjectId']['input'];
  custodianId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  depositaryId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  esgComponents?: InputMaybe<Array<EsgComponentEnum>>;
  fundCompanyId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  fundDescription?: InputMaybe<Scalars['String']['input']>;
  fundManager?: InputMaybe<Scalars['String']['input']>;
  fundReportComponents?: InputMaybe<Array<FundReportComponentEnum>>;
  fundReportTypes?: InputMaybe<Array<FundReportEnum>>;
  fundType?: InputMaybe<FundTypeEnum>;
  portfolio?: InputMaybe<Scalars['String']['input']>;
  riskLevel?: InputMaybe<Scalars['Int']['input']>;
  taId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  tradeFrequency?: InputMaybe<Scalars['String']['input']>;
};

export type PartyInfo = {
  __typename?: 'PartyInfo';
  _id: Scalars['GraphQLObjectId']['output'];
  name: Scalars['String']['output'];
};

export type PartyIssuerInput = {
  activitiesAffectingBiodiversityAreas?: InputMaybe<Scalars['Boolean']['input']>;
  captorDnshCompliant?: InputMaybe<Scalars['Boolean']['input']>;
  carbonFootprint?: InputMaybe<Scalars['Boolean']['input']>;
  deforestation?: InputMaybe<Scalars['Boolean']['input']>;
  energyIntensityHighImpact?: InputMaybe<Scalars['Boolean']['input']>;
  esg: PartyEsgInput;
  fossilFuelCompaniesExposure?: InputMaybe<Scalars['Boolean']['input']>;
  ghgEmissions?: InputMaybe<Scalars['Boolean']['input']>;
  ghgIntensityOfInvesteeCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  hazardousWasteRatio?: InputMaybe<Scalars['Boolean']['input']>;
  iorp: IorpEnum;
  keySector?: InputMaybe<Scalars['Boolean']['input']>;
  lackOfProcessesAndCompliance?: InputMaybe<Scalars['Boolean']['input']>;
  managementSupervisoryGenderDiversity?: InputMaybe<Scalars['Boolean']['input']>;
  nearTermTargetClassification?: InputMaybe<Scalars['String']['input']>;
  netZeroCommitted?: Scalars['Boolean']['input'];
  nonRenewableEnergyShare?: InputMaybe<Scalars['Boolean']['input']>;
  pollutionOfWater?: InputMaybe<Scalars['Boolean']['input']>;
  recordableWorkAccidents?: InputMaybe<Scalars['Boolean']['input']>;
  scienceBasedTargetInitiative?: ScienceBasedTargetInitiativeEnum;
  transitionCompany?: InputMaybe<Scalars['Boolean']['input']>;
  unadjustedGenderPayGap?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PartyIssuerType = {
  __typename?: 'PartyIssuerType';
  /** Activities negatively affecting biodiversity sensitive areas */
  activitiesAffectingBiodiversityAreas?: Maybe<Scalars['Boolean']['output']>;
  captorDnshCompliant?: Maybe<Scalars['Boolean']['output']>;
  carbonFootprint?: Maybe<Scalars['Boolean']['output']>;
  deforestation?: Maybe<Scalars['Boolean']['output']>;
  /** Energy consumption intensity per high impact climate sector */
  energyIntensityHighImpact?: Maybe<Scalars['Boolean']['output']>;
  esg?: Maybe<PartyEsg>;
  fossilFuelCompaniesExposure?: Maybe<Scalars['Boolean']['output']>;
  ghgEmissions?: Maybe<Scalars['Boolean']['output']>;
  ghgIntensityOfInvesteeCompanies?: Maybe<Scalars['Boolean']['output']>;
  hazardousWasteRatio?: Maybe<Scalars['Boolean']['output']>;
  iorp?: Maybe<IorpEnum>;
  keySector?: Maybe<Scalars['Boolean']['output']>;
  lackOfProcessesAndCompliance?: Maybe<Scalars['Boolean']['output']>;
  /** Management and supervisory board gender diversity */
  managementSupervisoryGenderDiversity?: Maybe<Scalars['Boolean']['output']>;
  nearTermTargetClassification?: Maybe<Scalars['String']['output']>;
  netZeroCommitted?: Maybe<Scalars['Boolean']['output']>;
  /** Share of non-renewable energy consumption and production */
  nonRenewableEnergyShare?: Maybe<Scalars['Boolean']['output']>;
  pollutionOfWater?: Maybe<Scalars['Boolean']['output']>;
  /** Rate of recordable work-related accidents */
  recordableWorkAccidents?: Maybe<Scalars['Boolean']['output']>;
  scienceBasedTargetInitiative: ScienceBasedTargetInitiativeEnum;
  transitionCompany?: Maybe<Scalars['Boolean']['output']>;
  /** Unadjusted gender pay gap between female and employees */
  unadjustedGenderPayGap?: Maybe<Scalars['Boolean']['output']>;
};

export type PartyStandardSettlementInstruction = {
  __typename?: 'PartyStandardSettlementInstruction';
  agentBusinessIdentifierCode: Scalars['String']['output'];
  beneficiaryBusinessIdentifierCode: Scalars['String']['output'];
  buyerSellerSafe: Scalars['String']['output'];
  iban: Scalars['String']['output'];
  placeOfSettlementId: Scalars['GraphQLObjectId']['output'];
  securityAccount: Scalars['String']['output'];
  tradeType?: Maybe<SsiTradeType>;
  type: Scalars['String']['output'];
};

export type PartyStandardSettlementInstructionInput = {
  agentBusinessIdentifierCode: Scalars['String']['input'];
  beneficiaryBusinessIdentifierCode: Scalars['String']['input'];
  buyerSellerSafe: Scalars['String']['input'];
  iban: Scalars['String']['input'];
  placeOfSettlementId: Scalars['GraphQLObjectId']['input'];
  securityAccount: Scalars['String']['input'];
  tradeType: SsiTradeType;
  type: PartyStandardSettlementInstructionType;
};

export enum PartyStandardSettlementInstructionType {
  Equity = 'Equity',
  FixedIncome = 'FixedIncome'
}

export enum PartyStatusEnum {
  Confirmed = 'Confirmed',
  Deleted = 'Deleted',
  Inactive = 'Inactive',
  Simulated = 'Simulated'
}

export enum PartyType {
  Broker = 'Broker',
  ClearingBroker = 'ClearingBroker',
  ClearingHouse = 'ClearingHouse',
  Client = 'Client',
  CreditRatingAgency = 'CreditRatingAgency',
  Custodian = 'Custodian',
  EsgDataProvider = 'EsgDataProvider',
  Fund = 'Fund',
  Integrator = 'Integrator',
  Issuer = 'Issuer',
  /** Mandate denotes Discretionary Mandate */
  Mandate = 'Mandate',
  MarketDataProvider = 'MarketDataProvider',
  PlaceOfSettlement = 'PlaceOfSettlement',
  PrivateClient = 'PrivateClient',
  TransferAgent = 'TransferAgent'
}

export type PerformanceFilterInput = {
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  startDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};

export enum PeriodicityAdjustmentEnum {
  ACTUAL = 'ACTUAL',
  CALENDAR = 'CALENDAR',
  FISCAL = 'FISCAL'
}

export enum PeriodicitySelectionEnum {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  SEMI_ANNUALLY = 'SEMI_ANNUALLY',
  WEEKLY = 'WEEKLY',
  YEARLY = 'YEARLY'
}

export enum PermissionAssetEnum {
  Accounting = 'Accounting',
  Admin = 'Admin',
  Agreement = 'Agreement',
  Attachment = 'Attachment',
  BackOffice = 'BackOffice',
  BankAccountTransaction = 'BankAccountTransaction',
  Base = 'Base',
  Bloomberg = 'Bloomberg',
  Collateral = 'Collateral',
  ConfirmAccounting = 'ConfirmAccounting',
  Customer = 'Customer',
  Esg = 'Esg',
  Instrument = 'Instrument',
  Job = 'Job',
  Kleer = 'Kleer',
  Limit = 'Limit',
  Nav = 'Nav',
  Note = 'Note',
  /** Team asset */
  Operations = 'Operations',
  Party = 'Party',
  Payment = 'Payment',
  Performance = 'Performance',
  Playground = 'Playground',
  /** PortfolioManager used in frontend */
  PortfolioManager = 'PortfolioManager',
  /** Team asset */
  PortfolioManagers = 'PortfolioManagers',
  Position = 'Position',
  Price = 'Price',
  Property = 'Property',
  Quote = 'Quote',
  Reconciliation = 'Reconciliation',
  Report = 'Report',
  Sustainalytics = 'Sustainalytics',
  Ticket = 'Ticket',
  TimeSeries = 'TimeSeries',
  Transaction = 'Transaction',
  User = 'User',
  Valuation = 'Valuation'
}

export type PortfolioPerformance = {
  __typename?: 'PortfolioPerformance';
  cashFlows?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  currency?: Maybe<CurrencyEnum>;
  dates?: Maybe<Array<Maybe<Scalars['GraphQLDateString']['output']>>>;
  id: Scalars['GraphQLObjectId']['output'];
  instrumentPerformances?: Maybe<Array<Maybe<InstrumentPerformance>>>;
  performanceItems?: Maybe<Array<Maybe<PortfolioPerformanceItem>>>;
  series?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  values?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type PortfolioPerformanceItem = {
  __typename?: 'PortfolioPerformanceItem';
  cashFlow?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['GraphQLDateString']['output']>;
  series?: Maybe<Scalars['Float']['output']>;
  totalReturn?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type PortfolioSwapItemValuation = {
  __typename?: 'PortfolioSwapItemValuation';
  date: Scalars['GraphQLDateString']['output'];
  value: PortfolioSwapItemValue;
};

export type PortfolioSwapItemValue = {
  __typename?: 'PortfolioSwapItemValue';
  currency: CurrencyEnum;
  price: Scalars['Float']['output'];
};

export type PortfolioSwapItemsPosition = {
  __typename?: 'PortfolioSwapItemsPosition';
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
  isDebtInstrument: Scalars['Boolean']['output'];
  quantity: Scalars['Float']['output'];
  valuation: PortfolioSwapItemValuation;
};

export type Position = {
  __typename?: 'Position';
  account?: Maybe<PartyAccount>;
  accountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  client?: Maybe<Party>;
  clientId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  externalAccount?: Maybe<PartyExternalAccount>;
  externalAccountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  instrument?: Maybe<Instrument>;
  instrumentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  isCashAccount?: Maybe<Scalars['Boolean']['output']>;
  portfolioInstrument?: Maybe<Instrument>;
  portfolioInstrumentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type PositionFilter = {
  accountIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  instrumentIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  statusIn?: InputMaybe<Array<TransactionStatus>>;
};

export enum PositionSelectorType {
  AccountId = 'AccountId',
  ClientId = 'ClientId',
  ExternalAccountId = 'ExternalAccountId'
}

export enum PositionTypeEnum {
  CreateRedeem = 'CreateRedeem',
  OffBalance = 'OffBalance',
  OnBalance = 'OnBalance'
}

export type Price = {
  __typename?: 'Price';
  _id: Scalars['GraphQLObjectId']['output'];
  accruedInterest?: Maybe<Scalars['String']['output']>;
  cleanPrice?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Party>;
  clientId: Scalars['GraphQLObjectId']['output'];
  createTimestamp: Scalars['Timestamp']['output'];
  currency: CurrencyEnum;
  date: Scalars['GraphQLDateString']['output'];
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
  price: Scalars['String']['output'];
  sourceId: Scalars['GraphQLObjectId']['output'];
  spread?: Maybe<Scalars['String']['output']>;
  type: PriceTypeEnum;
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type PriceFilterInput = {
  dateIn?: InputMaybe<Array<Scalars['GraphQLDateString']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  instrumentIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  typeIn?: InputMaybe<Array<PriceTypeEnum>>;
};

export type PriceInput = {
  accruedInterest?: InputMaybe<Scalars['String']['input']>;
  cleanPrice?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['GraphQLObjectId']['input'];
  currency: CurrencyEnum;
  date: Scalars['GraphQLDateString']['input'];
  instrumentId: Scalars['GraphQLObjectId']['input'];
  price: Scalars['String']['input'];
  spread?: InputMaybe<Scalars['String']['input']>;
};

export enum PriceType {
  AccruedInterest = 'AccruedInterest',
  CleanPrice = 'CleanPrice',
  Price = 'Price',
  PriceEstimate = 'PriceEstimate'
}

export enum PriceTypeEnum {
  Price = 'Price',
  PriceMapping = 'PriceMapping',
  Valuation = 'Valuation',
  ValuationMapping = 'ValuationMapping'
}

export enum PricingOptionEnum {
  PRICING_OPTION_PRICE = 'PRICING_OPTION_PRICE',
  PRICING_OPTION_YIELD = 'PRICING_OPTION_YIELD'
}

export type ProductInvolvement = {
  __typename?: 'ProductInvolvement';
  involvement: ProductInvolvementIndicator;
  range: RangeEnum;
};

export enum ProductInvolvementIndicator {
  AdultEntertainment = 'AdultEntertainment',
  AlcoholicBeverages = 'AlcoholicBeverages',
  ControversialWeapons = 'ControversialWeapons',
  Gambling = 'Gambling',
  MilitaryContracting = 'MilitaryContracting',
  OilGas = 'OilGas',
  OilSands = 'OilSands',
  SmallArms = 'SmallArms',
  ThermalCoal = 'ThermalCoal',
  TobaccoProducts = 'TobaccoProducts'
}

export type ProductInvolvementInput = {
  involvement: ProductInvolvementIndicator;
  range: RangeEnum;
};

export type PublishedToInput = {
  _id: Scalars['GraphQLObjectId']['input'];
  /** Name of external recipient */
  keys: Array<Scalars['String']['input']>;
};

export type PublishedToType = {
  __typename?: 'PublishedToType';
  /** Name of external recipient */
  key: Scalars['String']['output'];
  timestamp: Scalars['Timestamp']['output'];
  userId: Scalars['GraphQLObjectId']['output'];
};

export type QuantLibPeriod = {
  __typename?: 'QuantLibPeriod';
  unit?: Maybe<QuantLibTimeUnitEnum>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum QuantLibTimeUnitEnum {
  Days = 'Days',
  Hours = 'Hours',
  Microseconds = 'Microseconds',
  Milliseconds = 'Milliseconds',
  Minutes = 'Minutes',
  Months = 'Months',
  Seconds = 'Seconds',
  Weeks = 'Weeks',
  Years = 'Years'
}

export type Query = {
  __typename?: 'Query';
  /** Performance for specified account */
  accountPerformance?: Maybe<PortfolioPerformance>;
  accountingRun?: Maybe<AccountingRun>;
  accountingRunId: Scalars['GraphQLObjectId']['output'];
  accountingRuns?: Maybe<Array<Maybe<AccountingRun>>>;
  /** Accounting runs sorted by client and number descending */
  accountingRuns2?: Maybe<Array<AccountingRun2>>;
  adjustmentAmount?: Maybe<Array<Maybe<TradingManagerColumn>>>;
  agreements?: Maybe<Array<Maybe<Agreement>>>;
  allInstrumentsInPosition?: Maybe<Array<Maybe<InstrumentPosition>>>;
  annualReports: Array<AnnualReportType>;
  attachment?: Maybe<Attachment>;
  attachments: Array<Attachment>;
  bankAccountBalances: Array<BankAccountBalance>;
  bankAccountTransactions: Array<BankAccountTransaction>;
  /** Base calendars are unique by year combined with name */
  baseCalendars?: Maybe<Array<Maybe<BaseCalendar>>>;
  brokerTransactions: Array<BrokerTransaction>;
  calculateNav?: Maybe<NavData>;
  /**
   * Combining all dates from different years for calendar with the stated names or for
   * calendars in party.fundInfo for a specific fund
   */
  calendar?: Maybe<Calendar>;
  cashBalances?: Maybe<Array<Maybe<CashAccountBalance>>>;
  cashLadder?: Maybe<Array<Maybe<CashAccountLadder>>>;
  clientAccounts?: Maybe<Array<Maybe<PartyAccount>>>;
  clientsByAssets: Array<ClientForAsset>;
  corporateActions?: Maybe<Array<CorporateAction>>;
  costs?: Maybe<Array<Maybe<Cost>>>;
  curveDefinition?: Maybe<CurveDefinition>;
  curveDefinitionInstruments: Array<Instrument>;
  curveDefinitions?: Maybe<Array<Maybe<CurveDefinition>>>;
  custodianPositions: Array<CustodianApiPosition>;
  customers?: Maybe<Array<Maybe<Customer>>>;
  dart?: Maybe<DartReport>;
  defaultQuery?: Maybe<Scalars['String']['output']>;
  exposuresCollaterals: Array<ExposureCollateral>;
  extensions?: Maybe<Array<Maybe<Extension>>>;
  externalAccountsPositions?: Maybe<Array<Maybe<Position>>>;
  firstTransaction?: Maybe<Transaction>;
  firstTransactions?: Maybe<Array<Transaction>>;
  fredSeriesObservations?: Maybe<Array<Maybe<FredObservation>>>;
  fredSeriess?: Maybe<Array<Maybe<FredSeries>>>;
  /** Performance for funds based on create redeems and nav */
  fundPerformance?: Maybe<FundPortfolioPerformance>;
  fundUnits?: Maybe<Array<Maybe<FundUnit>>>;
  fxMiniTransactions?: Maybe<Array<Maybe<MiniTransaction>>>;
  fxValuations?: Maybe<Array<Maybe<FxValuation>>>;
  getRedisKey?: Maybe<Scalars['JSON']['output']>;
  historicalData?: Maybe<Array<Maybe<HistoricalData>>>;
  instrument?: Maybe<Instrument>;
  instrumentAccountPositions?: Maybe<Array<Maybe<InstrumentAccountPosition>>>;
  instruments?: Maybe<Array<Maybe<Instrument>>>;
  instrumentsUsedBy?: Maybe<Array<Maybe<Instrument>>>;
  inventory: Array<Inventory>;
  issuerprograms?: Maybe<Array<Maybe<IssuerProgram>>>;
  /**
   * Journal entries, queried in one of two exclusive ways:
   * 1. accountingRunId, optionally with batch
   * 2. clientId and accountingPeriod (journal entries of all non-deleted accounting runs in the period)
   * Mixing arguments from both cases is an error.
   */
  journalEntries?: Maybe<Array<JournalEntry>>;
  /**
   * Journal entries, queried in one of two exclusive ways:
   * 1. accountingRunId, optionally with batch
   * 2. clientId and accountingPeriod (journal entries of all non-deleted accounting runs in the period)
   * Mixing arguments from both cases is an error.
   */
  journalEntries2?: Maybe<Array<JournalEntry2>>;
  journalEntry?: Maybe<JournalEntry>;
  journalEntry2?: Maybe<JournalEntry2>;
  kleerAccountMetadata?: Maybe<Array<Maybe<KleerAccountMetadata>>>;
  kleerAccountingYears?: Maybe<Array<Maybe<KleerAccountingYear>>>;
  kleerCompanyInfo?: Maybe<KleerCompanyInfo>;
  kleerResultReport?: Maybe<Scalars['JSON']['output']>;
  kleerRevenueLedgers?: Maybe<Array<Maybe<KleerRevenueLedger>>>;
  kleerRevenues?: Maybe<Array<Maybe<KleerRevenue>>>;
  kleerVouchers?: Maybe<Array<Maybe<KleerVoucher>>>;
  lastValuations?: Maybe<Array<Maybe<Valuation>>>;
  latestExternalNumber: Scalars['Int']['output'];
  latestExternalNumber2: Scalars['Int']['output'];
  limit?: Maybe<Array<Maybe<LimitData>>>;
  marginRequirements: Array<MarginRequirement>;
  me?: Maybe<Me>;
  miniTransaction?: Maybe<MiniTransaction>;
  miniTransactions?: Maybe<Array<Maybe<MiniTransaction>>>;
  /**
   * Transactions that have at least one item with a missing fxRate.
   * items includes every item on those transactions, not only the items missing fxRate.
   */
  missingFxRateTransactions?: Maybe<Array<Maybe<Transaction>>>;
  nav?: Maybe<Nav>;
  navs?: Maybe<Array<Maybe<Nav>>>;
  notes?: Maybe<Array<Maybe<Note>>>;
  opConsents?: Maybe<Array<Maybe<OpConsent>>>;
  opPayments?: Maybe<Array<Maybe<OpPayment>>>;
  opSigningBasketAuthorization?: Maybe<SigningBasketAuthorization>;
  parties?: Maybe<Array<Maybe<Party>>>;
  party?: Maybe<Party>;
  partyExternalAccount?: Maybe<PartyExternalAccount>;
  partyUsage?: Maybe<Scalars['Boolean']['output']>;
  performance?: Maybe<PortfolioPerformance>;
  /** Performance based on price collection */
  performancePrice?: Maybe<PortfolioPerformance>;
  portfolioSwapConstituents?: Maybe<Array<Maybe<PortfolioSwapItemsPosition>>>;
  positions?: Maybe<Array<Maybe<Position>>>;
  prices?: Maybe<Array<Maybe<Price>>>;
  quotes?: Maybe<Array<Maybe<Quote>>>;
  reconcileExposureCollateral: Array<ReconciledExposureCollateralType>;
  reconcileFundUnits?: Maybe<Array<FundUnitReconciliationType>>;
  reconcilePositions?: Maybe<Array<ReconciliationType>>;
  redisKeys: Array<Scalars['String']['output']>;
  referenceData?: Maybe<Array<Maybe<ReferenceData>>>;
  registerExtracts?: Maybe<Array<RegisterExtract>>;
  report?: Maybe<Report>;
  reportTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reports?: Maybe<Array<Maybe<Report>>>;
  role?: Maybe<Role>;
  roles?: Maybe<Array<Maybe<Role>>>;
  screens?: Maybe<Array<Maybe<Screen>>>;
  securityLadder?: Maybe<Array<Maybe<SecurityLadder>>>;
  /** returns an array of clientAccount positions on selected day and per instruments */
  shareRegister?: Maybe<Array<ShareRegisterItem>>;
  shareRegisterDelta?: Maybe<Array<ShareRegisterItem>>;
  shareRegisterUnits?: Maybe<Array<ShareRegisterUnits>>;
  /** returns an array of clientAccount positions per day and per instruments */
  shareRegisters?: Maybe<Array<ShareRegisterItem>>;
  sustainalyticsDataModel: Array<SustainalyticsDataModel>;
  sustainalyticsDataService?: Maybe<Array<Maybe<SustainalyticsDataModelWithStatus>>>;
  sustainalyticsFieldDefinitions?: Maybe<Array<Maybe<SustainalyticsFieldDefinitionModel>>>;
  sustainalyticsFieldMappingDefinitions?: Maybe<Array<Maybe<SustainalyticsProductModel>>>;
  sustainalyticsFieldMappings?: Maybe<Array<Maybe<SustainalyticsProductModel>>>;
  sustainalyticsReport?: Maybe<SustainalyticsReport>;
  sustainalyticsReportService?: Maybe<Array<Maybe<SustainalyticsReport>>>;
  sustainalyticsReportUrl?: Maybe<SustainalyticsReportUrl>;
  sustainalyticsUniverseOfAccess?: Maybe<Array<Maybe<SustainalyticsSecurityListModel>>>;
  swifts?: Maybe<Array<Swift>>;
  tAccountChart?: Maybe<TAccountChart>;
  tAccountChart2?: Maybe<UpsertTAccountChart>;
  tAccountChartAccountsExport?: Maybe<Scalars['String']['output']>;
  tAccountChartMappingsExport?: Maybe<Scalars['String']['output']>;
  tAccountCharts?: Maybe<Array<Maybe<TAccountChart>>>;
  tAccountCharts2?: Maybe<Array<UpsertTAccountChart>>;
  ticketUsers?: Maybe<Array<TicketUser>>;
  tickets?: Maybe<Array<Maybe<Ticket>>>;
  timeserie?: Maybe<TimeSeries>;
  timeseries?: Maybe<Array<Maybe<TimeSeries>>>;
  tradingmanager?: Maybe<Array<Maybe<TradingManagerColumn>>>;
  tradingmanager2?: Maybe<Array<Maybe<TradingManagerColumn>>>;
  transaction?: Maybe<Transaction>;
  transactionItems?: Maybe<Array<Maybe<TransactionItem>>>;
  transactionitemStatus?: Maybe<Scalars['Float']['output']>;
  transactions?: Maybe<Array<Transaction>>;
  transferAgentAccountPerformance?: Maybe<TransferAgentAccountPerformance>;
  transferAgentOrder?: Maybe<TransferAgentOrder>;
  transferAgentOrders?: Maybe<Array<Maybe<TransferAgentOrder>>>;
  transferAgentTotalUnits?: Maybe<Array<Maybe<TransferAgentTotalUnit>>>;
  user?: Maybe<User>;
  users?: Maybe<Array<Maybe<User>>>;
  /** Used to assign tickets to teams */
  usersLimited: Array<UserLimited>;
  valuation?: Maybe<Valuation>;
  valuationmappings?: Maybe<Array<Maybe<ValuationMapping>>>;
  valuations?: Maybe<Array<Maybe<Valuation>>>;
};


export type QueryAccountPerformanceArgs = {
  accountId: Scalars['GraphQLObjectId']['input'];
  filter?: InputMaybe<PerformanceFilterInput>;
  lookThrough?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAccountingRunArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type QueryAccountingRunsArgs = {
  accountingPeriod?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  lastOnly?: InputMaybe<Scalars['Boolean']['input']>;
  maxNumber?: InputMaybe<Scalars['Int']['input']>;
  statusIn?: InputMaybe<Array<AccountingRunStatusEnum>>;
};


export type QueryAccountingRuns2Args = {
  filter?: InputMaybe<AccountingRun2FilterInput>;
};


export type QueryAdjustmentAmountArgs = {
  baseCurrency?: InputMaybe<CurrencyEnum>;
  clientId: Scalars['GraphQLObjectId']['input'];
  date: Scalars['GraphQLDateString']['input'];
};


export type QueryAgreementsArgs = {
  filter?: InputMaybe<AgreementFilterInput>;
};


export type QueryAllInstrumentsInPositionArgs = {
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  clientTypes?: InputMaybe<Array<PartyType>>;
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  instrumentIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  instrumentPositionType?: InputMaybe<InstrumentPositionType>;
  modelTypes?: InputMaybe<Array<InstrumentModelTypeEnum>>;
};


export type QueryAnnualReportsArgs = {
  clientIds: Array<Scalars['GraphQLObjectId']['input']>;
  date: Scalars['GraphQLDateString']['input'];
};


export type QueryAttachmentArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type QueryAttachmentsArgs = {
  fileIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
};


export type QueryBankAccountBalancesArgs = {
  filter?: InputMaybe<BankAccountBalanceFilterInput>;
};


export type QueryBankAccountTransactionsArgs = {
  filter?: InputMaybe<BankAccountTransactionFilterInput>;
};


export type QueryBaseCalendarsArgs = {
  filter?: InputMaybe<BaseCalendarFilterInput>;
};


export type QueryBrokerTransactionsArgs = {
  filter?: InputMaybe<BrokerTransactionFilterInput>;
};


export type QueryCalculateNavArgs = {
  date: Scalars['GraphQLDateString']['input'];
  fundId: Scalars['GraphQLObjectId']['input'];
};


export type QueryCalendarArgs = {
  fundId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  names?: InputMaybe<Array<CalendarNameEnum>>;
  years?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryCashBalancesArgs = {
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  instrumentIds: Array<Scalars['GraphQLObjectId']['input']>;
  viewFromDate: Scalars['GraphQLDateString']['input'];
};


export type QueryCashLadderArgs = {
  clientIds: Array<Scalars['GraphQLObjectId']['input']>;
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  statusNotIn?: InputMaybe<Array<TransactionStatus>>;
};


export type QueryClientAccountsArgs = {
  clientIds?: InputMaybe<Array<InputMaybe<Scalars['GraphQLObjectId']['input']>>>;
};


export type QueryCorporateActionsArgs = {
  filter?: InputMaybe<CorporateActionFilterInput>;
};


export type QueryCostsArgs = {
  filter?: InputMaybe<CostFilterInput>;
};


export type QueryCurveDefinitionArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type QueryCustodianPositionsArgs = {
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  filterZeroPositions?: InputMaybe<Scalars['Boolean']['input']>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  include?: InputMaybe<Array<InputMaybe<CustodianPositionType>>>;
  instrumentIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  isinIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  statusIn?: InputMaybe<Array<StatusEnum>>;
  typeIn?: InputMaybe<Array<CustodianPositionType>>;
};


export type QueryCustomersArgs = {
  filter?: InputMaybe<CustomerFilterInput>;
};


export type QueryDartArgs = {
  clientId: Scalars['GraphQLObjectId']['input'];
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type QueryExposuresCollateralsArgs = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  dates?: InputMaybe<Array<Scalars['GraphQLDateString']['input']>>;
};


export type QueryExtensionsArgs = {
  filter?: InputMaybe<ExtensionsFilterInput>;
};


export type QueryExternalAccountsPositionsArgs = {
  custodianAccountNumbers: Array<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  externalAccountIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  includeAllCashAccounts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFirstTransactionArgs = {
  clientId: Scalars['GraphQLObjectId']['input'];
  instrumentId: Scalars['GraphQLObjectId']['input'];
};


export type QueryFirstTransactionsArgs = {
  clientIds: Array<Scalars['GraphQLObjectId']['input']>;
  instrumentIds: Array<Scalars['GraphQLObjectId']['input']>;
};


export type QueryFredSeriesObservationsArgs = {
  id: Scalars['String']['input'];
  observationEnd?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  observationStart?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  queryArgs?: InputMaybe<FredQueryArgs>;
};


export type QueryFredSeriessArgs = {
  id: Scalars['String']['input'];
  queryArgs?: InputMaybe<FredQueryArgs>;
};


export type QueryFundPerformanceArgs = {
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type QueryFundUnitsArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type QueryFxMiniTransactionsArgs = {
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type QueryFxValuationsArgs = {
  date?: InputMaybe<Scalars['GraphQLSwedenDate']['input']>;
};


export type QueryGetRedisKeyArgs = {
  key: Scalars['String']['input'];
};


export type QueryHistoricalDataArgs = {
  adjustmentAbnormal?: InputMaybe<Scalars['Boolean']['input']>;
  adjustmentFollowDPDF?: InputMaybe<Scalars['Boolean']['input']>;
  adjustmentNormal?: InputMaybe<Scalars['Boolean']['input']>;
  adjustmentSplit?: InputMaybe<Scalars['Boolean']['input']>;
  calendarCodeOverride?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['Date']['input'];
  enumField?: InputMaybe<HistoricalFieldsEnum>;
  field?: InputMaybe<Scalars['String']['input']>;
  machine?: InputMaybe<RefDataMachine>;
  maxDataPoints?: InputMaybe<Scalars['Int']['input']>;
  nonTradingDayFillMethod?: InputMaybe<NonTradingDayFillMethodEnum>;
  nonTradingDayFillOption?: InputMaybe<NonTradingDayFillOptionEnum>;
  overrideOption?: InputMaybe<OverrideOptionEnum>;
  periodicityAdjustment?: InputMaybe<PeriodicityAdjustmentEnum>;
  periodicitySelection?: InputMaybe<PeriodicitySelectionEnum>;
  pricingOption?: InputMaybe<PricingOptionEnum>;
  returnRelativeDate?: InputMaybe<Scalars['Boolean']['input']>;
  securities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate: Scalars['Date']['input'];
};


export type QueryInstrumentArgs = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInstrumentAccountPositionsArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  filterZeroPositions?: InputMaybe<Scalars['Boolean']['input']>;
  groupPositionsBy?: InputMaybe<PositionSelectorType>;
  instrumentIds: Array<Scalars['GraphQLObjectId']['input']>;
};


export type QueryInstrumentsArgs = {
  aliasIn?: InputMaybe<Array<Scalars['String']['input']>>;
  filter?: InputMaybe<InstrumentFilterInput>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryInstrumentsUsedByArgs = {
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
};


export type QueryInventoryArgs = {
  clientId: Scalars['GraphQLObjectId']['input'];
  endDate: Scalars['GraphQLDateString']['input'];
};


export type QueryIssuerprogramsArgs = {
  filter?: InputMaybe<IssuerProgramsFilterInput>;
};


export type QueryJournalEntriesArgs = {
  accountingPeriod?: InputMaybe<Scalars['String']['input']>;
  accountingRunId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  batch?: InputMaybe<AccountingBatchType>;
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
};


export type QueryJournalEntries2Args = {
  accountingPeriod?: InputMaybe<Scalars['String']['input']>;
  accountingRunId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  batch?: InputMaybe<AccountingBatchType>;
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
};


export type QueryJournalEntryArgs = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  portfolioTransactionId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
};


export type QueryJournalEntry2Args = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  portfolioTransactionId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
};


export type QueryKleerAccountMetadataArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['GraphQLDateString']['input'];
  startDate: Scalars['GraphQLDateString']['input'];
};


export type QueryKleerAccountingYearsArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryKleerCompanyInfoArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryKleerResultReportArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  filterByDimensionEntryId?: InputMaybe<Scalars['Int']['input']>;
  groupByDimensionId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type QueryKleerRevenueLedgersArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryKleerRevenuesArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  ledgerId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  lowerDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  upperDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type QueryKleerVouchersArgs = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  startDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type QueryLastValuationsArgs = {
  endDate?: InputMaybe<Scalars['GraphQLSwedenDate']['input']>;
  instrumentIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
};


export type QueryLatestExternalNumberArgs = {
  accountingPeriod: Scalars['String']['input'];
  clientId: Scalars['GraphQLObjectId']['input'];
};


export type QueryLatestExternalNumber2Args = {
  accountingPeriod: Scalars['String']['input'];
  clientId: Scalars['GraphQLObjectId']['input'];
};


export type QueryLimitArgs = {
  clientId: Scalars['GraphQLObjectId']['input'];
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type QueryMarginRequirementsArgs = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  dates?: InputMaybe<Array<Scalars['GraphQLDateString']['input']>>;
};


export type QueryMiniTransactionArgs = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
};


export type QueryMiniTransactionsArgs = {
  brokerId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  filter?: InputMaybe<TransactionFilterInput>;
  includePortfolioSwapConstituents?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<InputMaybe<TransactionStatus>>>;
  type?: InputMaybe<Array<InputMaybe<TransactionType>>>;
};


export type QueryMissingFxRateTransactionsArgs = {
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type QueryNavArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type QueryNavsArgs = {
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  lastOnly?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  statusIn?: InputMaybe<Array<ReportStatusEnum>>;
};


export type QueryNotesArgs = {
  filter?: InputMaybe<NoteFilterInput>;
};


export type QueryOpConsentsArgs = {
  filter?: InputMaybe<OpConsentFilter>;
};


export type QueryOpPaymentsArgs = {
  filter?: InputMaybe<OpPaymentFilter>;
};


export type QueryOpSigningBasketAuthorizationArgs = {
  signingBasketId: Scalars['String']['input'];
};


export type QueryPartiesArgs = {
  filter?: InputMaybe<PartyFilterInput>;
};


export type QueryPartyArgs = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPartyExternalAccountArgs = {
  clientId: Scalars['GraphQLObjectId']['input'];
  externalAccountId: Scalars['GraphQLObjectId']['input'];
};


export type QueryPartyUsageArgs = {
  partyId: Scalars['GraphQLObjectId']['input'];
};


export type QueryPerformanceArgs = {
  clientId: Scalars['GraphQLObjectId']['input'];
  filter?: InputMaybe<PerformanceFilterInput>;
  lookThrough?: InputMaybe<Scalars['Boolean']['input']>;
  useCache?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPerformancePriceArgs = {
  clientId: Scalars['GraphQLObjectId']['input'];
  filter?: InputMaybe<PerformanceFilterInput>;
  lookThrough?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPortfolioSwapConstituentsArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  filterZeroPositions?: InputMaybe<Scalars['Boolean']['input']>;
  portfolioInstrumentId: Scalars['GraphQLObjectId']['input'];
};


export type QueryPositionsArgs = {
  excludeCollateral?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PositionFilter>;
  filterZeroPositions?: InputMaybe<Scalars['Boolean']['input']>;
  groupPositionsBy?: InputMaybe<PositionSelectorType>;
  includeAllCashAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  lookThrough?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPricesArgs = {
  filter?: InputMaybe<PriceFilterInput>;
};


export type QueryQuotesArgs = {
  filter?: InputMaybe<QuoteFilterInput>;
};


export type QueryReconcileExposureCollateralArgs = {
  clientIds: Array<Scalars['GraphQLObjectId']['input']>;
  date: Scalars['GraphQLDateString']['input'];
};


export type QueryReconcileFundUnitsArgs = {
  date: Scalars['GraphQLDateString']['input'];
  filterOutZeroDiff?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryReconcilePositionsArgs = {
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  date: Scalars['GraphQLDateString']['input'];
};


export type QueryReferenceDataArgs = {
  enumFields?: InputMaybe<Array<InputMaybe<ReferenceFieldsEnum>>>;
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  machine?: InputMaybe<RefDataMachine>;
  securities?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryRegisterExtractsArgs = {
  filter?: InputMaybe<RegisterExtractFilterInput>;
};


export type QueryReportArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type QueryReportTypesArgs = {
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  typeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryReportsArgs = {
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  lastOnly?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  statusIn?: InputMaybe<Array<ReportStatusEnum>>;
  type?: InputMaybe<Scalars['String']['input']>;
  typeNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryRoleArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type QueryRolesArgs = {
  statusIn?: InputMaybe<Array<DocumentStatusEnum>>;
};


export type QueryScreensArgs = {
  filter?: InputMaybe<FilterInput>;
};


export type QuerySecurityLadderArgs = {
  clientIds: Array<Scalars['GraphQLObjectId']['input']>;
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  statusNotIn?: InputMaybe<Array<TransactionStatus>>;
};


export type QueryShareRegisterArgs = {
  filter?: InputMaybe<ShareRegisterFilterInput>;
};


export type QueryShareRegisterDeltaArgs = {
  fromDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  toDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type QueryShareRegisterUnitsArgs = {
  filter?: InputMaybe<ShareRegisterFilterInput>;
};


export type QueryShareRegistersArgs = {
  fromDate: Scalars['GraphQLDateString']['input'];
  toDate: Scalars['GraphQLDateString']['input'];
};


export type QuerySustainalyticsDataModelArgs = {
  fieldClusterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldIds?: InputMaybe<Array<Scalars['String']['input']>>;
  identifiers: Array<Scalars['String']['input']>;
  packageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productId: Scalars['String']['input'];
};


export type QuerySustainalyticsDataServiceArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  fieldClusterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  fieldIds?: InputMaybe<Array<Scalars['String']['input']>>;
  identifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  packageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productId: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySustainalyticsReportArgs = {
  identifier: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type QuerySustainalyticsReportServiceArgs = {
  count?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['String']['input'];
  skip?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySustainalyticsReportUrlArgs = {
  identifier: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
};


export type QuerySwiftsArgs = {
  clientIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  filter?: InputMaybe<SwiftFilterInput>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  statusIn?: InputMaybe<Array<SwiftStatusEnum>>;
};


export type QueryTAccountChartArgs = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTAccountChart2Args = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type QueryTAccountChartAccountsExportArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
  delimiter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTAccountChartMappingsExportArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
  delimiter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTAccountChartsArgs = {
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTAccountCharts2Args = {
  filter?: InputMaybe<TAccountChart2FilterInput>;
};


export type QueryTicketsArgs = {
  filter?: InputMaybe<TicketFilterInput>;
};


export type QueryTimeserieArgs = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  filter?: InputMaybe<TimeSeriesFilterInput>;
  includeItems?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTimeseriesArgs = {
  filter?: InputMaybe<TimeSeriesFilterInput>;
  firstItem?: InputMaybe<Scalars['Boolean']['input']>;
  includeItems?: InputMaybe<Scalars['Boolean']['input']>;
  lastItem?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTradingmanagerArgs = {
  baseCurrency?: InputMaybe<CurrencyEnum>;
  excludeCollateral?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PositionFilter>;
  filterZeroPositions?: InputMaybe<Scalars['Boolean']['input']>;
  groupPositionsBy?: InputMaybe<PositionSelectorType>;
  includeAllCashAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  lookThrough?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTradingmanager2Args = {
  baseCurrency?: InputMaybe<CurrencyEnum>;
  clientId: Scalars['GraphQLObjectId']['input'];
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  excludeCollateral?: InputMaybe<Scalars['Boolean']['input']>;
  filterZeroPositions?: InputMaybe<Scalars['Boolean']['input']>;
  groupPositionsBy?: InputMaybe<PositionSelectorType>;
  includeAllCashAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  lookThrough?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTransactionArgs = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
};


export type QueryTransactionItemsArgs = {
  filter?: InputMaybe<TransactionItemFilterInput>;
};


export type QueryTransactionsArgs = {
  accountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  brokerId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  externalAccountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  filter?: InputMaybe<TransactionFilterInput>;
  includePortfolioSwapConstituents?: InputMaybe<Scalars['Boolean']['input']>;
  instrumentId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  status?: InputMaybe<Array<InputMaybe<TransactionStatus>>>;
};


export type QueryTransferAgentAccountPerformanceArgs = {
  absoluteRebate?: InputMaybe<Scalars['Float']['input']>;
  clientAccount: Scalars['String']['input'];
  isin: Scalars['ISIN']['input'];
  percentageRebate?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryTransferAgentOrderArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type QueryTransferAgentOrdersArgs = {
  filter?: InputMaybe<OrderFilterInput>;
};


export type QueryTransferAgentTotalUnitsArgs = {
  filter?: InputMaybe<TransferAgentTotalUnitFilterInput>;
};


export type QueryUserArgs = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  personalNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilterInput>;
};


export type QueryUsersLimitedArgs = {
  filter?: InputMaybe<LimitedUserFilterInput>;
};


export type QueryValuationArgs = {
  _id: Scalars['GraphQLObjectId']['input'];
};


export type QueryValuationmappingsArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  filter?: InputMaybe<ValuationMappingFilterInput>;
  valuationInstrumentIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
};


export type QueryValuationsArgs = {
  endDate?: InputMaybe<Scalars['GraphQLSwedenDate']['input']>;
  instrumentIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  startDate?: InputMaybe<Scalars['GraphQLSwedenDate']['input']>;
};

export type Quote = {
  __typename?: 'Quote';
  _id: Scalars['GraphQLObjectId']['output'];
  ask?: Maybe<Scalars['String']['output']>;
  bid?: Maybe<Scalars['String']['output']>;
  /** Broker is the quoting party */
  brokerId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  close?: Maybe<Scalars['String']['output']>;
  createTimestamp: Scalars['Timestamp']['output'];
  currency: CurrencyEnum;
  /** DataVendor is for example Bloomberg */
  dataVendorId: Scalars['GraphQLObjectId']['output'];
  date: Scalars['GraphQLDateString']['output'];
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
  last?: Maybe<Scalars['String']['output']>;
  /** Market is for example exchange, OTC, NASDAQ, Turquoise etc */
  market?: Maybe<Scalars['String']['output']>;
  mid?: Maybe<Scalars['String']['output']>;
  type: QuoteTypeEnum;
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type QuoteFilterInput = {
  dateIn?: InputMaybe<Array<Scalars['GraphQLDateString']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  instrumentIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
};

export type QuoteInput = {
  ask?: InputMaybe<Scalars['String']['input']>;
  bid?: InputMaybe<Scalars['String']['input']>;
  brokerId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  close?: InputMaybe<Scalars['String']['input']>;
  currency: CurrencyEnum;
  dataVendorId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  date: Scalars['GraphQLDateString']['input'];
  instrumentId: Scalars['GraphQLObjectId']['input'];
  last?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  mid?: InputMaybe<Scalars['String']['input']>;
  quoteTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  type: QuoteTypeEnum;
};

export enum QuoteTypeEnum {
  Clean = 'Clean',
  PctOfNominal = 'PctOfNominal',
  PerUnit = 'PerUnit',
  Pips4 = 'Pips4',
  Spread = 'Spread',
  Yield = 'Yield'
}

export enum RangeEnum {
  R0To5 = 'R0To5',
  R5To10 = 'R5To10',
  R10To25 = 'R10To25',
  R25To50 = 'R25To50',
  R50To100 = 'R50To100'
}

export enum ReconcileTypeEnum {
  ExposureCollateral = 'ExposureCollateral',
  NettingSet = 'NettingSet',
  NettingSetBaseCurrency = 'NettingSetBaseCurrency'
}

export type ReconciledExposureCollateralType = {
  __typename?: 'ReconciledExposureCollateralType';
  agreementType: AgreementType;
  baseCurrency: CurrencyEnum;
  client?: Maybe<ClientInfo>;
  clientId: Scalars['GraphQLObjectId']['output'];
  counterpartyExposure: Scalars['Float']['output'];
  counterpartyHaircut: Scalars['Float']['output'];
  counterpartyInitialMarginCollateral: Scalars['Float']['output'];
  counterpartyInitialMarginNetRequirement: Scalars['Float']['output'];
  counterpartyInitialMarginPosted: Scalars['Float']['output'];
  counterpartyInitialMarginSecuritiesCollateral: Scalars['Float']['output'];
  counterpartyMarginCall: Scalars['Float']['output'];
  counterpartyNetExposure: Scalars['Float']['output'];
  counterpartyQuantity: Scalars['Float']['output'];
  counterpartyValuationDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  counterpartyVariationMarginCollateral: Scalars['Float']['output'];
  counterpartyVariationMarginPosted: Scalars['Float']['output'];
  counterpartyVariationMarginSecuritiesCollateral: Scalars['Float']['output'];
  creditYieldDeltaSum: Scalars['Float']['output'];
  currency: CurrencyEnum;
  exposure: Scalars['Float']['output'];
  exposureDifference: Scalars['Float']['output'];
  externalAccount?: Maybe<PartyExternalAccount>;
  externalAccountId: Scalars['GraphQLObjectId']['output'];
  haircut: Scalars['Float']['output'];
  haircutDifference: Scalars['Float']['output'];
  initialMarginCollateral: Scalars['Float']['output'];
  initialMarginCollateralDifference: Scalars['Float']['output'];
  initialMarginNetRequirement: Scalars['Float']['output'];
  initialMarginRequirement: Scalars['Float']['output'];
  initialMarginSecuritiesCollateral: Scalars['Float']['output'];
  initialMarginSecuritiesCollateralDifference: Scalars['Float']['output'];
  instrument?: Maybe<Instrument>;
  instrumentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  interestRateYieldDeltaSum: Scalars['Float']['output'];
  marginCall: Scalars['Float']['output'];
  marginCallsMade: Scalars['Boolean']['output'];
  marginType?: Maybe<MarginType>;
  minimumTransferAmount: Scalars['Float']['output'];
  missingReport?: Maybe<Scalars['Boolean']['output']>;
  netExposure: Scalars['Float']['output'];
  netExposureDifference: Scalars['Float']['output'];
  netInitialMarginRequirementDifference: Scalars['Float']['output'];
  noCollateralRequirement: Scalars['Boolean']['output'];
  quantity: Scalars['Float']['output'];
  quantityDifference: Scalars['Float']['output'];
  reconcileType: ReconcileTypeEnum;
  roundingAmount: Scalars['Float']['output'];
  threshold: Scalars['Float']['output'];
  type?: Maybe<ExposureCollateralType>;
  valuationDate: Scalars['GraphQLDateString']['output'];
  variationMarginCollateral: Scalars['Float']['output'];
  variationMarginCollateralDifference: Scalars['Float']['output'];
  variationMarginPosted: Scalars['Float']['output'];
  variationMarginSecuritiesCollateral: Scalars['Float']['output'];
  variationMarginSecuritiesCollateralDifference: Scalars['Float']['output'];
};

export type ReconciliationType = {
  __typename?: 'ReconciliationType';
  client?: Maybe<Party>;
  clientId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  custodian?: Maybe<PartyInfo>;
  custodianDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  custodianId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  custodianPositionId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  custodianQuantity?: Maybe<Scalars['Float']['output']>;
  diff?: Maybe<Scalars['Float']['output']>;
  externalAccount?: Maybe<PartyExternalAccount>;
  externalAccountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  id?: Maybe<Scalars['GraphQLObjectId']['output']>;
  instrument?: Maybe<Instrument>;
  instrumentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  isCashAccount?: Maybe<Scalars['Boolean']['output']>;
  positionDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  positionQuantity?: Maybe<Scalars['Float']['output']>;
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
};

export type RedirectLinkInfo = {
  __typename?: 'RedirectLinkInfo';
  consentAuthId: Scalars['String']['output'];
  consentId: Scalars['String']['output'];
  link: Scalars['String']['output'];
};

export type RefDataError = {
  __typename?: 'RefDataError';
  category?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  code?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  message?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subcategory?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RefDataFieldException = {
  __typename?: 'RefDataFieldException';
  errors?: Maybe<Array<RefDataError>>;
  fieldId?: Maybe<Array<Scalars['String']['output']>>;
};

export type RefDataFieldExceptionsArray = {
  __typename?: 'RefDataFieldExceptionsArray';
  fieldExceptions?: Maybe<Array<RefDataFieldException>>;
};

export enum RefDataMachine {
  Daka = 'Daka',
  Office = 'Office'
}

export type ReferenceData = {
  __typename?: 'ReferenceData';
  eidDataArray?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fieldData?: Maybe<Array<Maybe<FieldDataItem>>>;
  fieldExceptionsArray?: Maybe<Array<RefDataFieldExceptionsArray>>;
  id?: Maybe<Scalars['GraphQLObjectId']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  security?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  securityError?: Maybe<Array<RefDataError>>;
};

export enum ReferenceFieldsEnum {
  CDS_SPREAD_MID_MODIFIED_DURATION = 'CDS_SPREAD_MID_MODIFIED_DURATION',
  CFI_CODE = 'CFI_CODE',
  CNTRY_OF_DOMICILE = 'CNTRY_OF_DOMICILE',
  COMPANY_IS_PRIVATE = 'COMPANY_IS_PRIVATE',
  CPN_TYP = 'CPN_TYP',
  CRNCY = 'CRNCY',
  DAYS_TO_SETTLE = 'DAYS_TO_SETTLE',
  DISC_MRGN_MID = 'DISC_MRGN_MID',
  DUR_ADJ_MID = 'DUR_ADJ_MID',
  ECBC_COVERED_BD_LABEL_INDICATOR = 'ECBC_COVERED_BD_LABEL_INDICATOR',
  EXCH_CODE = 'EXCH_CODE',
  GB_MANAGEMENT_PROCEEDS = 'GB_MANAGEMENT_PROCEEDS',
  GICS_SUB_INDUSTRY = 'GICS_SUB_INDUSTRY',
  ID_BB_COMPANY = 'ID_BB_COMPANY',
  ID_EXCH_SYMBOL = 'ID_EXCH_SYMBOL',
  ID_ISIN = 'ID_ISIN',
  INDUSTRY_SUBGROUP_NUM = 'INDUSTRY_SUBGROUP_NUM',
  ISSUER = 'ISSUER',
  ISSUER_INDUSTRY = 'ISSUER_INDUSTRY',
  LAST_UPDATE_BID_RT = 'LAST_UPDATE_BID_RT',
  LAST_UPDATE_DT_EXCH_TZ = 'LAST_UPDATE_DT_EXCH_TZ',
  LEGAL_ENTITY_IDENTIFIER = 'LEGAL_ENTITY_IDENTIFIER',
  MARKET_SECTOR_DES = 'MARKET_SECTOR_DES',
  PAR_AMT = 'PAR_AMT',
  PAYMENT_RANK = 'PAYMENT_RANK',
  PX_ASK = 'PX_ASK',
  PX_BID = 'PX_BID',
  PX_CLOSE = 'PX_CLOSE',
  PX_LAST = 'PX_LAST',
  RTG_FITCH = 'RTG_FITCH',
  RTG_FITCH_LONG = 'RTG_FITCH_LONG',
  RTG_FITCH_LT_ISSUER_DEFAULT = 'RTG_FITCH_LT_ISSUER_DEFAULT',
  RTG_MDY_ISSUER = 'RTG_MDY_ISSUER',
  RTG_MOODY = 'RTG_MOODY',
  RTG_MOODY_LONG_TERM = 'RTG_MOODY_LONG_TERM',
  RTG_SP = 'RTG_SP',
  RTG_SP_LONG = 'RTG_SP_LONG',
  RTG_SP_LT_LC_ISSUER_CREDIT = 'RTG_SP_LT_LC_ISSUER_CREDIT',
  SECURITY_NAME = 'SECURITY_NAME',
  SEC_ID_WITH_YK_PARSEKYABLE_RT = 'SEC_ID_WITH_YK_PARSEKYABLE_RT',
  SERIES = 'SERIES',
  TICKER = 'TICKER',
  TIME = 'TIME',
  YAS_ISPREAD_TO_GOVT = 'YAS_ISPREAD_TO_GOVT',
  YLD_YTM_MID = 'YLD_YTM_MID'
}

export type RegisterExtract = {
  __typename?: 'RegisterExtract';
  _id: Scalars['GraphQLObjectId']['output'];
  client: PartyInfo;
  clientId: Scalars['GraphQLObjectId']['output'];
  createTimestamp: Scalars['Timestamp']['output'];
  date: Scalars['GraphQLDateString']['output'];
  items: Array<RegisterExtractItem>;
  source: PartyInfo;
  sourceId: Scalars['GraphQLObjectId']['output'];
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId: Scalars['GraphQLObjectId']['output'];
  updateUserInfo: UserInfo;
};

export type RegisterExtractFilterInput = {
  dateIn?: InputMaybe<Array<Scalars['GraphQLDateString']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
};

export type RegisterExtractInput = {
  /** if _id is omitted, document will be created */
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientId: Scalars['GraphQLObjectId']['input'];
  date: Scalars['GraphQLDateString']['input'];
  items: Array<RegisterExtractItemInput>;
  sourceId: Scalars['GraphQLObjectId']['input'];
};

export type RegisterExtractItem = {
  __typename?: 'RegisterExtractItem';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  country: CountryCodeEnum;
  date: Scalars['GraphQLDateString']['output'];
  detailedCustomerSpecifics: Scalars['String']['output'];
  email: Scalars['String']['output'];
  fax: Scalars['String']['output'];
  fundClassName: Scalars['String']['output'];
  fundId: Scalars['String']['output'];
  fundPrice: Scalars['String']['output'];
  fundShortName: Scalars['String']['output'];
  instrumentId: Scalars['GraphQLObjectId']['output'];
  isin: Scalars['String']['output'];
  legalPerson: Scalars['String']['output'];
  nationalRegistrationId: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  purchaseAmount: Scalars['String']['output'];
  quantity: Scalars['String']['output'];
  taClientAccount: Scalars['String']['output'];
  taClientAccountLabel: Scalars['String']['output'];
  taClientName: Scalars['String']['output'];
  taxCountry: CountryCodeEnum;
};

export type RegisterExtractItemInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  country: CountryCodeEnum;
  date: Scalars['GraphQLDateString']['input'];
  detailedCustomerSpecifics: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fax: Scalars['String']['input'];
  fundClassName: Scalars['String']['input'];
  fundId: Scalars['String']['input'];
  fundPrice: Scalars['String']['input'];
  fundShortName: Scalars['String']['input'];
  instrumentId: Scalars['GraphQLObjectId']['input'];
  isin: Scalars['String']['input'];
  legalPerson: Scalars['String']['input'];
  nationalRegistrationId: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  purchaseAmount: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
  taClientAccount: Scalars['String']['input'];
  taClientAccountLabel: Scalars['String']['input'];
  taClientName: Scalars['String']['input'];
  taxCountry: CountryCodeEnum;
};

export type RemittanceInformationStructured = {
  __typename?: 'RemittanceInformationStructured';
  reference: Scalars['String']['output'];
  referenceIssuer?: Maybe<Scalars['String']['output']>;
  referenceType?: Maybe<Scalars['String']['output']>;
};

export type Report = {
  __typename?: 'Report';
  _id: Scalars['GraphQLObjectId']['output'];
  base64?: Maybe<Scalars['String']['output']>;
  client: PartyInfo;
  clientId: Scalars['GraphQLObjectId']['output'];
  clientName: Scalars['String']['output'];
  createTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  date: Scalars['GraphQLDateString']['output'];
  /** fileId is the same as reportId, both is an id of a file */
  fileId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  reportId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  sourceId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  sourceName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ReportStatusEnum>;
  type: Scalars['String']['output'];
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
};

export enum ReportStatusEnum {
  Active = 'Active',
  Deleted = 'Deleted',
  /** When locked, not possible to edit */
  Locked = 'Locked'
}

export type Role = {
  __typename?: 'Role';
  _id: Scalars['String']['output'];
  assets: Array<PermissionAssetEnum>;
  clientIds: Array<Scalars['GraphQLObjectId']['output']>;
  clients: Array<RoleClientInfo>;
  comment?: Maybe<Scalars['String']['output']>;
  createTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  name: Scalars['String']['output'];
  nbrOfActiveUsers: Scalars['Int']['output'];
  nbrOfUsers: Scalars['Int']['output'];
  permissionType: PermissionTypeEnum;
  roleType: RoleTypeEnum;
  status: DocumentStatusEnum;
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type RoleClientInfo = {
  __typename?: 'RoleClientInfo';
  _id: Scalars['GraphQLObjectId']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum RoleTypeEnum {
  Backend = 'Backend',
  Frontend = 'Frontend'
}

export type RoundTransactionInput = {
  _id: Scalars['GraphQLObjectId']['input'];
  /** Apply +/- according to how it should be applied to settlementAmount, same currency as settlement currency */
  rounding: Scalars['Float']['input'];
};

export enum ScaStatus {
  /** BankID login has started. This QR code does not sign the payment. */
  authenticationStarted = 'authenticationStarted',
  /** The creditor account is not a registered payment recipient. The QR code would add it as a recipient and must not be shown. */
  authoriseCreditorAccountStarted = 'authoriseCreditorAccountStarted',
  /** The bank did not require a signature for this payment. */
  exempted = 'exempted',
  /** Signing failed. The payment was not approved. */
  failed = 'failed',
  /** Signing is complete. The payment has been approved. */
  finalised = 'finalised',
  /** The signer is logged in at the bank. The payment is not signed yet. */
  psuAuthenticated = 'psuAuthenticated',
  /** The bank has identified the signer. The payment is not signed yet. */
  psuIdentified = 'psuIdentified',
  /** The bank has received the signing request. The payment is not signed yet. */
  received = 'received',
  /** The bank has chosen how the signer will sign, for example BankID. The payment is not signed yet. */
  scaMethodSelected = 'scaMethodSelected',
  /** Signing of the payment has started. The QR code approves the payment. */
  started = 'started'
}

export enum ScienceBasedTargetInitiativeEnum {
  Committed = 'Committed',
  NoTarget = 'NoTarget',
  TargetSet = 'TargetSet'
}

export type Screen = {
  __typename?: 'Screen';
  _id: Scalars['GraphQLObjectId']['output'];
  approved?: Maybe<Scalars['Boolean']['output']>;
  client?: Maybe<Party>;
  clientId: Scalars['GraphQLObjectId']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createTimestamp: Scalars['Timestamp']['output'];
  date?: Maybe<Scalars['GraphQLDateString']['output']>;
  issuer?: Maybe<Party>;
  issuerProgram?: Maybe<IssuerProgram>;
  /** document in client or issuerprogram collection depending on screenType */
  objectId: Scalars['GraphQLObjectId']['output'];
  screenType?: Maybe<ScreenType>;
  status?: Maybe<DocumentStatusEnum>;
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId: Scalars['GraphQLObjectId']['output'];
  updateUserInfo: UserInfo;
  /** A list of versions of the document */
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type ScreenInput = {
  approved: Scalars['Boolean']['input'];
  clientId: Scalars['GraphQLObjectId']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['GraphQLDateString']['input'];
  objectId: Scalars['GraphQLObjectId']['input'];
  screenType: ScreenType;
  status?: InputMaybe<DocumentStatusEnum>;
};

export enum ScreenType {
  Issuer = 'Issuer',
  IssuerProgram = 'IssuerProgram'
}

export type SecurityLadder = {
  __typename?: 'SecurityLadder';
  client?: Maybe<Party>;
  clientId: Scalars['GraphQLObjectId']['output'];
  dates: Array<Scalars['GraphQLDateString']['output']>;
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
  positions: Array<Scalars['Float']['output']>;
  quantities: Array<Scalars['Float']['output']>;
};

export type Selector = {
  __typename?: 'Selector';
  accountIds: Array<Maybe<Scalars['GraphQLObjectId']['output']>>;
  currencies: Array<Maybe<Scalars['String']['output']>>;
  instrumentIds: Array<Maybe<Scalars['GraphQLObjectId']['output']>>;
  statuses: Array<Maybe<Scalars['String']['output']>>;
};

export type SelectorInput = {
  accountIds: Array<InputMaybe<Scalars['GraphQLObjectId']['input']>>;
  currencies: Array<InputMaybe<Scalars['String']['input']>>;
  instrumentIds: Array<InputMaybe<Scalars['GraphQLObjectId']['input']>>;
  statuses: Array<InputMaybe<Scalars['String']['input']>>;
};

export type ShareRegisterFilterInput = {
  filterOutZeroUnits?: InputMaybe<Scalars['Boolean']['input']>;
  isinIn?: InputMaybe<Array<Scalars['String']['input']>>;
  tradeDateEnd?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};

export type ShareRegisterItem = {
  __typename?: 'ShareRegisterItem';
  /** sum of settledAmount on orders */
  amount: Scalars['String']['output'];
  clientAccount: Scalars['String']['output'];
  customer?: Maybe<Customer>;
  /** summed upon to and including date */
  date: Scalars['GraphQLDateString']['output'];
  fund?: Maybe<PartyInfo>;
  /** fundId */
  fundId: Scalars['GraphQLObjectId']['output'];
  instrument: Instrument;
  isin: Scalars['String']['output'];
  /** sum of settledUnits on orders */
  units: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ShareRegisterUnits = {
  __typename?: 'ShareRegisterUnits';
  /** summed upon to and including date */
  date: Scalars['GraphQLDateString']['output'];
  fund?: Maybe<PartyInfo>;
  /** fundId */
  fundId: Scalars['GraphQLObjectId']['output'];
  instrument: Instrument;
  isin: Scalars['String']['output'];
  /** sum of settledUnits on orders */
  units: Scalars['String']['output'];
};

export type ShareholderEngagement = {
  __typename?: 'ShareholderEngagement';
  agm: Scalars['GraphQLDateString']['output'];
  comment: Scalars['String']['output'];
  date: Scalars['GraphQLDateString']['output'];
  method: EngagementMethod;
  norm: StandardScreenNorm;
  principle: StandardScreenPrinciple;
};

export type ShareholderEngagementInput = {
  agm: Scalars['GraphQLDateString']['input'];
  comment: Scalars['String']['input'];
  date: Scalars['GraphQLDateString']['input'];
  method: EngagementMethod;
  norm: StandardScreenNorm;
  principle: StandardScreenPrinciple;
};

export type SigningBasketAuthorization = {
  __typename?: 'SigningBasketAuthorization';
  qrImage: Scalars['String']['output'];
  status: ScaStatus;
};

export enum SourceType {
  BloombergFit = 'BloombergFit',
  Coacs = 'Coacs',
  Emsx = 'Emsx',
  Fxgo = 'Fxgo',
  Internal = 'Internal',
  MarkitWire = 'MarkitWire',
  Tradeweb = 'Tradeweb',
  Voice = 'Voice'
}

export enum SsiTradeType {
  Collateral = 'Collateral',
  Security = 'Security'
}

export enum StandardScreenNorm {
  BusinessEthics = 'BusinessEthics',
  Environment = 'Environment',
  HumanRights = 'HumanRights',
  LabourRights = 'LabourRights',
  None = 'None'
}

export enum StandardScreenPrinciple {
  None = 'None',
  Principle1 = 'Principle1',
  Principle2 = 'Principle2',
  Principle3 = 'Principle3',
  Principle4 = 'Principle4',
  Principle5 = 'Principle5',
  Principle6 = 'Principle6',
  Principle7 = 'Principle7',
  Principle8 = 'Principle8',
  Principle9 = 'Principle9',
  Principle10 = 'Principle10'
}

export enum StandardScreenStatus {
  Compliant = 'Compliant',
  NonCompliant = 'NonCompliant',
  Watchlist = 'Watchlist'
}

export enum StatusEnum {
  Active = 'Active',
  Deleted = 'Deleted'
}

export enum SustainableDevelopmentGoal {
  /** No Poverty */
  Goal1_NoPoverty = 'Goal1_NoPoverty',
  /** Zero Hunger */
  Goal2_ZeroHunger = 'Goal2_ZeroHunger',
  /** Good Health and Well-being */
  Goal3_GoodHealthAndWellBeing = 'Goal3_GoodHealthAndWellBeing',
  /** Quality Education */
  Goal4_QualityEducation = 'Goal4_QualityEducation',
  /** Gender Equality */
  Goal5_GenderEquality = 'Goal5_GenderEquality',
  /** Clean Water and Sanitation */
  Goal6_CleanWaterAndSanitation = 'Goal6_CleanWaterAndSanitation',
  /** Affordable and Clean Energy */
  Goal7_AffordableAndCleanEnergy = 'Goal7_AffordableAndCleanEnergy',
  /** Decent Work and Economic Growth */
  Goal8_DecentWorkAndEconomicGrowth = 'Goal8_DecentWorkAndEconomicGrowth',
  /** Industry, Innovation and Infrastructure */
  Goal9_IndustryInnovationAndInfrastructure = 'Goal9_IndustryInnovationAndInfrastructure',
  /** Reduced Inequality */
  Goal10_ReducedInequality = 'Goal10_ReducedInequality',
  /** Sustainable Cities and Communities */
  Goal11_SustainableCitiesAndCommunities = 'Goal11_SustainableCitiesAndCommunities',
  /** Responsible Consumption and Production */
  Goal12_ResponsibleConsumptionAndProduction = 'Goal12_ResponsibleConsumptionAndProduction',
  /** CLimate Action */
  Goal13_ClimateAction = 'Goal13_ClimateAction',
  /** Life Below Water */
  Goal14_LifeBelowWater = 'Goal14_LifeBelowWater',
  /** Life on Land */
  Goal15_LifeOnLand = 'Goal15_LifeOnLand',
  /** Peace, Justice and Strong Institutions */
  Goal16_PeaceJusticeAndStrongInstitutions = 'Goal16_PeaceJusticeAndStrongInstitutions',
  /** Partnerships to achieve the Goal */
  Goal17_PartnershipsToAchieveTheGoal = 'Goal17_PartnershipsToAchieveTheGoal'
}

export type SustainalyticsDataModel = {
  __typename?: 'SustainalyticsDataModel';
  entityId?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  fieldNames: Array<SustainalyticsFieldDefinitionModel>;
  fields?: Maybe<Scalars['JSON']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  issuerId?: Maybe<Scalars['String']['output']>;
  issuerName?: Maybe<Scalars['String']['output']>;
};

export type SustainalyticsDataModelWithStatus = {
  __typename?: 'SustainalyticsDataModelWithStatus';
  entityId?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Scalars['JSON']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  issuerId?: Maybe<Scalars['String']['output']>;
  issuerName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SustainalyticsStatus>;
};

export type SustainalyticsFieldClusterModel = {
  __typename?: 'SustainalyticsFieldClusterModel';
  fieldClusterId?: Maybe<Scalars['String']['output']>;
  fieldClusterName?: Maybe<Scalars['String']['output']>;
  fieldDefinitions?: Maybe<Array<Maybe<SustainalyticsFieldDefinitionModel>>>;
  fieldIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type SustainalyticsFieldDefinitionModel = {
  __typename?: 'SustainalyticsFieldDefinitionModel';
  description?: Maybe<Scalars['String']['output']>;
  fieldId?: Maybe<Scalars['String']['output']>;
  fieldLength?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  fieldType?: Maybe<Scalars['String']['output']>;
  possibleValues?: Maybe<Scalars['String']['output']>;
};

export type SustainalyticsPackageModel = {
  __typename?: 'SustainalyticsPackageModel';
  clusters?: Maybe<Array<Maybe<SustainalyticsFieldClusterModel>>>;
  packageId?: Maybe<Scalars['String']['output']>;
  packageName?: Maybe<Scalars['String']['output']>;
};

export type SustainalyticsProductModel = {
  __typename?: 'SustainalyticsProductModel';
  packages?: Maybe<Array<Maybe<SustainalyticsPackageModel>>>;
  productId?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
};

export type SustainalyticsReport = {
  __typename?: 'SustainalyticsReport';
  entityId?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
  issuerId?: Maybe<Scalars['String']['output']>;
  issuerName?: Maybe<Scalars['String']['output']>;
  reports?: Maybe<Array<Maybe<SustainalyticsReportModel>>>;
};

export type SustainalyticsReportModel = {
  __typename?: 'SustainalyticsReportModel';
  lastUpdate?: Maybe<Scalars['String']['output']>;
  reportId?: Maybe<Scalars['String']['output']>;
  reportName?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SustainalyticsReportUrl = {
  __typename?: 'SustainalyticsReportUrl';
  filename?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SustainalyticsSecurityListModel = {
  __typename?: 'SustainalyticsSecurityListModel';
  entityIds?: Maybe<Array<Scalars['String']['output']>>;
  securityListId?: Maybe<Scalars['String']['output']>;
  securityListName?: Maybe<Scalars['String']['output']>;
};

export type SustainalyticsStatus = {
  __typename?: 'SustainalyticsStatus';
  hasPermissions?: Maybe<Scalars['Boolean']['output']>;
  matched?: Maybe<Scalars['String']['output']>;
};

export type Swaplab2Results = {
  __typename?: 'Swaplab2Results';
  bpShiftDelta?: Maybe<Scalars['Float']['output']>;
  bpShiftVega?: Maybe<Scalars['Float']['output']>;
  bsDelta?: Maybe<Scalars['Float']['output']>;
  bsVega?: Maybe<Scalars['Float']['output']>;
  creditYieldDelta?: Maybe<Scalars['Float']['output']>;
  interestRateYieldDelta?: Maybe<Scalars['Float']['output']>;
  interestRateYieldDeltaBuckets: Array<YieldDeltaBucket>;
  pctDelta?: Maybe<Scalars['Float']['output']>;
};

export enum SwedishFinancialAuthorityCategoryEnum {
  Banks = 'Banks',
  Emu = 'Emu',
  HousingInstitutes = 'HousingInstitutes',
  MunicipalAdministration = 'MunicipalAdministration',
  OfWhichThePensionsAuthority = 'OfWhichThePensionsAuthority',
  OtherEu = 'OtherEu',
  OtherForeign = 'OtherForeign',
  OtherSwedishFinancialInstitutions = 'OtherSwedishFinancialInstitutions',
  PensionInstitutes = 'PensionInstitutes',
  SocialSecurityFunds = 'SocialSecurityFunds',
  SumForeign = 'SumForeign',
  SwedishFinancialCompanies = 'SwedishFinancialCompanies',
  SwedishHouseholds = 'SwedishHouseholds',
  SwedishInsuranceCompanies = 'SwedishInsuranceCompanies',
  Unknown = 'Unknown'
}

export type Swift = {
  __typename?: 'Swift';
  _id: Scalars['GraphQLObjectId']['output'];
  client?: Maybe<Party>;
  clientId: Scalars['GraphQLObjectId']['output'];
  correspondingTransactionId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  createTimestamp: Scalars['Timestamp']['output'];
  error?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parsed: Scalars['JSON']['output'];
  /**
   * Currently the swift original is a report. We want to move it to
   * the "text" field.
   */
  reportIds: Array<Scalars['GraphQLObjectId']['output']>;
  status: SwiftStatusEnum;
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updateTimestamp: Scalars['Timestamp']['output'];
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
};

export type SwiftFilterInput = {
  /** Corporate action event */
  caev?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Corresponding transaction */
  correspondingTransactionId?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  /** Corporate action event reference */
  externalId?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Message type */
  msgType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Record date, format: YYYY-MM-DD */
  rdteEnd?: InputMaybe<Scalars['String']['input']>;
  /** Record date, format: YYYY-MM-DD */
  rdteStart?: InputMaybe<Scalars['String']['input']>;
};

export enum SwiftStatusEnum {
  Confirmed = 'Confirmed',
  Deleted = 'Deleted',
  Pending = 'Pending',
  Preliminary = 'Preliminary',
  /** Messages of messageType 566 gets status settled when matched */
  Settled = 'Settled',
  /** Used for messageType 566 when original swift of messageType 564 has been updated and swift of messageType is insignificant */
  UpdatedPrevious = 'UpdatedPrevious',
  /**
   * Used for messages with corporateActionEvent: DRIP/DVOP, these are received earlier (not received two days after ex-date
   * like other corporateActionEvents)
   */
  Waiting = 'Waiting'
}

export type TAccount = {
  __typename?: 'TAccount';
  description?: Maybe<Scalars['String']['output']>;
  group1?: Maybe<TAccountGroup1Enum>;
  group2?: Maybe<TAccountGroup2Enum>;
  group3?: Maybe<TAccountGroup3Enum>;
  group4?: Maybe<TAccountGroup4Enum>;
  group5?: Maybe<TAccountGroup5Enum>;
  number: Scalars['String']['output'];
  sruCode?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TAccountTypeEnum>;
};

export type TAccountChart = {
  __typename?: 'TAccountChart';
  _id: Scalars['GraphQLObjectId']['output'];
  client?: Maybe<Party>;
  clientId: Scalars['GraphQLObjectId']['output'];
  createTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  createUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tAccountMappings?: Maybe<Array<TAccountMapping>>;
  tAccounts?: Maybe<Array<TAccount>>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type TAccountChart2FilterInput = {
  clientIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
};

export enum TAccountGroup1Enum {
  Assets = 'Assets',
  Equity = 'Equity',
  Liabilities = 'Liabilities'
}

export enum TAccountGroup2Enum {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  DividendPaid = 'DividendPaid',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  I = 'I',
  J = 'J',
  K = 'K',
  L = 'L',
  M = 'M',
  N = 'N',
  O = 'O',
  P = 'P',
  ProfitLossCurrentYear = 'ProfitLossCurrentYear',
  Q = 'Q',
  R = 'R',
  RetainedEarnings = 'RetainedEarnings',
  S = 'S',
  ShareCapital = 'ShareCapital',
  T = 'T'
}

export enum TAccountGroup3Enum {
  A = 'A',
  B = 'B',
  C = 'C',
  Compensation = 'Compensation',
  Contribution = 'Contribution',
  D = 'D',
  DividendPaid = 'DividendPaid',
  E = 'E',
  Expenses = 'Expenses',
  F = 'F',
  G = 'G',
  H = 'H',
  I = 'I',
  J = 'J',
  K = 'K',
  L = 'L',
  M = 'M',
  N = 'N',
  O = 'O',
  P = 'P',
  Q = 'Q',
  R = 'R',
  RetainedEarnings = 'RetainedEarnings',
  Revenue = 'Revenue',
  S = 'S',
  ShareCapital = 'ShareCapital',
  T = 'T',
  Tax = 'Tax'
}

export enum TAccountGroup4Enum {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  I = 'I',
  J = 'J',
  K = 'K',
  L = 'L',
  M = 'M',
  ManagementFees = 'ManagementFees',
  N = 'N',
  None = 'None',
  O = 'O',
  P = 'P',
  Q = 'Q',
  R = 'R',
  S = 'S',
  T = 'T'
}

export enum TAccountGroup5Enum {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  H = 'H',
  I = 'I',
  J = 'J',
  K = 'K',
  L = 'L',
  M = 'M',
  N = 'N',
  None = 'None',
  O = 'O',
  P = 'P',
  Q = 'Q',
  R = 'R',
  S = 'S',
  T = 'T'
}

export type TAccountInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  group1?: InputMaybe<Scalars['String']['input']>;
  group2?: InputMaybe<Scalars['String']['input']>;
  group3?: InputMaybe<Scalars['String']['input']>;
  group4?: InputMaybe<Scalars['String']['input']>;
  group5?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  sruCode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TAccountTypeEnum>;
};

export type TAccountMapping = {
  __typename?: 'TAccountMapping';
  name?: Maybe<Scalars['String']['output']>;
  selector: TAccountMappingSelector;
  values?: Maybe<Array<TAccountMappingKeyValuePair>>;
};

export type TAccountMappingInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  selector: TAccountMappingSelectorInput;
  values?: InputMaybe<Array<TAccountMappingKeyValuePairInput>>;
};

export type TAccountMappingKeyValuePair = {
  __typename?: 'TAccountMappingKeyValuePair';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TAccountMappingKeyValuePairInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type TAccountMappingSelector = {
  __typename?: 'TAccountMappingSelector';
  categories?: Maybe<Array<Scalars['String']['output']>>;
  currencies?: Maybe<Array<Scalars['String']['output']>>;
  instruments?: Maybe<Array<InstrumentSelector>>;
  key?: Maybe<TAccountMappingSelectorKeyEnum>;
  notMatchCategories?: Maybe<Scalars['Boolean']['output']>;
  notMatchCurrencies?: Maybe<Scalars['Boolean']['output']>;
  notMatchProductTypes?: Maybe<Scalars['Boolean']['output']>;
  productTypes?: Maybe<Array<Scalars['String']['output']>>;
};

export type TAccountMappingSelectorInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  instruments?: InputMaybe<Array<InstrumentSelectorInput>>;
  key?: InputMaybe<TAccountMappingSelectorKeyEnum>;
  notMatchCategories?: InputMaybe<Scalars['Boolean']['input']>;
  notMatchCurrencies?: InputMaybe<Scalars['Boolean']['input']>;
  notMatchProductTypes?: InputMaybe<Scalars['Boolean']['input']>;
  productTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum TAccountMappingSelectorKeyEnum {
  Equity = 'Equity',
  OpeningBalance = 'OpeningBalance',
  Rounding = 'Rounding'
}

export type TAccountMappingValue = {
  __typename?: 'TAccountMappingValue';
  accountingTransactionType: AccountingTransactionType;
  /**
   * Credit: Recorded on the right side of an account ledger. It increases liability, equity,
   * or income accounts, and decreases asset or expense accounts.
   */
  credit: Scalars['String']['output'];
  /**
   * Debit: Recorded on the left side of an account ledger. It increases asset or expense accounts,
   * and decreases liability, equity, or income accounts.
   */
  debit: Scalars['String']['output'];
};

export type TAccountMappingValueInput = {
  accountingTransactionType: AccountingTransactionType;
  /**
   * Credit: Recorded on the right side of an account ledger. It increases liability, equity,
   * or income accounts, and decreases asset or expense accounts.
   */
  credit: Scalars['String']['input'];
  /**
   * Debit: Recorded on the left side of an account ledger. It increases asset or expense accounts,
   * and decreases liability, equity, or income accounts.
   */
  debit: Scalars['String']['input'];
};

export enum TAccountTypeEnum {
  Asset = 'Asset',
  Income = 'Income',
  Liability = 'Liability'
}

/**
 * Subset of PermissionAssetEnum, used for validation since a role with any value from TeamPermissionAssetEnum can only
 * have length 1
 */
export enum TeamPermissionAssetEnum {
  /** Used for Operations team role. One role/team. */
  Operations = 'Operations',
  /** Used for PortfolioManagers team role. One role/team. */
  PortfolioManagers = 'PortfolioManagers'
}

export type Ticket = {
  __typename?: 'Ticket';
  _id: Scalars['GraphQLObjectId']['output'];
  client: PartyInfo;
  clientId: Scalars['GraphQLObjectId']['output'];
  createTimestamp: Scalars['Timestamp']['output'];
  creator: UserInfo;
  creatorId: Scalars['GraphQLObjectId']['output'];
  previousStates: Array<TicketState>;
  readByUserIds?: Maybe<Array<Scalars['GraphQLObjectId']['output']>>;
  references?: Maybe<Array<TicketReference>>;
  state: TicketState;
  title: Scalars['String']['output'];
  type: TicketTypeEnum;
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
};

export type TicketFilterInput = {
  assigneeIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  creatorIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  statusIn?: InputMaybe<Array<TicketStatusEnum>>;
  typeIn?: InputMaybe<Array<TicketTypeEnum>>;
};

export type TicketInput = {
  /** if _id is omitted, a document will be created */
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientId: Scalars['GraphQLObjectId']['input'];
  references?: InputMaybe<Array<TicketReferenceInput>>;
  state: TicketStateInput;
  title: Scalars['String']['input'];
  type: TicketTypeEnum;
};

export type TicketReference = {
  __typename?: 'TicketReference';
  collection: CollectionNameEnum;
  documentId: Scalars['GraphQLObjectId']['output'];
};

export type TicketReferenceInput = {
  collection: CollectionNameEnum;
  documentId: Scalars['GraphQLObjectId']['input'];
};

export type TicketState = {
  __typename?: 'TicketState';
  assigneeIds: Array<Scalars['GraphQLObjectId']['output']>;
  assignees: Array<UserInfo>;
  /** comment is a markdown string */
  comment: Scalars['String']['output'];
  status: TicketStatusEnum;
  timestamp?: Maybe<Scalars['Timestamp']['output']>;
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
};

export type TicketStateInput = {
  assigneeIds: Array<Scalars['GraphQLObjectId']['input']>;
  comment: Scalars['String']['input'];
  status: TicketStatusEnum;
};

export enum TicketStatusEnum {
  Closed = 'Closed',
  Open = 'Open'
}

export enum TicketTypeEnum {
  AccountingRunStatusError = 'AccountingRunStatusError',
  CorporateActionError = 'CorporateActionError',
  Error = 'Error',
  ExposureCollateralError = 'ExposureCollateralError',
  ExternalDataError = 'ExternalDataError',
  FundUnitReconciliationError = 'FundUnitReconciliationError',
  MarginCall = 'MarginCall',
  MatchBrokerTransactionError = 'MatchBrokerTransactionError',
  OpenPaymentsConsentError = 'OpenPaymentsConsentError',
  PositionReconciliationError = 'PositionReconciliationError',
  WatchdogAccountPositionError = 'WatchdogAccountPositionError',
  WatchdogValueChangeError = 'WatchdogValueChangeError'
}

export type TicketUser = {
  __typename?: 'TicketUser';
  _id: Scalars['GraphQLObjectId']['output'];
  clientIds: Array<Scalars['GraphQLObjectId']['output']>;
  clients?: Maybe<Array<Maybe<PartyInfo>>>;
  name: Scalars['String']['output'];
};

export type TimeSeries = {
  __typename?: 'TimeSeries';
  _id: Scalars['GraphQLObjectId']['output'];
  client?: Maybe<Party>;
  clientId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  dates?: Maybe<Array<Maybe<Scalars['GraphQLDateString']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  /** The level of Value At Risk expressed as number, e.g 0.95 for 95% VaR */
  downSideVar?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  instrument?: Maybe<Instrument>;
  instrumentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  items?: Maybe<Array<Maybe<TimeSeriesItem>>>;
  /** The objectId points either to an instrument or a portfolio */
  objectId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  status: TimeSeriesStatus;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  volatility?: Maybe<Scalars['Float']['output']>;
};


export type TimeSeriesDownSideVarArgs = {
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  level?: InputMaybe<Scalars['Float']['input']>;
  startDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type TimeSeriesVolatilityArgs = {
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  startDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};

export type TimeSeriesFilterInput = {
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  /** ignored for timeserie() */
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  /** ignored for timeserie() */
  instrumentIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  /** ignored for timeserie() */
  instrumentIsinIn?: InputMaybe<Array<Scalars['ISIN']['input']>>;
  /** ignored for timeserie() */
  instrumentNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  /** ignored for timeserie() */
  statusIn?: InputMaybe<Array<TimeSeriesStatus>>;
  /** ignored for timeserie() */
  typeIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TimeSeriesInput = {
  /** If _id is omitted, a TimeSeries will be created */
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  /** clientId defaults to SYSTEM */
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  instrumentId: Scalars['GraphQLObjectId']['input'];
  items: Array<TimeSeriesItemInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /**
   * Type is typically one of: Price(Close),
   * Price(Last), Return(Total), Volume
   */
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TimeSeriesItem = {
  __typename?: 'TimeSeriesItem';
  _id: Scalars['GraphQLObjectId']['output'];
  date?: Maybe<Scalars['GraphQLDateString']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type TimeSeriesItemInput = {
  date: Scalars['GraphQLDateString']['input'];
  value: Scalars['Float']['input'];
};

export enum TimeSeriesStatus {
  Active = 'Active',
  Deleted = 'Deleted'
}

export type TimeSeriesUpsertInput = {
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  instrumentId: Scalars['GraphQLObjectId']['input'];
  items: Array<TimeSeriesItemInput>;
  type: Scalars['String']['input'];
};

export enum TimezoneEnum {
  AmericaChicago = 'AmericaChicago',
  AmericaNew_York = 'AmericaNew_York',
  AsiaHong_Kong = 'AsiaHong_Kong',
  AsiaTokyo = 'AsiaTokyo',
  EuropeAmsterdam = 'EuropeAmsterdam',
  EuropeBerlin = 'EuropeBerlin',
  EuropeBrussels = 'EuropeBrussels',
  EuropeCopenhagen = 'EuropeCopenhagen',
  EuropeHelsinki = 'EuropeHelsinki',
  EuropeLondon = 'EuropeLondon',
  EuropeLuxembourg = 'EuropeLuxembourg',
  EuropeOslo = 'EuropeOslo',
  EuropeParis = 'EuropeParis',
  EuropeStockholm = 'EuropeStockholm',
  EuropeZurich = 'EuropeZurich'
}

export enum TppCategory {
  ERROR = 'ERROR',
  INFORMATION = 'INFORMATION',
  UNMAPPED = 'UNMAPPED',
  WARNING = 'WARNING'
}

export enum TppCode {
  AUTHORISATION_PENDING_ONLINE_BANK = 'AUTHORISATION_PENDING_ONLINE_BANK',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PAYMENT_REJECTED = 'PAYMENT_REJECTED',
  RAW = 'RAW',
  WARNING = 'WARNING'
}

export type TppMessage = {
  __typename?: 'TppMessage';
  category: TppCategory;
  code: TppCode;
  text?: Maybe<Scalars['String']['output']>;
};

export enum TradeItemType {
  AccruedInterest = 'AccruedInterest',
  Commission = 'Commission',
  StampDuty = 'StampDuty'
}

export type TradingManagerColumn = {
  __typename?: 'TradingManagerColumn';
  account?: Maybe<PartyAccount>;
  accountDescription?: Maybe<Scalars['String']['output']>;
  /** // Account data */
  accountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  baseCurrency?: Maybe<CurrencyEnum>;
  bloombergTicker?: Maybe<Scalars['String']['output']>;
  client?: Maybe<ClientInfo>;
  /** // Client data */
  clientId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  creditRatings?: Maybe<Scalars['JSON']['output']>;
  creditYieldDelta?: Maybe<Scalars['Float']['output']>;
  /** // Position data */
  currency?: Maybe<CurrencyEnum>;
  /** // Exposure */
  exposure?: Maybe<Scalars['Float']['output']>;
  externalAccount?: Maybe<PartyExternalAccount>;
  /** // Custody Account data */
  externalAccountId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  externalAccountName?: Maybe<Scalars['String']['output']>;
  externalAccountType?: Maybe<PartyExternalAccountType>;
  financedExposure?: Maybe<Scalars['Float']['output']>;
  financedLocalExposure?: Maybe<Scalars['Float']['output']>;
  financing?: Maybe<Scalars['Float']['output']>;
  fxRate?: Maybe<Scalars['Float']['output']>;
  fxRateDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  /** // Connect full instrument and accounts for simple access */
  instrument?: Maybe<Instrument>;
  /** // Instrument data */
  instrumentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  interestRateYieldDelta?: Maybe<Scalars['Float']['output']>;
  isCashAccount?: Maybe<Scalars['Boolean']['output']>;
  isin?: Maybe<Scalars['String']['output']>;
  issuerCreditRatings?: Maybe<Scalars['JSON']['output']>;
  /** // Issuer data */
  issuerId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  issuerIndustryCode?: Maybe<Scalars['String']['output']>;
  issuerKeySector?: Maybe<Scalars['Boolean']['output']>;
  issuerLei?: Maybe<Scalars['String']['output']>;
  issuerName?: Maybe<Scalars['String']['output']>;
  issuerType?: Maybe<IssuerTypeEnum>;
  localExposure?: Maybe<Scalars['Float']['output']>;
  localFinancing?: Maybe<Scalars['Float']['output']>;
  longName?: Maybe<Scalars['String']['output']>;
  maturityDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  modelType?: Maybe<InstrumentModelTypeEnum>;
  name?: Maybe<Scalars['String']['output']>;
  portfolioInstrument?: Maybe<Instrument>;
  /** // Portfolio swap related */
  portfolioInstrumentId: Scalars['GraphQLObjectId']['output'];
  quantity?: Maybe<Scalars['Float']['output']>;
  /** // Issuer program data */
  sustainabilityClass?: Maybe<IssuerProgramCategory>;
  /** // Yield Deltas from Swaplab2 */
  swaplab2Results?: Maybe<Swaplab2Results>;
  valuationAccruedInterest?: Maybe<Scalars['Float']['output']>;
  valuationCleanPrice?: Maybe<Scalars['Float']['output']>;
  valuationCurrency?: Maybe<CurrencyEnum>;
  /** // Valuation */
  valuationDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  valuationPrice?: Maybe<Scalars['Float']['output']>;
};


export type TradingManagerColumnCreditYieldDeltaArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type TradingManagerColumnInterestRateYieldDeltaArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};


export type TradingManagerColumnSwaplab2ResultsArgs = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  riskBucketYears?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** A Transaction consists of one or more Transaction.items. */
export type Transaction = {
  __typename?: 'Transaction';
  /** _id is the database objectId generated when transaction is first saved. */
  _id: Scalars['GraphQLObjectId']['output'];
  attachments?: Maybe<Array<Attachment>>;
  /**
   * BestExecutionType is an enum telling in which capacity a transaction is
   * conducted under the MiFID II regulation.
   */
  bestExecutionType?: Maybe<BestExecutionType>;
  broker?: Maybe<Party>;
  /**
   * The objectId of the broker of the transaction. The broker is the party with
   * who the transaction i settled.
   */
  brokerId: Scalars['GraphQLObjectId']['output'];
  /**
   * BrokerTradeId is the unique reference of a transaction supplied by the broker.
   * The reference number is used for matching reconciling transaction with broker
   * confirmation.
   */
  brokerTradeId?: Maybe<Scalars['String']['output']>;
  brokerTransaction?: Maybe<BrokerTransaction>;
  /** CarryOwnCostDate is a date string with the date where the transaction should affect adjustment amount. */
  carryOwnCostDate?: Maybe<Scalars['GraphQLDateString']['output']>;
  clearingHouse?: Maybe<Party>;
  /** Clearing House is used for transactions with agreement type clearingAccount/omnibusClearingAccount */
  clearingHouseId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  client?: Maybe<Party>;
  /** ClientId is the objectId of the Party(Type=Client) owning the Transaction. */
  clientId: Scalars['GraphQLObjectId']['output'];
  corporateAction?: Maybe<CorporateAction>;
  createTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  /** Description is a free text field where comments can be stored. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Error is a free text field where error messages should be posted during trade
   * matching. When trade Status is set to Instructed it should be erased.
   */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * ExternalId is a unique reference of the transaction in delivering system. If
   * transaction is created without a external system a unique number is generated.
   */
  externalId: Scalars['String']['output'];
  /** Items consists of a list of one or more transaction items. */
  items?: Maybe<Array<TransactionItem>>;
  /** Number is generated as a unbroken sequence when accounting journal is Confirmed. */
  number: Scalars['Int']['output'];
  /** parentId makes it possible to link a transaction to another transaction. */
  parentId: Scalars['GraphQLObjectId']['output'];
  /**
   * Source is an enum which differs for different types of trades,
   * other transactions should have source Internal.
   */
  source: SourceType;
  /**
   * Status is an enum describing where in the processing the transaction is at the
   * moment and which user can update or delete it. Status has implications for
   * accounting module.
   */
  status?: Maybe<TransactionStatus>;
  /** tradeDate is calculated from tradeTimestamp with Europe/Stockholm timezone */
  tradeDate: Scalars['GraphQLDateString']['output'];
  /**
   * TradeTimeStamp is the time the transaction is created. If not supplied it will
   * be generated at the time of creation. If only date is given time is set to
   * 12.00.00.
   */
  tradeTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  /** Type is used for identifying the the creating transaction object. */
  type?: Maybe<TransactionType>;
  /**
   * UniqueTradeId is the reference number of the transaction reported to central
   * repository under the EMIR regulation.
   */
  uniqueTradeId?: Maybe<Scalars['String']['output']>;
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  /** Id of user who updated/created transaction */
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  /** A list of versions of the document */
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type TransactionFilterInput = {
  accountIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  externalIdIn?: InputMaybe<Array<Scalars['String']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  instrumentIdsIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  sourceIn?: InputMaybe<Array<SourceType>>;
  /** Added start and end date to comply with legacy PositionFilter */
  startDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  statusIn?: InputMaybe<Array<TransactionStatus>>;
  statusNotIn?: InputMaybe<Array<TransactionStatus>>;
  tradeTimestampEnd?: InputMaybe<Scalars['Timestamp']['input']>;
  tradeTimestampStart?: InputMaybe<Scalars['Timestamp']['input']>;
  typesIn?: InputMaybe<Array<TransactionType>>;
  typesNotIn?: InputMaybe<Array<TransactionType>>;
  updatedAfter?: InputMaybe<Scalars['Timestamp']['input']>;
  updatedBefore?: InputMaybe<Scalars['Timestamp']['input']>;
  valueDateEnd?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  valueDateStart?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};

export type TransactionIdentifier = {
  /** Used for CreateRedeem transactions which we often receive earlier than expected */
  newValueDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  rounding?: InputMaybe<Scalars['Float']['input']>;
  transactionId: Scalars['GraphQLObjectId']['input'];
  transactionItemId: Scalars['GraphQLObjectId']['input'];
};

export type TransactionItem = {
  __typename?: 'TransactionItem';
  _id: Scalars['GraphQLObjectId']['output'];
  /** Account gives the Account object. */
  account?: Maybe<PartyAccount>;
  /**
   * AccountId is the objectId of the Account defined in Party(Client).
   * A value of '000000000000000000000000' is interpreted as no yAccount.
   */
  accountId: Scalars['GraphQLObjectId']['output'];
  /** Amount is the amount of the item in the item currency. */
  amount: Scalars['Float']['output'];
  /**
   * Ids of bankAccountTransactions that the item amount has matched with, used for reconciliation
   * of bank accounts
   */
  bankAccountTransactionIds?: Maybe<Array<Scalars['GraphQLObjectId']['output']>>;
  /** Array of matched bank account transactions */
  bankAccountTransactions?: Maybe<Array<BankAccountTransaction>>;
  client?: Maybe<Party>;
  clientId: Scalars['GraphQLObjectId']['output'];
  /** Currency denotes the currency of the item amount. */
  currency?: Maybe<CurrencyEnum>;
  /**
   * Custodian gives the Custodian of the ExternalAccount: Custodian can be the actual
   * custodian of a SecuritiesAccount or the counter party under
   * [ISDA](https://en.wikipedia.org/wiki/ISDA_Master_Agreement),
   * GMSLA or GMRA
   */
  custodian?: Maybe<Party>;
  /**
   * Error is a free text field where error messages should be posted bank account transaction
   * matching. When transactionsStatus is set to Confirmed it should be erased.
   */
  error?: Maybe<Scalars['String']['output']>;
  /** ExternalAccount gives the ExternalAccount object. */
  externalAccount?: Maybe<PartyExternalAccount>;
  /**
   * ExternalAccountId is the objectId of the ExternalAccount defined in Party(Client).
   * A ExternalAccount in a wider definition is a counter party risk netting set and
   * can be a SecuritiesAccount as well as an ISDA CSA.
   * A value of '000000000000000000000000' is interpreted as no ExternalAccount.
   */
  externalAccountId: Scalars['GraphQLObjectId']['output'];
  /**
   * FxRate is set so that the sum of the items will be zero in the Client
   * accounting currency.
   */
  fxRate?: Maybe<Scalars['Float']['output']>;
  /** Instrument gives the Instrument object. */
  instrument?: Maybe<Instrument>;
  /**
   * InstrumentId is mandatory and is the objectId of the instrument in the
   * item. Fot item types in Security, CreateRedeem, Collateral and
   * CollateralPledge the instrumentId points to the Instrument collection
   * while SettlementAmount and PayableReceivable
   * points to instruments defined in the Party(Client) collection.
   */
  instrumentId: Scalars['GraphQLObjectId']['output'];
  /**
   * PerformanceType is an enum that dictates how to handle Normal transaction items,
   * Portfolio transaction items and PortfolioItem transaction items, explained in
   * the enum above. Here Portfolio and PortfolioItem are mutually exclusive and used to
   * either look at the portfolio swap instrument itself or the constituents
   */
  performanceType: TransactionItemPerformanceType;
  /** Portfolio Instrument gives the Instrument object. */
  portfolioInstrument?: Maybe<Instrument>;
  /**
   * PortfolioInstrumentId points to the portfolio swap instrument for all transaction items
   * performanceType = PortfolioItem and for all other, Normal and Portfolio,
   * portfolioInstrumentId = ObjectId("000000000000000000000000").
   */
  portfolioInstrumentId: Scalars['GraphQLObjectId']['output'];
  /** Price is mandatory for Security item type. */
  price?: Maybe<Scalars['Float']['output']>;
  /** Quantity is mandatory for Security item type. */
  quantity?: Maybe<Scalars['Float']['output']>;
  transaction?: Maybe<Transaction>;
  /** Id of transaction which item belongs to. */
  transactionId: Scalars['GraphQLObjectId']['output'];
  transactionStatus: TransactionStatus;
  transactionTradeDate: Scalars['GraphQLDateString']['output'];
  transactionTradeTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  transactionType: TransactionType;
  /** Type is an enum defining the business logic of the item. */
  type: TransactionItemType;
  /**
   * ValueDate denotes the date a SettlementAmount becomes a current account balance
   * or the date a Security is delivered. With Europe/Stockholm timezone
   */
  valueDate?: Maybe<Scalars['GraphQLDateString']['output']>;
};

export type TransactionItemFilterInput = {
  accountIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  endDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  externalAccountIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  externalAccountTypeIn?: InputMaybe<Array<PartyExternalAccountType>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  includePortfolioSwapConstituents?: InputMaybe<Scalars['Boolean']['input']>;
  instrumentIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  itemTypeIn?: InputMaybe<Array<TransactionItemType>>;
  positionTypeIn?: InputMaybe<Array<PositionTypeEnum>>;
  startDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  statusIn?: InputMaybe<Array<TransactionStatus>>;
  tradeDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  transactionIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  valueDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};

export enum TransactionItemPerformanceType {
  /**
   * Normal is used for all transaction items that have nothing to do with
   * portfolio swaps
   */
  Normal = 'Normal',
  /**
   * Portfolio is used for all transaction items that involves the
   * portfolio swaps directly
   */
  Portfolio = 'Portfolio',
  /**
   * PortfolioItem is used for all transaction items that involves the
   * constituent of portfolio swaps. They are interlinked to the portfolio
   * swaps by portfolioInstrumentId of an transaction item
   */
  PortfolioItem = 'PortfolioItem'
}

export enum TransactionItemType {
  /**
   * AccruedInterest in not position building and belongs to the Fee accounting
   * model and the CashFlow performance model.
   */
  AccruedInterest = 'AccruedInterest',
  /**
   * Collateral is an off-balance position which is not position building in
   * terms of performance or risk calculations but included inventory position for the
   * purpose of reconciling a Securities ExternalAccount. Collateral is not included
   * in accounting or performance calculations.
   */
  Collateral = 'Collateral',
  /**
   * CollateralPledge is an off-balance position which is not position building in
   * terms of performance or risk calculations but included in netting-sets such as
   * ISDA CSA or GMSLA. CollateralPledge is not included in accounting or performance
   * calculations.
   */
  CollateralPledge = 'CollateralPledge',
  /** Same as CollateralPledge, need this to separate if CollateralPledge is initial margin or variation margin */
  CollateralPledgeInitialMargin = 'CollateralPledgeInitialMargin',
  /**
   * Commission in not position building and belongs to the Fee accounting
   * model and the CashFlow performance model.
   */
  Commission = 'Commission',
  /**
   * CreateRedeem denoted creations and redemptions of fund units. It is not position
   * building and not included in performance calculations. It belongs to the Balance
   * accounting model.
   */
  CreateRedeem = 'CreateRedeem',
  /** A third CreateRedeem type. Only books amount. Doesn't set quantity and amount in the NAV process. */
  CreateRedeemAdjustmentAmount = 'CreateRedeemAdjustmentAmount',
  /** Do we need this one? Yes! Because NAV trade initialization and population differs from standard CreateRedeem. */
  CreateRedeemAdjustmentShares = 'CreateRedeemAdjustmentShares',
  /**
   * CustodyFee in not position building and belongs to the Fee accounting
   * model and the CashFlow performance model.
   */
  CustodyFee = 'CustodyFee',
  /**
   * Dividend in not position building and belongs to the Fee accounting
   * model and the CashFlow performance model.
   */
  Dividend = 'Dividend',
  /**
   * DividendPaid denotes dividend paid from fund classes. It is not position
   * building and not included in performance calculations.
   */
  DividendPaid = 'DividendPaid',
  /**
   * Fee in not position building and belongs to the Fee accounting
   * model and the CashFlow performance model.
   */
  Fee = 'Fee',
  /**
   * ForeignTax in not position building and belongs to the Fee accounting
   * model and the CashFlow performance model.
   */
  ForeignTax = 'ForeignTax',
  /**
   * Interest in not position building and belongs to the Fee accounting
   * model and the CashFlow performance model.
   */
  Interest = 'Interest',
  /**
   * ManagementCost in not position building and belongs to the Fee accounting
   * model and the CashFlow performance model.
   */
  ManagementCost = 'ManagementCost',
  /**
   * ManagementFee in not position building and belongs to the Fee accounting
   * model and the CashFlow performance model.
   */
  ManagementFee = 'ManagementFee',
  /**
   * PayableReceivable denotes balance sheet items other than current accounts or
   * financial instruments such as margins or loans and deposits under GMSLA or
   * GMRA agreements. PayableReceivable belong to the Asset performance model and
   * the Balance accounting model.
   */
  PayableReceivable = 'PayableReceivable',
  /**
   * Rebate is a type of fee , used to be able to differentiate between dividends and fundrebates. We book fundrebates
   * with quantity as stocktrades with price 0 and cash fundrebates as rebates.
   */
  Rebate = 'Rebate',
  /**
   * Security is position building and belongs to the Inventory accounting
   * model and the Asset performance model.
   */
  Security = 'Security',
  /** Similar to CollateralPledge but posting collateral instead of receiving. */
  SecurityLoan = 'SecurityLoan',
  /**
   * SettlementAmounts is payments on current accounts and is position
   * building belongs to the Asset performance and the Balance accounting model.
   */
  SettlementAmount = 'SettlementAmount',
  /**
   * StampDuty in not position building and belongs to the Fee accounting
   * model and the CashFlow performance model.
   */
  StampDuty = 'StampDuty',
  /**
   * Tax in not position building and belongs to the Fee accounting
   * model and the CashFlow performance model.
   */
  Tax = 'Tax',
  /**
   * TaxRestitution in not position building and belongs to the Fee accounting
   * model and the CashFlow performance model.
   */
  TaxRestitution = 'TaxRestitution'
}

export enum TransactionStatus {
  /**
   * Confirmed status is set when trade is confirmed with counterparty by the
   * Operations unit.
   */
  Confirmed = 'Confirmed',
  /**
   * Deleted denotes a transaction that has been deleted but still
   * exists in the database.
   */
  Deleted = 'Deleted',
  /** History is used when setting up a new client with historic transactions. */
  History = 'History',
  /**
   * Instructed denotes when a transaction has been
   * instructed with the Custodian.
   */
  Instructed = 'Instructed',
  /** Internal is used for transactions created only for internal use. */
  Internal = 'Internal',
  /**
   * Pending is a transaction entered by an external system or user that has not
   * been confirmed by the Operations unit.
   */
  Pending = 'Pending',
  /**
   * Preliminary is a status where one or more parameters is
   * not yet confirmed and will be treated as such in accounting
   * terms and will not be given a number until it reaches
   * at least Confirmed status.
   */
  Preliminary = 'Preliminary',
  /**
   * Settled denotes when a security has been delivered in custody
   * account or cash has been settled on a current account.
   */
  Settled = 'Settled'
}

export enum TransactionType {
  BondTrade = 'BondTrade',
  Collateral = 'Collateral',
  CreateRedeem = 'CreateRedeem',
  DerivativeTrade = 'DerivativeTrade',
  Dividend = 'Dividend',
  Fee = 'Fee',
  FundTrade = 'FundTrade',
  FxOutright = 'FxOutright',
  FxSpot = 'FxSpot',
  Insert = 'Insert',
  Interest = 'Interest',
  IrSwap = 'IrSwap',
  StockTrade = 'StockTrade',
  Trade = 'Trade',
  Transfer = 'Transfer'
}

export type TransferAgentAccountPerformance = {
  __typename?: 'TransferAgentAccountPerformance';
  account?: Maybe<Customer>;
  clientAccount: Scalars['String']['output'];
  instrument?: Maybe<Instrument>;
  isin: Scalars['ISIN']['output'];
  performanceItems: Array<TransferAgentAccountPerformanceItem>;
};

export type TransferAgentAccountPerformanceItem = {
  __typename?: 'TransferAgentAccountPerformanceItem';
  /**
   * Daily-accrued absolute rebate on the position's value (Actual/365).
   * `rate` is the annual absolute rebate rate (e.g. 0.001 for 10 bps).
   */
  absoluteRebate?: Maybe<Scalars['Float']['output']>;
  cashFlow?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['GraphQLDateString']['output']>;
  navPerUnit?: Maybe<Scalars['Float']['output']>;
  /**
   * Daily-accrued rebate as a share of the fund class' management fee, on the position's value (Actual/365).
   * `rate` is the share of the management fee to rebate (e.g. 0.5 for 50%).
   */
  percentageRebate?: Maybe<Scalars['Float']['output']>;
  series?: Maybe<Scalars['Float']['output']>;
  totalReturn?: Maybe<Scalars['Float']['output']>;
  units?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type TransferAgentOrder = {
  __typename?: 'TransferAgentOrder';
  _id: Scalars['GraphQLObjectId']['output'];
  adjustmentAmount: Scalars['String']['output'];
  adjustmentShares: Scalars['String']['output'];
  amount: Scalars['String']['output'];
  attachments?: Maybe<Array<Attachment>>;
  carryOwnTransactionCost: Scalars['Boolean']['output'];
  client: Party;
  clientAccount?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['GraphQLObjectId']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  clientNumber?: Maybe<Scalars['String']['output']>;
  createTimestamp: Scalars['Timestamp']['output'];
  currency: CurrencyEnum;
  description: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  instrument: Instrument;
  isin: Scalars['ISIN']['output'];
  netPrice: Scalars['String']['output'];
  /** If subType is ACCOUNT_SWITCH, referenceExternalId must be set to corresponding externalId */
  referenceExternalId: Scalars['String']['output'];
  settledAmount: Scalars['String']['output'];
  settledUnits: Scalars['String']['output'];
  source: Party;
  sourceId: Scalars['GraphQLObjectId']['output'];
  status: TransactionStatus;
  subType: TransferAgentOrderSubTypeEnum;
  tradeDate: Scalars['GraphQLDateString']['output'];
  transactionIds: Array<Scalars['GraphQLObjectId']['output']>;
  transactionType: TransferAgentOrderEnum;
  units: Scalars['String']['output'];
  updateTimestamp: Scalars['Timestamp']['output'];
  /** Id of the user that updated/created */
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  valueDate: Scalars['GraphQLDateString']['output'];
  /** A list of versions of the document */
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type TransferAgentOrderAttachmentsInput = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  attachments?: InputMaybe<Array<AttachmentInput>>;
};

export enum TransferAgentOrderEnum {
  BUY = 'BUY',
  SELL = 'SELL'
}

export type TransferAgentOrderInput = {
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  adjustmentAmount?: InputMaybe<Scalars['String']['input']>;
  adjustmentShares?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['TwoDecimalString']['input'];
  carryOwnTransactionCost?: InputMaybe<Scalars['Boolean']['input']>;
  clientAccount?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  currency: CurrencyEnum;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  isin: Scalars['ISIN']['input'];
  netPrice?: InputMaybe<Scalars['String']['input']>;
  /** If subType is ACCOUNT_SWITCH referenceExternalId, must be set to corresponding externalId */
  referenceExternalId: Scalars['String']['input'];
  settledAmount?: InputMaybe<Scalars['String']['input']>;
  settledUnits?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['GraphQLObjectId']['input'];
  status: TransactionStatus;
  subType: TransferAgentOrderSubTypeEnum;
  tradeDate: Scalars['GraphQLDateString']['input'];
  transactionIds: Array<Scalars['GraphQLObjectId']['input']>;
  transactionType: TransferAgentOrderEnum;
  units: Scalars['String']['input'];
  valueDate: Scalars['GraphQLDateString']['input'];
};

export enum TransferAgentOrderSubTypeEnum {
  ACCOUNT_SWITCH = 'ACCOUNT_SWITCH',
  NORMAL = 'NORMAL'
}

export type TransferAgentTotalUnit = {
  __typename?: 'TransferAgentTotalUnit';
  _id: Scalars['GraphQLObjectId']['output'];
  createTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  date: Scalars['GraphQLDateString']['output'];
  instrument: Instrument;
  isin: Scalars['ISIN']['output'];
  source: Party;
  sourceId: Scalars['GraphQLObjectId']['output'];
  totalUnits: Scalars['Float']['output'];
  updateTimestamp: Scalars['Timestamp']['output'];
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type TransferAgentTotalUnitFilterInput = {
  date?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  isinIn?: InputMaybe<Array<Scalars['ISIN']['input']>>;
  sourceId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
};

export type TrialInput = {
  clientId: Scalars['GraphQLObjectId']['input'];
};

export enum TrueFalseNone {
  False = 'False',
  None = 'None',
  True = 'True'
}

export type UpdateAccountingRunInput = {
  _id: Scalars['GraphQLObjectId']['input'];
  clientTAccountChartId: Scalars['GraphQLObjectId']['input'];
  endDate: Scalars['GraphQLDateString']['input'];
  keepManualJournalEntries?: InputMaybe<Scalars['Boolean']['input']>;
  masterTAccountChartId: Scalars['GraphQLObjectId']['input'];
  type: AccountingRunTypeEnum;
};

export type UpdateBrokerTransactionInput = {
  _id: Scalars['GraphQLObjectId']['input'];
  correspondingTransactionId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BrokerTransactionStatus>;
};

export type UpdateCurveDefinitionInput = {
  _id: Scalars['GraphQLObjectId']['input'];
  clientId: Scalars['GraphQLObjectId']['input'];
  definition?: InputMaybe<CurveDefinitionDefinitionInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CurveDefinitionType>;
};

export type UpdateExternalNumberInput = {
  _id: Scalars['GraphQLObjectId']['input'];
  externalNumber: Scalars['Int']['input'];
};

export type UpdateInstrumentInput = {
  _id: Scalars['GraphQLObjectId']['input'];
  accountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  aliases?: InputMaybe<Array<AliasInput>>;
  benchmarkId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  bloombergDailyDownload?: InputMaybe<Scalars['Boolean']['input']>;
  bloombergQuoteMultiplier?: InputMaybe<Scalars['Float']['input']>;
  bloombergTicker?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<InstrumentCategory>;
  cicArea?: InputMaybe<CicAreaEnum>;
  cicType?: InputMaybe<CicTypeEnum>;
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  creditRatings?: InputMaybe<Array<InputMaybe<CreditRatingInput>>>;
  currency?: InputMaybe<CurrencyEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  exchange?: InputMaybe<Scalars['String']['input']>;
  externalAccountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  isin?: InputMaybe<Scalars['ISIN']['input']>;
  issuerId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  issuerProgramId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  longName?: InputMaybe<Scalars['String']['input']>;
  /** https://www.iso20022.org/market-identifier-codes */
  mic?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<InstrumentModelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  placeOfSettlementId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  productType?: InputMaybe<InstrumentProductTypeEnum>;
  quantityDecimals?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<InstrumentStatusEnum>;
  type?: InputMaybe<InstrumentTypeEnum>;
};

/**
 * Only allowed to update: description, externalNumber and transactions
 * for manual journal entries if accounting run is Pending
 */
export type UpdateJournalEntry2Input = {
  _id: Scalars['GraphQLObjectId']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalNumber?: InputMaybe<Scalars['Int']['input']>;
  transactions?: InputMaybe<Array<AccountingTransaction2Input>>;
};

/**
 * Only allowed to update: description, effectiveDate, externalNumber and transactions
 * for manual journal entries if accounting run is Pending
 */
export type UpdateJournalEntryInput = {
  _id: Scalars['GraphQLObjectId']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalNumber?: InputMaybe<Scalars['Int']['input']>;
  transactions?: InputMaybe<Array<AccountingTransactionInput>>;
};

export type UpdateMiniTransactionInput = {
  _id: Scalars['GraphQLObjectId']['input'];
  accountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  accruedInterest?: InputMaybe<Scalars['Float']['input']>;
  agreementType?: InputMaybe<AgreementType>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  attachments?: InputMaybe<Array<AttachmentInput>>;
  bestExecutionType?: InputMaybe<BestExecutionType>;
  bonusShares?: InputMaybe<Scalars['Float']['input']>;
  brokerId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  brokerTradeId?: InputMaybe<Scalars['String']['input']>;
  carryOwnCostDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  clearingBrokerId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clearingHouseId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  close?: InputMaybe<Scalars['Boolean']['input']>;
  commission?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<CurrencyEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  dividendPaid?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  expiry?: InputMaybe<Scalars['Boolean']['input']>;
  externalAccountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  foreignTax?: InputMaybe<Scalars['Float']['input']>;
  fxRate?: InputMaybe<Scalars['Float']['input']>;
  initialMargin?: InputMaybe<Scalars['Boolean']['input']>;
  instrumentId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  itemType?: InputMaybe<FeeInterestItemType>;
  loan?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  reinvestedDividend?: InputMaybe<Scalars['Boolean']['input']>;
  reinvestedRebate?: InputMaybe<Scalars['Boolean']['input']>;
  rounding?: InputMaybe<Scalars['Float']['input']>;
  secondAccountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  secondAmount?: InputMaybe<Scalars['Float']['input']>;
  secondCurrency?: InputMaybe<CurrencyEnum>;
  secondInstrumentId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  source?: InputMaybe<SourceType>;
  stampDuty?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<TransactionStatus>;
  taxRestitution?: InputMaybe<Scalars['Boolean']['input']>;
  tradeTimestamp?: InputMaybe<Scalars['DateStringOrTimestamp']['input']>;
  uniqueTradeId?: InputMaybe<Scalars['String']['input']>;
  valueDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};

export type UpdatePartyInput = {
  _id: Scalars['GraphQLObjectId']['input'];
  accountant?: InputMaybe<Scalars['String']['input']>;
  accountingCompanyType?: InputMaybe<AccountingCompanyTypeEnum>;
  accountingCurrency?: InputMaybe<Scalars['String']['input']>;
  accountingFrequency?: InputMaybe<AccountingFrequencyEnum>;
  accounts?: InputMaybe<Array<InputMaybe<PartyAccountInput>>>;
  address?: InputMaybe<Scalars['String']['input']>;
  aliases?: InputMaybe<Array<AliasInput>>;
  approval?: InputMaybe<Scalars['String']['input']>;
  beneficialOwner?: InputMaybe<BeneficialOwnerInput>;
  bloombergEquityTicker?: InputMaybe<Scalars['String']['input']>;
  businessIdentifierCode?: InputMaybe<Scalars['String']['input']>;
  ceo?: InputMaybe<Scalars['String']['input']>;
  complaintsManager?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCodeEnum>;
  creditRatingScale?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  creditRatings?: InputMaybe<Array<InputMaybe<CreditRatingInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  esg?: InputMaybe<PartyEsgInput>;
  externalAccounts?: InputMaybe<Array<InputMaybe<PartyExternalAccountInput>>>;
  fundInfo?: InputMaybe<PartyFundInfoInput>;
  inLedgerNumber?: InputMaybe<Scalars['Int']['input']>;
  inLedgerTradeDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  industryCode?: InputMaybe<Scalars['String']['input']>;
  instrumentIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  issuerType?: InputMaybe<IssuerTypeEnum>;
  legalEntityIdentifier?: InputMaybe<Scalars['String']['input']>;
  legalNumber?: InputMaybe<Scalars['String']['input']>;
  limitSlackChannel?: InputMaybe<Scalars['String']['input']>;
  limitStartDate?: InputMaybe<Scalars['Date']['input']>;
  longName?: InputMaybe<Scalars['String']['input']>;
  nace?: InputMaybe<NaceClass>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  quantityDecimals?: InputMaybe<Scalars['Int']['input']>;
  regulator?: InputMaybe<Scalars['String']['input']>;
  standardSettlementInstructions?: InputMaybe<Array<PartyStandardSettlementInstructionInput>>;
  status?: InputMaybe<PartyStatusEnum>;
  sustainalyticsId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<TimezoneEnum>;
  types?: InputMaybe<Array<InputMaybe<PartyType>>>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReportInput = {
  _id: Scalars['GraphQLObjectId']['input'];
  base64?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['GraphQLObjectId']['input'];
  data?: InputMaybe<Scalars['JSON']['input']>;
  date: Scalars['GraphQLDateString']['input'];
  name: Scalars['String']['input'];
  sourceId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  status?: InputMaybe<ReportStatusEnum>;
  type: Scalars['String']['input'];
};

export type UpdateRoleInput = {
  _id: Scalars['GraphQLObjectId']['input'];
  assets?: InputMaybe<Array<PermissionAssetEnum>>;
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissionType?: InputMaybe<PermissionTypeEnum>;
  roleType?: InputMaybe<RoleTypeEnum>;
  status?: InputMaybe<DocumentStatusEnum>;
};

export type UpdateTAccountChartInput = {
  _id: Scalars['GraphQLObjectId']['input'];
  clientId: Scalars['GraphQLObjectId']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tAccountMappings?: InputMaybe<Array<TAccountMappingInput>>;
  tAccounts?: InputMaybe<Array<TAccountInput>>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTransactionInput = {
  _id: Scalars['GraphQLObjectId']['input'];
  attachments?: InputMaybe<Array<AttachmentInput>>;
  bestExecutionType?: InputMaybe<BestExecutionType>;
  brokerId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  brokerTradeId?: InputMaybe<Scalars['String']['input']>;
  carryOwnCostDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
  clearingHouseId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<UpdateTransactionItemInput>>;
  number?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TransactionStatus>;
  tradeTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  type?: InputMaybe<TransactionType>;
  uniqueTradeId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTransactionItemInput = {
  /** _id should be stated when updating an item, not required when adding new items though */
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  accountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  bankAccountTransactionIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  currency?: InputMaybe<CurrencyEnum>;
  error?: InputMaybe<Scalars['String']['input']>;
  externalAccountId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  fxRate?: InputMaybe<Scalars['Float']['input']>;
  instrumentId: Scalars['GraphQLObjectId']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type: TransactionItemType;
  valueDate?: InputMaybe<Scalars['GraphQLDateString']['input']>;
};

export type UpdateUserInput = {
  _id: Scalars['GraphQLObjectId']['input'];
  bidExpiration?: InputMaybe<Scalars['Int']['input']>;
  /** If a serviceUser, this is the clientId (INTEGRATOR party) the user is associated with. */
  clientId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  company?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  frontendRoleId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  /** If true, this user is allowed to use the GraphQL API. */
  graphqlApi?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * List of IP addresses allowed to use this service user.
   * When set and non-empty, requests for this user are only allowed from these IPs.
   */
  ipWhitelist?: InputMaybe<Array<Scalars['String']['input']>>;
  logins?: InputMaybe<Array<UserLoginInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  password?: InputMaybe<Scalars['String']['input']>;
  personalNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** If true, this user is allowed to use the REST API. */
  restApi?: InputMaybe<Scalars['Boolean']['input']>;
  roleIds?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  /** serviceUser denotes non human user */
  serviceUser?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<UserStatusEnum>;
};

/** Accounting run in collection accountingrun2, journal entries in collection journalentry2 */
export type UpsertAccountingRunInput = {
  /** if _id is omitted, a document will be created */
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientId: Scalars['GraphQLObjectId']['input'];
  clientTAccountChartId: Scalars['GraphQLObjectId']['input'];
  endDate: Scalars['GraphQLDateString']['input'];
  keepManualJournalEntries?: InputMaybe<Scalars['Boolean']['input']>;
  type: AccountingRunTypeEnum;
};

export type UpsertTAccount = {
  __typename?: 'UpsertTAccount';
  description?: Maybe<Scalars['String']['output']>;
  group1?: Maybe<TAccountGroup1Enum>;
  group2?: Maybe<TAccountGroup2Enum>;
  group3?: Maybe<TAccountGroup3Enum>;
  group4?: Maybe<TAccountGroup4Enum>;
  group5?: Maybe<TAccountGroup5Enum>;
  number: Scalars['String']['output'];
  type?: Maybe<TAccountTypeEnum>;
};

export type UpsertTAccountChart = {
  __typename?: 'UpsertTAccountChart';
  _id: Scalars['GraphQLObjectId']['output'];
  client?: Maybe<Party>;
  clientId: Scalars['GraphQLObjectId']['output'];
  createTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  createUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  createUserInfo?: Maybe<UserInfo>;
  /** Set when the chart is used by an accounting run, a locked chart can not be updated */
  locked?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tAccountMappings?: Maybe<Array<UpsertTAccountMapping>>;
  tAccounts?: Maybe<Array<UpsertTAccount>>;
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** Omit tAccounts and tAccountMappings on create to start from the default fund t-account chart */
export type UpsertTAccountChartInput = {
  /** Omit to create, set to update */
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientId: Scalars['GraphQLObjectId']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tAccountMappings?: InputMaybe<Array<UpsertTAccountMappingInput>>;
  tAccounts?: InputMaybe<Array<UpsertTAccountInput>>;
  /** Set to the loaded updateTimestamp on update to reject the update if the chart has been changed since */
  updateTimestamp?: InputMaybe<Scalars['Timestamp']['input']>;
  /** Omit on create to get the next version of the charts with the same client and name */
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertTAccountInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  group1?: InputMaybe<TAccountGroup1Enum>;
  group2?: InputMaybe<TAccountGroup2Enum>;
  group3?: InputMaybe<TAccountGroup3Enum>;
  group4?: InputMaybe<TAccountGroup4Enum>;
  group5?: InputMaybe<TAccountGroup5Enum>;
  number: Scalars['String']['input'];
  type?: InputMaybe<TAccountTypeEnum>;
};

export type UpsertTAccountMapping = {
  __typename?: 'UpsertTAccountMapping';
  name?: Maybe<Scalars['String']['output']>;
  selector: UpsertTAccountMappingSelector;
  values?: Maybe<Array<TAccountMappingValue>>;
};

export type UpsertTAccountMappingInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  selector: UpsertTAccountMappingSelectorInput;
  values?: InputMaybe<Array<TAccountMappingValueInput>>;
};

export type UpsertTAccountMappingSelector = {
  __typename?: 'UpsertTAccountMappingSelector';
  cicTypes?: Maybe<Array<CicTypeEnum>>;
  currencies?: Maybe<Array<CurrencyEnum>>;
  instruments?: Maybe<Array<Scalars['GraphQLObjectId']['output']>>;
  modelTypes?: Maybe<Array<InstrumentModelTypeEnum>>;
};

export type UpsertTAccountMappingSelectorInput = {
  cicTypes?: InputMaybe<Array<CicTypeEnum>>;
  currencies?: InputMaybe<Array<CurrencyEnum>>;
  instruments?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  modelTypes?: InputMaybe<Array<InstrumentModelTypeEnum>>;
};

export enum UseOfProceed {
  /** Access to essential services */
  AccessEssentialServices = 'AccessEssentialServices',
  /** Affordable housing */
  AffordableHousing = 'AffordableHousing',
  /** Affordable basic infrastructure */
  AffordableInfraStructure = 'AffordableInfraStructure',
  /** Clean Transportation */
  CleanTransportation = 'CleanTransportation',
  /** climate change adaptation */
  ClimateChangeAdaption = 'ClimateChangeAdaption',
  /** eco-efficient and/or circular economy adapted products, */
  EcoEfficientProducts = 'EcoEfficientProducts',
  /** Employment generation (including SME financing and Microfinance) */
  EmploymentGeneration = 'EmploymentGeneration',
  /** Energy efficiency */
  EnergyEfficiency = 'EnergyEfficiency',
  /** Environmentally sustainable management of living natural resources and land use */
  EnvironmentallySustainableManagement = 'EnvironmentallySustainableManagement',
  /** Green Buildings */
  GreenBuldings = 'GreenBuldings',
  Other = 'Other',
  /** Pollution prevention and control */
  PollutionPreventionAndControl = 'PollutionPreventionAndControl',
  /** Renewable energy */
  RenewableEnergy = 'RenewableEnergy',
  /** Socioeconomic advancement and empowerment */
  SocioEconomicAdvancement = 'SocioEconomicAdvancement',
  /** Food security and sustainable food systems */
  SustainableFoodSystems = 'SustainableFoodSystems',
  /** Sustainable water and wastewater management */
  SustainableWaterManagement = 'SustainableWaterManagement',
  /** Terrestrial and aquatic biodiversity conservation */
  TerrestrialandAcquaticConservation = 'TerrestrialandAcquaticConservation'
}

export type User = {
  __typename?: 'User';
  _id: Scalars['GraphQLObjectId']['output'];
  bidExpiration?: Maybe<Scalars['Int']['output']>;
  /** If a serviceUser, this is the clientId the user is associated with. */
  clientId: Scalars['GraphQLObjectId']['output'];
  clientIds: Array<Scalars['GraphQLObjectId']['output']>;
  clients: Array<PartyInfo>;
  company: Scalars['String']['output'];
  createTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  frontendRole: Role;
  frontendRoleId: Scalars['GraphQLObjectId']['output'];
  /** If true, this user is allowed to use the GraphQL API. */
  graphqlApi: Scalars['Boolean']['output'];
  /**
   * List of IP addresses allowed to use this service user.
   * When set and non-empty, requests for this user are only allowed from these IPs.
   */
  ipWhitelist?: Maybe<Array<Scalars['String']['output']>>;
  lastBankIdLoginTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  lastLoginTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  lastPasswordUpdate?: Maybe<Scalars['Timestamp']['output']>;
  logins?: Maybe<Array<UserLogin>>;
  name: Scalars['String']['output'];
  noteIds: Array<Scalars['GraphQLObjectId']['output']>;
  notes: Array<Note>;
  password?: Maybe<Scalars['String']['output']>;
  personalNumber: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** If true, this user is allowed to use the REST API. */
  restApi: Scalars['Boolean']['output'];
  roleIds: Array<Scalars['GraphQLObjectId']['output']>;
  roles: Array<Role>;
  /** serviceUser denotes non human user */
  serviceUser: Scalars['Boolean']['output'];
  status: UserStatusEnum;
  /** Latest terms of service from notes collection */
  termsOfService?: Maybe<Note>;
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  versions?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type UserFilterInput = {
  status?: InputMaybe<UserStatusEnum>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  _id: Scalars['GraphQLObjectId']['output'];
  company: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  personalNumber: Scalars['String']['output'];
};

export type UserLimited = {
  __typename?: 'UserLimited';
  _id: Scalars['GraphQLObjectId']['output'];
  /** Only returned when filtering by asset */
  asset?: Maybe<PermissionAssetEnum>;
  /** Only returned when filtering by asset */
  clientIds?: Maybe<Array<Scalars['GraphQLObjectId']['output']>>;
  status: UserStatusEnum;
};

export type UserLogin = {
  __typename?: 'UserLogin';
  timeStamp: Scalars['Timestamp']['output'];
  userAgent: Scalars['String']['output'];
};

export type UserLoginInput = {
  timeStamp: Scalars['Timestamp']['input'];
  userAgent: Scalars['String']['input'];
};

export enum UserStatusEnum {
  Confirmed = 'Confirmed',
  Disabled = 'Disabled',
  Pending = 'Pending'
}

export type Valuation = {
  __typename?: 'Valuation';
  _id: Scalars['GraphQLObjectId']['output'];
  attachments?: Maybe<Array<Attachment>>;
  date: Scalars['GraphQLSwedenDate']['output'];
  instrument?: Maybe<Instrument>;
  instrumentId: Scalars['GraphQLObjectId']['output'];
  records?: Maybe<Array<Maybe<ValuationRecord>>>;
  updateTimestamp?: Maybe<Scalars['Timestamp']['output']>;
};

export type ValuationMapping = {
  __typename?: 'ValuationMapping';
  _id: Scalars['GraphQLObjectId']['output'];
  client?: Maybe<Party>;
  clientId: Scalars['GraphQLObjectId']['output'];
  collectionName?: Maybe<MappingCollectionNameEnum>;
  createTimestamp: Scalars['Timestamp']['output'];
  currency?: Maybe<CurrencyEnum>;
  curveDefinition?: Maybe<CurveDefinition>;
  instrument?: Maybe<Instrument>;
  /** instrumentId should be a id to an instrument or null */
  instrumentId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  issuerProgram?: Maybe<IssuerProgram>;
  issuerProgramId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  mappingType?: Maybe<MappingTypeEnum>;
  modelType?: Maybe<InstrumentModelTypeEnum>;
  parameterType?: Maybe<MappingParameterEnum>;
  referenceId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  status?: Maybe<ValuationMappingStatus>;
  updateTimestamp: Scalars['Timestamp']['output'];
  /** Id of the user that updated/created */
  updateUserId?: Maybe<Scalars['GraphQLObjectId']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  validFrom: Scalars['GraphQLDateString']['output'];
  validTo: Scalars['GraphQLDateString']['output'];
  /** A list of versions of the document */
  versions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
};

export type ValuationMappingFilterInput = {
  clientIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  idIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  instrumentIdIn?: InputMaybe<Array<Scalars['GraphQLObjectId']['input']>>;
  mappingTypeIn?: InputMaybe<Array<MappingTypeEnum>>;
  parameterTypeIn?: InputMaybe<Array<MappingParameterEnum>>;
  statusIn?: InputMaybe<Array<InputMaybe<ValuationMappingStatus>>>;
};

export type ValuationMappingInput = {
  /** if _id is omitted, an ticket will be created */
  _id?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  clientId: Scalars['GraphQLObjectId']['input'];
  collectionName?: InputMaybe<MappingCollectionNameEnum>;
  currency?: InputMaybe<CurrencyEnum>;
  instrumentId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  issuerProgramId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  mappingType?: InputMaybe<MappingTypeEnum>;
  modelType?: InputMaybe<InstrumentModelTypeEnum>;
  parameterType?: InputMaybe<MappingParameterEnum>;
  referenceId?: InputMaybe<Scalars['GraphQLObjectId']['input']>;
  status?: InputMaybe<ValuationMappingStatus>;
  validFrom: Scalars['GraphQLDateString']['input'];
  validTo: Scalars['GraphQLDateString']['input'];
};

export enum ValuationMappingStatus {
  Active = 'Active',
  Deleted = 'Deleted'
}

export type ValuationPrice = {
  __typename?: 'ValuationPrice';
  currency?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PriceType>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type ValuationPriceInput = {
  currency: CurrencyEnum;
  type: PriceType;
  value: Scalars['Float']['input'];
};

export type ValuationRecord = {
  __typename?: 'ValuationRecord';
  bloombergTicker?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<Array<Maybe<ValuationPrice>>>;
  source?: Maybe<Scalars['String']['output']>;
  updateUserInfo?: Maybe<UserInfo>;
  writeTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  writeUser?: Maybe<Scalars['String']['output']>;
};

export type YieldDeltaBucket = {
  __typename?: 'YieldDeltaBucket';
  period?: Maybe<QuantLibPeriod>;
  value?: Maybe<Scalars['Float']['output']>;
};

export enum PermissionTypeEnum {
  Read = 'Read',
  ReadWrite = 'ReadWrite'
}



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = Record<PropertyKey, never>, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;





/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AcceptTermsInput: AcceptTermsInput;
  AccountSwitchAllInput: AccountSwitchAllInput;
  AccountingBatchType: AccountingBatchType;
  AccountingCompanyTypeEnum: AccountingCompanyTypeEnum;
  AccountingFrequencyEnum: AccountingFrequencyEnum;
  AccountingLanguageEnum: AccountingLanguageEnum;
  AccountingRun: ResolverTypeWrapper<AccountingRun>;
  AccountingRun2: ResolverTypeWrapper<AccountingRun2>;
  AccountingRun2FilterInput: AccountingRun2FilterInput;
  AccountingRunStatusEnum: AccountingRunStatusEnum;
  AccountingRunTypeEnum: AccountingRunTypeEnum;
  AccountingTransaction: ResolverTypeWrapper<AccountingTransaction>;
  AccountingTransaction2: ResolverTypeWrapper<AccountingTransaction2>;
  AccountingTransaction2Input: AccountingTransaction2Input;
  AccountingTransactionInput: AccountingTransactionInput;
  AccountingTransactionType: AccountingTransactionType;
  Agreement: ResolverTypeWrapper<Agreement>;
  AgreementFilterInput: AgreementFilterInput;
  AgreementInput: AgreementInput;
  AgreementStatusEnum: AgreementStatusEnum;
  AgreementType: AgreementType;
  AgreementTypeEnum: AgreementTypeEnum;
  Alias: ResolverTypeWrapper<Alias>;
  AliasInput: AliasInput;
  AmountData: ResolverTypeWrapper<AmountData>;
  AmountDataInput: AmountDataInput;
  AnnualReportType: ResolverTypeWrapper<AnnualReportType>;
  ApprovedInfo: ResolverTypeWrapper<ApprovedInfo>;
  ApprovedInfoInput: ApprovedInfoInput;
  ApprovedStatusEnum: ApprovedStatusEnum;
  Attachment: ResolverTypeWrapper<Attachment>;
  AttachmentInput: AttachmentInput;
  BIC: ResolverTypeWrapper<Scalars['BIC']['output']>;
  BankAccountBalance: ResolverTypeWrapper<BankAccountBalance>;
  BankAccountBalanceFilterInput: BankAccountBalanceFilterInput;
  BankAccountTransaction: ResolverTypeWrapper<BankAccountTransaction>;
  BankAccountTransactionFilterInput: BankAccountTransactionFilterInput;
  BankAccountTransactionInput: BankAccountTransactionInput;
  BankAccountTransactionStatusEnum: BankAccountTransactionStatusEnum;
  BaseCalendar: ResolverTypeWrapper<BaseCalendar>;
  BaseCalendarEvent: ResolverTypeWrapper<BaseCalendarEvent>;
  BaseCalendarEventInput: BaseCalendarEventInput;
  BaseCalendarFilterInput: BaseCalendarFilterInput;
  BaseCalendarInput: BaseCalendarInput;
  Benchmark: ResolverTypeWrapper<Benchmark>;
  BenchmarkInput: BenchmarkInput;
  BeneficialOwner: ResolverTypeWrapper<BeneficialOwner>;
  BeneficialOwnerInput: BeneficialOwnerInput;
  BestExecutionType: BestExecutionType;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BrokerTransaction: ResolverTypeWrapper<BrokerTransaction>;
  BrokerTransactionFilterInput: BrokerTransactionFilterInput;
  BrokerTransactionStatus: BrokerTransactionStatus;
  BrokerTransactionType: BrokerTransactionType;
  Calendar: ResolverTypeWrapper<Calendar>;
  CalendarEvent: ResolverTypeWrapper<CalendarEvent>;
  CalendarNameEnum: CalendarNameEnum;
  CalendarStateEnum: CalendarStateEnum;
  CalendarStatusEnum: CalendarStatusEnum;
  CashAccountBalance: ResolverTypeWrapper<CashAccountBalance>;
  CashAccountLadder: ResolverTypeWrapper<CashAccountLadder>;
  CashBalance: ResolverTypeWrapper<CashBalance>;
  CdsType: CdsType;
  ChangePasswordInput: ChangePasswordInput;
  CicAreaEnum: CicAreaEnum;
  CicTypeEnum: CicTypeEnum;
  ClientForAsset: ResolverTypeWrapper<ClientForAsset>;
  ClientInfo: ResolverTypeWrapper<ClientInfo>;
  CollectionNameEnum: CollectionNameEnum;
  CorporateAction: ResolverTypeWrapper<CorporateAction>;
  CorporateActionEvent: CorporateActionEvent;
  CorporateActionFilterInput: CorporateActionFilterInput;
  CorporateActionInput: CorporateActionInput;
  CorporateActionStatusEnum: CorporateActionStatusEnum;
  Cost: ResolverTypeWrapper<Cost>;
  CostFilterInput: CostFilterInput;
  CostInput: CostInput;
  CostStatusEnum: CostStatusEnum;
  CountryCodeEnum: CountryCodeEnum;
  CreateAccountingRunInput: CreateAccountingRunInput;
  CreateAttachmentInput: CreateAttachmentInput;
  CreateCurveDefinitionInput: CreateCurveDefinitionInput;
  CreateInstrumentInput: CreateInstrumentInput;
  CreateJournalEntry2Input: CreateJournalEntry2Input;
  CreateJournalEntryInput: CreateJournalEntryInput;
  CreateMiniTransactionInput: CreateMiniTransactionInput;
  CreatePartyInput: CreatePartyInput;
  CreateReportInput: CreateReportInput;
  CreateRoleInput: CreateRoleInput;
  CreateSwiftInput: CreateSwiftInput;
  CreateTAccountChartInput: CreateTAccountChartInput;
  CreateTransactionInput: CreateTransactionInput;
  CreateTransactionItemInput: CreateTransactionItemInput;
  CreateUpdateCashInstrumentInput: CreateUpdateCashInstrumentInput;
  CreateUpdateExternalAccountInput: CreateUpdateExternalAccountInput;
  CreateUpdatePartyCashOrBalanceInstrumentInput: CreateUpdatePartyCashOrBalanceInstrumentInput;
  CreateUserInput: CreateUserInput;
  CreateValuationInput: CreateValuationInput;
  CreditRatingInput: CreditRatingInput;
  CreditStatus: CreditStatus;
  CreditStatusType: ResolverTypeWrapper<CreditStatusType>;
  CurrencyEnum: CurrencyEnum;
  CurveDefinition: ResolverTypeWrapper<CurveDefinition>;
  CurveDefinitionDefinition: ResolverTypeWrapper<CurveDefinitionDefinition>;
  CurveDefinitionDefinitionInput: CurveDefinitionDefinitionInput;
  CurveDefinitionInstrument: ResolverTypeWrapper<CurveDefinitionInstrument>;
  CurveDefinitionInstrumentInput: CurveDefinitionInstrumentInput;
  CurveDefinitionType: CurveDefinitionType;
  CurveDefinitionType2: CurveDefinitionType2;
  CustodianApiPosition: ResolverTypeWrapper<CustodianApiPosition>;
  CustodianApiPositionInput: CustodianApiPositionInput;
  CustodianPosition: ResolverTypeWrapper<CustodianPosition>;
  CustodianPositionType: CustodianPositionType;
  Customer: ResolverTypeWrapper<Customer>;
  CustomerFilterInput: CustomerFilterInput;
  CustomerInput: CustomerInput;
  DartBasic: ResolverTypeWrapper<DartBasic>;
  DartHolding: ResolverTypeWrapper<DartHolding>;
  DartReport: ResolverTypeWrapper<DartReport>;
  DartTransaction: ResolverTypeWrapper<DartTransaction>;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DateQuote: ResolverTypeWrapper<DateQuote>;
  DateStringOrTimestamp: ResolverTypeWrapper<Scalars['DateStringOrTimestamp']['output']>;
  DateValue: ResolverTypeWrapper<DateValue>;
  DayAdjustmentEnum: DayAdjustmentEnum;
  DecimalString: ResolverTypeWrapper<Scalars['DecimalString']['output']>;
  DefaultCashInstrument: ResolverTypeWrapper<DefaultCashInstrument>;
  DefaultCashInstrumentInput: DefaultCashInstrumentInput;
  DocumentStatusEnum: DocumentStatusEnum;
  EmailAddress: ResolverTypeWrapper<Scalars['EmailAddress']['output']>;
  EngagementMethod: EngagementMethod;
  EsgActivityEnum: EsgActivityEnum;
  EsgAreaEnum: EsgAreaEnum;
  EsgComment: ResolverTypeWrapper<EsgComment>;
  EsgCommentInput: EsgCommentInput;
  EsgComponentEnum: EsgComponentEnum;
  EuTaxonomyEnvironmentalObjective: EuTaxonomyEnvironmentalObjective;
  EventInfo: ResolverTypeWrapper<EventInfo>;
  ExposureCollateral: ResolverTypeWrapper<ExposureCollateral>;
  ExposureCollateralInput: ExposureCollateralInput;
  ExposureCollateralType: ExposureCollateralType;
  Extension: ResolverTypeWrapper<Extension>;
  ExtensionInput: ExtensionInput;
  ExtensionsFilterInput: ExtensionsFilterInput;
  FeeInterestItemType: FeeInterestItemType;
  FieldDataItem: ResolverTypeWrapper<FieldDataItem>;
  FilterInput: FilterInput;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  FredObservation: ResolverTypeWrapper<FredObservation>;
  FredQueryArgs: FredQueryArgs;
  FredSeries: ResolverTypeWrapper<FredSeries>;
  FundPerformance: ResolverTypeWrapper<FundPerformance>;
  FundPortfolioPerformance: ResolverTypeWrapper<FundPortfolioPerformance>;
  FundReportComponentEnum: FundReportComponentEnum;
  FundReportEnum: FundReportEnum;
  FundTypeEnum: FundTypeEnum;
  FundUnit: ResolverTypeWrapper<FundUnit>;
  FundUnitReconciliationType: ResolverTypeWrapper<FundUnitReconciliationType>;
  FxValuation: ResolverTypeWrapper<FxValuation>;
  GlobalStandardScreen: ResolverTypeWrapper<GlobalStandardScreen>;
  GlobalStandardScreenInput: GlobalStandardScreenInput;
  GraphQLCreditRating: ResolverTypeWrapper<Scalars['GraphQLCreditRating']['output']>;
  GraphQLDateString: ResolverTypeWrapper<Scalars['GraphQLDateString']['output']>;
  GraphQLLei: ResolverTypeWrapper<Scalars['GraphQLLei']['output']>;
  GraphQLObjectId: ResolverTypeWrapper<Scalars['GraphQLObjectId']['output']>;
  GraphQLPatchInstrumentDate: ResolverTypeWrapper<Scalars['GraphQLPatchInstrumentDate']['output']>;
  GraphQLSwedenDate: ResolverTypeWrapper<Scalars['GraphQLSwedenDate']['output']>;
  GraphQLSwedishLegalNumber: ResolverTypeWrapper<Scalars['GraphQLSwedishLegalNumber']['output']>;
  HistoricalData: ResolverTypeWrapper<HistoricalData>;
  HistoricalFieldsEnum: HistoricalFieldsEnum;
  IBAN: ResolverTypeWrapper<Scalars['IBAN']['output']>;
  ISIN: ResolverTypeWrapper<Scalars['ISIN']['output']>;
  ImportBondTradeInput: ImportBondTradeInput;
  ImportCloseDerivativeTradeInput: ImportCloseDerivativeTradeInput;
  ImportCollateralInput: ImportCollateralInput;
  ImportCouponInput: ImportCouponInput;
  ImportCreateRedeemInput: ImportCreateRedeemInput;
  ImportDerivativeTradeInput: ImportDerivativeTradeInput;
  ImportDividendInput: ImportDividendInput;
  ImportExpiryDerivativeTradeInput: ImportExpiryDerivativeTradeInput;
  ImportFeeInterestInput: ImportFeeInterestInput;
  ImportFundTradeInput: ImportFundTradeInput;
  ImportFxSpotInput: ImportFxSpotInput;
  ImportInsertCashInput: ImportInsertCashInput;
  ImportInsertDerivativeTradeInput: ImportInsertDerivativeTradeInput;
  ImportInsertSecurityInput: ImportInsertSecurityInput;
  ImportStockTradeInput: ImportStockTradeInput;
  ImportTransferInput: ImportTransferInput;
  Instrument: ResolverTypeWrapper<Instrument>;
  InstrumentAccountPosition: ResolverTypeWrapper<InstrumentAccountPosition>;
  InstrumentCategory: InstrumentCategory;
  InstrumentFilterInput: InstrumentFilterInput;
  InstrumentModel: ResolverTypeWrapper<InstrumentModel>;
  InstrumentModelInput: InstrumentModelInput;
  InstrumentModelLegFixingTypesEnum: InstrumentModelLegFixingTypesEnum;
  InstrumentModelLegTypesEnum: InstrumentModelLegTypesEnum;
  InstrumentModelLegsItem: ResolverTypeWrapper<InstrumentModelLegsItem>;
  InstrumentModelLegsItemCashFlowsItem: ResolverTypeWrapper<InstrumentModelLegsItemCashFlowsItem>;
  InstrumentModelLegsItemCashFlowsItemFixingsItem: ResolverTypeWrapper<InstrumentModelLegsItemCashFlowsItemFixingsItem>;
  InstrumentModelLegsItemCashFlowsItemFixingsItemInput: InstrumentModelLegsItemCashFlowsItemFixingsItemInput;
  InstrumentModelLegsItemCashFlowsItemInput: InstrumentModelLegsItemCashFlowsItemInput;
  InstrumentModelLegsItemInput: InstrumentModelLegsItemInput;
  InstrumentModelLegsItemUnderlyingsItem: ResolverTypeWrapper<InstrumentModelLegsItemUnderlyingsItem>;
  InstrumentModelLegsItemUnderlyingsItemInput: InstrumentModelLegsItemUnderlyingsItemInput;
  InstrumentModelObjectTypeEnum: InstrumentModelObjectTypeEnum;
  InstrumentModelSubTypeEnum: InstrumentModelSubTypeEnum;
  InstrumentModelTypeEnum: InstrumentModelTypeEnum;
  InstrumentPerformance: ResolverTypeWrapper<InstrumentPerformance>;
  InstrumentPosition: ResolverTypeWrapper<InstrumentPosition>;
  InstrumentPositionType: InstrumentPositionType;
  InstrumentProductTypeEnum: InstrumentProductTypeEnum;
  InstrumentSelector: ResolverTypeWrapper<InstrumentSelector>;
  InstrumentSelectorInput: InstrumentSelectorInput;
  InstrumentStatusEnum: InstrumentStatusEnum;
  InstrumentTypeEnum: InstrumentTypeEnum;
  InstrumentValuation: ResolverTypeWrapper<InstrumentValuation>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  Inventory: ResolverTypeWrapper<Inventory>;
  IorpEnum: IorpEnum;
  IssuerProgram: ResolverTypeWrapper<IssuerProgram>;
  IssuerProgramCategory: IssuerProgramCategory;
  IssuerProgramInput: IssuerProgramInput;
  IssuerProgramsFilterInput: IssuerProgramsFilterInput;
  IssuerTypeEnum: IssuerTypeEnum;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  JSONObject: ResolverTypeWrapper<Scalars['JSONObject']['output']>;
  JournalEntry: ResolverTypeWrapper<JournalEntry>;
  JournalEntry2: ResolverTypeWrapper<JournalEntry2>;
  JournalEntryInput: JournalEntryInput;
  KleerAccountMetadata: ResolverTypeWrapper<KleerAccountMetadata>;
  KleerAccountingYear: ResolverTypeWrapper<KleerAccountingYear>;
  KleerAmount: ResolverTypeWrapper<KleerAmount>;
  KleerCompanyInfo: ResolverTypeWrapper<KleerCompanyInfo>;
  KleerIdRef: ResolverTypeWrapper<KleerIdRef>;
  KleerPeriod: ResolverTypeWrapper<KleerPeriod>;
  KleerRevenue: ResolverTypeWrapper<KleerRevenue>;
  KleerRevenueLedger: ResolverTypeWrapper<KleerRevenueLedger>;
  KleerRevenueRow: ResolverTypeWrapper<KleerRevenueRow>;
  KleerVoucher: ResolverTypeWrapper<KleerVoucher>;
  KleerVoucherTransaction: ResolverTypeWrapper<KleerVoucherTransaction>;
  LimitData: ResolverTypeWrapper<LimitData>;
  LimitedUserFilterInput: LimitedUserFilterInput;
  MappingCollectionNameEnum: MappingCollectionNameEnum;
  MappingParameterEnum: MappingParameterEnum;
  MappingTypeEnum: MappingTypeEnum;
  MarginRequirement: ResolverTypeWrapper<MarginRequirement>;
  MarginRequirementType: MarginRequirementType;
  MarginType: MarginType;
  MatchBankAccountTransactionsInput: MatchBankAccountTransactionsInput;
  MatchCoacsTransactionsInput: MatchCoacsTransactionsInput;
  MatchTransactionsInput: MatchTransactionsInput;
  MatchedBankAccountTransaction: ResolverTypeWrapper<MatchedBankAccountTransaction>;
  MatchedCoacsTransaction: ResolverTypeWrapper<MatchedCoacsTransaction>;
  MatchedTransaction: ResolverTypeWrapper<MatchedTransaction>;
  MatchingCoacsStatus: MatchingCoacsStatus;
  MatchingStatus: MatchingStatus;
  Max35CharString: ResolverTypeWrapper<Scalars['Max35CharString']['output']>;
  Max140CharString: ResolverTypeWrapper<Scalars['Max140CharString']['output']>;
  Me: ResolverTypeWrapper<Me>;
  Min1Max70CharString: ResolverTypeWrapper<Scalars['Min1Max70CharString']['output']>;
  MiniTransaction: ResolverTypeWrapper<MiniTransaction>;
  ModelIndexBenchmark: ResolverTypeWrapper<ModelIndexBenchmark>;
  ModelIndexBenchmarkInput: ModelIndexBenchmarkInput;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  NaceClass: NaceClass;
  NameAndId: ResolverTypeWrapper<NameAndId>;
  Nav: ResolverTypeWrapper<Nav>;
  NavData: ResolverTypeWrapper<NavData>;
  NavDataInput: NavDataInput;
  NavFundClass: ResolverTypeWrapper<NavFundClass>;
  NavFundClassInput: NavFundClassInput;
  NavInput: NavInput;
  NavOrder: ResolverTypeWrapper<NavOrder>;
  NavOrderInput: NavOrderInput;
  NavPosition: ResolverTypeWrapper<NavPosition>;
  NavPositionInput: NavPositionInput;
  NavTransaction: ResolverTypeWrapper<NavTransaction>;
  NavTransactionInput: NavTransactionInput;
  NavTransactionType: NavTransactionType;
  NonTradingDayFillMethodEnum: NonTradingDayFillMethodEnum;
  NonTradingDayFillOptionEnum: NonTradingDayFillOptionEnum;
  Note: ResolverTypeWrapper<Note>;
  NoteAssetEnum: NoteAssetEnum;
  NoteFilterInput: NoteFilterInput;
  NoteInput: NoteInput;
  NoteReference: ResolverTypeWrapper<NoteReference>;
  NoteReferenceInput: NoteReferenceInput;
  NoteStatusEnum: NoteStatusEnum;
  NoteTag: ResolverTypeWrapper<NoteTag>;
  NoteTagFilter: NoteTagFilter;
  NoteTagInput: NoteTagInput;
  OPAccess: ResolverTypeWrapper<OpAccess>;
  OPAccessItem: ResolverTypeWrapper<OpAccessItem>;
  OPAccessItemInput: OpAccessItemInput;
  OPConsent: ResolverTypeWrapper<OpConsent>;
  OPConsentFilter: OpConsentFilter;
  OPConsentStatus: OpConsentStatus;
  OPPayment: ResolverTypeWrapper<OpPayment>;
  OPPaymentFilter: OpPaymentFilter;
  OPPaymentInput: OpPaymentInput;
  OPPaymentStatusEnum: OpPaymentStatusEnum;
  OPSigningBasketData: ResolverTypeWrapper<OpSigningBasketData>;
  OpenPaymentLink: ResolverTypeWrapper<OpenPaymentLink>;
  OpenPaymentLinkData: ResolverTypeWrapper<OpenPaymentLinkData>;
  OrderFilterInput: OrderFilterInput;
  OverrideOptionEnum: OverrideOptionEnum;
  Party: ResolverTypeWrapper<Party>;
  PartyAccount: ResolverTypeWrapper<PartyAccount>;
  PartyAccountInput: PartyAccountInput;
  PartyAccountType: PartyAccountType;
  PartyAccountWeight: ResolverTypeWrapper<PartyAccountWeight>;
  PartyAccountWeightInput: PartyAccountWeightInput;
  PartyBaseInput: PartyBaseInput;
  PartyBenchmark: ResolverTypeWrapper<PartyBenchmark>;
  PartyBenchmarkInput: PartyBenchmarkInput;
  PartyCreditRating: ResolverTypeWrapper<PartyCreditRating>;
  PartyEsg: ResolverTypeWrapper<PartyEsg>;
  PartyEsgInput: PartyEsgInput;
  PartyExternalAccount: ResolverTypeWrapper<PartyExternalAccount>;
  PartyExternalAccountInput: PartyExternalAccountInput;
  PartyExternalAccountType: PartyExternalAccountType;
  PartyFilterInput: PartyFilterInput;
  PartyFundInfo: ResolverTypeWrapper<PartyFundInfo>;
  PartyFundInfoClass: ResolverTypeWrapper<PartyFundInfoClass>;
  PartyFundInfoClassInput: PartyFundInfoClassInput;
  PartyFundInfoInput: PartyFundInfoInput;
  PartyInfo: ResolverTypeWrapper<PartyInfo>;
  PartyIssuerInput: PartyIssuerInput;
  PartyIssuerType: ResolverTypeWrapper<PartyIssuerType>;
  PartyStandardSettlementInstruction: ResolverTypeWrapper<PartyStandardSettlementInstruction>;
  PartyStandardSettlementInstructionInput: PartyStandardSettlementInstructionInput;
  PartyStandardSettlementInstructionType: PartyStandardSettlementInstructionType;
  PartyStatusEnum: PartyStatusEnum;
  PartyType: PartyType;
  PerformanceFilterInput: PerformanceFilterInput;
  PeriodicityAdjustmentEnum: PeriodicityAdjustmentEnum;
  PeriodicitySelectionEnum: PeriodicitySelectionEnum;
  PermissionAssetEnum: PermissionAssetEnum;
  PortfolioPerformance: ResolverTypeWrapper<PortfolioPerformance>;
  PortfolioPerformanceItem: ResolverTypeWrapper<PortfolioPerformanceItem>;
  PortfolioSwapItemValuation: ResolverTypeWrapper<PortfolioSwapItemValuation>;
  PortfolioSwapItemValue: ResolverTypeWrapper<PortfolioSwapItemValue>;
  PortfolioSwapItemsPosition: ResolverTypeWrapper<PortfolioSwapItemsPosition>;
  Position: ResolverTypeWrapper<Position>;
  PositionFilter: PositionFilter;
  PositionSelectorType: PositionSelectorType;
  PositionTypeEnum: PositionTypeEnum;
  Price: ResolverTypeWrapper<Price>;
  PriceFilterInput: PriceFilterInput;
  PriceInput: PriceInput;
  PriceType: PriceType;
  PriceTypeEnum: PriceTypeEnum;
  PricingOptionEnum: PricingOptionEnum;
  ProductInvolvement: ResolverTypeWrapper<ProductInvolvement>;
  ProductInvolvementIndicator: ProductInvolvementIndicator;
  ProductInvolvementInput: ProductInvolvementInput;
  PublishedToInput: PublishedToInput;
  PublishedToType: ResolverTypeWrapper<PublishedToType>;
  QuantLibPeriod: ResolverTypeWrapper<QuantLibPeriod>;
  QuantLibTimeUnitEnum: QuantLibTimeUnitEnum;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  Quote: ResolverTypeWrapper<Quote>;
  QuoteFilterInput: QuoteFilterInput;
  QuoteInput: QuoteInput;
  QuoteTypeEnum: QuoteTypeEnum;
  RangeEnum: RangeEnum;
  ReconcileTypeEnum: ReconcileTypeEnum;
  ReconciledExposureCollateralType: ResolverTypeWrapper<ReconciledExposureCollateralType>;
  ReconciliationType: ResolverTypeWrapper<ReconciliationType>;
  RedirectLinkInfo: ResolverTypeWrapper<RedirectLinkInfo>;
  RefDataError: ResolverTypeWrapper<RefDataError>;
  RefDataFieldException: ResolverTypeWrapper<RefDataFieldException>;
  RefDataFieldExceptionsArray: ResolverTypeWrapper<RefDataFieldExceptionsArray>;
  RefDataMachine: RefDataMachine;
  ReferenceData: ResolverTypeWrapper<ReferenceData>;
  ReferenceFieldsEnum: ReferenceFieldsEnum;
  RegisterExtract: ResolverTypeWrapper<RegisterExtract>;
  RegisterExtractFilterInput: RegisterExtractFilterInput;
  RegisterExtractInput: RegisterExtractInput;
  RegisterExtractItem: ResolverTypeWrapper<RegisterExtractItem>;
  RegisterExtractItemInput: RegisterExtractItemInput;
  RemittanceInformationStructured: ResolverTypeWrapper<RemittanceInformationStructured>;
  Report: ResolverTypeWrapper<Report>;
  ReportStatusEnum: ReportStatusEnum;
  Role: ResolverTypeWrapper<Role>;
  RoleClientInfo: ResolverTypeWrapper<RoleClientInfo>;
  RoleTypeEnum: RoleTypeEnum;
  RoundTransactionInput: RoundTransactionInput;
  SCAStatus: ScaStatus;
  ScienceBasedTargetInitiativeEnum: ScienceBasedTargetInitiativeEnum;
  Screen: ResolverTypeWrapper<Screen>;
  ScreenInput: ScreenInput;
  ScreenType: ScreenType;
  SecurityLadder: ResolverTypeWrapper<SecurityLadder>;
  Selector: ResolverTypeWrapper<Selector>;
  SelectorInput: SelectorInput;
  ShareRegisterFilterInput: ShareRegisterFilterInput;
  ShareRegisterItem: ResolverTypeWrapper<ShareRegisterItem>;
  ShareRegisterUnits: ResolverTypeWrapper<ShareRegisterUnits>;
  ShareholderEngagement: ResolverTypeWrapper<ShareholderEngagement>;
  ShareholderEngagementInput: ShareholderEngagementInput;
  SigningBasketAuthorization: ResolverTypeWrapper<SigningBasketAuthorization>;
  SourceType: SourceType;
  SsiTradeType: SsiTradeType;
  StandardScreenNorm: StandardScreenNorm;
  StandardScreenPrinciple: StandardScreenPrinciple;
  StandardScreenStatus: StandardScreenStatus;
  StatusEnum: StatusEnum;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  SustainableDevelopmentGoal: SustainableDevelopmentGoal;
  SustainalyticsDataModel: ResolverTypeWrapper<SustainalyticsDataModel>;
  SustainalyticsDataModelWithStatus: ResolverTypeWrapper<SustainalyticsDataModelWithStatus>;
  SustainalyticsFieldClusterModel: ResolverTypeWrapper<SustainalyticsFieldClusterModel>;
  SustainalyticsFieldDefinitionModel: ResolverTypeWrapper<SustainalyticsFieldDefinitionModel>;
  SustainalyticsPackageModel: ResolverTypeWrapper<SustainalyticsPackageModel>;
  SustainalyticsProductModel: ResolverTypeWrapper<SustainalyticsProductModel>;
  SustainalyticsReport: ResolverTypeWrapper<SustainalyticsReport>;
  SustainalyticsReportModel: ResolverTypeWrapper<SustainalyticsReportModel>;
  SustainalyticsReportUrl: ResolverTypeWrapper<SustainalyticsReportUrl>;
  SustainalyticsSecurityListModel: ResolverTypeWrapper<SustainalyticsSecurityListModel>;
  SustainalyticsStatus: ResolverTypeWrapper<SustainalyticsStatus>;
  Swaplab2Results: ResolverTypeWrapper<Swaplab2Results>;
  SwedishFinancialAuthorityCategoryEnum: SwedishFinancialAuthorityCategoryEnum;
  Swift: ResolverTypeWrapper<Swift>;
  SwiftFilterInput: SwiftFilterInput;
  SwiftStatusEnum: SwiftStatusEnum;
  TAccount: ResolverTypeWrapper<TAccount>;
  TAccountChart: ResolverTypeWrapper<TAccountChart>;
  TAccountChart2FilterInput: TAccountChart2FilterInput;
  TAccountGroup1Enum: TAccountGroup1Enum;
  TAccountGroup2Enum: TAccountGroup2Enum;
  TAccountGroup3Enum: TAccountGroup3Enum;
  TAccountGroup4Enum: TAccountGroup4Enum;
  TAccountGroup5Enum: TAccountGroup5Enum;
  TAccountInput: TAccountInput;
  TAccountMapping: ResolverTypeWrapper<TAccountMapping>;
  TAccountMappingInput: TAccountMappingInput;
  TAccountMappingKeyValuePair: ResolverTypeWrapper<TAccountMappingKeyValuePair>;
  TAccountMappingKeyValuePairInput: TAccountMappingKeyValuePairInput;
  TAccountMappingSelector: ResolverTypeWrapper<TAccountMappingSelector>;
  TAccountMappingSelectorInput: TAccountMappingSelectorInput;
  TAccountMappingSelectorKeyEnum: TAccountMappingSelectorKeyEnum;
  TAccountMappingValue: ResolverTypeWrapper<TAccountMappingValue>;
  TAccountMappingValueInput: TAccountMappingValueInput;
  TAccountTypeEnum: TAccountTypeEnum;
  TeamPermissionAssetEnum: TeamPermissionAssetEnum;
  Ticket: ResolverTypeWrapper<Ticket>;
  TicketFilterInput: TicketFilterInput;
  TicketInput: TicketInput;
  TicketReference: ResolverTypeWrapper<TicketReference>;
  TicketReferenceInput: TicketReferenceInput;
  TicketState: ResolverTypeWrapper<TicketState>;
  TicketStateInput: TicketStateInput;
  TicketStatusEnum: TicketStatusEnum;
  TicketTypeEnum: TicketTypeEnum;
  TicketUser: ResolverTypeWrapper<TicketUser>;
  TimeSeries: ResolverTypeWrapper<TimeSeries>;
  TimeSeriesFilterInput: TimeSeriesFilterInput;
  TimeSeriesInput: TimeSeriesInput;
  TimeSeriesItem: ResolverTypeWrapper<TimeSeriesItem>;
  TimeSeriesItemInput: TimeSeriesItemInput;
  TimeSeriesStatus: TimeSeriesStatus;
  TimeSeriesUpsertInput: TimeSeriesUpsertInput;
  Timestamp: ResolverTypeWrapper<Scalars['Timestamp']['output']>;
  TimezoneEnum: TimezoneEnum;
  TppCategory: TppCategory;
  TppCode: TppCode;
  TppMessage: ResolverTypeWrapper<TppMessage>;
  TradeItemType: TradeItemType;
  TradingManagerColumn: ResolverTypeWrapper<TradingManagerColumn>;
  Transaction: ResolverTypeWrapper<Transaction>;
  TransactionFilterInput: TransactionFilterInput;
  TransactionIdentifier: TransactionIdentifier;
  TransactionItem: ResolverTypeWrapper<TransactionItem>;
  TransactionItemFilterInput: TransactionItemFilterInput;
  TransactionItemPerformanceType: TransactionItemPerformanceType;
  TransactionItemType: TransactionItemType;
  TransactionStatus: TransactionStatus;
  TransactionType: TransactionType;
  TransferAgentAccountPerformance: ResolverTypeWrapper<TransferAgentAccountPerformance>;
  TransferAgentAccountPerformanceItem: ResolverTypeWrapper<TransferAgentAccountPerformanceItem>;
  TransferAgentOrder: ResolverTypeWrapper<TransferAgentOrder>;
  TransferAgentOrderAttachmentsInput: TransferAgentOrderAttachmentsInput;
  TransferAgentOrderEnum: TransferAgentOrderEnum;
  TransferAgentOrderInput: TransferAgentOrderInput;
  TransferAgentOrderSubTypeEnum: TransferAgentOrderSubTypeEnum;
  TransferAgentTotalUnit: ResolverTypeWrapper<TransferAgentTotalUnit>;
  TransferAgentTotalUnitFilterInput: TransferAgentTotalUnitFilterInput;
  TrialInput: TrialInput;
  TrueFalseNone: TrueFalseNone;
  TwoDecimalString: ResolverTypeWrapper<Scalars['TwoDecimalString']['output']>;
  UpdateAccountingRunInput: UpdateAccountingRunInput;
  UpdateBrokerTransactionInput: UpdateBrokerTransactionInput;
  UpdateCurveDefinitionInput: UpdateCurveDefinitionInput;
  UpdateExternalNumberInput: UpdateExternalNumberInput;
  UpdateInstrumentInput: UpdateInstrumentInput;
  UpdateJournalEntry2Input: UpdateJournalEntry2Input;
  UpdateJournalEntryInput: UpdateJournalEntryInput;
  UpdateMiniTransactionInput: UpdateMiniTransactionInput;
  UpdatePartyInput: UpdatePartyInput;
  UpdateReportInput: UpdateReportInput;
  UpdateRoleInput: UpdateRoleInput;
  UpdateTAccountChartInput: UpdateTAccountChartInput;
  UpdateTransactionInput: UpdateTransactionInput;
  UpdateTransactionItemInput: UpdateTransactionItemInput;
  UpdateUserInput: UpdateUserInput;
  UpsertAccountingRunInput: UpsertAccountingRunInput;
  UpsertTAccount: ResolverTypeWrapper<UpsertTAccount>;
  UpsertTAccountChart: ResolverTypeWrapper<UpsertTAccountChart>;
  UpsertTAccountChartInput: UpsertTAccountChartInput;
  UpsertTAccountInput: UpsertTAccountInput;
  UpsertTAccountMapping: ResolverTypeWrapper<UpsertTAccountMapping>;
  UpsertTAccountMappingInput: UpsertTAccountMappingInput;
  UpsertTAccountMappingSelector: ResolverTypeWrapper<UpsertTAccountMappingSelector>;
  UpsertTAccountMappingSelectorInput: UpsertTAccountMappingSelectorInput;
  UriPartString: ResolverTypeWrapper<Scalars['UriPartString']['output']>;
  UseOfProceed: UseOfProceed;
  User: ResolverTypeWrapper<User>;
  UserFilterInput: UserFilterInput;
  UserInfo: ResolverTypeWrapper<UserInfo>;
  UserLimited: ResolverTypeWrapper<UserLimited>;
  UserLogin: ResolverTypeWrapper<UserLogin>;
  UserLoginInput: UserLoginInput;
  UserStatusEnum: UserStatusEnum;
  Valuation: ResolverTypeWrapper<Valuation>;
  ValuationMapping: ResolverTypeWrapper<ValuationMapping>;
  ValuationMappingFilterInput: ValuationMappingFilterInput;
  ValuationMappingInput: ValuationMappingInput;
  ValuationMappingStatus: ValuationMappingStatus;
  ValuationPrice: ResolverTypeWrapper<ValuationPrice>;
  ValuationPriceInput: ValuationPriceInput;
  ValuationRecord: ResolverTypeWrapper<ValuationRecord>;
  YieldDeltaBucket: ResolverTypeWrapper<YieldDeltaBucket>;
  permissionTypeEnum: PermissionTypeEnum;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AcceptTermsInput: AcceptTermsInput;
  AccountSwitchAllInput: AccountSwitchAllInput;
  AccountingRun: AccountingRun;
  AccountingRun2: AccountingRun2;
  AccountingRun2FilterInput: AccountingRun2FilterInput;
  AccountingTransaction: AccountingTransaction;
  AccountingTransaction2: AccountingTransaction2;
  AccountingTransaction2Input: AccountingTransaction2Input;
  AccountingTransactionInput: AccountingTransactionInput;
  Agreement: Agreement;
  AgreementFilterInput: AgreementFilterInput;
  AgreementInput: AgreementInput;
  Alias: Alias;
  AliasInput: AliasInput;
  AmountData: AmountData;
  AmountDataInput: AmountDataInput;
  AnnualReportType: AnnualReportType;
  ApprovedInfo: ApprovedInfo;
  ApprovedInfoInput: ApprovedInfoInput;
  Attachment: Attachment;
  AttachmentInput: AttachmentInput;
  BIC: Scalars['BIC']['output'];
  BankAccountBalance: BankAccountBalance;
  BankAccountBalanceFilterInput: BankAccountBalanceFilterInput;
  BankAccountTransaction: BankAccountTransaction;
  BankAccountTransactionFilterInput: BankAccountTransactionFilterInput;
  BankAccountTransactionInput: BankAccountTransactionInput;
  BaseCalendar: BaseCalendar;
  BaseCalendarEvent: BaseCalendarEvent;
  BaseCalendarEventInput: BaseCalendarEventInput;
  BaseCalendarFilterInput: BaseCalendarFilterInput;
  BaseCalendarInput: BaseCalendarInput;
  Benchmark: Benchmark;
  BenchmarkInput: BenchmarkInput;
  BeneficialOwner: BeneficialOwner;
  BeneficialOwnerInput: BeneficialOwnerInput;
  Boolean: Scalars['Boolean']['output'];
  BrokerTransaction: BrokerTransaction;
  BrokerTransactionFilterInput: BrokerTransactionFilterInput;
  Calendar: Calendar;
  CalendarEvent: CalendarEvent;
  CashAccountBalance: CashAccountBalance;
  CashAccountLadder: CashAccountLadder;
  CashBalance: CashBalance;
  ChangePasswordInput: ChangePasswordInput;
  ClientForAsset: ClientForAsset;
  ClientInfo: ClientInfo;
  CorporateAction: CorporateAction;
  CorporateActionFilterInput: CorporateActionFilterInput;
  CorporateActionInput: CorporateActionInput;
  Cost: Cost;
  CostFilterInput: CostFilterInput;
  CostInput: CostInput;
  CreateAccountingRunInput: CreateAccountingRunInput;
  CreateAttachmentInput: CreateAttachmentInput;
  CreateCurveDefinitionInput: CreateCurveDefinitionInput;
  CreateInstrumentInput: CreateInstrumentInput;
  CreateJournalEntry2Input: CreateJournalEntry2Input;
  CreateJournalEntryInput: CreateJournalEntryInput;
  CreateMiniTransactionInput: CreateMiniTransactionInput;
  CreatePartyInput: CreatePartyInput;
  CreateReportInput: CreateReportInput;
  CreateRoleInput: CreateRoleInput;
  CreateSwiftInput: CreateSwiftInput;
  CreateTAccountChartInput: CreateTAccountChartInput;
  CreateTransactionInput: CreateTransactionInput;
  CreateTransactionItemInput: CreateTransactionItemInput;
  CreateUpdateCashInstrumentInput: CreateUpdateCashInstrumentInput;
  CreateUpdateExternalAccountInput: CreateUpdateExternalAccountInput;
  CreateUpdatePartyCashOrBalanceInstrumentInput: CreateUpdatePartyCashOrBalanceInstrumentInput;
  CreateUserInput: CreateUserInput;
  CreateValuationInput: CreateValuationInput;
  CreditRatingInput: CreditRatingInput;
  CreditStatus: CreditStatus;
  CreditStatusType: CreditStatusType;
  CurveDefinition: CurveDefinition;
  CurveDefinitionDefinition: CurveDefinitionDefinition;
  CurveDefinitionDefinitionInput: CurveDefinitionDefinitionInput;
  CurveDefinitionInstrument: CurveDefinitionInstrument;
  CurveDefinitionInstrumentInput: CurveDefinitionInstrumentInput;
  CustodianApiPosition: CustodianApiPosition;
  CustodianApiPositionInput: CustodianApiPositionInput;
  CustodianPosition: CustodianPosition;
  Customer: Customer;
  CustomerFilterInput: CustomerFilterInput;
  CustomerInput: CustomerInput;
  DartBasic: DartBasic;
  DartHolding: DartHolding;
  DartReport: DartReport;
  DartTransaction: DartTransaction;
  Date: Scalars['Date']['output'];
  DateQuote: DateQuote;
  DateStringOrTimestamp: Scalars['DateStringOrTimestamp']['output'];
  DateValue: DateValue;
  DecimalString: Scalars['DecimalString']['output'];
  DefaultCashInstrument: DefaultCashInstrument;
  DefaultCashInstrumentInput: DefaultCashInstrumentInput;
  EmailAddress: Scalars['EmailAddress']['output'];
  EsgComment: EsgComment;
  EsgCommentInput: EsgCommentInput;
  EventInfo: EventInfo;
  ExposureCollateral: ExposureCollateral;
  ExposureCollateralInput: ExposureCollateralInput;
  Extension: Extension;
  ExtensionInput: ExtensionInput;
  ExtensionsFilterInput: ExtensionsFilterInput;
  FieldDataItem: FieldDataItem;
  FilterInput: FilterInput;
  Float: Scalars['Float']['output'];
  FredObservation: FredObservation;
  FredQueryArgs: FredQueryArgs;
  FredSeries: FredSeries;
  FundPerformance: FundPerformance;
  FundPortfolioPerformance: FundPortfolioPerformance;
  FundUnit: FundUnit;
  FundUnitReconciliationType: FundUnitReconciliationType;
  FxValuation: FxValuation;
  GlobalStandardScreen: GlobalStandardScreen;
  GlobalStandardScreenInput: GlobalStandardScreenInput;
  GraphQLCreditRating: Scalars['GraphQLCreditRating']['output'];
  GraphQLDateString: Scalars['GraphQLDateString']['output'];
  GraphQLLei: Scalars['GraphQLLei']['output'];
  GraphQLObjectId: Scalars['GraphQLObjectId']['output'];
  GraphQLPatchInstrumentDate: Scalars['GraphQLPatchInstrumentDate']['output'];
  GraphQLSwedenDate: Scalars['GraphQLSwedenDate']['output'];
  GraphQLSwedishLegalNumber: Scalars['GraphQLSwedishLegalNumber']['output'];
  HistoricalData: HistoricalData;
  IBAN: Scalars['IBAN']['output'];
  ISIN: Scalars['ISIN']['output'];
  ImportBondTradeInput: ImportBondTradeInput;
  ImportCloseDerivativeTradeInput: ImportCloseDerivativeTradeInput;
  ImportCollateralInput: ImportCollateralInput;
  ImportCouponInput: ImportCouponInput;
  ImportCreateRedeemInput: ImportCreateRedeemInput;
  ImportDerivativeTradeInput: ImportDerivativeTradeInput;
  ImportDividendInput: ImportDividendInput;
  ImportExpiryDerivativeTradeInput: ImportExpiryDerivativeTradeInput;
  ImportFeeInterestInput: ImportFeeInterestInput;
  ImportFundTradeInput: ImportFundTradeInput;
  ImportFxSpotInput: ImportFxSpotInput;
  ImportInsertCashInput: ImportInsertCashInput;
  ImportInsertDerivativeTradeInput: ImportInsertDerivativeTradeInput;
  ImportInsertSecurityInput: ImportInsertSecurityInput;
  ImportStockTradeInput: ImportStockTradeInput;
  ImportTransferInput: ImportTransferInput;
  Instrument: Instrument;
  InstrumentAccountPosition: InstrumentAccountPosition;
  InstrumentFilterInput: InstrumentFilterInput;
  InstrumentModel: InstrumentModel;
  InstrumentModelInput: InstrumentModelInput;
  InstrumentModelLegsItem: InstrumentModelLegsItem;
  InstrumentModelLegsItemCashFlowsItem: InstrumentModelLegsItemCashFlowsItem;
  InstrumentModelLegsItemCashFlowsItemFixingsItem: InstrumentModelLegsItemCashFlowsItemFixingsItem;
  InstrumentModelLegsItemCashFlowsItemFixingsItemInput: InstrumentModelLegsItemCashFlowsItemFixingsItemInput;
  InstrumentModelLegsItemCashFlowsItemInput: InstrumentModelLegsItemCashFlowsItemInput;
  InstrumentModelLegsItemInput: InstrumentModelLegsItemInput;
  InstrumentModelLegsItemUnderlyingsItem: InstrumentModelLegsItemUnderlyingsItem;
  InstrumentModelLegsItemUnderlyingsItemInput: InstrumentModelLegsItemUnderlyingsItemInput;
  InstrumentPerformance: InstrumentPerformance;
  InstrumentPosition: InstrumentPosition;
  InstrumentSelector: InstrumentSelector;
  InstrumentSelectorInput: InstrumentSelectorInput;
  InstrumentValuation: InstrumentValuation;
  Int: Scalars['Int']['output'];
  Inventory: Inventory;
  IssuerProgram: IssuerProgram;
  IssuerProgramInput: IssuerProgramInput;
  IssuerProgramsFilterInput: IssuerProgramsFilterInput;
  JSON: Scalars['JSON']['output'];
  JSONObject: Scalars['JSONObject']['output'];
  JournalEntry: JournalEntry;
  JournalEntry2: JournalEntry2;
  JournalEntryInput: JournalEntryInput;
  KleerAccountMetadata: KleerAccountMetadata;
  KleerAccountingYear: KleerAccountingYear;
  KleerAmount: KleerAmount;
  KleerCompanyInfo: KleerCompanyInfo;
  KleerIdRef: KleerIdRef;
  KleerPeriod: KleerPeriod;
  KleerRevenue: KleerRevenue;
  KleerRevenueLedger: KleerRevenueLedger;
  KleerRevenueRow: KleerRevenueRow;
  KleerVoucher: KleerVoucher;
  KleerVoucherTransaction: KleerVoucherTransaction;
  LimitData: LimitData;
  LimitedUserFilterInput: LimitedUserFilterInput;
  MarginRequirement: MarginRequirement;
  MatchBankAccountTransactionsInput: MatchBankAccountTransactionsInput;
  MatchCoacsTransactionsInput: MatchCoacsTransactionsInput;
  MatchTransactionsInput: MatchTransactionsInput;
  MatchedBankAccountTransaction: MatchedBankAccountTransaction;
  MatchedCoacsTransaction: MatchedCoacsTransaction;
  MatchedTransaction: MatchedTransaction;
  Max35CharString: Scalars['Max35CharString']['output'];
  Max140CharString: Scalars['Max140CharString']['output'];
  Me: Me;
  Min1Max70CharString: Scalars['Min1Max70CharString']['output'];
  MiniTransaction: MiniTransaction;
  ModelIndexBenchmark: ModelIndexBenchmark;
  ModelIndexBenchmarkInput: ModelIndexBenchmarkInput;
  Mutation: Record<PropertyKey, never>;
  NameAndId: NameAndId;
  Nav: Nav;
  NavData: NavData;
  NavDataInput: NavDataInput;
  NavFundClass: NavFundClass;
  NavFundClassInput: NavFundClassInput;
  NavInput: NavInput;
  NavOrder: NavOrder;
  NavOrderInput: NavOrderInput;
  NavPosition: NavPosition;
  NavPositionInput: NavPositionInput;
  NavTransaction: NavTransaction;
  NavTransactionInput: NavTransactionInput;
  Note: Note;
  NoteFilterInput: NoteFilterInput;
  NoteInput: NoteInput;
  NoteReference: NoteReference;
  NoteReferenceInput: NoteReferenceInput;
  NoteTag: NoteTag;
  NoteTagFilter: NoteTagFilter;
  NoteTagInput: NoteTagInput;
  OPAccess: OpAccess;
  OPAccessItem: OpAccessItem;
  OPAccessItemInput: OpAccessItemInput;
  OPConsent: OpConsent;
  OPConsentFilter: OpConsentFilter;
  OPPayment: OpPayment;
  OPPaymentFilter: OpPaymentFilter;
  OPPaymentInput: OpPaymentInput;
  OPSigningBasketData: OpSigningBasketData;
  OpenPaymentLink: OpenPaymentLink;
  OpenPaymentLinkData: OpenPaymentLinkData;
  OrderFilterInput: OrderFilterInput;
  Party: Party;
  PartyAccount: PartyAccount;
  PartyAccountInput: PartyAccountInput;
  PartyAccountWeight: PartyAccountWeight;
  PartyAccountWeightInput: PartyAccountWeightInput;
  PartyBaseInput: PartyBaseInput;
  PartyBenchmark: PartyBenchmark;
  PartyBenchmarkInput: PartyBenchmarkInput;
  PartyCreditRating: PartyCreditRating;
  PartyEsg: PartyEsg;
  PartyEsgInput: PartyEsgInput;
  PartyExternalAccount: PartyExternalAccount;
  PartyExternalAccountInput: PartyExternalAccountInput;
  PartyFilterInput: PartyFilterInput;
  PartyFundInfo: PartyFundInfo;
  PartyFundInfoClass: PartyFundInfoClass;
  PartyFundInfoClassInput: PartyFundInfoClassInput;
  PartyFundInfoInput: PartyFundInfoInput;
  PartyInfo: PartyInfo;
  PartyIssuerInput: PartyIssuerInput;
  PartyIssuerType: PartyIssuerType;
  PartyStandardSettlementInstruction: PartyStandardSettlementInstruction;
  PartyStandardSettlementInstructionInput: PartyStandardSettlementInstructionInput;
  PerformanceFilterInput: PerformanceFilterInput;
  PortfolioPerformance: PortfolioPerformance;
  PortfolioPerformanceItem: PortfolioPerformanceItem;
  PortfolioSwapItemValuation: PortfolioSwapItemValuation;
  PortfolioSwapItemValue: PortfolioSwapItemValue;
  PortfolioSwapItemsPosition: PortfolioSwapItemsPosition;
  Position: Position;
  PositionFilter: PositionFilter;
  Price: Price;
  PriceFilterInput: PriceFilterInput;
  PriceInput: PriceInput;
  ProductInvolvement: ProductInvolvement;
  ProductInvolvementInput: ProductInvolvementInput;
  PublishedToInput: PublishedToInput;
  PublishedToType: PublishedToType;
  QuantLibPeriod: QuantLibPeriod;
  Query: Record<PropertyKey, never>;
  Quote: Quote;
  QuoteFilterInput: QuoteFilterInput;
  QuoteInput: QuoteInput;
  ReconciledExposureCollateralType: ReconciledExposureCollateralType;
  ReconciliationType: ReconciliationType;
  RedirectLinkInfo: RedirectLinkInfo;
  RefDataError: RefDataError;
  RefDataFieldException: RefDataFieldException;
  RefDataFieldExceptionsArray: RefDataFieldExceptionsArray;
  ReferenceData: ReferenceData;
  RegisterExtract: RegisterExtract;
  RegisterExtractFilterInput: RegisterExtractFilterInput;
  RegisterExtractInput: RegisterExtractInput;
  RegisterExtractItem: RegisterExtractItem;
  RegisterExtractItemInput: RegisterExtractItemInput;
  RemittanceInformationStructured: RemittanceInformationStructured;
  Report: Report;
  Role: Role;
  RoleClientInfo: RoleClientInfo;
  RoundTransactionInput: RoundTransactionInput;
  Screen: Screen;
  ScreenInput: ScreenInput;
  SecurityLadder: SecurityLadder;
  Selector: Selector;
  SelectorInput: SelectorInput;
  ShareRegisterFilterInput: ShareRegisterFilterInput;
  ShareRegisterItem: ShareRegisterItem;
  ShareRegisterUnits: ShareRegisterUnits;
  ShareholderEngagement: ShareholderEngagement;
  ShareholderEngagementInput: ShareholderEngagementInput;
  SigningBasketAuthorization: SigningBasketAuthorization;
  String: Scalars['String']['output'];
  SustainalyticsDataModel: SustainalyticsDataModel;
  SustainalyticsDataModelWithStatus: SustainalyticsDataModelWithStatus;
  SustainalyticsFieldClusterModel: SustainalyticsFieldClusterModel;
  SustainalyticsFieldDefinitionModel: SustainalyticsFieldDefinitionModel;
  SustainalyticsPackageModel: SustainalyticsPackageModel;
  SustainalyticsProductModel: SustainalyticsProductModel;
  SustainalyticsReport: SustainalyticsReport;
  SustainalyticsReportModel: SustainalyticsReportModel;
  SustainalyticsReportUrl: SustainalyticsReportUrl;
  SustainalyticsSecurityListModel: SustainalyticsSecurityListModel;
  SustainalyticsStatus: SustainalyticsStatus;
  Swaplab2Results: Swaplab2Results;
  Swift: Swift;
  SwiftFilterInput: SwiftFilterInput;
  TAccount: TAccount;
  TAccountChart: TAccountChart;
  TAccountChart2FilterInput: TAccountChart2FilterInput;
  TAccountInput: TAccountInput;
  TAccountMapping: TAccountMapping;
  TAccountMappingInput: TAccountMappingInput;
  TAccountMappingKeyValuePair: TAccountMappingKeyValuePair;
  TAccountMappingKeyValuePairInput: TAccountMappingKeyValuePairInput;
  TAccountMappingSelector: TAccountMappingSelector;
  TAccountMappingSelectorInput: TAccountMappingSelectorInput;
  TAccountMappingValue: TAccountMappingValue;
  TAccountMappingValueInput: TAccountMappingValueInput;
  Ticket: Ticket;
  TicketFilterInput: TicketFilterInput;
  TicketInput: TicketInput;
  TicketReference: TicketReference;
  TicketReferenceInput: TicketReferenceInput;
  TicketState: TicketState;
  TicketStateInput: TicketStateInput;
  TicketUser: TicketUser;
  TimeSeries: TimeSeries;
  TimeSeriesFilterInput: TimeSeriesFilterInput;
  TimeSeriesInput: TimeSeriesInput;
  TimeSeriesItem: TimeSeriesItem;
  TimeSeriesItemInput: TimeSeriesItemInput;
  TimeSeriesUpsertInput: TimeSeriesUpsertInput;
  Timestamp: Scalars['Timestamp']['output'];
  TppMessage: TppMessage;
  TradingManagerColumn: TradingManagerColumn;
  Transaction: Transaction;
  TransactionFilterInput: TransactionFilterInput;
  TransactionIdentifier: TransactionIdentifier;
  TransactionItem: TransactionItem;
  TransactionItemFilterInput: TransactionItemFilterInput;
  TransferAgentAccountPerformance: TransferAgentAccountPerformance;
  TransferAgentAccountPerformanceItem: TransferAgentAccountPerformanceItem;
  TransferAgentOrder: TransferAgentOrder;
  TransferAgentOrderAttachmentsInput: TransferAgentOrderAttachmentsInput;
  TransferAgentOrderInput: TransferAgentOrderInput;
  TransferAgentTotalUnit: TransferAgentTotalUnit;
  TransferAgentTotalUnitFilterInput: TransferAgentTotalUnitFilterInput;
  TrialInput: TrialInput;
  TwoDecimalString: Scalars['TwoDecimalString']['output'];
  UpdateAccountingRunInput: UpdateAccountingRunInput;
  UpdateBrokerTransactionInput: UpdateBrokerTransactionInput;
  UpdateCurveDefinitionInput: UpdateCurveDefinitionInput;
  UpdateExternalNumberInput: UpdateExternalNumberInput;
  UpdateInstrumentInput: UpdateInstrumentInput;
  UpdateJournalEntry2Input: UpdateJournalEntry2Input;
  UpdateJournalEntryInput: UpdateJournalEntryInput;
  UpdateMiniTransactionInput: UpdateMiniTransactionInput;
  UpdatePartyInput: UpdatePartyInput;
  UpdateReportInput: UpdateReportInput;
  UpdateRoleInput: UpdateRoleInput;
  UpdateTAccountChartInput: UpdateTAccountChartInput;
  UpdateTransactionInput: UpdateTransactionInput;
  UpdateTransactionItemInput: UpdateTransactionItemInput;
  UpdateUserInput: UpdateUserInput;
  UpsertAccountingRunInput: UpsertAccountingRunInput;
  UpsertTAccount: UpsertTAccount;
  UpsertTAccountChart: UpsertTAccountChart;
  UpsertTAccountChartInput: UpsertTAccountChartInput;
  UpsertTAccountInput: UpsertTAccountInput;
  UpsertTAccountMapping: UpsertTAccountMapping;
  UpsertTAccountMappingInput: UpsertTAccountMappingInput;
  UpsertTAccountMappingSelector: UpsertTAccountMappingSelector;
  UpsertTAccountMappingSelectorInput: UpsertTAccountMappingSelectorInput;
  UriPartString: Scalars['UriPartString']['output'];
  User: User;
  UserFilterInput: UserFilterInput;
  UserInfo: UserInfo;
  UserLimited: UserLimited;
  UserLogin: UserLogin;
  UserLoginInput: UserLoginInput;
  Valuation: Valuation;
  ValuationMapping: ValuationMapping;
  ValuationMappingFilterInput: ValuationMappingFilterInput;
  ValuationMappingInput: ValuationMappingInput;
  ValuationPrice: ValuationPrice;
  ValuationPriceInput: ValuationPriceInput;
  ValuationRecord: ValuationRecord;
  YieldDeltaBucket: YieldDeltaBucket;
};

export type HasReadPermissionDirectiveArgs = {
  asset: Scalars['String']['input'];
  nullIfNoAccess?: Maybe<Scalars['Boolean']['input']>;
};

export type HasReadPermissionDirectiveResolver<Result, Parent, ContextType = ResolverContextType, Args = HasReadPermissionDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type HasTypeReadPermissionDirectiveArgs = {
  asset: Scalars['String']['input'];
};

export type HasTypeReadPermissionDirectiveResolver<Result, Parent, ContextType = ResolverContextType, Args = HasTypeReadPermissionDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type HasWritePermissionDirectiveArgs = {
  asset: Scalars['String']['input'];
};

export type HasWritePermissionDirectiveResolver<Result, Parent, ContextType = ResolverContextType, Args = HasWritePermissionDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AccountingRunResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['AccountingRun'] = ResolversParentTypes['AccountingRun']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  accountingPeriod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  clientTAccountChart?: Resolver<Maybe<ResolversTypes['TAccountChart']>, ParentType, ContextType>;
  clientTAccountChartId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  createTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  createUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  journalEntries?: Resolver<Maybe<Array<Maybe<ResolversTypes['JournalEntry']>>>, ParentType, ContextType>;
  masterTAccountChart?: Resolver<Maybe<ResolversTypes['TAccountChart']>, ParentType, ContextType>;
  masterTAccountChartId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  roundingDecimals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AccountingRunStatusEnum'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AccountingRunTypeEnum'], ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
};

export type AccountingRun2Resolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['AccountingRun2'] = ResolversParentTypes['AccountingRun2']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  accountingPeriod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  clientTAccountChart?: Resolver<Maybe<ResolversTypes['UpsertTAccountChart']>, ParentType, ContextType>;
  clientTAccountChartId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  createTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  createUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  journalEntries?: Resolver<Maybe<Array<ResolversTypes['JournalEntry2']>>, ParentType, ContextType>;
  keepManualJournalEntries?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AccountingRunStatusEnum'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AccountingRunTypeEnum'], ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
};

export type AccountingTransactionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['AccountingTransaction'] = ResolversParentTypes['AccountingTransaction']> = {
  accountingAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  localAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tAccountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['AccountingTransactionType']>, ParentType, ContextType>;
  valueDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
};

export type AccountingTransaction2Resolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['AccountingTransaction2'] = ResolversParentTypes['AccountingTransaction2']> = {
  accountingAmount?: Resolver<Maybe<ResolversTypes['DecimalString']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['DecimalString']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  localAmount?: Resolver<Maybe<ResolversTypes['DecimalString']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['DecimalString']>, ParentType, ContextType>;
  tAccountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['AccountingTransactionType']>, ParentType, ContextType>;
  valueDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
};

export type AgreementResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Agreement'] = ResolversParentTypes['Agreement']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  approvedInfo?: Resolver<Maybe<Array<ResolversTypes['ApprovedInfo']>>, ParentType, ContextType>;
  attachments?: Resolver<Array<Maybe<ResolversTypes['Attachment']>>, ParentType, ContextType>;
  client?: Resolver<ResolversTypes['PartyInfo'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  counterParties?: Resolver<Array<ResolversTypes['PartyInfo']>, ParentType, ContextType>;
  counterPartyIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parties?: Resolver<Maybe<Array<Maybe<ResolversTypes['PartyInfo']>>>, ParentType, ContextType>;
  partyIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['AgreementStatusEnum'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AgreementTypeEnum'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  updateUserInfo?: Resolver<ResolversTypes['UserInfo'], ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type AliasResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Alias'] = ResolversParentTypes['Alias']> = {
  collection?: Resolver<ResolversTypes['CollectionNameEnum'], ParentType, ContextType>;
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  documentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AmountDataResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['AmountData'] = ResolversParentTypes['AmountData']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AnnualReportTypeResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['AnnualReportType'] = ResolversParentTypes['AnnualReportType']> = {
  balanceSheet?: Resolver<Array<Maybe<Array<Maybe<ResolversTypes['String']>>>>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  derivativesSecurities?: Resolver<Array<Maybe<Array<Maybe<ResolversTypes['String']>>>>, ParentType, ContextType>;
  equityChange?: Resolver<Array<Maybe<Array<Maybe<ResolversTypes['String']>>>>, ParentType, ContextType>;
  fundFigures?: Resolver<Maybe<Array<Maybe<Array<Maybe<ResolversTypes['String']>>>>>, ParentType, ContextType>;
  issuers?: Resolver<Array<Maybe<Array<Maybe<ResolversTypes['String']>>>>, ParentType, ContextType>;
  keyFigures?: Resolver<Array<Maybe<Array<Maybe<ResolversTypes['String']>>>>, ParentType, ContextType>;
  positions?: Resolver<Array<Maybe<Array<Maybe<ResolversTypes['String']>>>>, ParentType, ContextType>;
  ratings?: Resolver<Array<Maybe<Array<Maybe<ResolversTypes['String']>>>>, ParentType, ContextType>;
  resultSheet?: Resolver<Array<Maybe<Array<Maybe<ResolversTypes['String']>>>>, ParentType, ContextType>;
};

export type ApprovedInfoResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['ApprovedInfo'] = ResolversParentTypes['ApprovedInfo']> = {
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ApprovedStatusEnum'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
};

export type AttachmentResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Attachment'] = ResolversParentTypes['Attachment']> = {
  base64?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  fileId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  fileName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mD5?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mimeType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
};

export interface BicScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BIC'], any> {
  name: 'BIC';
}

export type BankAccountBalanceResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['BankAccountBalance'] = ResolversParentTypes['BankAccountBalance']> = {
  balance?: Resolver<ResolversTypes['TwoDecimalString'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
};

export type BankAccountTransactionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['BankAccountTransaction'] = ResolversParentTypes['BankAccountTransaction']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  additionalInformation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['TwoDecimalString'], ParentType, ContextType>;
  balance?: Resolver<ResolversTypes['TwoDecimalString'], ParentType, ContextType>;
  client?: Resolver<ResolversTypes['PartyInfo'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  other?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BankAccountTransactionStatusEnum'], ParentType, ContextType>;
  transactionItemIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  transactionItems?: Resolver<Array<ResolversTypes['TransactionItem']>, ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type BaseCalendarResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['BaseCalendar'] = ResolversParentTypes['BaseCalendar']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  baseEvents?: Resolver<Array<ResolversTypes['BaseCalendarEvent']>, ParentType, ContextType>;
  clientIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  clients?: Resolver<Array<ResolversTypes['PartyInfo']>, ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isBusinessDay?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<BaseCalendarIsBusinessDayArgs, 'date'>>;
  isEarlyClose?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<BaseCalendarIsEarlyCloseArgs, 'date'>>;
  name?: Resolver<ResolversTypes['CalendarNameEnum'], ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CalendarStatusEnum'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  year?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type BaseCalendarEventResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['BaseCalendarEvent'] = ResolversParentTypes['BaseCalendarEvent']> = {
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  event?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['CalendarStateEnum'], ParentType, ContextType>;
};

export type BenchmarkResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Benchmark'] = ResolversParentTypes['Benchmark']> = {
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  offset?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type BeneficialOwnerResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['BeneficialOwner'] = ResolversParentTypes['BeneficialOwner']> = {
  _id?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type BrokerTransactionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['BrokerTransaction'] = ResolversParentTypes['BrokerTransaction']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  broker?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  commission?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  correspondingTransactionId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  createTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  isin?: Resolver<ResolversTypes['ISIN'], ParentType, ContextType>;
  mic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reportId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  settlementAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  stampDuty?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['BrokerTransactionStatus']>, ParentType, ContextType>;
  tradeCurrency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  tradeDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BrokerTransactionType'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  valueDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type CalendarResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Calendar'] = ResolversParentTypes['Calendar']> = {
  calendarEvents?: Resolver<Maybe<Array<ResolversTypes['CalendarEvent']>>, ParentType, ContextType>;
  isBusinessDay?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<CalendarIsBusinessDayArgs, 'date'>>;
  isEarlyClose?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<CalendarIsEarlyCloseArgs, 'date'>>;
  names?: Resolver<Maybe<Array<ResolversTypes['CalendarNameEnum']>>, ParentType, ContextType>;
};

export type CalendarEventResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['CalendarEvent'] = ResolversParentTypes['CalendarEvent']> = {
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  events?: Resolver<Array<ResolversTypes['EventInfo']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['CalendarStateEnum'], ParentType, ContextType>;
};

export type CashAccountBalanceResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['CashAccountBalance'] = ResolversParentTypes['CashAccountBalance']> = {
  balanceItems?: Resolver<Array<ResolversTypes['CashBalance']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
};

export type CashAccountLadderResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['CashAccountLadder'] = ResolversParentTypes['CashAccountLadder']> = {
  amounts?: Resolver<Array<ResolversTypes['Float']>, ParentType, ContextType>;
  balances?: Resolver<Array<ResolversTypes['Float']>, ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  dates?: Resolver<Array<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
};

export type CashBalanceResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['CashBalance'] = ResolversParentTypes['CashBalance']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  balance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tradeDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  transaction?: Resolver<Maybe<ResolversTypes['Transaction']>, ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  transactionItem?: Resolver<Maybe<ResolversTypes['TransactionItem']>, ParentType, ContextType>;
  transactionItemId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  valueDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
};

export type ClientForAssetResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['ClientForAsset'] = ResolversParentTypes['ClientForAsset']> = {
  asset?: Resolver<ResolversTypes['PermissionAssetEnum'], ParentType, ContextType>;
  clients?: Resolver<Array<ResolversTypes['ClientInfo']>, ParentType, ContextType>;
};

export type ClientInfoResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['ClientInfo'] = ResolversParentTypes['ClientInfo']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CorporateActionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['CorporateAction'] = ResolversParentTypes['CorporateAction']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  corporateActionEvent?: Resolver<ResolversTypes['CorporateActionEvent'], ParentType, ContextType>;
  correspondingTransaction?: Resolver<Maybe<ResolversTypes['Transaction']>, ParentType, ContextType>;
  correspondingTransactionId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  foreignTax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  messageType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  recordDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  reportIds?: Resolver<Maybe<Array<ResolversTypes['GraphQLObjectId']>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CorporateActionStatusEnum'], ParentType, ContextType>;
  swift?: Resolver<Maybe<ResolversTypes['Swift']>, ParentType, ContextType>;
  swiftId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type CostResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Cost'] = ResolversParentTypes['Cost']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<ResolversTypes['Attachment']>>, ParentType, ContextType>;
  client?: Resolver<ResolversTypes['PartyInfo'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  creator?: Resolver<ResolversTypes['UserInfo'], ParentType, ContextType>;
  creatorId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  debtorIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  debtors?: Resolver<Array<ResolversTypes['PartyInfo']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CostStatusEnum'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type CreditStatusTypeResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['CreditStatusType'] = ResolversParentTypes['CreditStatusType']> = {
  pariPassu?: Resolver<ResolversTypes['TrueFalseNone'], ParentType, ContextType>;
  secured?: Resolver<ResolversTypes['TrueFalseNone'], ParentType, ContextType>;
  senior?: Resolver<ResolversTypes['TrueFalseNone'], ParentType, ContextType>;
};

export type CurveDefinitionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['CurveDefinition'] = ResolversParentTypes['CurveDefinition']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  client?: Resolver<ResolversTypes['PartyInfo'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  definition?: Resolver<Maybe<ResolversTypes['CurveDefinitionDefinition']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CurveDefinitionType'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type CurveDefinitionDefinitionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['CurveDefinitionDefinition'] = ResolversParentTypes['CurveDefinitionDefinition']> = {
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  dayCount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  forwardPeriod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  instruments?: Resolver<Array<ResolversTypes['CurveDefinitionInstrument']>, ParentType, ContextType>;
  issuerProgram?: Resolver<Maybe<ResolversTypes['IssuerProgram']>, ParentType, ContextType>;
  issuerProgramId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CurveDefinitionType2'], ParentType, ContextType>;
};

export type CurveDefinitionInstrumentResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['CurveDefinitionInstrument'] = ResolversParentTypes['CurveDefinitionInstrument']> = {
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
};

export type CustodianApiPositionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['CustodianApiPosition'] = ResolversParentTypes['CustodianApiPosition']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  attachments?: Resolver<Array<ResolversTypes['Attachment']>, ParentType, ContextType>;
  cashAccountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  client?: Resolver<ResolversTypes['PartyInfo'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  createTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  custodian?: Resolver<ResolversTypes['PartyInfo'], ParentType, ContextType>;
  custodianId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  externalAccount?: Resolver<Maybe<ResolversTypes['PartyExternalAccount']>, ParentType, ContextType>;
  externalAccountId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  isin?: Resolver<ResolversTypes['ISIN'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['StatusEnum'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['CustodianPositionType'], ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type CustodianPositionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['CustodianPosition'] = ResolversParentTypes['CustodianPosition']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  custodianAccountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  isin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type CustomerResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Customer'] = ResolversParentTypes['Customer']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientAccount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientAccountLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  clientNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clients?: Resolver<Array<ResolversTypes['PartyInfo']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emails?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  swedishFinancialAuthorityCategory?: Resolver<ResolversTypes['SwedishFinancialAuthorityCategoryEnum'], ParentType, ContextType>;
  swedishFinancialAuthorityCategoryString?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
};

export type DartBasicResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['DartBasic'] = ResolversParentTypes['DartBasic']> = {
  analysisFeeDaily?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fund?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fundFigureAttribute?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fundName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  managementFeeDaily?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  navAfterManagementFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  navBeforeManagementFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  navDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  navPerUnit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfFundUnits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  organisationNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxRestitutions?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type DartHoldingResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['DartHolding'] = ResolversParentTypes['DartHolding']> = {
  accruedInterestLocalCurrency?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  accruedInterestSek?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  balanceNominal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bloombergTicker?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cfi?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fundName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fundOrganisationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fundShort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fxRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  instrumentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instrumentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marketValueLocalCurrency?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  marketValueSek?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  navDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  priceFuture?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pricePerUnit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  priceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quotation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securityGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securityName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securityShort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tradingCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unsettledAmountIncomingLocalCurrency?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unsettledAmountIncomingSek?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unsettledAmountOutgoingLocalCurrency?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unsettledAmountOutgoingSek?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unsettledQuantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type DartReportResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['DartReport'] = ResolversParentTypes['DartReport']> = {
  basics?: Resolver<Maybe<Array<Maybe<ResolversTypes['DartBasic']>>>, ParentType, ContextType>;
  holdings?: Resolver<Maybe<Array<Maybe<ResolversTypes['DartHolding']>>>, ParentType, ContextType>;
  transactions?: Resolver<Maybe<Array<Maybe<ResolversTypes['DartTransaction']>>>, ParentType, ContextType>;
};

export type DartTransactionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['DartTransaction'] = ResolversParentTypes['DartTransaction']> = {
  cashAccount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  grossAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  investor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shareClassInternalCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shareClassName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  units?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  valuationDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  valueDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export type DateQuoteResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['DateQuote'] = ResolversParentTypes['DateQuote']> = {
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['QuoteTypeEnum'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export interface DateStringOrTimestampScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateStringOrTimestamp'], any> {
  name: 'DateStringOrTimestamp';
}

export type DateValueResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['DateValue'] = ResolversParentTypes['DateValue']> = {
  date?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export interface DecimalStringScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DecimalString'], any> {
  name: 'DecimalString';
}

export type DefaultCashInstrumentResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['DefaultCashInstrument'] = ResolversParentTypes['DefaultCashInstrument']> = {
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  partyInstrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  partyInstrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
};

export interface EmailAddressScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['EmailAddress'], any> {
  name: 'EmailAddress';
}

export type EsgCommentResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['EsgComment'] = ResolversParentTypes['EsgComment']> = {
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
};

export type EventInfoResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['EventInfo'] = ResolversParentTypes['EventInfo']> = {
  event?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['CalendarNameEnum'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['CalendarStateEnum'], ParentType, ContextType>;
};

export type ExposureCollateralResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['ExposureCollateral'] = ResolversParentTypes['ExposureCollateral']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  agreementType?: Resolver<ResolversTypes['AgreementType'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  client?: Resolver<ResolversTypes['Party'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  custodianAccountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  haircut?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentAlias?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isin?: Resolver<Maybe<ResolversTypes['ISIN']>, ParentType, ContextType>;
  marginType?: Resolver<Maybe<ResolversTypes['MarginType']>, ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reportId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['Party'], ParentType, ContextType>;
  sourceId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ExposureCollateralType'], ParentType, ContextType>;
  uniqueTransactionIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type ExtensionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Extension'] = ResolversParentTypes['Extension']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  client?: Resolver<ResolversTypes['PartyInfo'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  collection?: Resolver<ResolversTypes['CollectionNameEnum'], ParentType, ContextType>;
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  documentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DocumentStatusEnum'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  updateUserInfo?: Resolver<ResolversTypes['UserInfo'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  versions?: Resolver<Array<ResolversTypes['JSON']>, ParentType, ContextType>;
};

export type FieldDataItemResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['FieldDataItem'] = ResolversParentTypes['FieldDataItem']> = {
  field?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
};

export type FredObservationResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['FredObservation'] = ResolversParentTypes['FredObservation']> = {
  date?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  realtime_end?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  realtime_start?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type FredSeriesResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['FredSeries'] = ResolversParentTypes['FredSeries']> = {
  frequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  frequency_short?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  last_updated?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  observation_end?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  observation_start?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  popularity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  realtime_end?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  realtime_start?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  seasonal_adjustment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seasonal_adjustment_short?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  units?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  units_short?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type FundPerformanceResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['FundPerformance'] = ResolversParentTypes['FundPerformance']> = {
  cashFlows?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  dates?: Resolver<Maybe<Array<Maybe<ResolversTypes['GraphQLDateString']>>>, ParentType, ContextType>;
  endValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fund?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  fundId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  instrumentPerformances?: Resolver<Maybe<Array<Maybe<ResolversTypes['InstrumentPerformance']>>>, ParentType, ContextType>;
  performanceItems?: Resolver<Maybe<Array<Maybe<ResolversTypes['PortfolioPerformanceItem']>>>, ParentType, ContextType>;
  series?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  values?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
};

export type FundPortfolioPerformanceResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['FundPortfolioPerformance'] = ResolversParentTypes['FundPortfolioPerformance']> = {
  cashFlows?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  dates?: Resolver<Maybe<Array<Maybe<ResolversTypes['GraphQLDateString']>>>, ParentType, ContextType>;
  endValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fundPerformances?: Resolver<Maybe<Array<Maybe<ResolversTypes['FundPerformance']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  instrumentPerformances?: Resolver<Maybe<Array<Maybe<ResolversTypes['InstrumentPerformance']>>>, ParentType, ContextType>;
  performanceItems?: Resolver<Maybe<Array<Maybe<ResolversTypes['PortfolioPerformanceItem']>>>, ParentType, ContextType>;
  series?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  values?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
};

export type FundUnitResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['FundUnit'] = ResolversParentTypes['FundUnit']> = {
  instrument?: Resolver<ResolversTypes['Instrument'], ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  totalUnits?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type FundUnitReconciliationTypeResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['FundUnitReconciliationType'] = ResolversParentTypes['FundUnitReconciliationType']> = {
  calculatedNbr?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  custodianAccountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  diff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  isin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  party?: Resolver<Maybe<ResolversTypes['PartyInfo']>, ParentType, ContextType>;
  partyId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  reportedId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  reportedNbr?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reporter?: Resolver<Maybe<ResolversTypes['PartyInfo']>, ParentType, ContextType>;
  reporterId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  shareRegisterDiff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  shareRegisterNbr?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  unitsAfterOrders?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type FxValuationResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['FxValuation'] = ResolversParentTypes['FxValuation']> = {
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instrumentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type GlobalStandardScreenResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['GlobalStandardScreen'] = ResolversParentTypes['GlobalStandardScreen']> = {
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  norm?: Resolver<ResolversTypes['StandardScreenNorm'], ParentType, ContextType>;
  principle?: Resolver<ResolversTypes['StandardScreenPrinciple'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['StandardScreenStatus'], ParentType, ContextType>;
};

export interface GraphQlCreditRatingScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['GraphQLCreditRating'], any> {
  name: 'GraphQLCreditRating';
}

export interface GraphQlDateStringScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['GraphQLDateString'], any> {
  name: 'GraphQLDateString';
}

export interface GraphQlLeiScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['GraphQLLei'], any> {
  name: 'GraphQLLei';
}

export interface GraphQlObjectIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['GraphQLObjectId'], any> {
  name: 'GraphQLObjectId';
}

export interface GraphQlPatchInstrumentDateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['GraphQLPatchInstrumentDate'], any> {
  name: 'GraphQLPatchInstrumentDate';
}

export interface GraphQlSwedenDateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['GraphQLSwedenDate'], any> {
  name: 'GraphQLSwedenDate';
}

export interface GraphQlSwedishLegalNumberScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['GraphQLSwedishLegalNumber'], any> {
  name: 'GraphQLSwedishLegalNumber';
}

export type HistoricalDataResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['HistoricalData'] = ResolversParentTypes['HistoricalData']> = {
  dates?: Resolver<Maybe<Array<Maybe<ResolversTypes['GraphQLDateString']>>>, ParentType, ContextType>;
  eidDataArray?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  field?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldExceptionsArray?: Resolver<Maybe<Array<ResolversTypes['RefDataFieldExceptionsArray']>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  info?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  security?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  securityError?: Resolver<Maybe<Array<ResolversTypes['RefDataError']>>, ParentType, ContextType>;
  values?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
};

export interface IbanScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['IBAN'], any> {
  name: 'IBAN';
}

export interface IsinScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ISIN'], any> {
  name: 'ISIN';
}

export type InstrumentResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Instrument'] = ResolversParentTypes['Instrument']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  account?: Resolver<Maybe<ResolversTypes['PartyAccount']>, ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  accruedInterest?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, Partial<InstrumentAccruedInterestArgs>>;
  accruedInterestOnly?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, Partial<InstrumentAccruedInterestOnlyArgs>>;
  aliases?: Resolver<Array<ResolversTypes['Alias']>, ParentType, ContextType>;
  benchmark?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  benchmarkId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  bic?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bloombergDailyDownload?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  bloombergQuoteMultiplier?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bloombergTicker?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['InstrumentCategory']>, ParentType, ContextType>;
  cic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cicArea?: Resolver<Maybe<ResolversTypes['CicAreaEnum']>, ParentType, ContextType>;
  cicType?: Resolver<Maybe<ResolversTypes['CicTypeEnum']>, ParentType, ContextType>;
  cleanPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, Partial<InstrumentCleanPriceArgs>>;
  clientIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  clients?: Resolver<Array<ResolversTypes['Party']>, ParentType, ContextType>;
  countryOfListing?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  couponFrequency?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  couponRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  creditQualityStep?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  creditRating?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creditRatings?: Resolver<Maybe<Array<ResolversTypes['PartyCreditRating']>>, ParentType, ContextType>;
  creditYieldDelta?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, Partial<InstrumentCreditYieldDeltaArgs>>;
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exchange?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  extensions?: Resolver<Array<ResolversTypes['Extension']>, ParentType, ContextType>;
  externalAccount?: Resolver<Maybe<ResolversTypes['PartyExternalAccount']>, ParentType, ContextType>;
  externalAccountId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  firstTradeDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType, Partial<InstrumentFirstTradeDateArgs>>;
  firstTradeExternalAccountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType, Partial<InstrumentFirstTradeExternalAccountIdArgs>>;
  firstTradeTransactionId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType, Partial<InstrumentFirstTradeTransactionIdArgs>>;
  iban?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  interestRateYieldDelta?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, Partial<InstrumentInterestRateYieldDeltaArgs>>;
  isin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issuer?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  issuerId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  issuerProgram?: Resolver<Maybe<ResolversTypes['IssuerProgram']>, ParentType, ContextType>;
  issuerProgramId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  longName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  marginCallsMade?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  maturityDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['InstrumentModel']>, ParentType, ContextType>;
  modelNotionalScaling?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  modelSubType?: Resolver<Maybe<ResolversTypes['InstrumentModelSubTypeEnum']>, ParentType, ContextType>;
  modelType?: Resolver<Maybe<ResolversTypes['InstrumentModelTypeEnum']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  placeOfSettlementId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  presentValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, Partial<InstrumentPresentValueArgs>>;
  productType?: Resolver<Maybe<ResolversTypes['InstrumentProductTypeEnum']>, ParentType, ContextType>;
  px?: Resolver<Maybe<ResolversTypes['DateValue']>, ParentType, ContextType, Partial<InstrumentPxArgs>>;
  pxLast?: Resolver<Maybe<ResolversTypes['DateValue']>, ParentType, ContextType, Partial<InstrumentPxLastArgs>>;
  quantityDecimals?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quote?: Resolver<Maybe<ResolversTypes['DateQuote']>, ParentType, ContextType, Partial<InstrumentQuoteArgs>>;
  quoteLast?: Resolver<Maybe<ResolversTypes['DateQuote']>, ParentType, ContextType, Partial<InstrumentQuoteLastArgs>>;
  startDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeSeries?: Resolver<Maybe<Array<ResolversTypes['TimeSeries']>>, ParentType, ContextType, Partial<InstrumentTimeSeriesArgs>>;
  type?: Resolver<ResolversTypes['InstrumentTypeEnum'], ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  valuations?: Resolver<Maybe<ResolversTypes['InstrumentValuation']>, ParentType, ContextType, Partial<InstrumentValuationsArgs>>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
  yield?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, Partial<InstrumentYieldArgs>>;
  yieldActual360?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, Partial<InstrumentYieldActual360Args>>;
  zeroSpread?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, Partial<InstrumentZeroSpreadArgs>>;
};

export type InstrumentAccountPositionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['InstrumentAccountPosition'] = ResolversParentTypes['InstrumentAccountPosition']> = {
  account?: Resolver<Maybe<ResolversTypes['PartyAccount']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  externalAccount?: Resolver<Maybe<ResolversTypes['PartyExternalAccount']>, ParentType, ContextType>;
  externalAccountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type InstrumentModelResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['InstrumentModel'] = ResolversParentTypes['InstrumentModel']> = {
  _t?: Resolver<ResolversTypes['InstrumentModelTypeEnum'], ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  expiryDate?: Resolver<Maybe<ResolversTypes['GraphQLPatchInstrumentDate']>, ParentType, ContextType>;
  legs?: Resolver<Maybe<Array<ResolversTypes['InstrumentModelLegsItem']>>, ParentType, ContextType>;
  notionalScaling?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  objectType?: Resolver<Maybe<ResolversTypes['InstrumentModelObjectTypeEnum']>, ParentType, ContextType>;
  quoteCurrency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  quoteType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['GraphQLPatchInstrumentDate']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['InstrumentModelTypeEnum'], ParentType, ContextType>;
};

export type InstrumentModelLegsItemResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['InstrumentModelLegsItem'] = ResolversParentTypes['InstrumentModelLegsItem']> = {
  _t?: Resolver<ResolversTypes['InstrumentModelLegTypesEnum'], ParentType, ContextType>;
  calendars?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  call?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  cashFlows?: Resolver<Maybe<Array<ResolversTypes['InstrumentModelLegsItemCashFlowsItem']>>, ParentType, ContextType>;
  creditSpread?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  dayAdjustment?: Resolver<ResolversTypes['DayAdjustmentEnum'], ParentType, ContextType>;
  dayCount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exercise?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expiry?: Resolver<Maybe<ResolversTypes['GraphQLPatchInstrumentDate']>, ParentType, ContextType>;
  fixingType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  flatAdjustment?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  issuerId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  longStub?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  maturityDate?: Resolver<Maybe<ResolversTypes['GraphQLPatchInstrumentDate']>, ParentType, ContextType>;
  maturityPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  multiplier?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  notional?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  payLeg?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rateIndexId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  recoveryRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  relativeAdjustment?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rollingDate?: Resolver<Maybe<ResolversTypes['GraphQLPatchInstrumentDate']>, ParentType, ContextType>;
  rollingPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  settlementType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spread?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['GraphQLPatchInstrumentDate']>, ParentType, ContextType>;
  startDateOffset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  strike?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['InstrumentModelLegTypesEnum'], ParentType, ContextType>;
  ultimateForwardRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  underlyingId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  underlyingInstrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  underlyings?: Resolver<Maybe<Array<ResolversTypes['InstrumentModelLegsItemUnderlyingsItem']>>, ParentType, ContextType>;
  volatility?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  zeroFloor?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type InstrumentModelLegsItemCashFlowsItemResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['InstrumentModelLegsItemCashFlowsItem'] = ResolversParentTypes['InstrumentModelLegsItemCashFlowsItem']> = {
  endDate?: Resolver<Maybe<ResolversTypes['GraphQLPatchInstrumentDate']>, ParentType, ContextType>;
  exDate?: Resolver<ResolversTypes['GraphQLPatchInstrumentDate'], ParentType, ContextType>;
  fixings?: Resolver<Maybe<Array<ResolversTypes['InstrumentModelLegsItemCashFlowsItemFixingsItem']>>, ParentType, ContextType>;
  notional?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  payDate?: Resolver<ResolversTypes['GraphQLPatchInstrumentDate'], ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['GraphQLPatchInstrumentDate']>, ParentType, ContextType>;
};

export type InstrumentModelLegsItemCashFlowsItemFixingsItemResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['InstrumentModelLegsItemCashFlowsItemFixingsItem'] = ResolversParentTypes['InstrumentModelLegsItemCashFlowsItemFixingsItem']> = {
  date?: Resolver<ResolversTypes['GraphQLPatchInstrumentDate'], ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['GraphQLPatchInstrumentDate'], ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['GraphQLPatchInstrumentDate'], ParentType, ContextType>;
};

export type InstrumentModelLegsItemUnderlyingsItemResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['InstrumentModelLegsItemUnderlyingsItem'] = ResolversParentTypes['InstrumentModelLegsItemUnderlyingsItem']> = {
  instrumentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quanto?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  weight?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type InstrumentPerformanceResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['InstrumentPerformance'] = ResolversParentTypes['InstrumentPerformance']> = {
  account?: Resolver<Maybe<ResolversTypes['PartyAccount']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  cashFlows?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  dates?: Resolver<Maybe<Array<Maybe<ResolversTypes['GraphQLDateString']>>>, ParentType, ContextType>;
  firstTradeDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  localCurrency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  positions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  series?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  values?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
};

export type InstrumentPositionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['InstrumentPosition'] = ResolversParentTypes['InstrumentPosition']> = {
  clientIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  clients?: Resolver<Maybe<Array<Maybe<ResolversTypes['Party']>>>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
};

export type InstrumentSelectorResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['InstrumentSelector'] = ResolversParentTypes['InstrumentSelector']> = {
  alias?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
};

export type InstrumentValuationResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['InstrumentValuation'] = ResolversParentTypes['InstrumentValuation']> = {
  accruedInterest?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cleanPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type InventoryResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Inventory'] = ResolversParentTypes['Inventory']> = {
  initialCost?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  initialFxRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  initialPrice?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  localAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type IssuerProgramResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['IssuerProgram'] = ResolversParentTypes['IssuerProgram']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  attachments?: Resolver<Array<ResolversTypes['Attachment']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['IssuerProgramCategory']>, ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  covered?: Resolver<ResolversTypes['TrueFalseNone'], ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  creditStatus?: Resolver<ResolversTypes['CreditStatusType'], ParentType, ContextType>;
  crossDefault?: Resolver<ResolversTypes['TrueFalseNone'], ParentType, ContextType>;
  euTaxonomyEnvironmentalObjectives?: Resolver<Array<ResolversTypes['EuTaxonomyEnvironmentalObjective']>, ParentType, ContextType>;
  guarantor?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  guarantorId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  instruments?: Resolver<Array<ResolversTypes['Instrument']>, ParentType, ContextType>;
  issuer?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  issuerId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  negativePledge?: Resolver<ResolversTypes['TrueFalseNone'], ParentType, ContextType>;
  screens?: Resolver<Maybe<Array<Maybe<ResolversTypes['Screen']>>>, ParentType, ContextType>;
  spoProvider?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  spoProviderId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['DocumentStatusEnum']>, ParentType, ContextType>;
  sustainableDevelopmentGoals?: Resolver<Maybe<Array<ResolversTypes['SustainableDevelopmentGoal']>>, ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  useOfProceeds?: Resolver<Maybe<Array<ResolversTypes['UseOfProceed']>>, ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export interface JsonObjectScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSONObject'], any> {
  name: 'JSONObject';
}

export type JournalEntryResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['JournalEntry'] = ResolversParentTypes['JournalEntry']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  accountingPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountingRunId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  batch?: Resolver<Maybe<ResolversTypes['AccountingBatchType']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  effectiveDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  externalNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  portfolioTransaction?: Resolver<Maybe<ResolversTypes['Transaction']>, ParentType, ContextType>;
  portfolioTransactionId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  transactions?: Resolver<Maybe<Array<ResolversTypes['AccountingTransaction']>>, ParentType, ContextType>;
};

export type JournalEntry2Resolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['JournalEntry2'] = ResolversParentTypes['JournalEntry2']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  accountingPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountingRunId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  batch?: Resolver<Maybe<ResolversTypes['AccountingBatchType']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  effectiveDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  externalNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  portfolioTransaction?: Resolver<Maybe<ResolversTypes['Transaction']>, ParentType, ContextType>;
  portfolioTransactionId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  transactions?: Resolver<Maybe<Array<ResolversTypes['AccountingTransaction2']>>, ParentType, ContextType>;
};

export type KleerAccountMetadataResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['KleerAccountMetadata'] = ResolversParentTypes['KleerAccountMetadata']> = {
  accountNr?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  creditCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  debitCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  inBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  outBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type KleerAccountingYearResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['KleerAccountingYear'] = ResolversParentTypes['KleerAccountingYear']> = {
  endDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
};

export type KleerAmountResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['KleerAmount'] = ResolversParentTypes['KleerAmount']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vat?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type KleerCompanyInfoResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['KleerCompanyInfo'] = ResolversParentTypes['KleerCompanyInfo']> = {
  accountingCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankgiro?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orgno?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supplierInvoiceEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type KleerIdRefResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['KleerIdRef'] = ResolversParentTypes['KleerIdRef']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type KleerPeriodResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['KleerPeriod'] = ResolversParentTypes['KleerPeriod']> = {
  end?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
};

export type KleerRevenueResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['KleerRevenue'] = ResolversParentTypes['KleerRevenue']> = {
  countryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ledger?: Resolver<Maybe<ResolversTypes['KleerIdRef']>, ParentType, ContextType>;
  rows?: Resolver<Maybe<Array<Maybe<ResolversTypes['KleerRevenueRow']>>>, ParentType, ContextType>;
  transactionDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
};

export type KleerRevenueLedgerResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['KleerRevenueLedger'] = ResolversParentTypes['KleerRevenueLedger']> = {
  accountNr?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type KleerRevenueRowResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['KleerRevenueRow'] = ResolversParentTypes['KleerRevenueRow']> = {
  accountingAmount?: Resolver<Maybe<ResolversTypes['KleerAmount']>, ParentType, ContextType>;
  dimensions?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  originalAmount?: Resolver<Maybe<ResolversTypes['KleerAmount']>, ParentType, ContextType>;
  period?: Resolver<Maybe<ResolversTypes['KleerPeriod']>, ParentType, ContextType>;
  product?: Resolver<Maybe<ResolversTypes['KleerIdRef']>, ParentType, ContextType>;
};

export type KleerVoucherResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['KleerVoucher'] = ResolversParentTypes['KleerVoucher']> = {
  date?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  serie?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transactions?: Resolver<Maybe<Array<Maybe<ResolversTypes['KleerVoucherTransaction']>>>, ParentType, ContextType>;
  turnover?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type KleerVoucherTransactionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['KleerVoucherTransaction'] = ResolversParentTypes['KleerVoucherTransaction']> = {
  accountNr?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currencyAmounts?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  dimensionEntries?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  vatCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type LimitDataResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['LimitData'] = ResolversParentTypes['LimitData']> = {
  creditYieldDelta?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  custodian?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exposure?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  externalAccountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  externalAccountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalAccountType?: Resolver<Maybe<ResolversTypes['PartyExternalAccountType']>, ParentType, ContextType>;
  fxRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  instrumentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  instrumentLongName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instrumentName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  interestRateYieldDelta?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isAncillaryLiquidAsset?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isCashAccount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isCollateral?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isCollateralInitialMargin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isCreditInstitution?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDeposit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isDerivative?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEquity?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEuCovered?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFinancialIndex?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFund?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isGovernment?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isGreenBond?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isInterestBearing?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isKeySector?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLookThrough?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMoneyMarket?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isNonGuaranteed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isNonVoting?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isOtc?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSecurity?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isTransferableSecurity?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isTsmmEmbeddedDerivative?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isUcitsFund?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isUnlisted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issuerId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  issuerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localExposure?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  localValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  parentIssuerId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  portfolioCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  positionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  separatedInitialMargin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type MarginRequirementResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['MarginRequirement'] = ResolversParentTypes['MarginRequirement']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  agreementType?: Resolver<ResolversTypes['AgreementType'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  client?: Resolver<ResolversTypes['Party'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['Party'], ParentType, ContextType>;
  sourceId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MarginRequirementType'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
};

export type MatchedBankAccountTransactionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['MatchedBankAccountTransaction'] = ResolversParentTypes['MatchedBankAccountTransaction']> = {
  bankAccountTransactionIds?: Resolver<Maybe<Array<ResolversTypes['GraphQLObjectId']>>, ParentType, ContextType>;
  bankAccountTransactions?: Resolver<Maybe<Array<ResolversTypes['BankAccountTransaction']>>, ParentType, ContextType>;
  transactionItemIds?: Resolver<Maybe<Array<ResolversTypes['GraphQLObjectId']>>, ParentType, ContextType>;
  transactionItems?: Resolver<Maybe<Array<ResolversTypes['TransactionItem']>>, ParentType, ContextType>;
};

export type MatchedCoacsTransactionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['MatchedCoacsTransaction'] = ResolversParentTypes['MatchedCoacsTransaction']> = {
  corporateAction?: Resolver<Maybe<ResolversTypes['CorporateAction']>, ParentType, ContextType>;
  corporateActionId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  transaction?: Resolver<Maybe<ResolversTypes['Transaction']>, ParentType, ContextType>;
  transactionId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
};

export type MatchedTransactionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['MatchedTransaction'] = ResolversParentTypes['MatchedTransaction']> = {
  brokerTransaction?: Resolver<Maybe<ResolversTypes['BrokerTransaction']>, ParentType, ContextType>;
  transaction?: Resolver<Maybe<ResolversTypes['Transaction']>, ParentType, ContextType>;
};

export interface Max35CharStringScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Max35CharString'], any> {
  name: 'Max35CharString';
}

export interface Max140CharStringScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Max140CharString'], any> {
  name: 'Max140CharString';
}

export type MeResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Me'] = ResolversParentTypes['Me']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  bidExpiration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  clientIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  clients?: Resolver<Array<ResolversTypes['PartyInfo']>, ParentType, ContextType>;
  company?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  frontendRole?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  frontendRoleId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  lastBankIdLoginTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  lastLoginTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  lastPasswordUpdate?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  noteIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  notes?: Resolver<Array<ResolversTypes['Note']>, ParentType, ContextType>;
  personalNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roleIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['Role']>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['UserStatusEnum'], ParentType, ContextType>;
  termsOfService?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType>;
  unreadTicketsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
};

export interface Min1Max70CharStringScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Min1Max70CharString'], any> {
  name: 'Min1Max70CharString';
}

export type MiniTransactionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['MiniTransaction'] = ResolversParentTypes['MiniTransaction']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  account?: Resolver<Maybe<ResolversTypes['PartyAccount']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  accruedInterest?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  agreementType?: Resolver<Maybe<ResolversTypes['AgreementType']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<ResolversTypes['Attachment']>>, ParentType, ContextType>;
  bestExecutionType?: Resolver<Maybe<ResolversTypes['BestExecutionType']>, ParentType, ContextType>;
  bonusShares?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  broker?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  brokerTradeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brokerTransaction?: Resolver<Maybe<ResolversTypes['BrokerTransaction']>, ParentType, ContextType>;
  carryOwnCostDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  clearingBroker?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clearingBrokerId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  clearingHouse?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clearingHouseId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  commission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  corporateAction?: Resolver<Maybe<ResolversTypes['CorporateAction']>, ParentType, ContextType>;
  createTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dividendPaid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  effectiveDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalAccountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  foreignTax?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fxRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  initialMargin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  itemType?: Resolver<Maybe<ResolversTypes['FeeInterestItemType']>, ParentType, ContextType>;
  loan?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  payableReceivable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reinvestedDividend?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  reinvestedRebate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  rounding?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  secondAccountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  secondAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  secondCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondExternalAccountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  secondInstrumentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  settlementAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['SourceType']>, ParentType, ContextType>;
  stampDuty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['TransactionStatus']>, ParentType, ContextType>;
  taxRestitution?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  tradeDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  tradeTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['TransactionType']>, ParentType, ContextType>;
  uniqueTradeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  valueDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
};

export type ModelIndexBenchmarkResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['ModelIndexBenchmark'] = ResolversParentTypes['ModelIndexBenchmark']> = {
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timeSeries?: Resolver<Maybe<ResolversTypes['TimeSeries']>, ParentType, ContextType, Partial<ModelIndexBenchmarkTimeSeriesArgs>>;
};

export type MutationResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  acceptTerms?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationAcceptTermsArgs, 'input'>>;
  addTimeSerieItems?: Resolver<Maybe<ResolversTypes['TimeSeries']>, ParentType, ContextType, RequireFields<MutationAddTimeSerieItemsArgs, '_id' | 'items'>>;
  adminAccountSwitchAll?: Resolver<Array<ResolversTypes['TransferAgentOrder']>, ParentType, ContextType, RequireFields<MutationAdminAccountSwitchAllArgs, 'input' | 'isins' | 'tradeDate'>>;
  changePassword?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType, RequireFields<MutationChangePasswordArgs, 'input'>>;
  cleanPerformanceCacheRedis?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<MutationCleanPerformanceCacheRedisArgs>>;
  cloneTAccountChart?: Resolver<Maybe<ResolversTypes['TAccountChart']>, ParentType, ContextType, RequireFields<MutationCloneTAccountChartArgs, 'clientId'>>;
  createAccountingRun?: Resolver<Maybe<ResolversTypes['AccountingRun']>, ParentType, ContextType, RequireFields<MutationCreateAccountingRunArgs, 'input'>>;
  createAttachment?: Resolver<Maybe<ResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<MutationCreateAttachmentArgs, 'clientId' | 'input'>>;
  createCdsValuations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Valuation']>>>, ParentType, ContextType, Partial<MutationCreateCdsValuationsArgs>>;
  createCurveDefinition?: Resolver<Maybe<ResolversTypes['CurveDefinition']>, ParentType, ContextType, RequireFields<MutationCreateCurveDefinitionArgs, 'input'>>;
  createDerivativeValuations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Valuation']>>>, ParentType, ContextType, RequireFields<MutationCreateDerivativeValuationsArgs, 'allowLastPrice' | 'date' | 'instrumentIdIn'>>;
  createExposureCollateral?: Resolver<ResolversTypes['ExposureCollateral'], ParentType, ContextType, RequireFields<MutationCreateExposureCollateralArgs, 'input'>>;
  createInstrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType, RequireFields<MutationCreateInstrumentArgs, 'input'>>;
  createIssuerProgram?: Resolver<Maybe<ResolversTypes['IssuerProgram']>, ParentType, ContextType, RequireFields<MutationCreateIssuerProgramArgs, 'input'>>;
  createJournalEntry?: Resolver<Maybe<ResolversTypes['JournalEntry']>, ParentType, ContextType, RequireFields<MutationCreateJournalEntryArgs, 'input'>>;
  createJournalEntry2?: Resolver<Maybe<ResolversTypes['JournalEntry2']>, ParentType, ContextType, RequireFields<MutationCreateJournalEntry2Args, 'input'>>;
  createManagementCostTransactions?: Resolver<Maybe<Array<Maybe<ResolversTypes['MiniTransaction']>>>, ParentType, ContextType, RequireFields<MutationCreateManagementCostTransactionsArgs, 'clientId' | 'date'>>;
  createMiniTransactions?: Resolver<Maybe<Array<Maybe<ResolversTypes['MiniTransaction']>>>, ParentType, ContextType, RequireFields<MutationCreateMiniTransactionsArgs, 'input'>>;
  createNav?: Resolver<Maybe<ResolversTypes['Nav']>, ParentType, ContextType, RequireFields<MutationCreateNavArgs, 'input'>>;
  createPartyAccount?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType, RequireFields<MutationCreatePartyAccountArgs, 'input' | 'partyId'>>;
  createPartyBase?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType, RequireFields<MutationCreatePartyBaseArgs, 'input' | 'partyId'>>;
  createReport?: Resolver<Maybe<ResolversTypes['Report']>, ParentType, ContextType, RequireFields<MutationCreateReportArgs, 'input'>>;
  createRole?: Resolver<Maybe<ResolversTypes['Role']>, ParentType, ContextType, RequireFields<MutationCreateRoleArgs, 'input'>>;
  createScreen?: Resolver<Maybe<ResolversTypes['Screen']>, ParentType, ContextType, RequireFields<MutationCreateScreenArgs, 'input'>>;
  createSwifts?: Resolver<Maybe<Array<ResolversTypes['Swift']>>, ParentType, ContextType, RequireFields<MutationCreateSwiftsArgs, 'input'>>;
  createTAccountChart?: Resolver<Maybe<ResolversTypes['TAccountChart']>, ParentType, ContextType, Partial<MutationCreateTAccountChartArgs>>;
  createTransaction?: Resolver<Maybe<ResolversTypes['Transaction']>, ParentType, ContextType, RequireFields<MutationCreateTransactionArgs, 'input'>>;
  createUpdateExternalAccount?: Resolver<Maybe<ResolversTypes['PartyExternalAccount']>, ParentType, ContextType, RequireFields<MutationCreateUpdateExternalAccountArgs, 'input' | 'partyId'>>;
  createUpdatePartyCashOrBalanceInstrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType, RequireFields<MutationCreateUpdatePartyCashOrBalanceInstrumentArgs, 'input'>>;
  createUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationCreateUserArgs, 'input'>>;
  createValuation?: Resolver<Maybe<ResolversTypes['Valuation']>, ParentType, ContextType, RequireFields<MutationCreateValuationArgs, 'input'>>;
  databaseMigration?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  defaultMutation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleteAttachment?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteAttachmentArgs, 'fileId'>>;
  deleteCurveDefinition?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteCurveDefinitionArgs, '_id'>>;
  deleteInstrument?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteInstrumentArgs, '_id'>>;
  deleteIssuerProgram?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteIssuerProgramArgs, '_id'>>;
  deleteJournalEntry?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteJournalEntryArgs, '_id'>>;
  deleteJournalEntry2?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteJournalEntry2Args, '_id'>>;
  deleteManagementCostTransactions?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteManagementCostTransactionsArgs, 'clientId' | 'date'>>;
  deleteNav?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteNavArgs, '_id'>>;
  deleteParty?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeletePartyArgs, '_id'>>;
  deletePartyAccount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeletePartyAccountArgs, 'accountId' | 'partyId'>>;
  deletePartyExternalAccount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeletePartyExternalAccountArgs, 'externalAccountId' | 'partyId'>>;
  deleteRedisKey?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteRedisKeyArgs, 'key'>>;
  deleteReport?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteReportArgs, '_id'>>;
  deleteReports?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteReportsArgs, 'idIn'>>;
  deleteScreen?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteScreenArgs, '_id'>>;
  deleteTAccountChart?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteTAccountChartArgs, '_id'>>;
  deleteTimeSerie?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteTimeSerieArgs, '_id'>>;
  deleteTransaction?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteTransactionArgs, '_id'>>;
  deleteTransferAgentOrder?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteTransferAgentOrderArgs, '_id'>>;
  deleteValuation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDeleteValuationArgs, '_id'>>;
  derivativesToPrices?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDerivativesToPricesArgs, 'date' | 'instrumentIdIn'>>;
  derivativesToValuations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationDerivativesToValuationsArgs, 'date' | 'instrumentIdIn'>>;
  fxPricesToValuations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationFxPricesToValuationsArgs, 'baseCurrency' | 'date' | 'instrumentIdIn'>>;
  fxQuotesToPrices?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationFxQuotesToPricesArgs, 'baseCurrency' | 'date' | 'instrumentIdIn'>>;
  importAccruedInterestPortfolioSwapX?: Resolver<Maybe<Array<Maybe<ResolversTypes['MiniTransaction']>>>, ParentType, ContextType, RequireFields<MutationImportAccruedInterestPortfolioSwapXArgs, 'aggregatedAmount' | 'portfolioInterestInput'>>;
  importBondTrade?: Resolver<Maybe<ResolversTypes['MiniTransaction']>, ParentType, ContextType, RequireFields<MutationImportBondTradeArgs, 'input'>>;
  importCloseDerivativeTrade?: Resolver<Maybe<ResolversTypes['MiniTransaction']>, ParentType, ContextType, RequireFields<MutationImportCloseDerivativeTradeArgs, 'input'>>;
  importCloseResetPortfolioSwapX?: Resolver<Maybe<Array<Maybe<ResolversTypes['MiniTransaction']>>>, ParentType, ContextType, RequireFields<MutationImportCloseResetPortfolioSwapXArgs, 'accountAlias' | 'date' | 'portfolioSwapAlias' | 'reset' | 'valueDate'>>;
  importCollateral?: Resolver<Maybe<ResolversTypes['MiniTransaction']>, ParentType, ContextType, RequireFields<MutationImportCollateralArgs, 'input'>>;
  importCoupon?: Resolver<Maybe<ResolversTypes['MiniTransaction']>, ParentType, ContextType, RequireFields<MutationImportCouponArgs, 'input'>>;
  importCreateRedeems?: Resolver<Maybe<Array<Maybe<ResolversTypes['MiniTransaction']>>>, ParentType, ContextType, Partial<MutationImportCreateRedeemsArgs>>;
  importDerivativeTrade?: Resolver<Maybe<ResolversTypes['MiniTransaction']>, ParentType, ContextType, RequireFields<MutationImportDerivativeTradeArgs, 'input'>>;
  importDividend?: Resolver<Maybe<ResolversTypes['MiniTransaction']>, ParentType, ContextType, RequireFields<MutationImportDividendArgs, 'input'>>;
  importDividendPortfolioSwapX?: Resolver<Maybe<Array<Maybe<ResolversTypes['MiniTransaction']>>>, ParentType, ContextType, RequireFields<MutationImportDividendPortfolioSwapXArgs, 'portfolioSwapAlias' | 'stockDividendInput'>>;
  importExpiryDerivativeTrade?: Resolver<Maybe<ResolversTypes['MiniTransaction']>, ParentType, ContextType, RequireFields<MutationImportExpiryDerivativeTradeArgs, 'input'>>;
  importFeeInterests?: Resolver<Maybe<Array<Maybe<ResolversTypes['MiniTransaction']>>>, ParentType, ContextType, RequireFields<MutationImportFeeInterestsArgs, 'input'>>;
  importFundTrades?: Resolver<Maybe<Array<Maybe<ResolversTypes['MiniTransaction']>>>, ParentType, ContextType, RequireFields<MutationImportFundTradesArgs, 'input'>>;
  importFxSpot?: Resolver<Maybe<ResolversTypes['MiniTransaction']>, ParentType, ContextType, RequireFields<MutationImportFxSpotArgs, 'input'>>;
  importInsertCash?: Resolver<Maybe<ResolversTypes['MiniTransaction']>, ParentType, ContextType, RequireFields<MutationImportInsertCashArgs, 'input'>>;
  importInsertCloseDerivativeTrade?: Resolver<Maybe<ResolversTypes['MiniTransaction']>, ParentType, ContextType, RequireFields<MutationImportInsertCloseDerivativeTradeArgs, 'input'>>;
  importInsertDerivativeTrade?: Resolver<Maybe<ResolversTypes['MiniTransaction']>, ParentType, ContextType, RequireFields<MutationImportInsertDerivativeTradeArgs, 'input'>>;
  importInsertSecurity?: Resolver<Maybe<ResolversTypes['MiniTransaction']>, ParentType, ContextType, RequireFields<MutationImportInsertSecurityArgs, 'input'>>;
  importInterestPortfolioSwapX?: Resolver<Maybe<Array<Maybe<ResolversTypes['MiniTransaction']>>>, ParentType, ContextType, RequireFields<MutationImportInterestPortfolioSwapXArgs, 'portfolioInterestInput'>>;
  importOpenPortfolioSwapX?: Resolver<Maybe<Array<Maybe<ResolversTypes['MiniTransaction']>>>, ParentType, ContextType, RequireFields<MutationImportOpenPortfolioSwapXArgs, 'stockInput' | 'swapInput'>>;
  importStockTradePortfolioSwapX?: Resolver<Maybe<Array<Maybe<ResolversTypes['MiniTransaction']>>>, ParentType, ContextType, RequireFields<MutationImportStockTradePortfolioSwapXArgs, 'portfolioSwapAlias' | 'stockInput'>>;
  importStockTrades?: Resolver<Maybe<Array<Maybe<ResolversTypes['MiniTransaction']>>>, ParentType, ContextType, RequireFields<MutationImportStockTradesArgs, 'input'>>;
  importTAccountChartAccounts?: Resolver<Maybe<ResolversTypes['TAccountChart']>, ParentType, ContextType, RequireFields<MutationImportTAccountChartAccountsArgs, '_id' | 'csv'>>;
  importTAccountChartMappings?: Resolver<Maybe<ResolversTypes['TAccountChart']>, ParentType, ContextType, RequireFields<MutationImportTAccountChartMappingsArgs, '_id' | 'csv'>>;
  importTransfers?: Resolver<Maybe<Array<Maybe<ResolversTypes['MiniTransaction']>>>, ParentType, ContextType, RequireFields<MutationImportTransfersArgs, 'input'>>;
  manuallyMatchBankAccountTransactions?: Resolver<Array<ResolversTypes['MatchedBankAccountTransaction']>, ParentType, ContextType, RequireFields<MutationManuallyMatchBankAccountTransactionsArgs, 'input'>>;
  matchBankAccountTransactions?: Resolver<Array<ResolversTypes['MatchedBankAccountTransaction']>, ParentType, ContextType, Partial<MutationMatchBankAccountTransactionsArgs>>;
  matchCoacsTransactions?: Resolver<Array<ResolversTypes['MatchedCoacsTransaction']>, ParentType, ContextType, RequireFields<MutationMatchCoacsTransactionsArgs, 'input'>>;
  matchTransactions?: Resolver<Array<ResolversTypes['MatchedTransaction']>, ParentType, ContextType, RequireFields<MutationMatchTransactionsArgs, 'input'>>;
  opCreatePayments?: Resolver<Maybe<Array<ResolversTypes['OPPayment']>>, ParentType, ContextType, RequireFields<MutationOpCreatePaymentsArgs, 'payments'>>;
  opCreateSigningBasket?: Resolver<Maybe<ResolversTypes['OPSigningBasketData']>, ParentType, ContextType, RequireFields<MutationOpCreateSigningBasketArgs, 'idIn'>>;
  opCreateSigningBasketToken?: Resolver<Maybe<Array<ResolversTypes['OPPayment']>>, ParentType, ContextType, RequireFields<MutationOpCreateSigningBasketTokenArgs, 'code' | 'legalNumber' | 'signingBasketAuthId' | 'signingBasketId'>>;
  opCreateToken?: Resolver<Maybe<ResolversTypes['OPConsent']>, ParentType, ContextType, RequireFields<MutationOpCreateTokenArgs, 'code' | 'consentAuthId' | 'consentId' | 'legalNumber' | 'scope'>>;
  opDeleteConsent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationOpDeleteConsentArgs, 'consentId'>>;
  opDeletePayments?: Resolver<Maybe<Array<ResolversTypes['OPPayment']>>, ParentType, ContextType, RequireFields<MutationOpDeletePaymentsArgs, 'idIn'>>;
  opGetRedirectLink?: Resolver<Maybe<ResolversTypes['RedirectLinkInfo']>, ParentType, ContextType, RequireFields<MutationOpGetRedirectLinkArgs, 'bic' | 'clientId' | 'legalNumber'>>;
  opUpdateConsent?: Resolver<Maybe<ResolversTypes['OPConsent']>, ParentType, ContextType, RequireFields<MutationOpUpdateConsentArgs, 'consentId'>>;
  opUpdatePayments?: Resolver<Maybe<Array<ResolversTypes['OPPayment']>>, ParentType, ContextType, RequireFields<MutationOpUpdatePaymentsArgs, 'idIn'>>;
  pricesToValuations?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationPricesToValuationsArgs, 'date' | 'instrumentIdIn'>>;
  quotesToPrices?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationQuotesToPricesArgs, 'date'>>;
  roundTransaction?: Resolver<Maybe<ResolversTypes['MiniTransaction']>, ParentType, ContextType, RequireFields<MutationRoundTransactionArgs, 'input'>>;
  setRedisKey?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<MutationSetRedisKeyArgs, 'data' | 'key'>>;
  updateAccountingRun?: Resolver<Maybe<ResolversTypes['AccountingRun']>, ParentType, ContextType, RequireFields<MutationUpdateAccountingRunArgs, 'input'>>;
  updateAccountingRunStatus?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdateAccountingRunStatusArgs, '_id' | 'status'>>;
  updateAccountingRunStatus2?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpdateAccountingRunStatus2Args, '_id' | 'status'>>;
  updateBrokerTransaction?: Resolver<ResolversTypes['BrokerTransaction'], ParentType, ContextType, RequireFields<MutationUpdateBrokerTransactionArgs, 'input'>>;
  updateCurveDefinition?: Resolver<Maybe<ResolversTypes['CurveDefinition']>, ParentType, ContextType, RequireFields<MutationUpdateCurveDefinitionArgs, 'input'>>;
  updateExposureCollateral?: Resolver<ResolversTypes['ExposureCollateral'], ParentType, ContextType, RequireFields<MutationUpdateExposureCollateralArgs, '_id' | 'input'>>;
  updateExternalNumbers?: Resolver<Maybe<Array<Maybe<ResolversTypes['JournalEntry']>>>, ParentType, ContextType, RequireFields<MutationUpdateExternalNumbersArgs, 'input'>>;
  updateExternalNumbers2?: Resolver<Maybe<Array<Maybe<ResolversTypes['JournalEntry2']>>>, ParentType, ContextType, RequireFields<MutationUpdateExternalNumbers2Args, 'input'>>;
  updateInstrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType, RequireFields<MutationUpdateInstrumentArgs, 'input'>>;
  updateIssuerProgram?: Resolver<Maybe<ResolversTypes['IssuerProgram']>, ParentType, ContextType, RequireFields<MutationUpdateIssuerProgramArgs, '_id' | 'input'>>;
  updateJournalEntry?: Resolver<Maybe<ResolversTypes['JournalEntry']>, ParentType, ContextType, RequireFields<MutationUpdateJournalEntryArgs, 'input'>>;
  updateJournalEntry2?: Resolver<Maybe<ResolversTypes['JournalEntry2']>, ParentType, ContextType, RequireFields<MutationUpdateJournalEntry2Args, 'input'>>;
  updateMiniTransaction?: Resolver<Maybe<ResolversTypes['MiniTransaction']>, ParentType, ContextType, RequireFields<MutationUpdateMiniTransactionArgs, 'input'>>;
  updateNavsPublishedTo?: Resolver<Maybe<Array<Maybe<ResolversTypes['Nav']>>>, ParentType, ContextType, RequireFields<MutationUpdateNavsPublishedToArgs, 'publishedToInput'>>;
  updateParty?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType, RequireFields<MutationUpdatePartyArgs, 'input'>>;
  updatePartyAccount?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType, RequireFields<MutationUpdatePartyAccountArgs, 'input' | 'partyId'>>;
  updatePartyBase?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType, RequireFields<MutationUpdatePartyBaseArgs, 'input' | 'partyId'>>;
  updatePartyExternalAccount?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType, RequireFields<MutationUpdatePartyExternalAccountArgs, 'input' | 'partyId'>>;
  updatePartyFundInfo?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType, RequireFields<MutationUpdatePartyFundInfoArgs, 'input' | 'partyId'>>;
  updatePartyIssuer?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType, RequireFields<MutationUpdatePartyIssuerArgs, 'input' | 'partyId'>>;
  updateReport?: Resolver<Maybe<ResolversTypes['Report']>, ParentType, ContextType, RequireFields<MutationUpdateReportArgs, 'input'>>;
  updateRole?: Resolver<Maybe<ResolversTypes['Role']>, ParentType, ContextType, RequireFields<MutationUpdateRoleArgs, 'input'>>;
  updateScreen?: Resolver<Maybe<ResolversTypes['Screen']>, ParentType, ContextType, RequireFields<MutationUpdateScreenArgs, '_id' | 'input'>>;
  updateTAccountChart?: Resolver<Maybe<ResolversTypes['TAccountChart']>, ParentType, ContextType, Partial<MutationUpdateTAccountChartArgs>>;
  updateTimeSerie?: Resolver<Maybe<ResolversTypes['TimeSeries']>, ParentType, ContextType, RequireFields<MutationUpdateTimeSerieArgs, 'input'>>;
  updateTransactions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Transaction']>>>, ParentType, ContextType, RequireFields<MutationUpdateTransactionsArgs, 'input'>>;
  updateTransferAgentOrderAttachments?: Resolver<Maybe<ResolversTypes['TransferAgentOrder']>, ParentType, ContextType, RequireFields<MutationUpdateTransferAgentOrderAttachmentsArgs, 'input'>>;
  updateUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<MutationUpdateUserArgs, 'input'>>;
  upsertAccountingRun?: Resolver<Maybe<ResolversTypes['AccountingRun2']>, ParentType, ContextType, RequireFields<MutationUpsertAccountingRunArgs, 'input'>>;
  upsertAgreements?: Resolver<Maybe<Array<Maybe<ResolversTypes['Agreement']>>>, ParentType, ContextType, RequireFields<MutationUpsertAgreementsArgs, 'input'>>;
  upsertArrayOfTimeSerieItems?: Resolver<Array<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationUpsertArrayOfTimeSerieItemsArgs, 'data'>>;
  upsertBankAccountTransactions?: Resolver<Array<ResolversTypes['BankAccountTransaction']>, ParentType, ContextType, RequireFields<MutationUpsertBankAccountTransactionsArgs, 'input'>>;
  upsertBaseCalendars?: Resolver<Maybe<Array<Maybe<ResolversTypes['BaseCalendar']>>>, ParentType, ContextType, RequireFields<MutationUpsertBaseCalendarsArgs, 'input'>>;
  upsertCorporateActions?: Resolver<Maybe<Array<ResolversTypes['CorporateAction']>>, ParentType, ContextType, RequireFields<MutationUpsertCorporateActionsArgs, 'input'>>;
  upsertCosts?: Resolver<Maybe<Array<Maybe<ResolversTypes['Cost']>>>, ParentType, ContextType, RequireFields<MutationUpsertCostsArgs, 'input'>>;
  upsertCustodianPositions?: Resolver<Array<ResolversTypes['CustodianApiPosition']>, ParentType, ContextType, RequireFields<MutationUpsertCustodianPositionsArgs, 'input'>>;
  upsertCustomers?: Resolver<Maybe<Array<Maybe<ResolversTypes['Customer']>>>, ParentType, ContextType, RequireFields<MutationUpsertCustomersArgs, 'input'>>;
  upsertExtensions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Extension']>>>, ParentType, ContextType, RequireFields<MutationUpsertExtensionsArgs, 'input'>>;
  upsertNotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Note']>>>, ParentType, ContextType, RequireFields<MutationUpsertNotesArgs, 'input'>>;
  upsertPrices?: Resolver<Maybe<Array<Maybe<ResolversTypes['Price']>>>, ParentType, ContextType, RequireFields<MutationUpsertPricesArgs, 'input'>>;
  upsertQuotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Quote']>>>, ParentType, ContextType, RequireFields<MutationUpsertQuotesArgs, 'input'>>;
  upsertRegisterExtracts?: Resolver<Maybe<Array<ResolversTypes['RegisterExtract']>>, ParentType, ContextType, RequireFields<MutationUpsertRegisterExtractsArgs, 'input'>>;
  upsertTAccountChart2?: Resolver<Maybe<ResolversTypes['UpsertTAccountChart']>, ParentType, ContextType, Partial<MutationUpsertTAccountChart2Args>>;
  upsertTickets?: Resolver<Maybe<Array<Maybe<ResolversTypes['Ticket']>>>, ParentType, ContextType, RequireFields<MutationUpsertTicketsArgs, 'input'>>;
  upsertTimeSerieItems?: Resolver<Maybe<ResolversTypes['TimeSeries']>, ParentType, ContextType, RequireFields<MutationUpsertTimeSerieItemsArgs, 'instrumentId' | 'items' | 'type'>>;
  upsertTransferAgentOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['TransferAgentOrder']>>>, ParentType, ContextType, RequireFields<MutationUpsertTransferAgentOrdersArgs, 'input'>>;
  upsertValuationAttachments?: Resolver<Maybe<ResolversTypes['Valuation']>, ParentType, ContextType, RequireFields<MutationUpsertValuationAttachmentsArgs, 'attachments' | 'valuationId'>>;
  upsertValuationMappings?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValuationMapping']>>>, ParentType, ContextType, RequireFields<MutationUpsertValuationMappingsArgs, 'input'>>;
  upsertValuations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Price']>>>, ParentType, ContextType, RequireFields<MutationUpsertValuationsArgs, 'input'>>;
  valuationsToPrices?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type NameAndIdResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['NameAndId'] = ResolversParentTypes['NameAndId']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type NavResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Nav'] = ResolversParentTypes['Nav']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  absHighTolerancePercent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  absLowTolerancePercent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['NavData'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  frontOfficeNav?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fundRiskLevel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  publishedTo?: Resolver<Maybe<Array<ResolversTypes['PublishedToType']>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ReportStatusEnum'], ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  updateUserId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
};

export type NavDataResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['NavData'] = ResolversParentTypes['NavData']> = {
  adjustmentAmountPositions?: Resolver<Array<ResolversTypes['NavPosition']>, ParentType, ContextType>;
  classes?: Resolver<Array<ResolversTypes['NavFundClass']>, ParentType, ContextType>;
  orders?: Resolver<Array<ResolversTypes['NavOrder']>, ParentType, ContextType>;
  positions?: Resolver<Array<ResolversTypes['NavPosition']>, ParentType, ContextType>;
  transactions?: Resolver<Array<ResolversTypes['NavTransaction']>, ParentType, ContextType>;
};

export type NavFundClassResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['NavFundClass'] = ResolversParentTypes['NavFundClass']> = {
  adjustmentAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dividendPaid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fxHedge?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fxRate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  managementFee?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  navAfterAdjustmentsAfterOrders?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  navAfterAdjustmentsBeforeOrders?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  navBeforeAdjustmentsBeforeOrders?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  navCurrency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  navPerUnit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  navPerUnitReturn1D?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unitsAfterOrders?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  unitsBeforeOrders?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  weight?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type NavOrderResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['NavOrder'] = ResolversParentTypes['NavOrder']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carryOwnTransactionCost?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  isin?: Resolver<ResolversTypes['ISIN'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['TransferAgentOrder']>, ParentType, ContextType>;
  orderId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransferAgentOrderEnum'], ParentType, ContextType>;
  units?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  valueDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
};

export type NavPositionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['NavPosition'] = ResolversParentTypes['NavPosition']> = {
  account?: Resolver<Maybe<ResolversTypes['PartyAccount']>, ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  fxRate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fxValuationDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  valuationDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type NavTransactionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['NavTransaction'] = ResolversParentTypes['NavTransaction']> = {
  account?: Resolver<Maybe<ResolversTypes['PartyAccount']>, ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  accountSwitchOrder?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  accountingAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountingCurrency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  accountingPrice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  adjustmentAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  adjustmentShares?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fxRate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  isin?: Resolver<ResolversTypes['ISIN'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['NavTransactionType'], ParentType, ContextType>;
  units?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  valueDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
};

export type NoteResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Note'] = ResolversParentTypes['Note']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  asset?: Resolver<ResolversTypes['NoteAssetEnum'], ParentType, ContextType>;
  clientIds?: Resolver<Maybe<Array<ResolversTypes['GraphQLObjectId']>>, ParentType, ContextType>;
  clients?: Resolver<Array<ResolversTypes['PartyInfo']>, ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  creator?: Resolver<ResolversTypes['UserInfo'], ParentType, ContextType>;
  creatorId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refs?: Resolver<Array<ResolversTypes['NoteReference']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['NoteStatusEnum'], ParentType, ContextType>;
  tags?: Resolver<Array<ResolversTypes['NoteTag']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['UriPartString'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
};

export type NoteReferenceResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['NoteReference'] = ResolversParentTypes['NoteReference']> = {
  collection?: Resolver<ResolversTypes['CollectionNameEnum'], ParentType, ContextType>;
  documentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
};

export type NoteTagResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['NoteTag'] = ResolversParentTypes['NoteTag']> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OpAccessResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['OPAccess'] = ResolversParentTypes['OPAccess']> = {
  accounts?: Resolver<Maybe<Array<ResolversTypes['OPAccessItem']>>, ParentType, ContextType>;
  balances?: Resolver<Maybe<Array<ResolversTypes['OPAccessItem']>>, ParentType, ContextType>;
  transactions?: Resolver<Maybe<Array<ResolversTypes['OPAccessItem']>>, ParentType, ContextType>;
};

export type OpAccessItemResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['OPAccessItem'] = ResolversParentTypes['OPAccessItem']> = {
  iban?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type OpConsentResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['OPConsent'] = ResolversParentTypes['OPConsent']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  access?: Resolver<ResolversTypes['OPAccess'], ParentType, ContextType>;
  bic?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['NameAndId']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  consentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  consentStatus?: Resolver<ResolversTypes['OPConsentStatus'], ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  createUserId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  createUserInfo?: Resolver<Maybe<ResolversTypes['NameAndId']>, ParentType, ContextType>;
  frequencyPerDay?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lastActionDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  psuId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recurringIndicator?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['NameAndId']>, ParentType, ContextType>;
  validUntil?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type OpPaymentResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['OPPayment'] = ResolversParentTypes['OPPayment']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  _links?: Resolver<ResolversTypes['OpenPaymentLinkData'], ParentType, ContextType>;
  authorizationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  createUserId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  createUserInfo?: Resolver<Maybe<ResolversTypes['NameAndId']>, ParentType, ContextType>;
  creditorAccount?: Resolver<Maybe<ResolversTypes['OPAccessItem']>, ParentType, ContextType>;
  creditorAgent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creditorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  debtorAccount?: Resolver<Maybe<ResolversTypes['OPAccessItem']>, ParentType, ContextType>;
  debtorAccountMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endToEndIdentification?: Resolver<Maybe<ResolversTypes['Max35CharString']>, ParentType, ContextType>;
  instructedAmount?: Resolver<Maybe<ResolversTypes['AmountData']>, ParentType, ContextType>;
  paymentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  remittanceInformationStructured?: Resolver<Maybe<ResolversTypes['RemittanceInformationStructured']>, ParentType, ContextType>;
  remittanceInformationUnstructured?: Resolver<Maybe<ResolversTypes['Max140CharString']>, ParentType, ContextType>;
  requestedExecutionDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  signingBasketId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tppMessages?: Resolver<Maybe<Array<ResolversTypes['TppMessage']>>, ParentType, ContextType>;
  transactionFees?: Resolver<Maybe<ResolversTypes['AmountData']>, ParentType, ContextType>;
  transactionStatus?: Resolver<ResolversTypes['OPPaymentStatusEnum'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['NameAndId']>, ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type OpSigningBasketDataResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['OPSigningBasketData'] = ResolversParentTypes['OPSigningBasketData']> = {
  payments?: Resolver<Array<ResolversTypes['OPPayment']>, ParentType, ContextType>;
  redirectLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type OpenPaymentLinkResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['OpenPaymentLink'] = ResolversParentTypes['OpenPaymentLink']> = {
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type OpenPaymentLinkDataResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['OpenPaymentLinkData'] = ResolversParentTypes['OpenPaymentLinkData']> = {
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scaOAuth?: Resolver<Maybe<ResolversTypes['OpenPaymentLink']>, ParentType, ContextType>;
  scaRedirect?: Resolver<Maybe<ResolversTypes['OpenPaymentLink']>, ParentType, ContextType>;
  scaStatus?: Resolver<Maybe<ResolversTypes['OpenPaymentLink']>, ParentType, ContextType>;
  self?: Resolver<Maybe<ResolversTypes['OpenPaymentLink']>, ParentType, ContextType>;
  startAuthorisation?: Resolver<Maybe<ResolversTypes['OpenPaymentLink']>, ParentType, ContextType>;
  startAuthorisationWithAuthenticationMethodSelection?: Resolver<Maybe<ResolversTypes['OpenPaymentLink']>, ParentType, ContextType>;
  startAuthorisationWithEncryptedPsuAuthentication?: Resolver<Maybe<ResolversTypes['OpenPaymentLink']>, ParentType, ContextType>;
  startAuthorisationWithPsuAuthentication?: Resolver<Maybe<ResolversTypes['OpenPaymentLink']>, ParentType, ContextType>;
  startAuthorisationWithPsuIdentification?: Resolver<Maybe<ResolversTypes['OpenPaymentLink']>, ParentType, ContextType>;
  startAuthorisationWithTransactionAuthorisation?: Resolver<Maybe<ResolversTypes['OpenPaymentLink']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['OpenPaymentLink']>, ParentType, ContextType>;
};

export type PartyResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Party'] = ResolversParentTypes['Party']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  accountant?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountingCompanyType?: Resolver<Maybe<ResolversTypes['AccountingCompanyTypeEnum']>, ParentType, ContextType>;
  accountingCurrency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  accountingFrequency?: Resolver<Maybe<ResolversTypes['AccountingFrequencyEnum']>, ParentType, ContextType>;
  accounts?: Resolver<Array<ResolversTypes['PartyAccount']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  aliases?: Resolver<Array<ResolversTypes['Alias']>, ParentType, ContextType>;
  approval?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  beneficialOwner?: Resolver<Maybe<ResolversTypes['BeneficialOwner']>, ParentType, ContextType>;
  bloombergEquityTicker?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  businessIdentifierCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ceo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  complaintsManager?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['CountryCodeEnum']>, ParentType, ContextType>;
  creditRatingScale?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  creditRatings?: Resolver<Array<ResolversTypes['PartyCreditRating']>, ParentType, ContextType>;
  dashName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalAccounts?: Resolver<Array<ResolversTypes['PartyExternalAccount']>, ParentType, ContextType>;
  firstTradeDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  fundInfo?: Resolver<Maybe<ResolversTypes['PartyFundInfo']>, ParentType, ContextType>;
  inLedgerNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  inLedgerTradeDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  industryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instrumentIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  instruments?: Resolver<Array<ResolversTypes['Instrument']>, ParentType, ContextType>;
  issuer?: Resolver<Maybe<ResolversTypes['PartyIssuerType']>, ParentType, ContextType>;
  issuerType?: Resolver<Maybe<ResolversTypes['IssuerTypeEnum']>, ParentType, ContextType>;
  legalEntityIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legalNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  limitSlackChannel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  limitStartDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  longName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nace?: Resolver<Maybe<ResolversTypes['NaceClass']>, ParentType, ContextType>;
  naceDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  regulator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  standardSettlementInstructions?: Resolver<Array<ResolversTypes['PartyStandardSettlementInstruction']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['PartyStatusEnum']>, ParentType, ContextType>;
  sustainalyticsData?: Resolver<Maybe<ResolversTypes['SustainalyticsDataModelWithStatus']>, ParentType, ContextType>;
  sustainalyticsId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timezone?: Resolver<Maybe<ResolversTypes['TimezoneEnum']>, ParentType, ContextType>;
  topAccount?: Resolver<Maybe<ResolversTypes['PartyAccount']>, ParentType, ContextType>;
  types?: Resolver<Array<Maybe<ResolversTypes['PartyType']>>, ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PartyAccountResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['PartyAccount'] = ResolversParentTypes['PartyAccount']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  benchmarks?: Resolver<Array<ResolversTypes['PartyBenchmark']>, ParentType, ContextType>;
  childrenAccounts?: Resolver<Array<ResolversTypes['PartyAccount']>, ParentType, ContextType>;
  childrenAccountsIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  clientName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultAccount?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  defaultAccruedInstruments?: Resolver<Maybe<Array<ResolversTypes['DefaultCashInstrument']>>, ParentType, ContextType>;
  defaultCashInstruments?: Resolver<Array<ResolversTypes['DefaultCashInstrument']>, ParentType, ContextType>;
  defaultDebtInstruments?: Resolver<Array<ResolversTypes['DefaultCashInstrument']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modelIndexBenchmark?: Resolver<Maybe<ResolversTypes['ModelIndexBenchmark']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  parentAccountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  securityExternalAccountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  transientCashInstruments?: Resolver<Array<ResolversTypes['DefaultCashInstrument']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PartyAccountType'], ParentType, ContextType>;
  weights?: Resolver<Array<ResolversTypes['PartyAccountWeight']>, ParentType, ContextType>;
};

export type PartyAccountWeightResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['PartyAccountWeight'] = ResolversParentTypes['PartyAccountWeight']> = {
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  expectedReturn?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  max?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  min?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  model?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type PartyBenchmarkResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['PartyBenchmark'] = ResolversParentTypes['PartyBenchmark']> = {
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  mainBenchmark?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  showBenchmark?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showExternal?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type PartyCreditRatingResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['PartyCreditRating'] = ResolversParentTypes['PartyCreditRating']> = {
  creditRatingAgencyId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  grade?: Resolver<ResolversTypes['GraphQLCreditRating'], ParentType, ContextType>;
};

export type PartyEsgResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['PartyEsg'] = ResolversParentTypes['PartyEsg']> = {
  attachments?: Resolver<Maybe<Array<ResolversTypes['Attachment']>>, ParentType, ContextType>;
  comments?: Resolver<Array<ResolversTypes['EsgComment']>, ParentType, ContextType>;
  globalStandardScreen?: Resolver<Array<ResolversTypes['GlobalStandardScreen']>, ParentType, ContextType>;
  productInvolvement?: Resolver<Array<ResolversTypes['ProductInvolvement']>, ParentType, ContextType>;
  shareholderEngagement?: Resolver<Array<ResolversTypes['ShareholderEngagement']>, ParentType, ContextType>;
};

export type PartyExternalAccountResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['PartyExternalAccount'] = ResolversParentTypes['PartyExternalAccount']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  agreement?: Resolver<Maybe<ResolversTypes['Agreement']>, ParentType, ContextType>;
  attachments?: Resolver<Array<ResolversTypes['Attachment']>, ParentType, ContextType>;
  baseCurrency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  clearingBroker?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clearingBrokerId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  clearingHouses?: Resolver<Maybe<Array<ResolversTypes['Party']>>, ParentType, ContextType>;
  clearingHousesIds?: Resolver<Maybe<Array<ResolversTypes['GraphQLObjectId']>>, ParentType, ContextType>;
  custodian?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  custodianAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  custodianAccountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  custodianId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emirReporting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  initialMarginCurrencies?: Resolver<Maybe<Array<ResolversTypes['CurrencyEnum']>>, ParentType, ContextType>;
  minimumTransferAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  noCollateralRequirement?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  partyInstrumentIds?: Resolver<Maybe<Array<ResolversTypes['GraphQLObjectId']>>, ParentType, ContextType>;
  partyInstruments?: Resolver<Maybe<Array<ResolversTypes['Instrument']>>, ParentType, ContextType>;
  principalCurrencies?: Resolver<Maybe<Array<ResolversTypes['CurrencyEnum']>>, ParentType, ContextType>;
  reconcile?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  roundingAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  separatedInitialMargin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  settlementOnVMInstrument?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  threshold?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['PartyExternalAccountType']>, ParentType, ContextType>;
  variationMarginCurrencies?: Resolver<Maybe<Array<ResolversTypes['CurrencyEnum']>>, ParentType, ContextType>;
};

export type PartyFundInfoResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['PartyFundInfo'] = ResolversParentTypes['PartyFundInfo']> = {
  calendar?: Resolver<Maybe<ResolversTypes['Calendar']>, ParentType, ContextType, Partial<PartyFundInfoCalendarArgs>>;
  calendarNames?: Resolver<Maybe<Array<ResolversTypes['CalendarNameEnum']>>, ParentType, ContextType>;
  classes?: Resolver<Array<Maybe<ResolversTypes['PartyFundInfoClass']>>, ParentType, ContextType>;
  createRedeemInstrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  createRedeemInstrumentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  custodian?: Resolver<Maybe<ResolversTypes['PartyInfo']>, ParentType, ContextType>;
  custodianId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  depositary?: Resolver<Maybe<ResolversTypes['PartyInfo']>, ParentType, ContextType>;
  depositaryId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  esgComponents?: Resolver<Maybe<Array<ResolversTypes['EsgComponentEnum']>>, ParentType, ContextType>;
  fundCompany?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  fundCompanyId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  fundDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fundManager?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fundReportComponents?: Resolver<Maybe<Array<ResolversTypes['FundReportComponentEnum']>>, ParentType, ContextType>;
  fundReportTypes?: Resolver<Array<ResolversTypes['FundReportEnum']>, ParentType, ContextType>;
  fundType?: Resolver<Maybe<ResolversTypes['FundTypeEnum']>, ParentType, ContextType>;
  portfolio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  riskLevel?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ta?: Resolver<Maybe<ResolversTypes['PartyInfo']>, ParentType, ContextType>;
  taId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  tradeFrequency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PartyFundInfoClassResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['PartyFundInfoClass'] = ResolversParentTypes['PartyFundInfoClass']> = {
  carryOwnCostPossible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  cleanClass?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  dividendPaying?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  earlyCloseTradeCutOff?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  fxHedgeAccount?: Resolver<Maybe<ResolversTypes['PartyAccount']>, ParentType, ContextType>;
  fxHedgeAccountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  fxHedged?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  mainClass?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  managementFee?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  managementFeeStruct?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minimumInitialSubscription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minimumSubscriptionAdded?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numberOfDecimalsNAVPerUnit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfDecimalsUnits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  redemptionFee?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sIFA_ID?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sIFA_UNIT?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sfdr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shareClass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  startNAVPerUnit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionFee?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tradeCutOff?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PartyInfoResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['PartyInfo'] = ResolversParentTypes['PartyInfo']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PartyIssuerTypeResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['PartyIssuerType'] = ResolversParentTypes['PartyIssuerType']> = {
  activitiesAffectingBiodiversityAreas?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  captorDnshCompliant?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  carbonFootprint?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  deforestation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  energyIntensityHighImpact?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  esg?: Resolver<Maybe<ResolversTypes['PartyEsg']>, ParentType, ContextType>;
  fossilFuelCompaniesExposure?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ghgEmissions?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ghgIntensityOfInvesteeCompanies?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hazardousWasteRatio?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  iorp?: Resolver<Maybe<ResolversTypes['IorpEnum']>, ParentType, ContextType>;
  keySector?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lackOfProcessesAndCompliance?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  managementSupervisoryGenderDiversity?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nearTermTargetClassification?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netZeroCommitted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nonRenewableEnergyShare?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pollutionOfWater?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  recordableWorkAccidents?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  scienceBasedTargetInitiative?: Resolver<ResolversTypes['ScienceBasedTargetInitiativeEnum'], ParentType, ContextType>;
  transitionCompany?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  unadjustedGenderPayGap?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type PartyStandardSettlementInstructionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['PartyStandardSettlementInstruction'] = ResolversParentTypes['PartyStandardSettlementInstruction']> = {
  agentBusinessIdentifierCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  beneficiaryBusinessIdentifierCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  buyerSellerSafe?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  iban?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  placeOfSettlementId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  securityAccount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeType?: Resolver<Maybe<ResolversTypes['SsiTradeType']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PortfolioPerformanceResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['PortfolioPerformance'] = ResolversParentTypes['PortfolioPerformance']> = {
  cashFlows?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  dates?: Resolver<Maybe<Array<Maybe<ResolversTypes['GraphQLDateString']>>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  instrumentPerformances?: Resolver<Maybe<Array<Maybe<ResolversTypes['InstrumentPerformance']>>>, ParentType, ContextType>;
  performanceItems?: Resolver<Maybe<Array<Maybe<ResolversTypes['PortfolioPerformanceItem']>>>, ParentType, ContextType>;
  series?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  values?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
};

export type PortfolioPerformanceItemResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['PortfolioPerformanceItem'] = ResolversParentTypes['PortfolioPerformanceItem']> = {
  cashFlow?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  series?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalReturn?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type PortfolioSwapItemValuationResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['PortfolioSwapItemValuation'] = ResolversParentTypes['PortfolioSwapItemValuation']> = {
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['PortfolioSwapItemValue'], ParentType, ContextType>;
};

export type PortfolioSwapItemValueResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['PortfolioSwapItemValue'] = ResolversParentTypes['PortfolioSwapItemValue']> = {
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type PortfolioSwapItemsPositionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['PortfolioSwapItemsPosition'] = ResolversParentTypes['PortfolioSwapItemsPosition']> = {
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  isDebtInstrument?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  valuation?: Resolver<ResolversTypes['PortfolioSwapItemValuation'], ParentType, ContextType>;
};

export type PositionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Position'] = ResolversParentTypes['Position']> = {
  account?: Resolver<Maybe<ResolversTypes['PartyAccount']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalAccount?: Resolver<Maybe<ResolversTypes['PartyExternalAccount']>, ParentType, ContextType>;
  externalAccountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  isCashAccount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  portfolioInstrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  portfolioInstrumentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type PriceResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Price'] = ResolversParentTypes['Price']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  accruedInterest?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cleanPrice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  spread?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PriceTypeEnum'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type ProductInvolvementResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['ProductInvolvement'] = ResolversParentTypes['ProductInvolvement']> = {
  involvement?: Resolver<ResolversTypes['ProductInvolvementIndicator'], ParentType, ContextType>;
  range?: Resolver<ResolversTypes['RangeEnum'], ParentType, ContextType>;
};

export type PublishedToTypeResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['PublishedToType'] = ResolversParentTypes['PublishedToType']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
};

export type QuantLibPeriodResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['QuantLibPeriod'] = ResolversParentTypes['QuantLibPeriod']> = {
  unit?: Resolver<Maybe<ResolversTypes['QuantLibTimeUnitEnum']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type QueryResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  accountPerformance?: Resolver<Maybe<ResolversTypes['PortfolioPerformance']>, ParentType, ContextType, RequireFields<QueryAccountPerformanceArgs, 'accountId'>>;
  accountingRun?: Resolver<Maybe<ResolversTypes['AccountingRun']>, ParentType, ContextType, RequireFields<QueryAccountingRunArgs, '_id'>>;
  accountingRunId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  accountingRuns?: Resolver<Maybe<Array<Maybe<ResolversTypes['AccountingRun']>>>, ParentType, ContextType, Partial<QueryAccountingRunsArgs>>;
  accountingRuns2?: Resolver<Maybe<Array<ResolversTypes['AccountingRun2']>>, ParentType, ContextType, Partial<QueryAccountingRuns2Args>>;
  adjustmentAmount?: Resolver<Maybe<Array<Maybe<ResolversTypes['TradingManagerColumn']>>>, ParentType, ContextType, RequireFields<QueryAdjustmentAmountArgs, 'clientId' | 'date'>>;
  agreements?: Resolver<Maybe<Array<Maybe<ResolversTypes['Agreement']>>>, ParentType, ContextType, Partial<QueryAgreementsArgs>>;
  allInstrumentsInPosition?: Resolver<Maybe<Array<Maybe<ResolversTypes['InstrumentPosition']>>>, ParentType, ContextType, Partial<QueryAllInstrumentsInPositionArgs>>;
  annualReports?: Resolver<Array<ResolversTypes['AnnualReportType']>, ParentType, ContextType, RequireFields<QueryAnnualReportsArgs, 'clientIds' | 'date'>>;
  attachment?: Resolver<Maybe<ResolversTypes['Attachment']>, ParentType, ContextType, RequireFields<QueryAttachmentArgs, '_id'>>;
  attachments?: Resolver<Array<ResolversTypes['Attachment']>, ParentType, ContextType, Partial<QueryAttachmentsArgs>>;
  bankAccountBalances?: Resolver<Array<ResolversTypes['BankAccountBalance']>, ParentType, ContextType, Partial<QueryBankAccountBalancesArgs>>;
  bankAccountTransactions?: Resolver<Array<ResolversTypes['BankAccountTransaction']>, ParentType, ContextType, Partial<QueryBankAccountTransactionsArgs>>;
  baseCalendars?: Resolver<Maybe<Array<Maybe<ResolversTypes['BaseCalendar']>>>, ParentType, ContextType, Partial<QueryBaseCalendarsArgs>>;
  brokerTransactions?: Resolver<Array<ResolversTypes['BrokerTransaction']>, ParentType, ContextType, Partial<QueryBrokerTransactionsArgs>>;
  calculateNav?: Resolver<Maybe<ResolversTypes['NavData']>, ParentType, ContextType, RequireFields<QueryCalculateNavArgs, 'date' | 'fundId'>>;
  calendar?: Resolver<Maybe<ResolversTypes['Calendar']>, ParentType, ContextType, Partial<QueryCalendarArgs>>;
  cashBalances?: Resolver<Maybe<Array<Maybe<ResolversTypes['CashAccountBalance']>>>, ParentType, ContextType, RequireFields<QueryCashBalancesArgs, 'instrumentIds' | 'viewFromDate'>>;
  cashLadder?: Resolver<Maybe<Array<Maybe<ResolversTypes['CashAccountLadder']>>>, ParentType, ContextType, RequireFields<QueryCashLadderArgs, 'clientIds'>>;
  clientAccounts?: Resolver<Maybe<Array<Maybe<ResolversTypes['PartyAccount']>>>, ParentType, ContextType, Partial<QueryClientAccountsArgs>>;
  clientsByAssets?: Resolver<Array<ResolversTypes['ClientForAsset']>, ParentType, ContextType>;
  corporateActions?: Resolver<Maybe<Array<ResolversTypes['CorporateAction']>>, ParentType, ContextType, Partial<QueryCorporateActionsArgs>>;
  costs?: Resolver<Maybe<Array<Maybe<ResolversTypes['Cost']>>>, ParentType, ContextType, Partial<QueryCostsArgs>>;
  curveDefinition?: Resolver<Maybe<ResolversTypes['CurveDefinition']>, ParentType, ContextType, RequireFields<QueryCurveDefinitionArgs, '_id'>>;
  curveDefinitionInstruments?: Resolver<Array<ResolversTypes['Instrument']>, ParentType, ContextType>;
  curveDefinitions?: Resolver<Maybe<Array<Maybe<ResolversTypes['CurveDefinition']>>>, ParentType, ContextType>;
  custodianPositions?: Resolver<Array<ResolversTypes['CustodianApiPosition']>, ParentType, ContextType, Partial<QueryCustodianPositionsArgs>>;
  customers?: Resolver<Maybe<Array<Maybe<ResolversTypes['Customer']>>>, ParentType, ContextType, Partial<QueryCustomersArgs>>;
  dart?: Resolver<Maybe<ResolversTypes['DartReport']>, ParentType, ContextType, RequireFields<QueryDartArgs, 'clientId'>>;
  defaultQuery?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exposuresCollaterals?: Resolver<Array<ResolversTypes['ExposureCollateral']>, ParentType, ContextType, Partial<QueryExposuresCollateralsArgs>>;
  extensions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Extension']>>>, ParentType, ContextType, Partial<QueryExtensionsArgs>>;
  externalAccountsPositions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Position']>>>, ParentType, ContextType, RequireFields<QueryExternalAccountsPositionsArgs, 'custodianAccountNumbers'>>;
  firstTransaction?: Resolver<Maybe<ResolversTypes['Transaction']>, ParentType, ContextType, RequireFields<QueryFirstTransactionArgs, 'clientId' | 'instrumentId'>>;
  firstTransactions?: Resolver<Maybe<Array<ResolversTypes['Transaction']>>, ParentType, ContextType, RequireFields<QueryFirstTransactionsArgs, 'clientIds' | 'instrumentIds'>>;
  fredSeriesObservations?: Resolver<Maybe<Array<Maybe<ResolversTypes['FredObservation']>>>, ParentType, ContextType, RequireFields<QueryFredSeriesObservationsArgs, 'id'>>;
  fredSeriess?: Resolver<Maybe<Array<Maybe<ResolversTypes['FredSeries']>>>, ParentType, ContextType, RequireFields<QueryFredSeriessArgs, 'id'>>;
  fundPerformance?: Resolver<Maybe<ResolversTypes['FundPortfolioPerformance']>, ParentType, ContextType, Partial<QueryFundPerformanceArgs>>;
  fundUnits?: Resolver<Maybe<Array<Maybe<ResolversTypes['FundUnit']>>>, ParentType, ContextType, Partial<QueryFundUnitsArgs>>;
  fxMiniTransactions?: Resolver<Maybe<Array<Maybe<ResolversTypes['MiniTransaction']>>>, ParentType, ContextType, Partial<QueryFxMiniTransactionsArgs>>;
  fxValuations?: Resolver<Maybe<Array<Maybe<ResolversTypes['FxValuation']>>>, ParentType, ContextType, Partial<QueryFxValuationsArgs>>;
  getRedisKey?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, RequireFields<QueryGetRedisKeyArgs, 'key'>>;
  historicalData?: Resolver<Maybe<Array<Maybe<ResolversTypes['HistoricalData']>>>, ParentType, ContextType, RequireFields<QueryHistoricalDataArgs, 'endDate' | 'startDate'>>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType, Partial<QueryInstrumentArgs>>;
  instrumentAccountPositions?: Resolver<Maybe<Array<Maybe<ResolversTypes['InstrumentAccountPosition']>>>, ParentType, ContextType, RequireFields<QueryInstrumentAccountPositionsArgs, 'instrumentIds'>>;
  instruments?: Resolver<Maybe<Array<Maybe<ResolversTypes['Instrument']>>>, ParentType, ContextType, Partial<QueryInstrumentsArgs>>;
  instrumentsUsedBy?: Resolver<Maybe<Array<Maybe<ResolversTypes['Instrument']>>>, ParentType, ContextType, Partial<QueryInstrumentsUsedByArgs>>;
  inventory?: Resolver<Array<ResolversTypes['Inventory']>, ParentType, ContextType, RequireFields<QueryInventoryArgs, 'clientId' | 'endDate'>>;
  issuerprograms?: Resolver<Maybe<Array<Maybe<ResolversTypes['IssuerProgram']>>>, ParentType, ContextType, Partial<QueryIssuerprogramsArgs>>;
  journalEntries?: Resolver<Maybe<Array<ResolversTypes['JournalEntry']>>, ParentType, ContextType, Partial<QueryJournalEntriesArgs>>;
  journalEntries2?: Resolver<Maybe<Array<ResolversTypes['JournalEntry2']>>, ParentType, ContextType, Partial<QueryJournalEntries2Args>>;
  journalEntry?: Resolver<Maybe<ResolversTypes['JournalEntry']>, ParentType, ContextType, Partial<QueryJournalEntryArgs>>;
  journalEntry2?: Resolver<Maybe<ResolversTypes['JournalEntry2']>, ParentType, ContextType, Partial<QueryJournalEntry2Args>>;
  kleerAccountMetadata?: Resolver<Maybe<Array<Maybe<ResolversTypes['KleerAccountMetadata']>>>, ParentType, ContextType, RequireFields<QueryKleerAccountMetadataArgs, 'endDate' | 'startDate'>>;
  kleerAccountingYears?: Resolver<Maybe<Array<Maybe<ResolversTypes['KleerAccountingYear']>>>, ParentType, ContextType, Partial<QueryKleerAccountingYearsArgs>>;
  kleerCompanyInfo?: Resolver<Maybe<ResolversTypes['KleerCompanyInfo']>, ParentType, ContextType, Partial<QueryKleerCompanyInfoArgs>>;
  kleerResultReport?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType, Partial<QueryKleerResultReportArgs>>;
  kleerRevenueLedgers?: Resolver<Maybe<Array<Maybe<ResolversTypes['KleerRevenueLedger']>>>, ParentType, ContextType, Partial<QueryKleerRevenueLedgersArgs>>;
  kleerRevenues?: Resolver<Maybe<Array<Maybe<ResolversTypes['KleerRevenue']>>>, ParentType, ContextType, RequireFields<QueryKleerRevenuesArgs, 'ledgerId'>>;
  kleerVouchers?: Resolver<Maybe<Array<Maybe<ResolversTypes['KleerVoucher']>>>, ParentType, ContextType, Partial<QueryKleerVouchersArgs>>;
  lastValuations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Valuation']>>>, ParentType, ContextType, Partial<QueryLastValuationsArgs>>;
  latestExternalNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryLatestExternalNumberArgs, 'accountingPeriod' | 'clientId'>>;
  latestExternalNumber2?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<QueryLatestExternalNumber2Args, 'accountingPeriod' | 'clientId'>>;
  limit?: Resolver<Maybe<Array<Maybe<ResolversTypes['LimitData']>>>, ParentType, ContextType, RequireFields<QueryLimitArgs, 'clientId'>>;
  marginRequirements?: Resolver<Array<ResolversTypes['MarginRequirement']>, ParentType, ContextType, Partial<QueryMarginRequirementsArgs>>;
  me?: Resolver<Maybe<ResolversTypes['Me']>, ParentType, ContextType>;
  miniTransaction?: Resolver<Maybe<ResolversTypes['MiniTransaction']>, ParentType, ContextType, Partial<QueryMiniTransactionArgs>>;
  miniTransactions?: Resolver<Maybe<Array<Maybe<ResolversTypes['MiniTransaction']>>>, ParentType, ContextType, Partial<QueryMiniTransactionsArgs>>;
  missingFxRateTransactions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Transaction']>>>, ParentType, ContextType, Partial<QueryMissingFxRateTransactionsArgs>>;
  nav?: Resolver<Maybe<ResolversTypes['Nav']>, ParentType, ContextType, RequireFields<QueryNavArgs, '_id'>>;
  navs?: Resolver<Maybe<Array<Maybe<ResolversTypes['Nav']>>>, ParentType, ContextType, Partial<QueryNavsArgs>>;
  notes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Note']>>>, ParentType, ContextType, Partial<QueryNotesArgs>>;
  opConsents?: Resolver<Maybe<Array<Maybe<ResolversTypes['OPConsent']>>>, ParentType, ContextType, Partial<QueryOpConsentsArgs>>;
  opPayments?: Resolver<Maybe<Array<Maybe<ResolversTypes['OPPayment']>>>, ParentType, ContextType, Partial<QueryOpPaymentsArgs>>;
  opSigningBasketAuthorization?: Resolver<Maybe<ResolversTypes['SigningBasketAuthorization']>, ParentType, ContextType, RequireFields<QueryOpSigningBasketAuthorizationArgs, 'signingBasketId'>>;
  parties?: Resolver<Maybe<Array<Maybe<ResolversTypes['Party']>>>, ParentType, ContextType, Partial<QueryPartiesArgs>>;
  party?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType, Partial<QueryPartyArgs>>;
  partyExternalAccount?: Resolver<Maybe<ResolversTypes['PartyExternalAccount']>, ParentType, ContextType, RequireFields<QueryPartyExternalAccountArgs, 'clientId' | 'externalAccountId'>>;
  partyUsage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<QueryPartyUsageArgs, 'partyId'>>;
  performance?: Resolver<Maybe<ResolversTypes['PortfolioPerformance']>, ParentType, ContextType, RequireFields<QueryPerformanceArgs, 'clientId'>>;
  performancePrice?: Resolver<Maybe<ResolversTypes['PortfolioPerformance']>, ParentType, ContextType, RequireFields<QueryPerformancePriceArgs, 'clientId'>>;
  portfolioSwapConstituents?: Resolver<Maybe<Array<Maybe<ResolversTypes['PortfolioSwapItemsPosition']>>>, ParentType, ContextType, RequireFields<QueryPortfolioSwapConstituentsArgs, 'portfolioInstrumentId'>>;
  positions?: Resolver<Maybe<Array<Maybe<ResolversTypes['Position']>>>, ParentType, ContextType, Partial<QueryPositionsArgs>>;
  prices?: Resolver<Maybe<Array<Maybe<ResolversTypes['Price']>>>, ParentType, ContextType, Partial<QueryPricesArgs>>;
  quotes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Quote']>>>, ParentType, ContextType, Partial<QueryQuotesArgs>>;
  reconcileExposureCollateral?: Resolver<Array<ResolversTypes['ReconciledExposureCollateralType']>, ParentType, ContextType, RequireFields<QueryReconcileExposureCollateralArgs, 'clientIds' | 'date'>>;
  reconcileFundUnits?: Resolver<Maybe<Array<ResolversTypes['FundUnitReconciliationType']>>, ParentType, ContextType, RequireFields<QueryReconcileFundUnitsArgs, 'date'>>;
  reconcilePositions?: Resolver<Maybe<Array<ResolversTypes['ReconciliationType']>>, ParentType, ContextType, RequireFields<QueryReconcilePositionsArgs, 'date'>>;
  redisKeys?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  referenceData?: Resolver<Maybe<Array<Maybe<ResolversTypes['ReferenceData']>>>, ParentType, ContextType, Partial<QueryReferenceDataArgs>>;
  registerExtracts?: Resolver<Maybe<Array<ResolversTypes['RegisterExtract']>>, ParentType, ContextType, Partial<QueryRegisterExtractsArgs>>;
  report?: Resolver<Maybe<ResolversTypes['Report']>, ParentType, ContextType, RequireFields<QueryReportArgs, '_id'>>;
  reportTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType, Partial<QueryReportTypesArgs>>;
  reports?: Resolver<Maybe<Array<Maybe<ResolversTypes['Report']>>>, ParentType, ContextType, Partial<QueryReportsArgs>>;
  role?: Resolver<Maybe<ResolversTypes['Role']>, ParentType, ContextType, RequireFields<QueryRoleArgs, '_id'>>;
  roles?: Resolver<Maybe<Array<Maybe<ResolversTypes['Role']>>>, ParentType, ContextType, Partial<QueryRolesArgs>>;
  screens?: Resolver<Maybe<Array<Maybe<ResolversTypes['Screen']>>>, ParentType, ContextType, Partial<QueryScreensArgs>>;
  securityLadder?: Resolver<Maybe<Array<Maybe<ResolversTypes['SecurityLadder']>>>, ParentType, ContextType, RequireFields<QuerySecurityLadderArgs, 'clientIds'>>;
  shareRegister?: Resolver<Maybe<Array<ResolversTypes['ShareRegisterItem']>>, ParentType, ContextType, Partial<QueryShareRegisterArgs>>;
  shareRegisterDelta?: Resolver<Maybe<Array<ResolversTypes['ShareRegisterItem']>>, ParentType, ContextType, Partial<QueryShareRegisterDeltaArgs>>;
  shareRegisterUnits?: Resolver<Maybe<Array<ResolversTypes['ShareRegisterUnits']>>, ParentType, ContextType, Partial<QueryShareRegisterUnitsArgs>>;
  shareRegisters?: Resolver<Maybe<Array<ResolversTypes['ShareRegisterItem']>>, ParentType, ContextType, RequireFields<QueryShareRegistersArgs, 'fromDate' | 'toDate'>>;
  sustainalyticsDataModel?: Resolver<Array<ResolversTypes['SustainalyticsDataModel']>, ParentType, ContextType, RequireFields<QuerySustainalyticsDataModelArgs, 'identifiers' | 'productId'>>;
  sustainalyticsDataService?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainalyticsDataModelWithStatus']>>>, ParentType, ContextType, RequireFields<QuerySustainalyticsDataServiceArgs, 'productId'>>;
  sustainalyticsFieldDefinitions?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainalyticsFieldDefinitionModel']>>>, ParentType, ContextType>;
  sustainalyticsFieldMappingDefinitions?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainalyticsProductModel']>>>, ParentType, ContextType>;
  sustainalyticsFieldMappings?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainalyticsProductModel']>>>, ParentType, ContextType>;
  sustainalyticsReport?: Resolver<Maybe<ResolversTypes['SustainalyticsReport']>, ParentType, ContextType, RequireFields<QuerySustainalyticsReportArgs, 'identifier' | 'productId'>>;
  sustainalyticsReportService?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainalyticsReport']>>>, ParentType, ContextType, RequireFields<QuerySustainalyticsReportServiceArgs, 'productId'>>;
  sustainalyticsReportUrl?: Resolver<Maybe<ResolversTypes['SustainalyticsReportUrl']>, ParentType, ContextType, RequireFields<QuerySustainalyticsReportUrlArgs, 'identifier' | 'reportId'>>;
  sustainalyticsUniverseOfAccess?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainalyticsSecurityListModel']>>>, ParentType, ContextType>;
  swifts?: Resolver<Maybe<Array<ResolversTypes['Swift']>>, ParentType, ContextType, Partial<QuerySwiftsArgs>>;
  tAccountChart?: Resolver<Maybe<ResolversTypes['TAccountChart']>, ParentType, ContextType, Partial<QueryTAccountChartArgs>>;
  tAccountChart2?: Resolver<Maybe<ResolversTypes['UpsertTAccountChart']>, ParentType, ContextType, RequireFields<QueryTAccountChart2Args, '_id'>>;
  tAccountChartAccountsExport?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryTAccountChartAccountsExportArgs, '_id'>>;
  tAccountChartMappingsExport?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryTAccountChartMappingsExportArgs, '_id'>>;
  tAccountCharts?: Resolver<Maybe<Array<Maybe<ResolversTypes['TAccountChart']>>>, ParentType, ContextType, Partial<QueryTAccountChartsArgs>>;
  tAccountCharts2?: Resolver<Maybe<Array<ResolversTypes['UpsertTAccountChart']>>, ParentType, ContextType, Partial<QueryTAccountCharts2Args>>;
  ticketUsers?: Resolver<Maybe<Array<ResolversTypes['TicketUser']>>, ParentType, ContextType>;
  tickets?: Resolver<Maybe<Array<Maybe<ResolversTypes['Ticket']>>>, ParentType, ContextType, Partial<QueryTicketsArgs>>;
  timeserie?: Resolver<Maybe<ResolversTypes['TimeSeries']>, ParentType, ContextType, Partial<QueryTimeserieArgs>>;
  timeseries?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimeSeries']>>>, ParentType, ContextType, Partial<QueryTimeseriesArgs>>;
  tradingmanager?: Resolver<Maybe<Array<Maybe<ResolversTypes['TradingManagerColumn']>>>, ParentType, ContextType, Partial<QueryTradingmanagerArgs>>;
  tradingmanager2?: Resolver<Maybe<Array<Maybe<ResolversTypes['TradingManagerColumn']>>>, ParentType, ContextType, RequireFields<QueryTradingmanager2Args, 'clientId'>>;
  transaction?: Resolver<Maybe<ResolversTypes['Transaction']>, ParentType, ContextType, Partial<QueryTransactionArgs>>;
  transactionItems?: Resolver<Maybe<Array<Maybe<ResolversTypes['TransactionItem']>>>, ParentType, ContextType, Partial<QueryTransactionItemsArgs>>;
  transactionitemStatus?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  transactions?: Resolver<Maybe<Array<ResolversTypes['Transaction']>>, ParentType, ContextType, Partial<QueryTransactionsArgs>>;
  transferAgentAccountPerformance?: Resolver<Maybe<ResolversTypes['TransferAgentAccountPerformance']>, ParentType, ContextType, RequireFields<QueryTransferAgentAccountPerformanceArgs, 'absoluteRebate' | 'clientAccount' | 'isin' | 'percentageRebate'>>;
  transferAgentOrder?: Resolver<Maybe<ResolversTypes['TransferAgentOrder']>, ParentType, ContextType, RequireFields<QueryTransferAgentOrderArgs, '_id'>>;
  transferAgentOrders?: Resolver<Maybe<Array<Maybe<ResolversTypes['TransferAgentOrder']>>>, ParentType, ContextType, Partial<QueryTransferAgentOrdersArgs>>;
  transferAgentTotalUnits?: Resolver<Maybe<Array<Maybe<ResolversTypes['TransferAgentTotalUnit']>>>, ParentType, ContextType, Partial<QueryTransferAgentTotalUnitsArgs>>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, Partial<QueryUserArgs>>;
  users?: Resolver<Maybe<Array<Maybe<ResolversTypes['User']>>>, ParentType, ContextType, Partial<QueryUsersArgs>>;
  usersLimited?: Resolver<Array<ResolversTypes['UserLimited']>, ParentType, ContextType, Partial<QueryUsersLimitedArgs>>;
  valuation?: Resolver<Maybe<ResolversTypes['Valuation']>, ParentType, ContextType, RequireFields<QueryValuationArgs, '_id'>>;
  valuationmappings?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValuationMapping']>>>, ParentType, ContextType, Partial<QueryValuationmappingsArgs>>;
  valuations?: Resolver<Maybe<Array<Maybe<ResolversTypes['Valuation']>>>, ParentType, ContextType, Partial<QueryValuationsArgs>>;
};

export type QuoteResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Quote'] = ResolversParentTypes['Quote']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  ask?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  close?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  dataVendorId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  last?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  market?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['QuoteTypeEnum'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type ReconciledExposureCollateralTypeResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['ReconciledExposureCollateralType'] = ResolversParentTypes['ReconciledExposureCollateralType']> = {
  agreementType?: Resolver<ResolversTypes['AgreementType'], ParentType, ContextType>;
  baseCurrency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['ClientInfo']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  counterpartyExposure?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  counterpartyHaircut?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  counterpartyInitialMarginCollateral?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  counterpartyInitialMarginNetRequirement?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  counterpartyInitialMarginPosted?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  counterpartyInitialMarginSecuritiesCollateral?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  counterpartyMarginCall?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  counterpartyNetExposure?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  counterpartyQuantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  counterpartyValuationDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  counterpartyVariationMarginCollateral?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  counterpartyVariationMarginPosted?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  counterpartyVariationMarginSecuritiesCollateral?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  creditYieldDeltaSum?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  exposure?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  exposureDifference?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  externalAccount?: Resolver<Maybe<ResolversTypes['PartyExternalAccount']>, ParentType, ContextType>;
  externalAccountId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  haircut?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  haircutDifference?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  initialMarginCollateral?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  initialMarginCollateralDifference?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  initialMarginNetRequirement?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  initialMarginRequirement?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  initialMarginSecuritiesCollateral?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  initialMarginSecuritiesCollateralDifference?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  interestRateYieldDeltaSum?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  marginCall?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  marginCallsMade?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  marginType?: Resolver<Maybe<ResolversTypes['MarginType']>, ParentType, ContextType>;
  minimumTransferAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  missingReport?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  netExposure?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  netExposureDifference?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  netInitialMarginRequirementDifference?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  noCollateralRequirement?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  quantityDifference?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  reconcileType?: Resolver<ResolversTypes['ReconcileTypeEnum'], ParentType, ContextType>;
  roundingAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  threshold?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ExposureCollateralType']>, ParentType, ContextType>;
  valuationDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  variationMarginCollateral?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  variationMarginCollateralDifference?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  variationMarginPosted?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  variationMarginSecuritiesCollateral?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  variationMarginSecuritiesCollateralDifference?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type ReconciliationTypeResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['ReconciliationType'] = ResolversParentTypes['ReconciliationType']> = {
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  custodian?: Resolver<Maybe<ResolversTypes['PartyInfo']>, ParentType, ContextType>;
  custodianDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  custodianId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  custodianPositionId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  custodianQuantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  diff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  externalAccount?: Resolver<Maybe<ResolversTypes['PartyExternalAccount']>, ParentType, ContextType>;
  externalAccountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  isCashAccount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  positionDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  positionQuantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
};

export type RedirectLinkInfoResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['RedirectLinkInfo'] = ResolversParentTypes['RedirectLinkInfo']> = {
  consentAuthId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  consentId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  link?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type RefDataErrorResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['RefDataError'] = ResolversParentTypes['RefDataError']> = {
  category?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  code?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  message?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  source?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  subcategory?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
};

export type RefDataFieldExceptionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['RefDataFieldException'] = ResolversParentTypes['RefDataFieldException']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['RefDataError']>>, ParentType, ContextType>;
  fieldId?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
};

export type RefDataFieldExceptionsArrayResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['RefDataFieldExceptionsArray'] = ResolversParentTypes['RefDataFieldExceptionsArray']> = {
  fieldExceptions?: Resolver<Maybe<Array<ResolversTypes['RefDataFieldException']>>, ParentType, ContextType>;
};

export type ReferenceDataResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['ReferenceData'] = ResolversParentTypes['ReferenceData']> = {
  eidDataArray?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  fieldData?: Resolver<Maybe<Array<Maybe<ResolversTypes['FieldDataItem']>>>, ParentType, ContextType>;
  fieldExceptionsArray?: Resolver<Maybe<Array<ResolversTypes['RefDataFieldExceptionsArray']>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  info?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  security?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  securityError?: Resolver<Maybe<Array<ResolversTypes['RefDataError']>>, ParentType, ContextType>;
};

export type RegisterExtractResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['RegisterExtract'] = ResolversParentTypes['RegisterExtract']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  client?: Resolver<ResolversTypes['PartyInfo'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  items?: Resolver<Array<ResolversTypes['RegisterExtractItem']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['PartyInfo'], ParentType, ContextType>;
  sourceId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  updateUserInfo?: Resolver<ResolversTypes['UserInfo'], ParentType, ContextType>;
};

export type RegisterExtractItemResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['RegisterExtractItem'] = ResolversParentTypes['RegisterExtractItem']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['CountryCodeEnum'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  detailedCustomerSpecifics?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fax?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fundClassName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fundId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fundPrice?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fundShortName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  isin?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  legalPerson?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nationalRegistrationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  organizationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purchaseAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taClientAccount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taClientAccountLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taClientName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  taxCountry?: Resolver<ResolversTypes['CountryCodeEnum'], ParentType, ContextType>;
};

export type RemittanceInformationStructuredResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['RemittanceInformationStructured'] = ResolversParentTypes['RemittanceInformationStructured']> = {
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referenceIssuer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ReportResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Report'] = ResolversParentTypes['Report']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  base64?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client?: Resolver<ResolversTypes['PartyInfo'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  clientName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  fileId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  mimeType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reportId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  sourceId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  sourceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ReportStatusEnum']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
};

export type RoleResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Role'] = ResolversParentTypes['Role']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  assets?: Resolver<Array<ResolversTypes['PermissionAssetEnum']>, ParentType, ContextType>;
  clientIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  clients?: Resolver<Array<ResolversTypes['RoleClientInfo']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nbrOfActiveUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  nbrOfUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  permissionType?: Resolver<ResolversTypes['permissionTypeEnum'], ParentType, ContextType>;
  roleType?: Resolver<ResolversTypes['RoleTypeEnum'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['DocumentStatusEnum'], ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type RoleClientInfoResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['RoleClientInfo'] = ResolversParentTypes['RoleClientInfo']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ScreenResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Screen'] = ResolversParentTypes['Screen']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  approved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  issuer?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  issuerProgram?: Resolver<Maybe<ResolversTypes['IssuerProgram']>, ParentType, ContextType>;
  objectId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  screenType?: Resolver<Maybe<ResolversTypes['ScreenType']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['DocumentStatusEnum']>, ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  updateUserInfo?: Resolver<ResolversTypes['UserInfo'], ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type SecurityLadderResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['SecurityLadder'] = ResolversParentTypes['SecurityLadder']> = {
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  dates?: Resolver<Array<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  positions?: Resolver<Array<ResolversTypes['Float']>, ParentType, ContextType>;
  quantities?: Resolver<Array<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type SelectorResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Selector'] = ResolversParentTypes['Selector']> = {
  accountIds?: Resolver<Array<Maybe<ResolversTypes['GraphQLObjectId']>>, ParentType, ContextType>;
  currencies?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  instrumentIds?: Resolver<Array<Maybe<ResolversTypes['GraphQLObjectId']>>, ParentType, ContextType>;
  statuses?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
};

export type ShareRegisterItemResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['ShareRegisterItem'] = ResolversParentTypes['ShareRegisterItem']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientAccount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customer?: Resolver<Maybe<ResolversTypes['Customer']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  fund?: Resolver<Maybe<ResolversTypes['PartyInfo']>, ParentType, ContextType>;
  fundId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  instrument?: Resolver<ResolversTypes['Instrument'], ParentType, ContextType>;
  isin?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  units?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ShareRegisterUnitsResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['ShareRegisterUnits'] = ResolversParentTypes['ShareRegisterUnits']> = {
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  fund?: Resolver<Maybe<ResolversTypes['PartyInfo']>, ParentType, ContextType>;
  fundId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  instrument?: Resolver<ResolversTypes['Instrument'], ParentType, ContextType>;
  isin?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  units?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ShareholderEngagementResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['ShareholderEngagement'] = ResolversParentTypes['ShareholderEngagement']> = {
  agm?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['EngagementMethod'], ParentType, ContextType>;
  norm?: Resolver<ResolversTypes['StandardScreenNorm'], ParentType, ContextType>;
  principle?: Resolver<ResolversTypes['StandardScreenPrinciple'], ParentType, ContextType>;
};

export type SigningBasketAuthorizationResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['SigningBasketAuthorization'] = ResolversParentTypes['SigningBasketAuthorization']> = {
  qrImage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SCAStatus'], ParentType, ContextType>;
};

export type SustainalyticsDataModelResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['SustainalyticsDataModel'] = ResolversParentTypes['SustainalyticsDataModel']> = {
  entityId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entityName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldNames?: Resolver<Array<ResolversTypes['SustainalyticsFieldDefinitionModel']>, ParentType, ContextType>;
  fields?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issuerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issuerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SustainalyticsDataModelWithStatusResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['SustainalyticsDataModelWithStatus'] = ResolversParentTypes['SustainalyticsDataModelWithStatus']> = {
  entityId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entityName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fields?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issuerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issuerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['SustainalyticsStatus']>, ParentType, ContextType>;
};

export type SustainalyticsFieldClusterModelResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['SustainalyticsFieldClusterModel'] = ResolversParentTypes['SustainalyticsFieldClusterModel']> = {
  fieldClusterId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldClusterName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldDefinitions?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainalyticsFieldDefinitionModel']>>>, ParentType, ContextType>;
  fieldIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
};

export type SustainalyticsFieldDefinitionModelResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['SustainalyticsFieldDefinitionModel'] = ResolversParentTypes['SustainalyticsFieldDefinitionModel']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldLength?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fieldType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  possibleValues?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SustainalyticsPackageModelResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['SustainalyticsPackageModel'] = ResolversParentTypes['SustainalyticsPackageModel']> = {
  clusters?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainalyticsFieldClusterModel']>>>, ParentType, ContextType>;
  packageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  packageName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SustainalyticsProductModelResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['SustainalyticsProductModel'] = ResolversParentTypes['SustainalyticsProductModel']> = {
  packages?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainalyticsPackageModel']>>>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SustainalyticsReportResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['SustainalyticsReport'] = ResolversParentTypes['SustainalyticsReport']> = {
  entityId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entityName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  identifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issuerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issuerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reports?: Resolver<Maybe<Array<Maybe<ResolversTypes['SustainalyticsReportModel']>>>, ParentType, ContextType>;
};

export type SustainalyticsReportModelResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['SustainalyticsReportModel'] = ResolversParentTypes['SustainalyticsReportModel']> = {
  lastUpdate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SustainalyticsReportUrlResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['SustainalyticsReportUrl'] = ResolversParentTypes['SustainalyticsReportUrl']> = {
  filename?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SustainalyticsSecurityListModelResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['SustainalyticsSecurityListModel'] = ResolversParentTypes['SustainalyticsSecurityListModel']> = {
  entityIds?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  securityListId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securityListName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SustainalyticsStatusResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['SustainalyticsStatus'] = ResolversParentTypes['SustainalyticsStatus']> = {
  hasPermissions?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  matched?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type Swaplab2ResultsResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Swaplab2Results'] = ResolversParentTypes['Swaplab2Results']> = {
  bpShiftDelta?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bpShiftVega?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bsDelta?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bsVega?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  creditYieldDelta?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  interestRateYieldDelta?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  interestRateYieldDeltaBuckets?: Resolver<Array<ResolversTypes['YieldDeltaBucket']>, ParentType, ContextType>;
  pctDelta?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type SwiftResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Swift'] = ResolversParentTypes['Swift']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  correspondingTransactionId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parsed?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  reportIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SwiftStatusEnum'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
};

export type TAccountResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TAccount'] = ResolversParentTypes['TAccount']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  group1?: Resolver<Maybe<ResolversTypes['TAccountGroup1Enum']>, ParentType, ContextType>;
  group2?: Resolver<Maybe<ResolversTypes['TAccountGroup2Enum']>, ParentType, ContextType>;
  group3?: Resolver<Maybe<ResolversTypes['TAccountGroup3Enum']>, ParentType, ContextType>;
  group4?: Resolver<Maybe<ResolversTypes['TAccountGroup4Enum']>, ParentType, ContextType>;
  group5?: Resolver<Maybe<ResolversTypes['TAccountGroup5Enum']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sruCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['TAccountTypeEnum']>, ParentType, ContextType>;
};

export type TAccountChartResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TAccountChart'] = ResolversParentTypes['TAccountChart']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  createTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  createUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  locked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tAccountMappings?: Resolver<Maybe<Array<ResolversTypes['TAccountMapping']>>, ParentType, ContextType>;
  tAccounts?: Resolver<Maybe<Array<ResolversTypes['TAccount']>>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type TAccountMappingResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TAccountMapping'] = ResolversParentTypes['TAccountMapping']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  selector?: Resolver<ResolversTypes['TAccountMappingSelector'], ParentType, ContextType>;
  values?: Resolver<Maybe<Array<ResolversTypes['TAccountMappingKeyValuePair']>>, ParentType, ContextType>;
};

export type TAccountMappingKeyValuePairResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TAccountMappingKeyValuePair'] = ResolversParentTypes['TAccountMappingKeyValuePair']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type TAccountMappingSelectorResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TAccountMappingSelector'] = ResolversParentTypes['TAccountMappingSelector']> = {
  categories?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  currencies?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  instruments?: Resolver<Maybe<Array<ResolversTypes['InstrumentSelector']>>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['TAccountMappingSelectorKeyEnum']>, ParentType, ContextType>;
  notMatchCategories?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  notMatchCurrencies?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  notMatchProductTypes?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  productTypes?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
};

export type TAccountMappingValueResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TAccountMappingValue'] = ResolversParentTypes['TAccountMappingValue']> = {
  accountingTransactionType?: Resolver<ResolversTypes['AccountingTransactionType'], ParentType, ContextType>;
  credit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  debit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type TicketResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Ticket'] = ResolversParentTypes['Ticket']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  client?: Resolver<ResolversTypes['PartyInfo'], ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  creator?: Resolver<ResolversTypes['UserInfo'], ParentType, ContextType>;
  creatorId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  previousStates?: Resolver<Array<ResolversTypes['TicketState']>, ParentType, ContextType>;
  readByUserIds?: Resolver<Maybe<Array<ResolversTypes['GraphQLObjectId']>>, ParentType, ContextType>;
  references?: Resolver<Maybe<Array<ResolversTypes['TicketReference']>>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['TicketState'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['TicketTypeEnum'], ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
};

export type TicketReferenceResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TicketReference'] = ResolversParentTypes['TicketReference']> = {
  collection?: Resolver<ResolversTypes['CollectionNameEnum'], ParentType, ContextType>;
  documentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
};

export type TicketStateResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TicketState'] = ResolversParentTypes['TicketState']> = {
  assigneeIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  assignees?: Resolver<Array<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TicketStatusEnum'], ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
};

export type TicketUserResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TicketUser'] = ResolversParentTypes['TicketUser']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  clientIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  clients?: Resolver<Maybe<Array<Maybe<ResolversTypes['PartyInfo']>>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type TimeSeriesResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TimeSeries'] = ResolversParentTypes['TimeSeries']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  dates?: Resolver<Maybe<Array<Maybe<ResolversTypes['GraphQLDateString']>>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  downSideVar?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, Partial<TimeSeriesDownSideVarArgs>>;
  format?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<Maybe<ResolversTypes['TimeSeriesItem']>>>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TimeSeriesStatus'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  values?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  volatility?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, Partial<TimeSeriesVolatilityArgs>>;
};

export type TimeSeriesItemResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TimeSeriesItem'] = ResolversParentTypes['TimeSeriesItem']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export interface TimestampScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Timestamp'], any> {
  name: 'Timestamp';
}

export type TppMessageResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TppMessage'] = ResolversParentTypes['TppMessage']> = {
  category?: Resolver<ResolversTypes['TppCategory'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['TppCode'], ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type TradingManagerColumnResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TradingManagerColumn'] = ResolversParentTypes['TradingManagerColumn']> = {
  account?: Resolver<Maybe<ResolversTypes['PartyAccount']>, ParentType, ContextType>;
  accountDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  accountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  baseCurrency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  bloombergTicker?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['ClientInfo']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  creditRatings?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  creditYieldDelta?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, Partial<TradingManagerColumnCreditYieldDeltaArgs>>;
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  exposure?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  externalAccount?: Resolver<Maybe<ResolversTypes['PartyExternalAccount']>, ParentType, ContextType>;
  externalAccountId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  externalAccountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalAccountType?: Resolver<Maybe<ResolversTypes['PartyExternalAccountType']>, ParentType, ContextType>;
  financedExposure?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  financedLocalExposure?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  financing?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fxRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fxRateDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  interestRateYieldDelta?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType, Partial<TradingManagerColumnInterestRateYieldDeltaArgs>>;
  isCashAccount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issuerCreditRatings?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  issuerId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  issuerIndustryCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issuerKeySector?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  issuerLei?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issuerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issuerType?: Resolver<Maybe<ResolversTypes['IssuerTypeEnum']>, ParentType, ContextType>;
  localExposure?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  localFinancing?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  maturityDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  modelType?: Resolver<Maybe<ResolversTypes['InstrumentModelTypeEnum']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portfolioInstrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  portfolioInstrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sustainabilityClass?: Resolver<Maybe<ResolversTypes['IssuerProgramCategory']>, ParentType, ContextType>;
  swaplab2Results?: Resolver<Maybe<ResolversTypes['Swaplab2Results']>, ParentType, ContextType, Partial<TradingManagerColumnSwaplab2ResultsArgs>>;
  valuationAccruedInterest?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  valuationCleanPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  valuationCurrency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  valuationDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  valuationPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type TransactionResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Transaction'] = ResolversParentTypes['Transaction']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<ResolversTypes['Attachment']>>, ParentType, ContextType>;
  bestExecutionType?: Resolver<Maybe<ResolversTypes['BestExecutionType']>, ParentType, ContextType>;
  broker?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  brokerTradeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brokerTransaction?: Resolver<Maybe<ResolversTypes['BrokerTransaction']>, ParentType, ContextType>;
  carryOwnCostDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  clearingHouse?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clearingHouseId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  corporateAction?: Resolver<Maybe<ResolversTypes['CorporateAction']>, ParentType, ContextType>;
  createTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['TransactionItem']>>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  parentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['SourceType'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['TransactionStatus']>, ParentType, ContextType>;
  tradeDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  tradeTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['TransactionType']>, ParentType, ContextType>;
  uniqueTradeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type TransactionItemResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TransactionItem'] = ResolversParentTypes['TransactionItem']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  account?: Resolver<Maybe<ResolversTypes['PartyAccount']>, ParentType, ContextType>;
  accountId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bankAccountTransactionIds?: Resolver<Maybe<Array<ResolversTypes['GraphQLObjectId']>>, ParentType, ContextType>;
  bankAccountTransactions?: Resolver<Maybe<Array<ResolversTypes['BankAccountTransaction']>>, ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  custodian?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalAccount?: Resolver<Maybe<ResolversTypes['PartyExternalAccount']>, ParentType, ContextType>;
  externalAccountId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  fxRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  performanceType?: Resolver<ResolversTypes['TransactionItemPerformanceType'], ParentType, ContextType>;
  portfolioInstrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  portfolioInstrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  transaction?: Resolver<Maybe<ResolversTypes['Transaction']>, ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  transactionStatus?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  transactionTradeDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  transactionTradeTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['TransactionItemType'], ParentType, ContextType>;
  valueDate?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
};

export type TransferAgentAccountPerformanceResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TransferAgentAccountPerformance'] = ResolversParentTypes['TransferAgentAccountPerformance']> = {
  account?: Resolver<Maybe<ResolversTypes['Customer']>, ParentType, ContextType>;
  clientAccount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  isin?: Resolver<ResolversTypes['ISIN'], ParentType, ContextType>;
  performanceItems?: Resolver<Array<ResolversTypes['TransferAgentAccountPerformanceItem']>, ParentType, ContextType>;
};

export type TransferAgentAccountPerformanceItemResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TransferAgentAccountPerformanceItem'] = ResolversParentTypes['TransferAgentAccountPerformanceItem']> = {
  absoluteRebate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  cashFlow?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['GraphQLDateString']>, ParentType, ContextType>;
  navPerUnit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  percentageRebate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  series?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalReturn?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  units?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type TransferAgentOrderResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TransferAgentOrder'] = ResolversParentTypes['TransferAgentOrder']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  adjustmentAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  adjustmentShares?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<ResolversTypes['Attachment']>>, ParentType, ContextType>;
  carryOwnTransactionCost?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  client?: Resolver<ResolversTypes['Party'], ParentType, ContextType>;
  clientAccount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  clientName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  clientNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyEnum'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instrument?: Resolver<ResolversTypes['Instrument'], ParentType, ContextType>;
  isin?: Resolver<ResolversTypes['ISIN'], ParentType, ContextType>;
  netPrice?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referenceExternalId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  settledAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  settledUnits?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['Party'], ParentType, ContextType>;
  sourceId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  subType?: Resolver<ResolversTypes['TransferAgentOrderSubTypeEnum'], ParentType, ContextType>;
  tradeDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  transactionIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  transactionType?: Resolver<ResolversTypes['TransferAgentOrderEnum'], ParentType, ContextType>;
  units?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  valueDate?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type TransferAgentTotalUnitResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['TransferAgentTotalUnit'] = ResolversParentTypes['TransferAgentTotalUnit']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  createTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  instrument?: Resolver<ResolversTypes['Instrument'], ParentType, ContextType>;
  isin?: Resolver<ResolversTypes['ISIN'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['Party'], ParentType, ContextType>;
  sourceId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  totalUnits?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export interface TwoDecimalStringScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['TwoDecimalString'], any> {
  name: 'TwoDecimalString';
}

export type UpsertTAccountResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['UpsertTAccount'] = ResolversParentTypes['UpsertTAccount']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  group1?: Resolver<Maybe<ResolversTypes['TAccountGroup1Enum']>, ParentType, ContextType>;
  group2?: Resolver<Maybe<ResolversTypes['TAccountGroup2Enum']>, ParentType, ContextType>;
  group3?: Resolver<Maybe<ResolversTypes['TAccountGroup3Enum']>, ParentType, ContextType>;
  group4?: Resolver<Maybe<ResolversTypes['TAccountGroup4Enum']>, ParentType, ContextType>;
  group5?: Resolver<Maybe<ResolversTypes['TAccountGroup5Enum']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['TAccountTypeEnum']>, ParentType, ContextType>;
};

export type UpsertTAccountChartResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['UpsertTAccountChart'] = ResolversParentTypes['UpsertTAccountChart']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  createTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  createUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  createUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  locked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tAccountMappings?: Resolver<Maybe<Array<ResolversTypes['UpsertTAccountMapping']>>, ParentType, ContextType>;
  tAccounts?: Resolver<Maybe<Array<ResolversTypes['UpsertTAccount']>>, ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type UpsertTAccountMappingResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['UpsertTAccountMapping'] = ResolversParentTypes['UpsertTAccountMapping']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  selector?: Resolver<ResolversTypes['UpsertTAccountMappingSelector'], ParentType, ContextType>;
  values?: Resolver<Maybe<Array<ResolversTypes['TAccountMappingValue']>>, ParentType, ContextType>;
};

export type UpsertTAccountMappingSelectorResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['UpsertTAccountMappingSelector'] = ResolversParentTypes['UpsertTAccountMappingSelector']> = {
  cicTypes?: Resolver<Maybe<Array<ResolversTypes['CicTypeEnum']>>, ParentType, ContextType>;
  currencies?: Resolver<Maybe<Array<ResolversTypes['CurrencyEnum']>>, ParentType, ContextType>;
  instruments?: Resolver<Maybe<Array<ResolversTypes['GraphQLObjectId']>>, ParentType, ContextType>;
  modelTypes?: Resolver<Maybe<Array<ResolversTypes['InstrumentModelTypeEnum']>>, ParentType, ContextType>;
};

export interface UriPartStringScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['UriPartString'], any> {
  name: 'UriPartString';
}

export type UserResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  bidExpiration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  clientIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  clients?: Resolver<Array<ResolversTypes['PartyInfo']>, ParentType, ContextType>;
  company?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  frontendRole?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  frontendRoleId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  graphqlApi?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ipWhitelist?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  lastBankIdLoginTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  lastLoginTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  lastPasswordUpdate?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  logins?: Resolver<Maybe<Array<ResolversTypes['UserLogin']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  noteIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  notes?: Resolver<Array<ResolversTypes['Note']>, ParentType, ContextType>;
  password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personalNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  restApi?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  roleIds?: Resolver<Array<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['Role']>, ParentType, ContextType>;
  serviceUser?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['UserStatusEnum'], ParentType, ContextType>;
  termsOfService?: Resolver<Maybe<ResolversTypes['Note']>, ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<ResolversTypes['JSON']>>, ParentType, ContextType>;
};

export type UserInfoResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['UserInfo'] = ResolversParentTypes['UserInfo']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  company?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  personalNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type UserLimitedResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['UserLimited'] = ResolversParentTypes['UserLimited']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  asset?: Resolver<Maybe<ResolversTypes['PermissionAssetEnum']>, ParentType, ContextType>;
  clientIds?: Resolver<Maybe<Array<ResolversTypes['GraphQLObjectId']>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['UserStatusEnum'], ParentType, ContextType>;
};

export type UserLoginResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['UserLogin'] = ResolversParentTypes['UserLogin']> = {
  timeStamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  userAgent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ValuationResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['Valuation'] = ResolversParentTypes['Valuation']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<ResolversTypes['Attachment']>>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['GraphQLSwedenDate'], ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  records?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValuationRecord']>>>, ParentType, ContextType>;
  updateTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
};

export type ValuationMappingResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['ValuationMapping'] = ResolversParentTypes['ValuationMapping']> = {
  _id?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  client?: Resolver<Maybe<ResolversTypes['Party']>, ParentType, ContextType>;
  clientId?: Resolver<ResolversTypes['GraphQLObjectId'], ParentType, ContextType>;
  collectionName?: Resolver<Maybe<ResolversTypes['MappingCollectionNameEnum']>, ParentType, ContextType>;
  createTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['CurrencyEnum']>, ParentType, ContextType>;
  curveDefinition?: Resolver<Maybe<ResolversTypes['CurveDefinition']>, ParentType, ContextType>;
  instrument?: Resolver<Maybe<ResolversTypes['Instrument']>, ParentType, ContextType>;
  instrumentId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  issuerProgram?: Resolver<Maybe<ResolversTypes['IssuerProgram']>, ParentType, ContextType>;
  issuerProgramId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  mappingType?: Resolver<Maybe<ResolversTypes['MappingTypeEnum']>, ParentType, ContextType>;
  modelType?: Resolver<Maybe<ResolversTypes['InstrumentModelTypeEnum']>, ParentType, ContextType>;
  parameterType?: Resolver<Maybe<ResolversTypes['MappingParameterEnum']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ValuationMappingStatus']>, ParentType, ContextType>;
  updateTimestamp?: Resolver<ResolversTypes['Timestamp'], ParentType, ContextType>;
  updateUserId?: Resolver<Maybe<ResolversTypes['GraphQLObjectId']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  validFrom?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  validTo?: Resolver<ResolversTypes['GraphQLDateString'], ParentType, ContextType>;
  versions?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
};

export type ValuationPriceResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['ValuationPrice'] = ResolversParentTypes['ValuationPrice']> = {
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['PriceType']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type ValuationRecordResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['ValuationRecord'] = ResolversParentTypes['ValuationRecord']> = {
  bloombergTicker?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prices?: Resolver<Maybe<Array<Maybe<ResolversTypes['ValuationPrice']>>>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updateUserInfo?: Resolver<Maybe<ResolversTypes['UserInfo']>, ParentType, ContextType>;
  writeTimestamp?: Resolver<Maybe<ResolversTypes['Timestamp']>, ParentType, ContextType>;
  writeUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type YieldDeltaBucketResolvers<ContextType = ResolverContextType, ParentType extends ResolversParentTypes['YieldDeltaBucket'] = ResolversParentTypes['YieldDeltaBucket']> = {
  period?: Resolver<Maybe<ResolversTypes['QuantLibPeriod']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
};

export type Resolvers<ContextType = ResolverContextType> = {
  AccountingRun?: AccountingRunResolvers<ContextType>;
  AccountingRun2?: AccountingRun2Resolvers<ContextType>;
  AccountingTransaction?: AccountingTransactionResolvers<ContextType>;
  AccountingTransaction2?: AccountingTransaction2Resolvers<ContextType>;
  Agreement?: AgreementResolvers<ContextType>;
  Alias?: AliasResolvers<ContextType>;
  AmountData?: AmountDataResolvers<ContextType>;
  AnnualReportType?: AnnualReportTypeResolvers<ContextType>;
  ApprovedInfo?: ApprovedInfoResolvers<ContextType>;
  Attachment?: AttachmentResolvers<ContextType>;
  BIC?: GraphQLScalarType;
  BankAccountBalance?: BankAccountBalanceResolvers<ContextType>;
  BankAccountTransaction?: BankAccountTransactionResolvers<ContextType>;
  BaseCalendar?: BaseCalendarResolvers<ContextType>;
  BaseCalendarEvent?: BaseCalendarEventResolvers<ContextType>;
  Benchmark?: BenchmarkResolvers<ContextType>;
  BeneficialOwner?: BeneficialOwnerResolvers<ContextType>;
  BrokerTransaction?: BrokerTransactionResolvers<ContextType>;
  Calendar?: CalendarResolvers<ContextType>;
  CalendarEvent?: CalendarEventResolvers<ContextType>;
  CashAccountBalance?: CashAccountBalanceResolvers<ContextType>;
  CashAccountLadder?: CashAccountLadderResolvers<ContextType>;
  CashBalance?: CashBalanceResolvers<ContextType>;
  ClientForAsset?: ClientForAssetResolvers<ContextType>;
  ClientInfo?: ClientInfoResolvers<ContextType>;
  CorporateAction?: CorporateActionResolvers<ContextType>;
  Cost?: CostResolvers<ContextType>;
  CreditStatusType?: CreditStatusTypeResolvers<ContextType>;
  CurveDefinition?: CurveDefinitionResolvers<ContextType>;
  CurveDefinitionDefinition?: CurveDefinitionDefinitionResolvers<ContextType>;
  CurveDefinitionInstrument?: CurveDefinitionInstrumentResolvers<ContextType>;
  CustodianApiPosition?: CustodianApiPositionResolvers<ContextType>;
  CustodianPosition?: CustodianPositionResolvers<ContextType>;
  Customer?: CustomerResolvers<ContextType>;
  DartBasic?: DartBasicResolvers<ContextType>;
  DartHolding?: DartHoldingResolvers<ContextType>;
  DartReport?: DartReportResolvers<ContextType>;
  DartTransaction?: DartTransactionResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateQuote?: DateQuoteResolvers<ContextType>;
  DateStringOrTimestamp?: GraphQLScalarType;
  DateValue?: DateValueResolvers<ContextType>;
  DecimalString?: GraphQLScalarType;
  DefaultCashInstrument?: DefaultCashInstrumentResolvers<ContextType>;
  EmailAddress?: GraphQLScalarType;
  EsgComment?: EsgCommentResolvers<ContextType>;
  EventInfo?: EventInfoResolvers<ContextType>;
  ExposureCollateral?: ExposureCollateralResolvers<ContextType>;
  Extension?: ExtensionResolvers<ContextType>;
  FieldDataItem?: FieldDataItemResolvers<ContextType>;
  FredObservation?: FredObservationResolvers<ContextType>;
  FredSeries?: FredSeriesResolvers<ContextType>;
  FundPerformance?: FundPerformanceResolvers<ContextType>;
  FundPortfolioPerformance?: FundPortfolioPerformanceResolvers<ContextType>;
  FundUnit?: FundUnitResolvers<ContextType>;
  FundUnitReconciliationType?: FundUnitReconciliationTypeResolvers<ContextType>;
  FxValuation?: FxValuationResolvers<ContextType>;
  GlobalStandardScreen?: GlobalStandardScreenResolvers<ContextType>;
  GraphQLCreditRating?: GraphQLScalarType;
  GraphQLDateString?: GraphQLScalarType;
  GraphQLLei?: GraphQLScalarType;
  GraphQLObjectId?: GraphQLScalarType;
  GraphQLPatchInstrumentDate?: GraphQLScalarType;
  GraphQLSwedenDate?: GraphQLScalarType;
  GraphQLSwedishLegalNumber?: GraphQLScalarType;
  HistoricalData?: HistoricalDataResolvers<ContextType>;
  IBAN?: GraphQLScalarType;
  ISIN?: GraphQLScalarType;
  Instrument?: InstrumentResolvers<ContextType>;
  InstrumentAccountPosition?: InstrumentAccountPositionResolvers<ContextType>;
  InstrumentModel?: InstrumentModelResolvers<ContextType>;
  InstrumentModelLegsItem?: InstrumentModelLegsItemResolvers<ContextType>;
  InstrumentModelLegsItemCashFlowsItem?: InstrumentModelLegsItemCashFlowsItemResolvers<ContextType>;
  InstrumentModelLegsItemCashFlowsItemFixingsItem?: InstrumentModelLegsItemCashFlowsItemFixingsItemResolvers<ContextType>;
  InstrumentModelLegsItemUnderlyingsItem?: InstrumentModelLegsItemUnderlyingsItemResolvers<ContextType>;
  InstrumentPerformance?: InstrumentPerformanceResolvers<ContextType>;
  InstrumentPosition?: InstrumentPositionResolvers<ContextType>;
  InstrumentSelector?: InstrumentSelectorResolvers<ContextType>;
  InstrumentValuation?: InstrumentValuationResolvers<ContextType>;
  Inventory?: InventoryResolvers<ContextType>;
  IssuerProgram?: IssuerProgramResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  JSONObject?: GraphQLScalarType;
  JournalEntry?: JournalEntryResolvers<ContextType>;
  JournalEntry2?: JournalEntry2Resolvers<ContextType>;
  KleerAccountMetadata?: KleerAccountMetadataResolvers<ContextType>;
  KleerAccountingYear?: KleerAccountingYearResolvers<ContextType>;
  KleerAmount?: KleerAmountResolvers<ContextType>;
  KleerCompanyInfo?: KleerCompanyInfoResolvers<ContextType>;
  KleerIdRef?: KleerIdRefResolvers<ContextType>;
  KleerPeriod?: KleerPeriodResolvers<ContextType>;
  KleerRevenue?: KleerRevenueResolvers<ContextType>;
  KleerRevenueLedger?: KleerRevenueLedgerResolvers<ContextType>;
  KleerRevenueRow?: KleerRevenueRowResolvers<ContextType>;
  KleerVoucher?: KleerVoucherResolvers<ContextType>;
  KleerVoucherTransaction?: KleerVoucherTransactionResolvers<ContextType>;
  LimitData?: LimitDataResolvers<ContextType>;
  MarginRequirement?: MarginRequirementResolvers<ContextType>;
  MatchedBankAccountTransaction?: MatchedBankAccountTransactionResolvers<ContextType>;
  MatchedCoacsTransaction?: MatchedCoacsTransactionResolvers<ContextType>;
  MatchedTransaction?: MatchedTransactionResolvers<ContextType>;
  Max35CharString?: GraphQLScalarType;
  Max140CharString?: GraphQLScalarType;
  Me?: MeResolvers<ContextType>;
  Min1Max70CharString?: GraphQLScalarType;
  MiniTransaction?: MiniTransactionResolvers<ContextType>;
  ModelIndexBenchmark?: ModelIndexBenchmarkResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NameAndId?: NameAndIdResolvers<ContextType>;
  Nav?: NavResolvers<ContextType>;
  NavData?: NavDataResolvers<ContextType>;
  NavFundClass?: NavFundClassResolvers<ContextType>;
  NavOrder?: NavOrderResolvers<ContextType>;
  NavPosition?: NavPositionResolvers<ContextType>;
  NavTransaction?: NavTransactionResolvers<ContextType>;
  Note?: NoteResolvers<ContextType>;
  NoteReference?: NoteReferenceResolvers<ContextType>;
  NoteTag?: NoteTagResolvers<ContextType>;
  OPAccess?: OpAccessResolvers<ContextType>;
  OPAccessItem?: OpAccessItemResolvers<ContextType>;
  OPConsent?: OpConsentResolvers<ContextType>;
  OPPayment?: OpPaymentResolvers<ContextType>;
  OPSigningBasketData?: OpSigningBasketDataResolvers<ContextType>;
  OpenPaymentLink?: OpenPaymentLinkResolvers<ContextType>;
  OpenPaymentLinkData?: OpenPaymentLinkDataResolvers<ContextType>;
  Party?: PartyResolvers<ContextType>;
  PartyAccount?: PartyAccountResolvers<ContextType>;
  PartyAccountWeight?: PartyAccountWeightResolvers<ContextType>;
  PartyBenchmark?: PartyBenchmarkResolvers<ContextType>;
  PartyCreditRating?: PartyCreditRatingResolvers<ContextType>;
  PartyEsg?: PartyEsgResolvers<ContextType>;
  PartyExternalAccount?: PartyExternalAccountResolvers<ContextType>;
  PartyFundInfo?: PartyFundInfoResolvers<ContextType>;
  PartyFundInfoClass?: PartyFundInfoClassResolvers<ContextType>;
  PartyInfo?: PartyInfoResolvers<ContextType>;
  PartyIssuerType?: PartyIssuerTypeResolvers<ContextType>;
  PartyStandardSettlementInstruction?: PartyStandardSettlementInstructionResolvers<ContextType>;
  PortfolioPerformance?: PortfolioPerformanceResolvers<ContextType>;
  PortfolioPerformanceItem?: PortfolioPerformanceItemResolvers<ContextType>;
  PortfolioSwapItemValuation?: PortfolioSwapItemValuationResolvers<ContextType>;
  PortfolioSwapItemValue?: PortfolioSwapItemValueResolvers<ContextType>;
  PortfolioSwapItemsPosition?: PortfolioSwapItemsPositionResolvers<ContextType>;
  Position?: PositionResolvers<ContextType>;
  Price?: PriceResolvers<ContextType>;
  ProductInvolvement?: ProductInvolvementResolvers<ContextType>;
  PublishedToType?: PublishedToTypeResolvers<ContextType>;
  QuantLibPeriod?: QuantLibPeriodResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Quote?: QuoteResolvers<ContextType>;
  ReconciledExposureCollateralType?: ReconciledExposureCollateralTypeResolvers<ContextType>;
  ReconciliationType?: ReconciliationTypeResolvers<ContextType>;
  RedirectLinkInfo?: RedirectLinkInfoResolvers<ContextType>;
  RefDataError?: RefDataErrorResolvers<ContextType>;
  RefDataFieldException?: RefDataFieldExceptionResolvers<ContextType>;
  RefDataFieldExceptionsArray?: RefDataFieldExceptionsArrayResolvers<ContextType>;
  ReferenceData?: ReferenceDataResolvers<ContextType>;
  RegisterExtract?: RegisterExtractResolvers<ContextType>;
  RegisterExtractItem?: RegisterExtractItemResolvers<ContextType>;
  RemittanceInformationStructured?: RemittanceInformationStructuredResolvers<ContextType>;
  Report?: ReportResolvers<ContextType>;
  Role?: RoleResolvers<ContextType>;
  RoleClientInfo?: RoleClientInfoResolvers<ContextType>;
  Screen?: ScreenResolvers<ContextType>;
  SecurityLadder?: SecurityLadderResolvers<ContextType>;
  Selector?: SelectorResolvers<ContextType>;
  ShareRegisterItem?: ShareRegisterItemResolvers<ContextType>;
  ShareRegisterUnits?: ShareRegisterUnitsResolvers<ContextType>;
  ShareholderEngagement?: ShareholderEngagementResolvers<ContextType>;
  SigningBasketAuthorization?: SigningBasketAuthorizationResolvers<ContextType>;
  SustainalyticsDataModel?: SustainalyticsDataModelResolvers<ContextType>;
  SustainalyticsDataModelWithStatus?: SustainalyticsDataModelWithStatusResolvers<ContextType>;
  SustainalyticsFieldClusterModel?: SustainalyticsFieldClusterModelResolvers<ContextType>;
  SustainalyticsFieldDefinitionModel?: SustainalyticsFieldDefinitionModelResolvers<ContextType>;
  SustainalyticsPackageModel?: SustainalyticsPackageModelResolvers<ContextType>;
  SustainalyticsProductModel?: SustainalyticsProductModelResolvers<ContextType>;
  SustainalyticsReport?: SustainalyticsReportResolvers<ContextType>;
  SustainalyticsReportModel?: SustainalyticsReportModelResolvers<ContextType>;
  SustainalyticsReportUrl?: SustainalyticsReportUrlResolvers<ContextType>;
  SustainalyticsSecurityListModel?: SustainalyticsSecurityListModelResolvers<ContextType>;
  SustainalyticsStatus?: SustainalyticsStatusResolvers<ContextType>;
  Swaplab2Results?: Swaplab2ResultsResolvers<ContextType>;
  Swift?: SwiftResolvers<ContextType>;
  TAccount?: TAccountResolvers<ContextType>;
  TAccountChart?: TAccountChartResolvers<ContextType>;
  TAccountMapping?: TAccountMappingResolvers<ContextType>;
  TAccountMappingKeyValuePair?: TAccountMappingKeyValuePairResolvers<ContextType>;
  TAccountMappingSelector?: TAccountMappingSelectorResolvers<ContextType>;
  TAccountMappingValue?: TAccountMappingValueResolvers<ContextType>;
  Ticket?: TicketResolvers<ContextType>;
  TicketReference?: TicketReferenceResolvers<ContextType>;
  TicketState?: TicketStateResolvers<ContextType>;
  TicketUser?: TicketUserResolvers<ContextType>;
  TimeSeries?: TimeSeriesResolvers<ContextType>;
  TimeSeriesItem?: TimeSeriesItemResolvers<ContextType>;
  Timestamp?: GraphQLScalarType;
  TppMessage?: TppMessageResolvers<ContextType>;
  TradingManagerColumn?: TradingManagerColumnResolvers<ContextType>;
  Transaction?: TransactionResolvers<ContextType>;
  TransactionItem?: TransactionItemResolvers<ContextType>;
  TransferAgentAccountPerformance?: TransferAgentAccountPerformanceResolvers<ContextType>;
  TransferAgentAccountPerformanceItem?: TransferAgentAccountPerformanceItemResolvers<ContextType>;
  TransferAgentOrder?: TransferAgentOrderResolvers<ContextType>;
  TransferAgentTotalUnit?: TransferAgentTotalUnitResolvers<ContextType>;
  TwoDecimalString?: GraphQLScalarType;
  UpsertTAccount?: UpsertTAccountResolvers<ContextType>;
  UpsertTAccountChart?: UpsertTAccountChartResolvers<ContextType>;
  UpsertTAccountMapping?: UpsertTAccountMappingResolvers<ContextType>;
  UpsertTAccountMappingSelector?: UpsertTAccountMappingSelectorResolvers<ContextType>;
  UriPartString?: GraphQLScalarType;
  User?: UserResolvers<ContextType>;
  UserInfo?: UserInfoResolvers<ContextType>;
  UserLimited?: UserLimitedResolvers<ContextType>;
  UserLogin?: UserLoginResolvers<ContextType>;
  Valuation?: ValuationResolvers<ContextType>;
  ValuationMapping?: ValuationMappingResolvers<ContextType>;
  ValuationPrice?: ValuationPriceResolvers<ContextType>;
  ValuationRecord?: ValuationRecordResolvers<ContextType>;
  YieldDeltaBucket?: YieldDeltaBucketResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = ResolverContextType> = {
  hasReadPermission?: HasReadPermissionDirectiveResolver<any, any, ContextType>;
  hasTypeReadPermission?: HasTypeReadPermissionDirectiveResolver<any, any, ContextType>;
  hasWritePermission?: HasWritePermissionDirectiveResolver<any, any, ContextType>;
};

export const AccountingBatchTypeDescriptions = {
  A: "Automated, similar to BVU but automatically added adjustment",
  AR: "Automated reverse, similar to BVI but closing previous A",
  BVI: "Balance valuation ingoing, closing previous BVU",
  BVU: "Balance valuation outgoing",
  IB: "Ingoing balance",
  M: "Manual, similar to BVU but manually added",
  MR: "Manual reverse, similar to BVI but closing previous M",
  T: "Transaction"
};

export const AccountingCompanyTypeEnumDescriptions = {
  GeneralPortfolio: null,
  None: null,
  SwedishMutualFund: null,
  SwedishPensionTrust: null
};

export const AccountingFrequencyEnumDescriptions = {
  Annually: null,
  Monthly: null,
  None: null,
  Quarterly: null,
  SemiAnnually: null
};

export const AccountingLanguageEnumDescriptions = {
  Sv: null
};

export const AccountingRunStatusEnumDescriptions = {
  Confirmed: null,
  Deleted: null,
  Pending: null,
  Preliminary: null
};

export const AccountingRunTypeEnumDescriptions = {
  Manual: null,
  Transaction: null
};

export const AccountingTransactionTypeDescriptions = {
  AccruedInterest: "AccruedInterest is the balance sheet accrued interest of a position at closing. Booked in batch BVU, reversed in batch BVI. Counterpart of Interest.",
  Commission: "Commission is cost from Commission transaction items. Booked in batch T.",
  CustodyFee: "CustodyFee is cost from CustodyFee transaction items. Booked in batch T.",
  Dividend: "Dividend is received dividend income. Booked in batch T from Dividend transaction items.",
  DividendPaid: "DividendPaid is dividend paid from fund classes. Booked in batch T from DividendPaid transaction items, no BVU/BVI.",
  Equity: "Equity is the fund's equity. T-account taken from the Equity t-account mapping.",
  Fee: "Fee is income or cost from fee type transaction items not covered by a more specific type.",
  ForeignTax: "ForeignTax is withholding tax from ForeignTax transaction items. Booked in batch T.",
  ForwardCash: "ForwardCash is position building and books cash with value date after the accounting run date. Created in batch A by moving the amount from the InitialCost t-account, only if a ForwardCash mapping exists.",
  InitialCost: "InitialCost is position building and books the acquisition cost of an instrument (cash accounts included) on the balance sheet. Booked in batch T for position building transaction items and carried forward in batch IB. Quantity, localAmount, accountingAmount and valueDate are only set for this type.",
  Interest: "Interest is interest income or cost. Booked in batch T from Interest and AccruedInterest transaction items and in batch BVU as counterpart of AccruedInterest.",
  ManagementCost: "ManagementCost is cost from ManagementCost transaction items. Booked in batch T.",
  ManagementFee: "ManagementFee is cost from ManagementFee transaction items. Booked in batch T.",
  OpeningBalance: "OpeningBalance balances an opening balance journal entry (batch IB) that does not sum to zero. T-account taken from the OpeningBalance t-account mapping.",
  Realized: "Realized is realized profit or loss from price changes when a position is reduced. Booked in batch T.",
  RealizedFx: "RealizedFx is realized profit or loss from fx changes when a position is reduced. Booked in batch T.",
  Rebate: "Rebate is cash fund rebate income from Rebate transaction items. Booked in batch T.",
  Rounding: "Rounding balances a journal entry that does not sum to zero due to rounding. T-account taken from the Rounding t-account mapping.",
  ShareCapital: "ShareCapital is position building and books creations and redemptions of fund units (CreateRedeem, CreateRedeemAdjustmentAmount and CreateRedeemAdjustmentShares items). Only booked in batch T, no BVU/BVI.",
  StampDuty: "StampDuty is cost from StampDuty transaction items. Booked in batch T.",
  Tax: "Tax is tax from Tax transaction items. Booked in batch T.",
  TaxRestitution: "TaxRestitution is restituted tax from TaxRestitution transaction items. Booked in batch T.",
  Unrealized: "Unrealized is unrealized profit or loss from price changes. Booked in batch BVU, reversed in batch BVI.",
  UnrealizedFx: "UnrealizedFx is unrealized profit or loss from fx changes. Booked in batch BVU, reversed in batch BVI.",
  ValueChange: "ValueChange is the balance sheet revaluation of a position (price and fx) relative to initial cost. Booked in batch BVU at closing and reversed in batch BVI. Counterpart of Unrealized and UnrealizedFx."
};

export const AgreementStatusEnumDescriptions = {
  Active: null,
  Deleted: null,
  Inactive: null,
  Pending: null,
  Superseded: null
};

export const AgreementTypeDescriptions = {
  ClearingAccount: null,
  CollateralisedLoan: null,
  Gmra: null,
  Gmsla: null,
  Isda: null,
  OmnibusClearingAccount: null
};

export const AgreementTypeEnumDescriptions = {
  CashTrading: null,
  Cdea: null,
  ClearingBroker: null,
  CustodyAgreement: null,
  Emir: null,
  EquityDma: null,
  FxTrading: null,
  Gmra: null,
  Gmsla: null,
  Gua: null,
  InvestmentManagement: null,
  InvestmentPolicy: null,
  Isda: null,
  Mt101: null,
  ProcessAgent: null,
  Sftr: null,
  Ssi: null,
  SubscriptionRedemptionForm: null,
  TriParty: null,
  UserAgreement: null
};

export const ApprovedStatusEnumDescriptions = {
  Accepted: null,
  Rejected: null
};

export const BankAccountTransactionStatusEnumDescriptions = {
  Deleted: null,
  Pending: null,
  Settled: null
};

export const BestExecutionTypeDescriptions = {
  Client: "Client denotes transactions entered by a client it self as a part of an asset management agreement.",
  Execution: "Execution denotes a trade executed on behalf a client outside an asset management agreement.",
  Maintenance: "Maintenance denotes transactions such as dividends, coupons etc. that follows from positions held.",
  Portfolio: "Portfolio denotes a trade conducted as under an asset management agreement.",
  Transmission: "Transmission denotes a trade passed on to another broker on behalf of a client outside an asset management agreement."
};

export const BrokerTransactionStatusDescriptions = {
  Confirmed: null,
  Deleted: null,
  Pending: null
};

export const BrokerTransactionTypeDescriptions = {
  Buy: null,
  Sell: null
};

export const CalendarNameEnumDescriptions = {
  SwedenFixedIncome: null,
  UnitedKingdom: null,
  UnitedStatesEquity: null,
  UnitedStatesFixedIncome: null
};

export const CalendarStateEnumDescriptions = {
  Closed: null,
  EarlyClose: null
};

export const CalendarStatusEnumDescriptions = {
  Active: null,
  Deleted: null
};

export const CdsTypeDescriptions = {
  Basket: null,
  Index: null
};

export const CicAreaEnumDescriptions = {
  AE: "UnitedArabEmirates",
  AR: "Argentina",
  AT: "Austria",
  AU: "Australia",
  BE: "Belgium",
  BG: "Bulgaria",
  BM: "Bermuda",
  CA: "Canada",
  CH: "Switzerland",
  CL: "Chile",
  CN: "China",
  CY: "Cyprus",
  CZ: "CzechRepublic",
  DE: "Germany",
  DK: "Denmark",
  EE: "Estonia",
  ES: "Spain",
  FI: "Finland",
  FO: "FaroeIslands",
  FR: "France",
  GB: "UnitedKingdom",
  GG: "Guernsey",
  GR: "Greece",
  HK: "HongKong",
  HR: "Croatia",
  HU: "Hungary",
  IE: "Ireland",
  IL: "Israel",
  IM: "IsleOfMan",
  IR: "Iran",
  IT: "Italy",
  JE: "Jersey",
  JO: "Jordan",
  JP: "Japan",
  KY: "CaymanIslands",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  MO: "Macao",
  MT: "Malta",
  MX: "Mexico",
  NL: "Netherlands",
  NO: "Norway",
  NZ: "NewZealand",
  None: "None",
  PL: "Poland",
  PT: "Portugal",
  RO: "Romania",
  SE: "Sweden",
  SG: "Singapore",
  SI: "Slovenia",
  SK: "Slovakia",
  US: "UnitedStates",
  XL: "Assets that are not listed in a stock exchange",
  XT: "Assets that are not exchange tradable",
  ZA: "SouthAfrica"
};

export const CicTypeEnumDescriptions = {
  None: "None",
  XX00: "00 Other investments",
  XX11: "11 Central Government bonds",
  XX12: "12 Supra-national bonds",
  XX13: "13 Regional government bonds",
  XX14: "14 Municipal government bonds",
  XX15: "15 Treasury bonds",
  XX16: "16 Covered bonds",
  XX17: "17 National Central bank bonds",
  XX19: "19 Government bonds Other",
  XX21: "21 Corporate bonds",
  XX22: "22 Convertible bonds",
  XX23: "23 Commercial paper",
  XX24: "24 Money market instruments",
  XX25: "25 Hybrid bonds",
  XX26: "26 Common covered bonds",
  XX27: "27 Covered bonds subject to specific law",
  XX28: "28 Subordinated bonds",
  XX29: "29 Corporate bonds Other",
  XX31: "31 Common equity",
  XX32: "32 Equity of real estate related corporation",
  XX33: "33 Equity rights",
  XX34: "34 Preferred equity",
  XX39: "39 Equity Other",
  XX41: "41 Equity funds",
  XX42: "42 Debt funds",
  XX43: "43 Money market funds",
  XX44: "44 Asset allocation funds",
  XX45: "45 Real estate funds",
  XX46: "46 Alternative funds",
  XX47: "47 Private equity funds",
  XX48: "48 Infrastructure funds",
  XX49: "49 Collective Investment Undertakings (funds) other",
  XX51: "51 Structured notes Equity risk",
  XX52: "52 Structured notes Interest rate risk",
  XX53: "53 Structured notes Currency risk",
  XX54: "54 Structured notes Credit risk",
  XX55: "55 Structured notes Real estate risk",
  XX56: "56 Structured notes Commodity risk",
  XX57: "57 Structured notes Catastrophe and Weather risk",
  XX58: "58 Structured notes Mortality risk",
  XX59: "59 Structured notes Structured notes Other",
  XX61: "61 Collateralised securities Equity risk",
  XX62: "62 Collateralised securities Interest rate risk",
  XX63: "63 Collateralised securities Currency risk",
  XX64: "64 Collateralised securities Credit risk",
  XX65: "65 Collateralised securities Real estate risk",
  XX66: "66 Collateralised securities Commodity risk",
  XX67: "67 Collateralised securities Catastrophe and Weather risk",
  XX68: "68 Collateralised securities Mortality risk",
  XX69: "69 Collateralised securities Other",
  XX71: "71 Cash",
  XX72: "72 Cash Transferable deposits ,cash equivalents",
  XX73: "73 Cash Other deposits short term ,less than or equal to one year",
  XX74: "74 Cash Other deposits with term longer than one year",
  XX75: "75 Cash Deposits to cedants",
  XX76: "76 Captor Specific - Initial Margin Account",
  XX77: "77 Captor Specific - Variation Margin Account",
  XX78: "78 Captor Specific - Balance Account",
  XX79: "79 Cash and deposits Other",
  XX81: "81 Uncollateralized loans made",
  XX82: "82 Loans made collateralized with securities",
  XX84: "84 Mortgages",
  XX85: "85 Other collateralized loans made",
  XX86: "86 Loans on policies",
  XX89: "89 Mortgages and loans Other",
  XX91: "91 Property (office and commercial)",
  XX92: "92 Property (residential)",
  XX93: "93 Property (for own use)",
  XX94: "94 Property (under construction)",
  XX95: "95 Plant and equipment (for own use)",
  XX99: "99 Property Other",
  XXA1: "A1 Equity and index futures",
  XXA2: "A2 Interest rate futures",
  XXA3: "A3 Currency futures",
  XXA5: "A5 Commodity futures",
  XXA7: "A7 Catastrophe and Weather risk futures",
  XXA8: "A8 Mortality risk futures",
  XXA9: "A9 Futures Other",
  XXB1: "B1 Equity and index call options",
  XXB2: "B2 Bond call options",
  XXB3: "B3 Currency call options",
  XXB4: "B4 Call Warrants",
  XXB5: "B5 Commodity call options",
  XXB6: "B6 Swaptions call / receiver",
  XXB7: "B7 Catastrophe and Weather risk call options",
  XXB8: "B8 Mortality risk call options",
  XXB9: "B9 Call Options Other",
  XXC1: "C1 Equity and index put options",
  XXC2: "C2 Bond put options",
  XXC3: "C3 Currency put options",
  XXC4: "C4 Put Warrants",
  XXC5: "C5 Commodity put options",
  XXC6: "C6 Swaptions put / payer",
  XXC7: "C7 Catastrophe and Weather risk put options",
  XXC8: "C8 Mortality risk put options",
  XXC9: "C9 Put Options Other",
  XXD1: "D1 Interest rate swaps",
  XXD2: "D2 Currency swaps",
  XXD3: "D3 Interest rate and currency swaps",
  XXD5: "D5 Security swaps",
  XXD7: "D7 Catastrophe and Weather risk swaps",
  XXD8: "D8 Mortality risk swaps",
  XXD9: "D9 Swaps Other",
  XXE1: "E1 Forward interest rate agreement",
  XXE2: "E2 Forward exchange rate agreement",
  XXE7: "E7 Catastrophe and Weather risk forwards",
  XXE8: "E8 Mortality risk forwards",
  XXE9: "E9 Forwards Other",
  XXF1: "F1 Credit default swap",
  XXF2: "F2 Credit spread option",
  XXF3: "F3 Credit spread swap",
  XXF4: "F4 Total return swap",
  XXF9: "F9 Credit derivatives other",
  XXX1: "X1 Captor Specific - Equity",
  XXX2: "X2 Captor Specific - Opening",
  XXX3: "X3 Captor Specific - Rounding"
};

export const CollectionNameEnumDescriptions = {
  BrokerTransaction: null,
  CorporateAction: null,
  Instrument: null,
  IssuerProgram: null,
  None: null,
  OPConsent: null,
  Party: null,
  Screen: null,
  Swift: null,
  Transaction: null
};

export const CorporateActionEventDescriptions = {
  ACCU: "Accumulation",
  ACTV: "Trading Status: Active",
  ATTI: "Attachment",
  BIDS: "Repurchase Offer",
  BMET: "Bondholder Meeting",
  BONU: "Bonus Issue",
  BPUT: "Put Redemption",
  BRUP: "Bankruptcy",
  CAPD: "Capital Distribution",
  CAPG: "Capital Gains Distribution",
  CAPI: "Capitalisation",
  CERT: "Non-US TEFRA D Certification",
  CHAN: "Change",
  CLSA: "Class Action",
  CMET: "Court Meeting",
  CONS: "Consent",
  CONV: "Conversion",
  COOP: "Company Option",
  CREV: "Credit Event",
  DECR: "Decrease in Value",
  DETI: "Detachment",
  DFLT: "Bond Default",
  DLST: "Trading Status: Delisted",
  DRAW: "Drawing",
  DRCA: "Cash Distribution from Non-Eligible Securities Sales",
  DRIP: "Dividend Reinvestment",
  DSCL: "Disclosure",
  DTCH: "Dutch Auction",
  DVCA: "Cash Dividend",
  DVOP: "Dividend Option",
  DVSC: "Scrip Dividend",
  DVSE: "Stock Dividend",
  EXOF: "Exchange",
  EXRI: "Call on Intermediate Securities",
  EXTM: "Maturity Extension",
  EXWA: "Warrant Exercise",
  INCR: "Increase in Value",
  INFO: "Information",
  INTR: "Interest Payment",
  LIQU: "Liquidation Dividend",
  MCAL: "Full Call",
  MEET: "Annual General Meeting",
  MRGR: "Merger",
  NOOF: "New Offer",
  ODLT: "Odd Lot Offer",
  OTHR: "Other Event",
  PARI: "Parity Adjustment",
  PDEF: "Partial Defeasance",
  PINK: "Pink Sheet Trading",
  PLAC: "Placement",
  PPUB: "Partial Redemption with Pool Factor Reduction",
  PRII: "Prime Rate Interest Payment",
  PRIO: "Priority Issue",
  REDM: "Redemption",
  REMK: "Remarketing",
  RHDI: "Rights Distribution",
  RHTS: "Rights Issue",
  SDRV: "Spin-Off",
  SHPR: "Shareholders' Meeting",
  SMAL: "Smallest Negotiable Unit",
  SOFF: "Stock Offering",
  SPLF: "Stock Split",
  SPLR: "Reverse Stock Split",
  TEND: "Tender Offer",
  TREC: "Transaction Reclassification",
  WRTH: "Worthless Security"
};

export const CorporateActionStatusEnumDescriptions = {
  Confirmed: null,
  Deleted: null,
  Pending: null,
  Preliminary: null,
  Settled: "Messages of type 566 gets status settled when matched",
  UpdatedPrevious: "Used for messageType 566 when original coacs(swift) of messageType 564 has been updated and coacs(swift) of messageType is insignificant",
  Waiting: "Used for messages with corporateActionEvent: DRIP/DVOP, theese are received earlier (not received two days after ex-date like other corporateActionEvents)"
};

export const CostStatusEnumDescriptions = {
  Active: null,
  Deleted: null
};

export const CountryCodeEnumDescriptions = {
  AE: "UnitedArabEmirates",
  AR: "Argentina",
  AT: "Austria",
  AU: "Australia",
  BE: "Belgium",
  BG: "Bulgaria",
  BM: "Bermuda",
  CA: "Canada",
  CH: "Switzerland",
  CL: "Chile",
  CN: "China",
  CY: "Cyprus",
  CZ: "CzechRepublic",
  DE: "Germany",
  DK: "Denmark",
  EE: "Estonia",
  ES: "Spain",
  FI: "Finland",
  FO: "FaroeIslands",
  FR: "France",
  GB: "UnitedKingdom",
  GG: "Guernsey",
  GR: "Greece",
  HK: "HongKong",
  HR: "Croatia",
  HU: "Hungary",
  IE: "Ireland",
  IL: "Israel",
  IM: "IsleOfMan",
  IR: "Iran",
  IS: "Iceland",
  IT: "Italy",
  JE: "Jersey",
  JO: "Jordan",
  JP: "Japan",
  KY: "CaymanIslands",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  MO: "Macao",
  MT: "Malta",
  MX: "Mexico",
  NL: "Netherlands",
  NO: "Norway",
  NZ: "NewZealand",
  PL: "Poland",
  PT: "Portugal",
  RO: "Romania",
  SE: "Sweden",
  SG: "Singapore",
  SI: "Slovenia",
  SK: "Slovakia",
  US: "UnitedStates",
  Unknown: "Unknown",
  ZA: "SouthAfrica"
};

export const CurrencyEnumDescriptions = {
  AUD: null,
  BRL: null,
  CAD: null,
  CHF: null,
  CNY: null,
  DKK: null,
  EUR: null,
  GBP: null,
  HKD: null,
  ILS: null,
  INR: null,
  ISK: null,
  JPY: null,
  KRW: null,
  MXN: null,
  NOK: null,
  NZD: null,
  RUB: null,
  SEK: null,
  SGD: null,
  TRY: null,
  USD: null,
  ZAR: null
};

export const CurveDefinitionTypeDescriptions = {
  BasisCurve: null,
  CreditCurve: null,
  FixingCurve: null,
  FxCurve: null,
  YieldCurve: null
};

export const CurveDefinitionType2Descriptions = {
  YieldCurveDefinition: null
};

export const CustodianPositionTypeDescriptions = {
  Automatic: null,
  Manual: null
};

export const DayAdjustmentEnumDescriptions = {
  FixedPeriods: null,
  Following: null,
  ModifiedFollowing: null
};

export const DocumentStatusEnumDescriptions = {
  Active: null,
  Deleted: null
};

export const EngagementMethodDescriptions = {
  Dialog: null,
  Voting: null
};

export const EsgActivityEnumDescriptions = {
  ApprovedScreen: null,
  Dialogue: null,
  Divestment: null,
  Investment: null,
  Other: null,
  OtherActivity: null,
  ProxyVoting: null,
  RatingEvent: null,
  ShareholderMeeting: null,
  Voting: null
};

export const EsgAreaEnumDescriptions = {
  BusinessEthics: null,
  Climate: null,
  Environment: null,
  HumanRights: null,
  LabourRights: null,
  Other: null,
  Ratings: null,
  Social: null
};

export const EsgComponentEnumDescriptions = {
  CdsIndexEsgScreenings: null,
  EsgCategory: null,
  GlobalStandardScreen: null,
  KeySector: null,
  ProductInvolvement: null,
  ProductInvolvementRanges: null,
  ScreeningInformation: null,
  SpoProviders: null,
  SustainableDevelopmentGoals: null,
  TransitionCompanies: null,
  UseOfProceeds: null
};

export const EuTaxonomyEnvironmentalObjectiveDescriptions = {
  ClimateChangeAdaption: "Climate change adaptation",
  ClimateChangeMitigation: "Climate change mitigation",
  PollutionPreventionAndControl: "Pollution prevention and control",
  ProtectionAndRestorationBioDiversityAndEcosystems: "Protection and restoration of biodiversity and ecosystems",
  SustainableUseAndProtectionWaterAndMarineResources: "Sustainable use and protection of water and marine resources",
  TransitionToCircularEconomy: "Transition to a circular economy"
};

export const ExposureCollateralTypeDescriptions = {
  CollateralCash: null,
  CollateralSecurity: null,
  Exposure: null
};

export const FeeInterestItemTypeDescriptions = {
  AccruedInterest: null,
  Commission: null,
  CustodyFee: null,
  Fee: null,
  ForeignTax: null,
  Interest: null,
  ManagementCost: "ManagementCost is an type used for costs due to management of funds, e.g. Bloomberg license.",
  ManagementFee: null,
  Rebate: null,
  TaxRestitution: null
};

export const FundReportComponentEnumDescriptions = {
  AttributionMonth: null,
  AtttributionTotal: null,
  BarReturnsMonth: null,
  BarReturnsYearly: null,
  CdsIndexComponents: null,
  CdsIndexEsgScreenings: null,
  CdsIndexHYComponents: null,
  CdsIndexIGComponents: null,
  CountryPieChart: null,
  CreditRating: null,
  CreditSpreadRisk: null,
  CurrencyBarChart: null,
  CurrencyPieChart: null,
  EsgCategory: null,
  InterestRateBuckets: null,
  KeyNumbers: null,
  ReturnVsVolatility: null,
  Sectors: null,
  SustainableDevelopmentGoals: null,
  TopHoldings: null,
  TopIssuers: null,
  TransitionCompanies: null,
  UseOfProceeds: null
};

export const FundReportEnumDescriptions = {
  Benchmark: null,
  Bonds: null,
  Derivatives: null,
  Equities: null,
  Leverage: null
};

export const FundTypeEnumDescriptions = {
  AIF: null,
  UCITS: null
};

export const HistoricalFieldsEnumDescriptions = {
  PX_LAST: null,
  PX_VOLUME: null
};

export const InstrumentCategoryDescriptions = {
  Alternative: null,
  CashAccount: null,
  Equity: null,
  Fx: null,
  HedgeFund: null,
  Interest: null,
  InterestRate: null,
  Liability: null,
  Margin: null,
  None: null,
  RealEstate: null,
  System: null
};

export const InstrumentModelLegFixingTypesEnumDescriptions = {
  Compound: null,
  Single: null
};

export const InstrumentModelLegTypesEnumDescriptions = {
  CashFlowLeg: null,
  EquityBasketOptionLeg: null,
  EquityUnitOptionLeg: null,
  FixedAmountLeg: null,
  FixedRateLeg: null,
  FloatRateLeg: null,
  FtaLeg: null,
  GenericFixedAmountLeg: null,
  GenericFixedRateLeg: null,
  GenericFloatRateLeg: null,
  SwaptionLeg: null
};

export const InstrumentModelObjectTypeEnumDescriptions = {
  Account: null,
  Client: null,
  Instrument: null,
  Portfolio: null
};

export const InstrumentModelSubTypeEnumDescriptions = {
  Fixed: null,
  Float: null,
  Payer: null,
  PayerSwaption: null,
  Receiver: null,
  ReceiverSwaption: null
};

export const InstrumentModelTypeEnumDescriptions = {
  Balance: "Balance model is used for bank accounts and such, a placeholder for a currency position.",
  Bond: "Bond model is used for fixed coupon bonds, floating rate bonds and zero coupon bonds. The model needs one fixed amount leg for principal and one coupon leg for coupons. For zero coupon bonds, use fixed rate leg type and 0 coupon.",
  CashFlowEngineering: "DO NOT USE! CashFlowEngineering is not implemented.",
  CdsBasket: "CdsBasket model is used for valuation of a custom CDS Basket traded as a warrant, i.e. as a transferable security.",
  CdsIndex: "CdsIndex model is used for standard CDS index instruments cleared at a CCP.",
  EquityBasketOption: "DO NOT USE! NOT IMPLEMENTED IN SWAPLAB2! EquityBasketOption model is used for valuations of equity basket options. Volatility surfaces are stored in system.",
  EquityUnitOption: "DO NOT USE! NOT IMPLEMENTED IN SWAPLAB2! EquityUnitOption model is used for valuations of single underlying equity options. Volatility surfaces are stored in system.",
  Etf: "Etf model is a spot valuation model used for all Exchange-Traded Funds.",
  Fta: "DO NOT USE! NOT IMPLEMENTED IN SWAPLAB2! Fta model is used for liability valuation.",
  FundExternal: "FundExternal model is used for fund instruments not connected to their own portfolio within the system. The valuation has to be provided from external source.",
  FundInternal: "FundInternal model is used for fund instruments linked to their own portfolio within the system. The issuerId field serves as a link to the portfolio and can be used for more advanced calculations.",
  FxSwap: "FXSwap model is used for the outright leg of an FX Swap position. Model uses a set of FixedAmountLegs in different currencies.",
  GenericDeposit: "GenericDeposit model is used for generic deposit instruments used in curve building. This instrument type should never be connected to a traded position.",
  GenericFxSpot: "GenericFxSpot model is used for generic swap instruments used in curve building. This instrument type should never be connected to a traded position.",
  GenericFxSwap: "GenericFxSwap model is used for generic swap instruments used in curve building. This instrument type should never be connected to a traded position.",
  GenericSwap: "GenericSwap model is used for generic swap instruments used in curve building. This instrument type should never be connected to a traded position.",
  Loan: "Loan model is used for loans. Valuation is a clean price of one an accrued interest",
  LoanCollateral: "LoanCollateral model is used for collateralized loans. Valuation is a sum of collateral for a specific loan int he loans currency",
  Pending: "SHOULD NEVER BE SET MANUALLY! Pending model is set for trades uploaded where no instrument exists in system. A fund can not be valued while an instrument with model type Pending exists in the underlying portfolio.",
  PortfolioSwap: "DEPRECATED! PortfolioSwap model is the OLD Portfolio Swap model based on keeping positions using swap counterparty as owner of portfolio in system.",
  PortfolioSwapX: "PortfolioSwapX model is the new Portfolio Swap model.",
  PrivateEquity: "RealEstate model is a spot valuation model which differentiates Real Estate risk factor instruments from other spot valuation models.",
  RealEstate: "PrivateEquity model is, for now a spot valuation model which differentiates Private Equity risk factor instruments from other spot valuation models.",
  Spot: "DO NOT USE! NOT IMPLEMENTED IN SWAPLAB2! Spot model is a generic spot model, please use Stock or RealEstate models instead.",
  Stock: "Stock model is a spot valuation model used for all normal equity like instruments, including stock, dividend rights and such. All valuations are done T+0 i.e. no T+2 discounting.",
  Swap: "Swap model is used for interest rate swaps. Currently the model does not support OIS-swaps.",
  Swaption: "Swaption model is used for valuation of swaptions. Using the call/put and pay/recieve properties of the SwaptionLeg gives call: false = Payer Swaption, payleg: false = sold (short) position.",
  ZeroCouponLinear: "ZeroCouponLinear model is used as an amortizing model for not marked valued corporate certificates and other not market valued zero coupon structures. Valuation is a linear amortizing model towards par."
};

export const InstrumentPositionTypeDescriptions = {
  All: null,
  CashAccounts: null,
  Securities: null
};

export const InstrumentProductTypeEnumDescriptions = {
  Account: null,
  BalanceAccount: "For PayableReceivable transactions just a balance since no cash involved",
  Bond: null,
  Cash: null,
  CashAccount: null,
  Fund: null,
  FutureForward: null,
  FxPair: null,
  Index: null,
  InitialMarginAccount: null,
  Liability: null,
  None: null,
  Option: null,
  PrincipalAccount: null,
  RealEstate: null,
  Shares: null,
  Swap: null,
  System: null,
  VariationMarginAccount: null
};

export const InstrumentStatusEnumDescriptions = {
  Confirmed: null,
  Deleted: null,
  Pending: null
};

export const InstrumentTypeEnumDescriptions = {
  Instrument: null,
  PartyInstrument: null
};

export const IorpEnumDescriptions = {
  None: null,
  RiskFree: null,
  SOBL: null
};

export const IssuerProgramCategoryDescriptions = {
  Green: null,
  None: null,
  Social: null,
  SustainabilityLinked: null,
  Sustainable: null,
  Transition: null
};

export const IssuerTypeEnumDescriptions = {
  CreditInstitution: null,
  EuCovered: null,
  Government: null,
  None: null
};

export const MappingCollectionNameEnumDescriptions = {
  CurveDefinition: null
};

export const MappingParameterEnumDescriptions = {
  CreditCurve: null,
  DiscountCurve: null,
  FixingCurve: null,
  ForwardCurve: null,
  FxCurve: null
};

export const MappingTypeEnumDescriptions = {
  Currency: null,
  Instrument: null,
  IssuerProgram: null,
  Model: null
};

export const MarginRequirementTypeDescriptions = {
  InitialMarginRequirement: null,
  VariationMarginRequirement: null
};

export const MarginTypeDescriptions = {
  InitialMargin: null,
  VariationMargin: null
};

export const MatchingCoacsStatusDescriptions = {
  Confirmed: null,
  Matched: "Matched with a transaction but found at least on error",
  Mismatch: null,
  Preliminary: null,
  Settled: "Messages of type 566 gets status settled when matched"
};

export const MatchingStatusDescriptions = {
  Confirmed: null,
  Deleted: null,
  Matched: "Matched with a transaction but found at least on error",
  Mismatch: null
};

export const NaceClassDescriptions = {
  A: "(A) AGRICULTURE, FORESTRY AND FISHING",
  A01: "(01) Crop and animal production, hunting and related service activities",
  A02: "(02) Forestry and logging",
  A03: "(03) Fishing and aquaculture",
  A011: "(01.1) Growing of non-perennial crops",
  A012: "(01.2) Growing of perennial crops",
  A013: "(01.3) Plant propagation",
  A014: "(01.4) Animal production",
  A015: "(01.5) Mixed farming",
  A016: "(01.6) Support activities to agriculture and post-harvest crop activities",
  A017: "(01.7) Hunting, trapping and related service activities",
  A021: "(02.1) Silviculture and other forestry activities",
  A022: "(02.2) Logging",
  A023: "(02.3) Gathering of wild growing non-wood products",
  A024: "(02.4) Support services to forestry",
  A031: "(03.1) Fishing",
  A032: "(03.2) Aquaculture",
  A033: "(03.3) Support activities for fishing and aquaculture",
  A0111: "(01.11) Growing of cereals, other than rice, leguminous crops and oil seeds",
  A0112: "(01.12) Growing of rice",
  A0113: "(01.13) Growing of vegetables and melons, roots and tubers",
  A0114: "(01.14) Growing of sugar cane",
  A0115: "(01.15) Growing of tobacco",
  A0116: "(01.16) Growing of fibre crops",
  A0119: "(01.19) Growing of other non-perennial crops",
  A0121: "(01.21) Growing of grapes",
  A0122: "(01.22) Growing of tropical and subtropical fruits",
  A0123: "(01.23) Growing of citrus fruits",
  A0124: "(01.24) Growing of pome fruits and stone fruits",
  A0125: "(01.25) Growing of other tree and bush fruits and nuts",
  A0126: "(01.26) Growing of oleaginous fruits",
  A0127: "(01.27) Growing of beverage crops",
  A0128: "(01.28) Growing of spices, aromatic, drug and pharmaceutical crops",
  A0129: "(01.29) Growing of other perennial crops",
  A0130: "(01.30) Plant propagation",
  A0141: "(01.41) Raising of dairy cattle",
  A0142: "(01.42) Raising of other cattle and buffaloes",
  A0143: "(01.43) Raising of horses and other equines",
  A0144: "(01.44) Raising of camels and camelids",
  A0145: "(01.45) Raising of sheep and goats",
  A0146: "(01.46) Raising of swine and pigs",
  A0147: "(01.47) Raising of poultry",
  A0148: "(01.48) Raising of other animals",
  A0150: "(01.50) Mixed farming",
  A0161: "(01.61) Support activities for crop production",
  A0162: "(01.62) Support activities for animal production",
  A0163: "(01.63) Post-harvest crop activities and seed processing for propagation",
  A0170: "(01.70) Hunting, trapping and related service activities",
  A0210: "(02.10) Silviculture and other forestry activities",
  A0220: "(02.20) Logging",
  A0230: "(02.30) Gathering of wild growing non-wood products",
  A0240: "(02.40) Support services to forestry",
  A0311: "(03.11) Marine fishing",
  A0312: "(03.12) Freshwater fishing",
  A0321: "(03.21) Marine aquaculture",
  A0322: "(03.22) Freshwater aquaculture",
  A0330: "(03.30) Support activities for fishing and aquaculture",
  B: "(B) MINING AND QUARRYING",
  B05: "(05) Mining of coal and lignite",
  B06: "(06) Extraction of crude petroleum and natural gas",
  B07: "(07) Mining of metal ores",
  B08: "(08) Other mining and quarrying",
  B09: "(09) Mining support service activities",
  B051: "(05.1) Mining of hard coal",
  B052: "(05.2) Mining of lignite",
  B061: "(06.1) Extraction of crude petroleum",
  B062: "(06.2) Extraction of natural gas",
  B071: "(07.1) Mining of iron ores",
  B072: "(07.2) Mining of non-ferrous metal ores",
  B081: "(08.1) Quarrying of stone, sand and clay",
  B089: "(08.9) Mining and quarrying n.e.c.",
  B091: "(09.1) Support activities for petroleum and natural gas extraction",
  B099: "(09.9) Support activities for other mining and quarrying",
  B0510: "(05.10) Mining of hard coal",
  B0520: "(05.20) Mining of lignite",
  B0610: "(06.10) Extraction of crude petroleum",
  B0620: "(06.20) Extraction of natural gas",
  B0710: "(07.10) Mining of iron ores",
  B0721: "(07.21) Mining of uranium and thorium ores",
  B0729: "(07.29) Mining of other non-ferrous metal ores",
  B0811: "(08.11) Quarrying of ornamental stone, limestone, gypsum, slate and other stone",
  B0812: "(08.12) Operation of gravel and sand pits and mining of clay and kaolin",
  B0891: "(08.91) Mining of chemical and fertiliser minerals",
  B0892: "(08.92) Extraction of peat",
  B0893: "(08.93) Extraction of salt",
  B0899: "(08.99) Other mining and quarrying n.e.c.",
  B0910: "(09.10) Support activities for petroleum and natural gas extraction",
  B0990: "(09.90) Support activities for other mining and quarrying",
  C: "(C) MANUFACTURING",
  C10: "(10) Manufacture of food products",
  C11: "(11) Manufacture of beverages",
  C12: "(12) Manufacture of tobacco products",
  C13: "(13) Manufacture of textiles",
  C14: "(14) Manufacture of wearing apparel",
  C15: "(15) Manufacture of leather and related products of other materials",
  C16: "(16) Manufacture of wood and of products of wood and cork, except furniture; manufacture of articles of straw and plaiting materials",
  C17: "(17) Manufacture of paper and paper products",
  C18: "(18) Printing and reproduction of recorded media",
  C19: "(19) Manufacture of coke and refined petroleum products",
  C20: "(20) Manufacture of chemicals and chemical products",
  C21: "(21) Manufacture of basic pharmaceutical products and pharmaceutical preparations",
  C22: "(22) Manufacture of rubber and plastic products",
  C23: "(23) Manufacture of other non-metallic mineral products",
  C24: "(24) Manufacture of basic metals",
  C25: "(25) Manufacture of fabricated metal products, except machinery and equipment",
  C26: "(26) Manufacture of computer, electronic and optical products",
  C27: "(27) Manufacture of electrical equipment",
  C28: "(28) Manufacture of machinery and equipment n.e.c.",
  C29: "(29) Manufacture of motor vehicles, trailers and semi-trailers",
  C30: "(30) Manufacture of other transport equipment",
  C31: "(31) Manufacture of furniture",
  C32: "(32) Other manufacturing",
  C33: "(33) Repair, maintenance and installation of machinery and equipment",
  C101: "(10.1) Processing and preserving of meat and production of meat products",
  C102: "(10.2) Processing and preserving of fish, crustaceans and molluscs",
  C103: "(10.3) Processing and preserving of fruit and vegetables",
  C104: "(10.4) Manufacture of vegetable and animal oils and fats",
  C105: "(10.5) Manufacture of dairy products and edible ice",
  C106: "(10.6) Manufacture of grain mill products, starches and starch products",
  C107: "(10.7) Manufacture of bakery and farinaceous products",
  C108: "(10.8) Manufacture of other food products",
  C109: "(10.9) Manufacture of prepared animal feeds",
  C110: "(11.0) Manufacture of beverages",
  C120: "(12.0) Manufacture of tobacco products",
  C131: "(13.1) Preparation and spinning of textile fibres",
  C132: "(13.2) Weaving of textiles",
  C133: "(13.3) Finishing of textiles",
  C139: "(13.9) Manufacture of other textiles",
  C141: "(14.1) Manufacture of knitted and crocheted apparel",
  C142: "(14.2) Manufacture of other wearing apparel and accessories",
  C151: "(15.1) Tanning, dyeing, dressing of leather and fur; manufacture of luggage, handbags, saddlery and harness",
  C152: "(15.2) Manufacture of footwear",
  C161: "(16.1) Sawmilling and planing of wood; processing and finishing of wood",
  C162: "(16.2) Manufacture of products of wood, cork, straw and plaiting materials",
  C171: "(17.1) Manufacture of pulp, paper and paperboard",
  C172: "(17.2) Manufacture of articles of paper and paperboard",
  C181: "(18.1) Printing and service activities related to printing",
  C182: "(18.2) Reproduction of recorded media",
  C191: "(19.1) Manufacture of coke oven products",
  C192: "(19.2) Manufacture of refined petroleum products and fossil fuel products",
  C201: "(20.1) Manufacture of basic chemicals, fertilisers and nitrogen compounds, plastics and synthetic rubber in primary forms",
  C202: "(20.2) Manufacture of pesticides, disinfectants and other agrochemical products",
  C203: "(20.3) Manufacture of paints, varnishes and similar coatings, printing ink and mastics",
  C204: "(20.4) Manufacture of washing, cleaning and polishing preparations",
  C205: "(20.5) Manufacture of other chemical products",
  C206: "(20.6) Manufacture of man-made fibres",
  C211: "(21.1) Manufacture of basic pharmaceutical products",
  C212: "(21.2) Manufacture of pharmaceutical preparations",
  C221: "(22.1) Manufacture of rubber products",
  C222: "(22.2) Manufacture of plastic products",
  C231: "(23.1) Manufacture of glass and glass products",
  C232: "(23.2) Manufacture of refractory products",
  C233: "(23.3) Manufacture of clay building materials",
  C234: "(23.4) Manufacture of other porcelain and ceramic products",
  C235: "(23.5) Manufacture of cement, lime and plaster",
  C236: "(23.6) Manufacture of articles of concrete, cement and plaster",
  C237: "(23.7) Cutting, shaping and finishing of stone",
  C239: "(23.9) Manufacture of abrasive products and non-metallic mineral products n.e.c.",
  C241: "(24.1) Manufacture of basic iron and steel and of ferro-alloys",
  C242: "(24.2) Manufacture of tubes, pipes, hollow profiles and related fittings, of steel",
  C243: "(24.3) Manufacture of other products of first processing of steel",
  C244: "(24.4) Manufacture of basic precious and other non-ferrous metals",
  C245: "(24.5) Casting of metals",
  C251: "(25.1) Manufacture of structural metal products",
  C252: "(25.2) Manufacture of tanks, reservoirs and containers of metal",
  C253: "(25.3) Manufacture of weapons and ammunition",
  C254: "(25.4) Forging and shaping metal and powder metallurgy",
  C255: "(25.5) Treatment and coating of metals; machining",
  C256: "(25.6) Manufacture of cutlery, tools and general hardware",
  C259: "(25.9) Manufacture of other fabricated metal products",
  C261: "(26.1) Manufacture of electronic components and boards",
  C262: "(26.2) Manufacture of computers and peripheral equipment",
  C263: "(26.3) Manufacture of communication equipment",
  C264: "(26.4) Manufacture of consumer electronics",
  C265: "(26.5) Manufacture of measuring testing instruments, clocks and watches",
  C266: "(26.6) Manufacture of irradiation, electromedical and electrotherapeutic equipment",
  C267: "(26.7) Manufacture of optical instruments, magnetic and optical media and photographic equipment",
  C271: "(27.1) Manufacture of electric motors, generators, transformers and electricity distribution and control apparatus",
  C272: "(27.2) Manufacture of batteries and accumulators",
  C273: "(27.3) Manufacture of wiring and wiring devices",
  C274: "(27.4) Manufacture of lighting equipment",
  C275: "(27.5) Manufacture of domestic appliances",
  C279: "(27.9) Manufacture of other electrical equipment",
  C281: "(28.1) Manufacture of general-purpose machinery",
  C282: "(28.2) Manufacture of other general-purpose machinery",
  C283: "(28.3) Manufacture of agricultural and forestry machinery",
  C284: "(28.4) Manufacture of metal forming machinery and machine tools",
  C289: "(28.9) Manufacture of other special-purpose machinery",
  C291: "(29.1) Manufacture of motor vehicles",
  C292: "(29.2) Manufacture of bodies and coachwork for motor vehicles; manufacture of trailers and semi-trailers",
  C293: "(29.3) Manufacture of motor vehicle parts and accessories",
  C301: "(30.1) Building of ships and boats",
  C302: "(30.2) Manufacture of railway locomotives and rolling stock",
  C303: "(30.3) Manufacture of air and spacecraft and related machinery",
  C304: "(30.4) Manufacture of military fighting vehicles",
  C309: "(30.9) Manufacture of transport equipment n.e.c.",
  C310: "(31.0) Manufacture of furniture",
  C321: "(32.1) Manufacture of jewellery, bijouterie and related articles",
  C322: "(32.2) Manufacture of musical instruments",
  C323: "(32.3) Manufacture of sports goods",
  C324: "(32.4) Manufacture of games and toys",
  C325: "(32.5) Manufacture of medical and dental instruments and supplies",
  C329: "(32.9) Manufacturing n.e.c.",
  C331: "(33.1) Repair and maintenance of fabricated metal products, machinery and equipment",
  C332: "(33.2) Installation of industrial machinery and equipment",
  C1011: "(10.11) Processing and preserving of meat, except of poultry meat",
  C1012: "(10.12) Processing and preserving of poultry meat",
  C1013: "(10.13) Production of meat and poultry meat products",
  C1020: "(10.20) Processing and preserving of fish, crustaceans and molluscs",
  C1031: "(10.31) Processing and preserving of potatoes",
  C1032: "(10.32) Manufacture of fruit and vegetable juice",
  C1039: "(10.39) Other processing and preserving of fruit and vegetables",
  C1041: "(10.41) Manufacture of oils and fats",
  C1042: "(10.42) Manufacture of margarine and similar edible fats",
  C1051: "(10.51) Manufacture of dairy products",
  C1052: "(10.52) Manufacture of ice cream and other edible ice",
  C1061: "(10.61) Manufacture of grain mill products",
  C1062: "(10.62) Manufacture of starches and starch products",
  C1071: "(10.71) Manufacture of bread; manufacture of fresh pastry goods and cakes",
  C1072: "(10.72) Manufacture of rusks, biscuits, preserved pastries and cakes",
  C1073: "(10.73) Manufacture of farinaceous products",
  C1081: "(10.81) Manufacture of sugar",
  C1082: "(10.82) Manufacture of cocoa, chocolate and sugar confectionery",
  C1083: "(10.83) Processing of tea and coffee",
  C1084: "(10.84) Manufacture of condiments and seasonings",
  C1085: "(10.85) Manufacture of prepared meals and dishes",
  C1086: "(10.86) Manufacture of homogenised food preparations and dietetic food",
  C1089: "(10.89) Manufacture of other food products n.e.c.",
  C1091: "(10.91) Manufacture of prepared feeds for farm animals",
  C1092: "(10.92) Manufacture of prepared pet foods",
  C1101: "(11.01) Distilling, rectifying and blending of spirits",
  C1102: "(11.02) Manufacture of wine from grape",
  C1103: "(11.03) Manufacture of cider and other fruit fermented beverages",
  C1104: "(11.04) Manufacture of other non-distilled fermented beverages",
  C1105: "(11.05) Manufacture of beer",
  C1106: "(11.06) Manufacture of malt",
  C1107: "(11.07) Manufacture of soft drinks and bottled waters",
  C1200: "(12.00) Manufacture of tobacco products",
  C1310: "(13.10) Preparation and spinning of textile fibres",
  C1320: "(13.20) Weaving of textiles",
  C1330: "(13.30) Finishing of textiles",
  C1391: "(13.91) Manufacture of knitted and crocheted fabrics",
  C1392: "(13.92) Manufacture of household textiles and made-up furnishing articles",
  C1393: "(13.93) Manufacture of carpets and rugs",
  C1394: "(13.94) Manufacture of cordage, rope, twine and netting",
  C1395: "(13.95) Manufacture of non-wovens and non-woven articles",
  C1396: "(13.96) Manufacture of other technical and industrial textiles",
  C1399: "(13.99) Manufacture of other textiles n.e.c.",
  C1410: "(14.10) Manufacture of knitted and crocheted apparel",
  C1421: "(14.21) Manufacture of outerwear",
  C1422: "(14.22) Manufacture of underwear",
  C1423: "(14.23) Manufacture of workwear",
  C1424: "(14.24) Manufacture of leather clothes and fur apparel",
  C1429: "(14.29) Manufacture of other wearing apparel and accessories n.e.c.",
  C1511: "(15.11) Tanning, dressing, dyeing of leather and fur",
  C1512: "(15.12) Manufacture of luggage, handbags, saddlery and harness of any material",
  C1520: "(15.20) Manufacture of footwear",
  C1611: "(16.11) Sawmilling and planing of wood",
  C1612: "(16.12) Processing and finishing of wood",
  C1621: "(16.21) Manufacture of veneer sheets and wood-based panels",
  C1622: "(16.22) Manufacture of assembled parquet floors",
  C1623: "(16.23) Manufacture of other builders' carpentry and joinery",
  C1624: "(16.24) Manufacture of wooden containers",
  C1625: "(16.25) Manufacture of doors and windows of wood",
  C1626: "(16.26) Manufacture of solid fuels from vegetable biomass",
  C1627: "(16.27) Finishing of wooden products",
  C1628: "(16.28) Manufacture of other products of wood and articles of cork, straw and plaiting materials",
  C1711: "(17.11) Manufacture of pulp",
  C1712: "(17.12) Manufacture of paper and paperboard",
  C1721: "(17.21) Manufacture of corrugated paper, paperboard and containers of paper and paperboard",
  C1722: "(17.22) Manufacture of household and sanitary goods and of toilet requisites",
  C1723: "(17.23) Manufacture of paper stationery",
  C1724: "(17.24) Manufacture of wallpaper",
  C1725: "(17.25) Manufacture of other articles of paper and paperboard",
  C1811: "(18.11) Printing of newspapers",
  C1812: "(18.12) Other printing",
  C1813: "(18.13) Pre-press and pre-media services",
  C1814: "(18.14) Binding and related services",
  C1820: "(18.20) Reproduction of recorded media",
  C1910: "(19.10) Manufacture of coke oven products",
  C1920: "(19.20) Manufacture of refined petroleum products and fossil fuel products",
  C2011: "(20.11) Manufacture of industrial gases",
  C2012: "(20.12) Manufacture of dyes and pigments",
  C2013: "(20.13) Manufacture of other inorganic basic chemicals",
  C2014: "(20.14) Manufacture of other organic basic chemicals",
  C2015: "(20.15) Manufacture of fertilisers and nitrogen compounds",
  C2016: "(20.16) Manufacture of plastics in primary forms",
  C2017: "(20.17) Manufacture of synthetic rubber in primary forms",
  C2020: "(20.20) Manufacture of pesticides, disinfectants and other agrochemical products",
  C2030: "(20.30) Manufacture of paints, varnishes and similar coatings, printing ink and mastics",
  C2041: "(20.41) Manufacture of soap and detergents, cleaning and polishing preparations",
  C2042: "(20.42) Manufacture of perfumes and toilet preparations",
  C2051: "(20.51) Manufacture of liquid biofuels",
  C2059: "(20.59) Manufacture of other chemical products n.e.c.",
  C2060: "(20.60) Manufacture of man-made fibres",
  C2110: "(21.10) Manufacture of basic pharmaceutical products",
  C2120: "(21.20) Manufacture of pharmaceutical preparations",
  C2211: "(22.11) Manufacture, retreading and rebuilding of rubber tyres and manufacture of tubes",
  C2212: "(22.12) Manufacture of other rubber products",
  C2221: "(22.21) Manufacture of plastic plates, sheets, tubes and profiles",
  C2222: "(22.22) Manufacture of plastic packing goods",
  C2223: "(22.23) Manufacture of doors and windows of plastic",
  C2224: "(22.24) Manufacture of builders’ ware of plastic",
  C2225: "(22.25) Processing and finishing of plastic products",
  C2226: "(22.26) Manufacture of other plastic products",
  C2311: "(23.11) Manufacture of flat glass",
  C2312: "(23.12) Shaping and processing of flat glass",
  C2313: "(23.13) Manufacture of hollow glass",
  C2314: "(23.14) Manufacture of glass fibres",
  C2315: "(23.15) Manufacture and processing of other glass, including technical glassware",
  C2320: "(23.20) Manufacture of refractory products",
  C2331: "(23.31) Manufacture of ceramic tiles and flags",
  C2332: "(23.32) Manufacture of bricks, tiles and construction products, in baked clay",
  C2341: "(23.41) Manufacture of ceramic household and ornamental articles",
  C2342: "(23.42) Manufacture of ceramic sanitary fixtures",
  C2343: "(23.43) Manufacture of ceramic insulators and insulating fittings",
  C2344: "(23.44) Manufacture of other technical ceramic products",
  C2345: "(23.45) Manufacture of other ceramic products",
  C2351: "(23.51) Manufacture of cement",
  C2352: "(23.52) Manufacture of lime and plaster",
  C2361: "(23.61) Manufacture of concrete products for construction purposes",
  C2362: "(23.62) Manufacture of plaster products for construction purposes",
  C2363: "(23.63) Manufacture of ready-mixed concrete",
  C2364: "(23.64) Manufacture of mortars",
  C2365: "(23.65) Manufacture of fibre cement",
  C2366: "(23.66) Manufacture of other articles of concrete, cement and plaster",
  C2370: "(23.70) Cutting, shaping and finishing of stone",
  C2391: "(23.91) Manufacture of abrasive products",
  C2399: "(23.99) Manufacture of other non-metallic mineral products n.e.c.",
  C2410: "(24.10) Manufacture of basic iron and steel and of ferro-alloys",
  C2420: "(24.20) Manufacture of tubes, pipes, hollow profiles and related fittings, of steel",
  C2431: "(24.31) Cold drawing of bars",
  C2432: "(24.32) Cold rolling of narrow strip",
  C2433: "(24.33) Cold forming or folding",
  C2434: "(24.34) Cold drawing of wire",
  C2441: "(24.41) Precious metals production",
  C2442: "(24.42) Aluminium production",
  C2443: "(24.43) Lead, zinc and tin production",
  C2444: "(24.44) Copper production",
  C2445: "(24.45) Other non-ferrous metal production",
  C2446: "(24.46) Processing of nuclear fuel",
  C2451: "(24.51) Casting of iron",
  C2452: "(24.52) Casting of steel",
  C2453: "(24.53) Casting of light metals",
  C2454: "(24.54) Casting of other non-ferrous metals",
  C2511: "(25.11) Manufacture of metal structures and parts of structures",
  C2512: "(25.12) Manufacture of doors and windows of metal",
  C2521: "(25.21) Manufacture of central heating radiators, steam generators and boilers",
  C2522: "(25.22) Manufacture of other tanks, reservoirs and containers of metal",
  C2530: "(25.30) Manufacture of weapons and ammunition",
  C2540: "(25.40) Forging and shaping metal and powder metallurgy",
  C2551: "(25.51) Coating of metals",
  C2552: "(25.52) Heat treatment of metals",
  C2553: "(25.53) Machining of metals",
  C2561: "(25.61) Manufacture of cutlery",
  C2562: "(25.62) Manufacture of locks and hinges",
  C2563: "(25.63) Manufacture of tools",
  C2591: "(25.91) Manufacture of steel drums and similar containers",
  C2592: "(25.92) Manufacture of light metal packaging",
  C2593: "(25.93) Manufacture of wire products, chain and springs",
  C2594: "(25.94) Manufacture of fasteners and screw machine products",
  C2599: "(25.99) Manufacture of other fabricated metal products n.e.c.",
  C2611: "(26.11) Manufacture of electronic components",
  C2612: "(26.12) Manufacture of loaded electronic boards",
  C2620: "(26.20) Manufacture of computers and peripheral equipment",
  C2630: "(26.30) Manufacture of communication equipment",
  C2640: "(26.40) Manufacture of consumer electronics",
  C2651: "(26.51) Manufacture of instruments and appliances for measuring, testing and navigation",
  C2652: "(26.52) Manufacture of watches and clocks",
  C2660: "(26.60) Manufacture of irradiation, electromedical and electrotherapeutic equipment",
  C2670: "(26.70) Manufacture of optical instruments, magnetic and optical media and photographic equipment",
  C2711: "(27.11) Manufacture of electric motors, generators and transformers",
  C2712: "(27.12) Manufacture of electricity distribution and control apparatus",
  C2720: "(27.20) Manufacture of batteries and accumulators",
  C2731: "(27.31) Manufacture of fibre optic cables",
  C2732: "(27.32) Manufacture of other electronic and electric wires and cables",
  C2733: "(27.33) Manufacture of wiring devices",
  C2740: "(27.40) Manufacture of lighting equipment",
  C2751: "(27.51) Manufacture of electric domestic appliances",
  C2752: "(27.52) Manufacture of non-electric domestic appliances",
  C2790: "(27.90) Manufacture of other electrical equipment",
  C2811: "(28.11) Manufacture of engines and turbines, except aircraft, vehicle and cycle engines",
  C2812: "(28.12) Manufacture of fluid power equipment",
  C2813: "(28.13) Manufacture of other pumps and compressors",
  C2814: "(28.14) Manufacture of other taps and valves",
  C2815: "(28.15) Manufacture of bearings, gears, gearing and driving elements",
  C2821: "(28.21) Manufacture of ovens, furnaces and permanent household heating equipment",
  C2822: "(28.22) Manufacture of lifting and handling equipment",
  C2823: "(28.23) Manufacture of office machinery and equipment, except computers and peripheral equipment",
  C2824: "(28.24) Manufacture of power-driven hand tools",
  C2825: "(28.25) Manufacture of non-domestic air conditioning equipment",
  C2829: "(28.29) Manufacture of other general-purpose machinery n.e.c.",
  C2830: "(28.30) Manufacture of agricultural and forestry machinery",
  C2841: "(28.41) Manufacture of metal forming machinery and machine tools for metal work",
  C2842: "(28.42) Manufacture of other machine tools",
  C2891: "(28.91) Manufacture of machinery for metallurgy",
  C2892: "(28.92) Manufacture of machinery for mining, quarrying and construction",
  C2893: "(28.93) Manufacture of machinery for food, beverage and tobacco processing",
  C2894: "(28.94) Manufacture of machinery for textile, apparel and leather production",
  C2895: "(28.95) Manufacture of machinery for paper and paperboard production",
  C2896: "(28.96) Manufacture of plastics and rubber machinery",
  C2897: "(28.97) Manufacture of additive manufacturing machinery",
  C2899: "(28.99) Manufacture of other special-purpose machinery n.e.c.",
  C2910: "(29.10) Manufacture of motor vehicles",
  C2920: "(29.20) Manufacture of bodies and coachwork for motor vehicles; manufacture of trailers and semi-trailers",
  C2931: "(29.31) Manufacture of electrical and electronic equipment for motor vehicles",
  C2932: "(29.32) Manufacture of other parts and accessories for motor vehicles",
  C3011: "(30.11) Building of civilian ships and floating structures",
  C3012: "(30.12) Building of pleasure and sporting boats",
  C3013: "(30.13) Building of military ships and vessels",
  C3020: "(30.20) Manufacture of railway locomotives and rolling stock",
  C3031: "(30.31) Manufacture of civilian air and spacecraft and related machinery",
  C3032: "(30.32) Manufacture of military air and spacecraft and related machinery",
  C3040: "(30.40) Manufacture of military fighting vehicles",
  C3091: "(30.91) Manufacture of motorcycles",
  C3092: "(30.92) Manufacture of bicycles and invalid carriages",
  C3099: "(30.99) Manufacture of other transport equipment n.e.c.",
  C3100: "(31.00) Manufacture of furniture",
  C3211: "(32.11) Striking of coins",
  C3212: "(32.12) Manufacture of jewellery and related articles",
  C3213: "(32.13) Manufacture of imitation jewellery and related articles",
  C3220: "(32.20) Manufacture of musical instruments",
  C3230: "(32.30) Manufacture of sports goods",
  C3240: "(32.40) Manufacture of games and toys",
  C3250: "(32.50) Manufacture of medical and dental instruments and supplies",
  C3291: "(32.91) Manufacture of brooms and brushes",
  C3299: "(32.99) Other manufacturing n.e.c.",
  C3311: "(33.11) Repair and maintenance of fabricated metal products",
  C3312: "(33.12) Repair and maintenance of machinery",
  C3313: "(33.13) Repair and maintenance of electronic and optical equipment",
  C3314: "(33.14) Repair and maintenance of electrical equipment",
  C3315: "(33.15) Repair and maintenance of civilian ships and boats",
  C3316: "(33.16) Repair and maintenance of civilian air and spacecraft",
  C3317: "(33.17) Repair and maintenance of other civilian transport equipment",
  C3318: "(33.18) Repair and maintenance of military fighting vehicles, ships, boats, air and spacecraft",
  C3319: "(33.19) Repair and maintenance of other equipment",
  C3320: "(33.20) Installation of industrial machinery and equipment",
  D: "(D) ELECTRICITY, GAS, STEAM AND AIR CONDITIONING SUPPLY",
  D35: "(35) Electricity, gas, steam and air conditioning supply",
  D351: "(35.1) Electric power generation, transmission and distribution",
  D352: "(35.2) Manufacture of gas, and distribution of gaseous fuels through mains",
  D353: "(35.3) Steam and air conditioning supply",
  D354: "(35.4) Activities of brokers and agents for electric power and natural gas",
  D3511: "(35.11) Production of electricity from non-renewable sources",
  D3512: "(35.12) Production of electricity from renewable sources",
  D3513: "(35.13) Transmission of electricity",
  D3514: "(35.14) Distribution of electricity",
  D3515: "(35.15) Trade of electricity",
  D3516: "(35.16) Storage of electricity",
  D3521: "(35.21) Manufacture of gas",
  D3522: "(35.22) Distribution of gaseous fuels through mains",
  D3523: "(35.23) Trade of gas through mains",
  D3524: "(35.24) Storage of gas as part of network supply services",
  D3530: "(35.30) Steam and air conditioning supply",
  D3540: "(35.40) Activities of brokers and agents for electric power and natural gas",
  E: "(E) WATER SUPPLY; SEWERAGE, WASTE MANAGEMENT AND REMEDIATION ACTIVITIES",
  E36: "(36) Water collection, treatment and supply",
  E37: "(37) Sewerage",
  E38: "(38) Waste collection, recovery and disposal activities",
  E39: "(39) Remediation activities and other waste management service activities",
  E360: "(36.0) Water collection, treatment and supply",
  E370: "(37.0) Sewerage",
  E381: "(38.1) Waste collection",
  E382: "(38.2) Waste recovery",
  E383: "(38.3) Waste disposal without recovery",
  E390: "(39.0) Remediation activities and other waste management service activities",
  E3600: "(36.00) Water collection, treatment and supply",
  E3700: "(37.00) Sewerage",
  E3811: "(38.11) Collection of non-hazardous waste",
  E3812: "(38.12) Collection of hazardous waste",
  E3821: "(38.21) Materials recovery",
  E3822: "(38.22) Energy recovery",
  E3823: "(38.23) Other waste recovery",
  E3831: "(38.31) Incineration without energy recovery",
  E3832: "(38.32) Landfilling or permanent storage",
  E3833: "(38.33) Other waste disposal",
  E3900: "(39.00) Remediation activities and other waste management service activities",
  F: "(F) CONSTRUCTION",
  F41: "(41) Construction of residential and non-residential buildings",
  F42: "(42) Civil engineering",
  F43: "(43) Specialised construction activities",
  F410: "(41.0) Construction of residential and non-residential buildings",
  F421: "(42.1) Construction of roads and railways",
  F422: "(42.2) Construction of utility projects",
  F429: "(42.9) Construction of other civil engineering projects",
  F431: "(43.1) Demolition and site preparation",
  F432: "(43.2) Electrical, plumbing and other construction installation activities",
  F433: "(43.3) Building completion and finishing",
  F434: "(43.4) Specialised construction activities in construction of buildings",
  F435: "(43.5) Specialised construction activities in civil engineering",
  F436: "(43.6) Intermediation service activities for specialised construction services",
  F439: "(43.9) Other specialised construction activities",
  F4100: "(41.00) Construction of residential and non-residential buildings",
  F4211: "(42.11) Construction of roads and motorways",
  F4212: "(42.12) Construction of railways and underground railways",
  F4213: "(42.13) Construction of bridges and tunnels",
  F4221: "(42.21) Construction of utility projects for fluids",
  F4222: "(42.22) Construction of utility projects for electricity and telecommunications",
  F4291: "(42.91) Construction of water projects",
  F4299: "(42.99) Construction of other civil engineering projects n.e.c.",
  F4311: "(43.11) Demolition",
  F4312: "(43.12) Site preparation",
  F4313: "(43.13) Test drilling and boring",
  F4321: "(43.21) Electrical installation",
  F4322: "(43.22) Plumbing, heat and air-conditioning installation",
  F4323: "(43.23) Installation of insulation",
  F4324: "(43.24) Other construction installation",
  F4331: "(43.31) Plastering",
  F4332: "(43.32) Joinery installation",
  F4333: "(43.33) Floor and wall covering",
  F4334: "(43.34) Painting and glazing",
  F4335: "(43.35) Other building completion and finishing",
  F4341: "(43.41) Roofing activities",
  F4342: "(43.42) Other specialised construction activities in construction of buildings",
  F4350: "(43.50) Specialised construction activities in civil engineering",
  F4360: "(43.60) Intermediation service activities for specialised construction services",
  F4391: "(43.91) Masonry and bricklaying activities",
  F4399: "(43.99) Other specialised construction activities n.e.c.",
  G: "(G) WHOLESALE AND RETAIL TRADE",
  G46: "(46) Wholesale trade",
  G47: "(47) Retail trade",
  G461: "(46.1) Wholesale on a fee or contract basis",
  G462: "(46.2) Wholesale of agricultural raw materials and live animals",
  G463: "(46.3) Wholesale of food, beverages and tobacco",
  G464: "(46.4) Wholesale of household goods",
  G465: "(46.5) Wholesale of information and communication equipment",
  G466: "(46.6) Wholesale of other machinery, equipment and supplies",
  G467: "(46.7) Wholesale of motor vehicles, motorcycles and related parts and accessories",
  G468: "(46.8) Other specialised wholesale",
  G469: "(46.9) Non-specialised wholesale trade",
  G471: "(47.1) Non-specialised retail sale",
  G472: "(47.2) Retail sale of food, beverages and tobacco",
  G473: "(47.3) Retail sale of automotive fuel",
  G474: "(47.4) Retail sale of information and communication equipment",
  G475: "(47.5) Retail sale of other household equipment",
  G476: "(47.6) Retail sale of cultural and recreational goods",
  G477: "(47.7) Retail sale of other goods, except motor vehicles and motorcycles",
  G478: "(47.8) Retail sale of motor vehicles, motorcycles and related parts and accessories",
  G479: "(47.9) Intermediation service activities for retail sale",
  G4611: "(46.11) Activities of agents involved in the wholesale of agricultural raw materials, live animals, textile raw materials and semi-finished goods",
  G4612: "(46.12) Activities of agents involved in the wholesale of fuels, ores, metals and industrial chemicals",
  G4613: "(46.13) Activities of agents involved in the wholesale of timber and building materials",
  G4614: "(46.14) Activities of agents involved in the wholesale of machinery, industrial equipment, ships and aircraft",
  G4615: "(46.15) Activities of agents involved in the wholesale of furniture, household goods, hardware and ironmongery",
  G4616: "(46.16) Activities of agents involved in the wholesale of textiles, clothing, fur, footwear and leather goods",
  G4617: "(46.17) Activities of agents involved in the wholesale of food, beverages and tobacco",
  G4618: "(46.18) Activities of agents involved in the wholesale of other particular products",
  G4619: "(46.19) Activities of agents involved in non-specialised wholesale",
  G4621: "(46.21) Wholesale of grain, unmanufactured tobacco, seeds and animal feeds",
  G4622: "(46.22) Wholesale of flowers and plants",
  G4623: "(46.23) Wholesale of live animals",
  G4624: "(46.24) Wholesale of hides, skins and leather",
  G4631: "(46.31) Wholesale of fruit and vegetables",
  G4632: "(46.32) Wholesale of meat, meat products, fish and fish products",
  G4633: "(46.33) Wholesale of dairy products, eggs and edible oils and fats",
  G4634: "(46.34) Wholesale of beverages",
  G4635: "(46.35) Wholesale of tobacco products",
  G4636: "(46.36) Wholesale of sugar, chocolate and sugar confectionery",
  G4637: "(46.37) Wholesale of coffee, tea, cocoa and spices",
  G4638: "(46.38) Wholesale of other food",
  G4639: "(46.39) Non-specialised wholesale of food, beverages and tobacco",
  G4641: "(46.41) Wholesale of textiles",
  G4642: "(46.42) Wholesale of clothing and footwear",
  G4643: "(46.43) Wholesale of electrical household appliances",
  G4644: "(46.44) Wholesale of china and glassware and cleaning materials",
  G4645: "(46.45) Wholesale of perfume and cosmetics",
  G4646: "(46.46) Wholesale of pharmaceutical and medical goods",
  G4647: "(46.47) Wholesale of household, office and shop furniture, carpets and lighting equipment",
  G4648: "(46.48) Wholesale of watches and jewellery",
  G4649: "(46.49) Wholesale of other household goods",
  G4650: "(46.50) Wholesale of information and communication equipment",
  G4661: "(46.61) Wholesale of agricultural machinery, equipment and supplies",
  G4662: "(46.62) Wholesale of machine tools",
  G4663: "(46.63) Wholesale of mining, construction and civil engineering machinery",
  G4664: "(46.64) Wholesale of other machinery and equipment",
  G4671: "(46.71) Wholesale of motor vehicles",
  G4672: "(46.72) Wholesale of motor vehicle parts and accessories",
  G4673: "(46.73) Wholesale of motorcycles, motorcycle parts and accessories",
  G4681: "(46.81) Wholesale of solid, liquid and gaseous fuels and related products",
  G4682: "(46.82) Wholesale of metals and metal ores",
  G4683: "(46.83) Wholesale of wood, construction materials and sanitary equipment",
  G4684: "(46.84) Wholesale of hardware, plumbing and heating equipment and supplies",
  G4685: "(46.85) Wholesale of chemical products",
  G4686: "(46.86) Wholesale of other intermediate products",
  G4687: "(46.87) Wholesale of waste and scrap",
  G4689: "(46.89) Other specialised wholesale n.e.c.",
  G4690: "(46.90) Non-specialised wholesale trade",
  G4711: "(47.11) Non-specialised retail sale of predominately food, beverages or tobacco",
  G4712: "(47.12) Other non-specialised retail sale",
  G4721: "(47.21) Retail sale of fruit and vegetables",
  G4722: "(47.22) Retail sale of meat and meat products",
  G4723: "(47.23) Retail sale of fish, crustaceans and molluscs",
  G4724: "(47.24) Retail sale of bread, cake and confectionery",
  G4725: "(47.25) Retail sale of beverages",
  G4726: "(47.26) Retail sale of tobacco products",
  G4727: "(47.27) Retail sale of other food",
  G4730: "(47.30) Retail sale of automotive fuel",
  G4740: "(47.40) Retail sale of information and communication equipment",
  G4751: "(47.51) Retail sale of textiles",
  G4752: "(47.52) Retail sale of hardware, building materials, paints and glass",
  G4753: "(47.53) Retail sale of carpets, rugs, wall and floor coverings",
  G4754: "(47.54) Retail sale of electrical household appliances",
  G4755: "(47.55) Retail sale of furniture, lighting equipment, tableware and other household goods",
  G4761: "(47.61) Retail sale of books",
  G4762: "(47.62) Retail sale of newspapers, and other periodical publications and stationery",
  G4763: "(47.63) Retail sale of sporting equipment",
  G4764: "(47.64) Retail sale of games and toys",
  G4769: "(47.69) Retail sale of cultural and recreational goods n.e.c.",
  G4771: "(47.71) Retail sale of clothing",
  G4772: "(47.72) Retail sale of footwear and leather goods",
  G4773: "(47.73) Retail sale of pharmaceutical products",
  G4774: "(47.74) Retail sale of medical and orthopaedic goods",
  G4775: "(47.75) Retail sale of cosmetic and toilet articles",
  G4776: "(47.76) Retail sale of flowers, plants, fertilisers, pets and pet food",
  G4777: "(47.77) Retail sale of watches and jewellery",
  G4778: "(47.78) Retail sale of other new goods",
  G4779: "(47.79) Retail sale of second-hand goods",
  G4781: "(47.81) Retail sale of motor vehicles",
  G4782: "(47.82) Retail sale of motor vehicle parts and accessories",
  G4783: "(47.83) Retail sale of motorcycles, motorcycle parts and accessories",
  G4791: "(47.91) Intermediation service activities for non-specialised retail sale",
  G4792: "(47.92) Intermediation service activities for specialised retail sale",
  H: "(H) TRANSPORTATION AND STORAGE",
  H49: "(49) Land transport and transport via pipelines",
  H50: "(50) Water transport",
  H51: "(51) Air transport",
  H52: "(52) Warehousing, storage and support activities for transportation",
  H53: "(53) Postal and courier activities",
  H491: "(49.1) Passenger rail transport",
  H492: "(49.2) Freight rail transport",
  H493: "(49.3) Other passenger land transport",
  H494: "(49.4) Freight transport by road and removal services",
  H495: "(49.5) Transport via pipeline",
  H501: "(50.1) Sea and coastal passenger water transport",
  H502: "(50.2) Sea and coastal freight water transport",
  H503: "(50.3) Inland passenger water transport",
  H504: "(50.4) Inland freight water transport",
  H511: "(51.1) Passenger air transport",
  H512: "(51.2) Freight air transport and space transport",
  H521: "(52.1) Warehousing and storage",
  H522: "(52.2) Support activities for transportation",
  H523: "(52.3) Intermediation service activities for transportation",
  H531: "(53.1) Postal activities under universal service obligation",
  H532: "(53.2) Other postal and courier activities",
  H533: "(53.3) Intermediation service activities for postal and courier activities",
  H4911: "(49.11) Passenger heavy rail transport",
  H4912: "(49.12) Other passenger rail transport",
  H4920: "(49.20) Freight rail transport",
  H4931: "(49.31) Scheduled passenger transport by road",
  H4932: "(49.32) Non-scheduled passenger transport by road",
  H4933: "(49.33) On-demand passenger transport service activities by vehicle with driver",
  H4934: "(49.34) Passenger transport by cableways and ski lifts",
  H4939: "(49.39) Other passenger land transport n.e.c.",
  H4941: "(49.41) Freight transport by road",
  H4942: "(49.42) Removal services",
  H4950: "(49.50) Transport via pipeline",
  H5010: "(50.10) Sea and coastal passenger water transport",
  H5020: "(50.20) Sea and coastal freight water transport",
  H5030: "(50.30) Inland passenger water transport",
  H5040: "(50.40) Inland freight water transport",
  H5110: "(51.10) Passenger air transport",
  H5121: "(51.21) Freight air transport",
  H5122: "(51.22) Space transport",
  H5210: "(52.10) Warehousing and storage",
  H5221: "(52.21) Service activities incidental to land transportation",
  H5222: "(52.22) Service activities incidental to water transportation",
  H5223: "(52.23) Service activities incidental to air transportation",
  H5224: "(52.24) Cargo handling",
  H5225: "(52.25) Logistics service activities",
  H5226: "(52.26) Other support activities for transportation",
  H5231: "(52.31) Intermediation service activities for freight transportation",
  H5232: "(52.32) Intermediation service activities for passenger transportation",
  H5310: "(53.10) Postal activities under universal service obligation",
  H5320: "(53.20) Other postal and courier activities",
  H5330: "(53.30) Intermediation service activities for postal and courier activities",
  I: "(I) ACCOMMODATION AND FOOD SERVICE ACTIVITIES",
  I55: "(55) Accommodation",
  I56: "(56) Food and beverage service activities",
  I551: "(55.1) Hotels and similar accommodation",
  I552: "(55.2) Holiday and other short-stay accommodation",
  I553: "(55.3) Camping grounds and recreational vehicle parks",
  I554: "(55.4) Intermediation service activities for accommodation",
  I559: "(55.9) Other accommodation",
  I561: "(56.1) Restaurants and mobile food service activities",
  I562: "(56.2) Event catering, contract catering service activities and other food service activities",
  I563: "(56.3) Beverage serving activities",
  I564: "(56.4) Intermediation service activities for food and beverage services activities",
  I5510: "(55.10) Hotels and similar accommodation",
  I5520: "(55.20) Holiday and other short-stay accommodation",
  I5530: "(55.30) Camping grounds and recreational vehicle parks",
  I5540: "(55.40) Intermediation service activities for accommodation",
  I5590: "(55.90) Other accommodation",
  I5611: "(56.11) Restaurant activities",
  I5612: "(56.12) Mobile food service activities",
  I5621: "(56.21) Event catering activities",
  I5622: "(56.22) Contract catering service activities and other food service activities",
  I5630: "(56.30) Beverage serving activities",
  I5640: "(56.40) Intermediation service activities for food and beverage services activities",
  J: "(J) PUBLISHING, BROADCASTING, AND CONTENT PRODUCTION AND DISTRIBUTION ACTIVITIES",
  J58: "(58) Publishing activities",
  J59: "(59) Motion picture, video and television programme production, sound recording and music publishing activities",
  J60: "(60) Programming, broadcasting, news agency and other content distribution activities",
  J581: "(58.1) Publishing of books, newspapers and other publishing activities, except software publishing",
  J582: "(58.2) Software publishing",
  J591: "(59.1) Motion picture, video and television programme activities",
  J592: "(59.2) Sound recording and music publishing activities",
  J601: "(60.1) Radio broadcasting and audio distribution activities",
  J602: "(60.2) Television programming, broadcasting and video distribution activities",
  J603: "(60.3) News agency and other content distribution activities",
  J5811: "(58.11) Publishing of books",
  J5812: "(58.12) Publishing of newspapers",
  J5813: "(58.13) Publishing of journals and periodicals",
  J5819: "(58.19) Other publishing activities, except software publishing",
  J5821: "(58.21) Publishing of video games",
  J5829: "(58.29) Other software publishing",
  J5911: "(59.11) Motion picture, video and television programme production activities",
  J5912: "(59.12) Motion picture, video and television programme post-production activities",
  J5913: "(59.13) Motion picture and video distribution activities",
  J5914: "(59.14) Motion picture projection activities",
  J5920: "(59.20) Sound recording and music publishing activities",
  J6010: "(60.10) Radio broadcasting and audio distribution activities",
  J6020: "(60.20) Television programming, broadcasting and video distribution activities",
  J6031: "(60.31) News agency activities",
  J6039: "(60.39) Other content distribution activities",
  K: "(K) TELECOMMUNICATION, COMPUTER PROGRAMMING, CONSULTING, COMPUTING INFRASTRUCTURE AND OTHER INFORMATION SERVICE ACTIVITIES",
  K61: "(61) Telecommunication",
  K62: "(62) Computer programming, consultancy and related activities",
  K63: "(63) Computing infrastructure, data processing, hosting and other information service activities",
  K611: "(61.1) Wired, wireless, and satellite telecommunication activities",
  K612: "(61.2) Telecommunication reselling activities and intermediation service activities for telecommunication",
  K619: "(61.9) Other telecommunication activities",
  K621: "(62.1) Computer programming activities",
  K622: "(62.2) Computer consultancy and computer facilities management activities",
  K629: "(62.9) Other information technology and computer service activities",
  K631: "(63.1) Computing infrastructure, data processing, hosting and related activities",
  K639: "(63.9) Web search portal activities and other information service activities",
  K6110: "(61.10) Wired, wireless, and satellite telecommunication activities",
  K6120: "(61.20) Telecommunication reselling activities and intermediation service activities for telecommunication",
  K6190: "(61.90) Other telecommunication activities",
  K6210: "(62.10) Computer programming activities",
  K6220: "(62.20) Computer consultancy and computer facilities management activities",
  K6290: "(62.90) Other information technology and computer service activities",
  K6310: "(63.10) Computing infrastructure, data processing, hosting and related activities",
  K6391: "(63.91) Web search portal activities",
  K6392: "(63.92) Other information service activities",
  L: "(L) FINANCIAL AND INSURANCE ACTIVITIES",
  L64: "(64) Financial service activities, except insurance and pension funding",
  L65: "(65) Insurance, reinsurance and pension funding, except compulsory social security",
  L66: "(66) Activities auxiliary to financial services and insurance activities",
  L641: "(64.1) Monetary intermediation",
  L642: "(64.2) Activities of holding companies and financing conduits",
  L643: "(64.3) Activities of trusts, funds and similar financial entities",
  L649: "(64.9) Other financial service activities, except insurance and pension funding",
  L651: "(65.1) Insurance",
  L652: "(65.2) Reinsurance",
  L653: "(65.3) Pension funding",
  L661: "(66.1) Activities auxiliary to financial services, except insurance and pension funding",
  L662: "(66.2) Activities auxiliary to insurance and pension funding",
  L663: "(66.3) Fund management activities",
  L6411: "(64.11) Central banking",
  L6419: "(64.19) Other monetary intermediation",
  L6421: "(64.21) Activities of holding companies",
  L6422: "(64.22) Activities of financing conduits",
  L6431: "(64.31) Activities of money market and non-money market investments funds",
  L6432: "(64.32) Activities of trust, estate and agency accounts",
  L6491: "(64.91) Financial leasing",
  L6492: "(64.92) Other credit granting",
  L6499: "(64.99) Other financial service activities, except insurance and pension funding n.e.c.",
  L6511: "(65.11) Life insurance",
  L6512: "(65.12) Non-life insurance",
  L6520: "(65.20) Reinsurance",
  L6530: "(65.30) Pension funding",
  L6611: "(66.11) Administration of financial markets",
  L6612: "(66.12) Security and commodity contracts brokerage",
  L6619: "(66.19) Other activities auxiliary to financial services, except insurance and pension funding",
  L6621: "(66.21) Risk and damage evaluation",
  L6622: "(66.22) Activities of insurance agents and brokers",
  L6629: "(66.29) Activities auxiliary to insurance and pension funding n.e.c.",
  L6630: "(66.30) Fund management activities",
  M: "(M) REAL ESTATE ACTIVITIES",
  M68: "(68) Real estate activities",
  M681: "(68.1) Real estate activities with own property and development of building projects",
  M682: "(68.2) Rental and operating of own or leased real estate",
  M683: "(68.3) Real estate activities on a fee or contract basis",
  M6811: "(68.11) Buying and selling of own real estate",
  M6812: "(68.12) Development of building projects",
  M6820: "(68.20) Rental and operating of own or leased real estate",
  M6831: "(68.31) Intermediation service activities for real estate activities",
  M6832: "(68.32) Other real estate activities on a fee or contract basis",
  N: "(N) PROFESSIONAL, SCIENTIFIC AND TECHNICAL ACTIVITIES",
  N69: "(69) Legal and accounting activities",
  N70: "(70) Activities of head offices and management consultancy",
  N71: "(71) Architectural and engineering activities; technical testing and analysis",
  N72: "(72) Scientific research and development",
  N73: "(73) Activities of advertising, market research and public relations",
  N74: "(74) Other professional, scientific and technical activities",
  N75: "(75) Veterinary activities",
  N691: "(69.1) Legal activities",
  N692: "(69.2) Accounting, bookkeeping and auditing activities; tax consultancy",
  N701: "(70.1) Activities of head offices",
  N702: "(70.2) Business and other management consultancy activities",
  N711: "(71.1) Architectural and engineering activities and related technical consultancy",
  N712: "(71.2) Technical testing and analysis",
  N721: "(72.1) Research and experimental development on natural sciences and engineering",
  N722: "(72.2) Research and experimental development on social sciences and humanities",
  N731: "(73.1) Advertising",
  N732: "(73.2) Market research and public opinion polling",
  N733: "(73.3) Public relations and communication activities",
  N741: "(74.1) Specialised design activities",
  N742: "(74.2) Photographic activities",
  N743: "(74.3) Translation and interpretation activities",
  N749: "(74.9) Other professional, scientific and technical activities n.e.c.",
  N750: "(75.0) Veterinary activities",
  N6910: "(69.10) Legal activities",
  N6920: "(69.20) Accounting, bookkeeping and auditing activities; tax consultancy",
  N7010: "(70.10) Activities of head offices",
  N7020: "(70.20) Business and other management consultancy activities",
  N7111: "(71.11) Architectural activities",
  N7112: "(71.12) Engineering activities and related technical consultancy",
  N7120: "(71.20) Technical testing and analysis",
  N7210: "(72.10) Research and experimental development on natural sciences and engineering",
  N7220: "(72.20) Research and experimental development on social sciences and humanities",
  N7311: "(73.11) Activities of advertising agencies",
  N7312: "(73.12) Media representation",
  N7320: "(73.20) Market research and public opinion polling",
  N7330: "(73.30) Public relations and communication activities",
  N7411: "(74.11) Industrial product and fashion design activities",
  N7412: "(74.12) Graphic design and visual communication activities",
  N7413: "(74.13) Interior design activities",
  N7414: "(74.14) Other specialised design activities",
  N7420: "(74.20) Photographic activities",
  N7430: "(74.30) Translation and interpretation activities",
  N7491: "(74.91) Patent brokering and marketing service activities",
  N7499: "(74.99) All other professional, scientific and technical activities n.e.c.",
  N7500: "(75.00) Veterinary activities",
  None: "None",
  O: "(O) ADMINISTRATIVE AND SUPPORT SERVICE ACTIVITIES",
  O77: "(77) Rental and leasing activities",
  O78: "(78) Employment activities",
  O79: "(79) Travel agency, tour operator and other reservation service and related activities",
  O80: "(80) Investigation and security activities",
  O81: "(81) Services to buildings and landscape activities",
  O82: "(82) Office administrative, office support and other business support activities",
  O771: "(77.1) Rental and leasing of motor vehicles",
  O772: "(77.2) Rental and leasing of personal and household goods",
  O773: "(77.3) Rental and leasing of other machinery, equipment and tangible goods",
  O774: "(77.4) Leasing of intellectual property and similar products, except copyrighted works",
  O775: "(77.5) Intermediation service activities for rental and leasing of tangible goods and non-financial intangible assets",
  O781: "(78.1) Activities of employment placement agencies",
  O782: "(78.2) Temporary employment agency activities and other human resource provisions",
  O791: "(79.1) Travel agency and tour operator activities",
  O799: "(79.9) Other reservation service and related activities",
  O800: "(80.0) Investigation and security activities",
  O811: "(81.1) Combined facilities support activities",
  O812: "(81.2) Cleaning activities",
  O813: "(81.3) Landscape service activities",
  O821: "(82.1) Office administrative and support activities",
  O822: "(82.2) Activities of call centres",
  O823: "(82.3) Organisation of conventions and trade shows",
  O824: "(82.4) Intermediation service activities for business support service activities n.e.c.",
  O829: "(82.9) Business support service activities n.e.c.",
  O7711: "(77.11) Rental and leasing of cars and light motor vehicles",
  O7712: "(77.12) Rental and leasing of trucks",
  O7721: "(77.21) Rental and leasing of recreational and sports goods",
  O7722: "(77.22) Rental and leasing of other personal and household goods",
  O7731: "(77.31) Rental and leasing of agricultural machinery and equipment",
  O7732: "(77.32) Rental and leasing of construction and civil engineering machinery and equipment",
  O7733: "(77.33) Rental and leasing of office machinery, equipment and computers",
  O7734: "(77.34) Rental and leasing of water transport equipment",
  O7735: "(77.35) Rental and leasing of air transport equipment",
  O7739: "(77.39) Rental and leasing of other machinery, equipment and tangible goods n.e.c.",
  O7740: "(77.40) Leasing of intellectual property and similar products, except copyrighted works",
  O7751: "(77.51) Intermediation service activities for rental and leasing of cars, motorhomes and trailers",
  O7752: "(77.52) Intermediation service activities for rental and leasing of other tangible goods and non-financial intangible assets",
  O7810: "(78.10) Activities of employment placement agencies",
  O7820: "(78.20) Temporary employment agency activities and other human resource provisions",
  O7911: "(79.11) Travel agency activities",
  O7912: "(79.12) Tour operator activities",
  O7990: "(79.90) Other reservation service and related activities",
  O8001: "(80.01) Investigation and private security activities",
  O8009: "(80.09) Security activities n.e.c.",
  O8110: "(81.10) Combined facilities support activities",
  O8121: "(81.21) General cleaning of buildings",
  O8122: "(81.22) Other building and industrial cleaning activities",
  O8123: "(81.23) Other cleaning activities",
  O8130: "(81.30) Landscape service activities",
  O8210: "(82.10) Office administrative and support activities",
  O8220: "(82.20) Activities of call centres",
  O8230: "(82.30) Organisation of conventions and trade shows",
  O8240: "(82.40) Intermediation service activities for business support service activities n.e.c.",
  O8291: "(82.91) Activities of collection agencies and credit bureaus",
  O8292: "(82.92) Packaging activities",
  O8299: "(82.99) Other business support service activities n.e.c.",
  P: "(P) PUBLIC ADMINISTRATION AND DEFENCE; COMPULSORY SOCIAL SECURITY",
  P84: "(84) Public administration and defence; compulsory social security",
  P841: "(84.1) Administration of the State and the economic, social and environmental policies of the community",
  P842: "(84.2) Provision of services to the community as a whole",
  P843: "(84.3) Compulsory social security activities",
  P8411: "(84.11) General public administration activities",
  P8412: "(84.12) Regulation of health care, education, cultural services and other social services",
  P8413: "(84.13) Regulation of and contribution to more efficient operation of businesses",
  P8421: "(84.21) Foreign affairs",
  P8422: "(84.22) Defence activities",
  P8423: "(84.23) Justice and judicial activities",
  P8424: "(84.24) Public order and safety activities",
  P8425: "(84.25) Fire service activities",
  P8430: "(84.30) Compulsory social security activities",
  Q: "(Q) EDUCATION",
  Q85: "(85) Education",
  Q851: "(85.1) Pre-primary education",
  Q852: "(85.2) Primary education",
  Q853: "(85.3) Secondary and post-secondary non-tertiary education",
  Q854: "(85.4) Tertiary education",
  Q855: "(85.5) Other education",
  Q856: "(85.6) Educational support activities",
  Q8510: "(85.10) Pre-primary education",
  Q8520: "(85.20) Primary education",
  Q8531: "(85.31) General secondary education",
  Q8532: "(85.32) Vocational secondary education",
  Q8533: "(85.33) Post-secondary non-tertiary education",
  Q8540: "(85.40) Tertiary education",
  Q8551: "(85.51) Sports and recreation education",
  Q8552: "(85.52) Cultural education",
  Q8553: "(85.53) Driving school activities",
  Q8559: "(85.59) Other education n.e.c.",
  Q8561: "(85.61) Intermediation service activities for courses and tutors",
  Q8569: "(85.69) Educational support activities n.e.c.",
  R: "(R) HUMAN HEALTH AND SOCIAL WORK ACTIVITIES",
  R86: "(86) Human health activities",
  R87: "(87) Residential care activities",
  R88: "(88) Social work activities without accommodation",
  R861: "(86.1) Hospital activities",
  R862: "(86.2) Medical and dental practice activities",
  R869: "(86.9) Other human health activities",
  R871: "(87.1) Residential nursing care activities",
  R872: "(87.2) Residential care activities for persons living with or having a diagnosis of a mental illness or substance abuse",
  R873: "(87.3) Residential care activities for older persons or persons with physical disabilities",
  R879: "(87.9) Other residential care activities",
  R881: "(88.1) Social work activities without accommodation for older persons or persons with disabilities",
  R889: "(88.9) Other social work activities without accommodation",
  R8610: "(86.10) Hospital activities",
  R8621: "(86.21) General medical practice activities",
  R8622: "(86.22) Medical specialists activities",
  R8623: "(86.23) Dental practice care activities",
  R8691: "(86.91) Diagnostic imaging services and medical laboratory activities",
  R8692: "(86.92) Patient transportation by ambulance",
  R8693: "(86.93) Activities of psychologists and psychotherapists, except medical doctors",
  R8694: "(86.94) Nursing and midwifery activities",
  R8695: "(86.95) Physiotherapy activities",
  R8696: "(86.96) Traditional, complementary and alternative medicine activities",
  R8697: "(86.97) Intermediation service activities for medical, dental and other human health services",
  R8699: "(86.99) Other human health activities n.e.c.",
  R8710: "(87.10) Residential nursing care activities",
  R8720: "(87.20) Residential care activities for persons living with or having a diagnosis of a mental illness or substance abuse",
  R8730: "(87.30) Residential care activities for older persons or persons with physical disabilities",
  R8791: "(87.91) Intermediation service activities for residential care activities",
  R8799: "(87.99) Other residential care activities n.e.c.",
  R8810: "(88.10) Social work activities without accommodation for older persons or persons with disabilities",
  R8891: "(88.91) Child day-care activities",
  R8899: "(88.99) Other social work activities without accommodation n.e.c.",
  S: "(S) ARTS, SPORTS AND RECREATION",
  S90: "(90) Arts creation and performing arts activities",
  S91: "(91) Libraries, archives, museums and other cultural activities",
  S92: "(92) Gambling and betting activities",
  S93: "(93) Sports activities and amusement and recreation activities",
  S901: "(90.1) Arts creation activities",
  S902: "(90.2) Activities of performing arts",
  S903: "(90.3) Support activities to arts creation and performing arts",
  S911: "(91.1) Library and archive activities",
  S912: "(91.2) Museum, collection, historical site and monument activities",
  S913: "(91.3) Conservation, restoration and other support activities for cultural heritage",
  S914: "(91.4) Botanical and zoological garden and nature reserve activities",
  S920: "(92.0) Gambling and betting activities",
  S931: "(93.1) Sports activities",
  S932: "(93.2) Amusement and recreation activities",
  S9011: "(90.11) Literary creation and musical composition activities",
  S9012: "(90.12) Visual arts creation activities",
  S9013: "(90.13) Other arts creation activities",
  S9020: "(90.20) Activities of performing arts",
  S9031: "(90.31) Operation of arts facilities and sites",
  S9039: "(90.39) Other support activities to arts and performing arts",
  S9111: "(91.11) Library activities",
  S9112: "(91.12) Archive activities",
  S9121: "(91.21) Museum and collection activities",
  S9122: "(91.22) Historical site and monument activities",
  S9130: "(91.30) Conservation, restoration and other support activities for cultural heritage",
  S9141: "(91.41) Botanical and zoological garden activities",
  S9142: "(91.42) Nature reserve activities",
  S9200: "(92.00) Gambling and betting activities",
  S9311: "(93.11) Operation of sports facilities",
  S9312: "(93.12) Activities of sports clubs",
  S9313: "(93.13) Activities of fitness centres",
  S9319: "(93.19) Sports activities n.e.c.",
  S9321: "(93.21) Activities of amusement parks and theme parks",
  S9329: "(93.29) Amusement and recreation activities n.e.c.",
  T: "(T) OTHER SERVICE ACTIVITIES",
  T94: "(94) Activities of membership organisations",
  T95: "(95) Repair and maintenance of computers, personal and household goods, and motor vehicles and motorcycles",
  T96: "(96) Personal service activities",
  T941: "(94.1) Activities of business, employers and professional membership organisations",
  T942: "(94.2) Activities of trade unions",
  T949: "(94.9) Activities of other membership organisations",
  T951: "(95.1) Repair and maintenance of computers and communication equipment",
  T952: "(95.2) Repair and maintenance of personal and household goods",
  T953: "(95.3) Repair and maintenance of motor vehicles and motorcycles",
  T954: "(95.4) Intermediation service activities for repair and maintenance of computers, personal and household goods, and motor vehicles and motorcycles",
  T961: "(96.1) Washing and cleaning of textile and fur products",
  T962: "(96.2) Hairdressing, beauty treatment, day spa and similar activities",
  T963: "(96.3) Funeral and related activities",
  T964: "(96.4) Intermediation service activities for personal services",
  T969: "(96.9) Other personal service activities",
  T9411: "(94.11) Activities of business and employers membership organisations",
  T9412: "(94.12) Activities of professional membership organisations",
  T9420: "(94.20) Activities of trade unions",
  T9491: "(94.91) Activities of religious organisations",
  T9492: "(94.92) Activities of political organisations",
  T9499: "(94.99) Activities of other membership organisations n.e.c.",
  T9510: "(95.10) Repair and maintenance of computers and communication equipment",
  T9521: "(95.21) Repair and maintenance of consumer electronics",
  T9522: "(95.22) Repair and maintenance of household appliances and home and garden equipment",
  T9523: "(95.23) Repair and maintenance of footwear and leather goods",
  T9524: "(95.24) Repair and maintenance of furniture and home furnishings",
  T9525: "(95.25) Repair and maintenance of watches, clocks and jewellery",
  T9529: "(95.29) Repair and maintenance of personal and household goods n.e.c.",
  T9531: "(95.31) Repair and maintenance of motor vehicles",
  T9532: "(95.32) Repair and maintenance of motorcycles",
  T9540: "(95.40) Intermediation service activities for repair and maintenance of computers, personal and household goods, and motor vehicles and motorcycles",
  T9610: "(96.10) Washing and cleaning of textile and fur products",
  T9621: "(96.21) Hairdressing and barber activities",
  T9622: "(96.22) Beauty care and other beauty treatment activities",
  T9623: "(96.23) Day spa, sauna and steam bath activities",
  T9630: "(96.30) Funeral and related activities",
  T9640: "(96.40) Intermediation service activities for personal services",
  T9691: "(96.91) Provision of domestic personal service activities",
  T9699: "(96.99) Other personal service activities n.e.c.",
  U: "(U) ACTIVITIES OF HOUSEHOLDS AS EMPLOYERS AND UNDIFFERENTIATED GOODS - AND SERVICE-PRODUCING ACTIVITIES OF HOUSEHOLDS FOR OWN USE",
  U97: "(97) Activities of households as employers of domestic personnel",
  U98: "(98) Undifferentiated goods- and service-producing activities of private households for own use",
  U970: "(97.0) Activities of households as employers of domestic personnel",
  U981: "(98.1) Undifferentiated goods-producing activities of private households for own use",
  U982: "(98.2) Undifferentiated service-producing activities of private households for own use",
  U9700: "(97.00) Activities of households as employers of domestic personnel",
  U9810: "(98.10) Undifferentiated goods-producing activities of private households for own use",
  U9820: "(98.20) Undifferentiated service-producing activities of private households for own use",
  V: "(V) ACTIVITIES OF EXTRATERRITORIAL ORGANISATIONS AND BODIES",
  V99: "(99) Activities of extraterritorial organisations and bodies",
  V990: "(99.0) Activities of extraterritorial organisations and bodies",
  V9900: "(99.00) Activities of extraterritorial organisations and bodies"
};

export const NavTransactionTypeDescriptions = {
  CreateRedeemAmount: null,
  CreateRedeemUnits: null,
  FxSpot: null,
  ManagementFee: null,
  Transfer: null
};

export const NonTradingDayFillMethodEnumDescriptions = {
  NIL_VALUE: null,
  PREVIOUS_VALUE: null
};

export const NonTradingDayFillOptionEnumDescriptions = {
  ACTIVE_DAYS_ONLY: null,
  ALL_CALENDAR_DAYS: null,
  NON_TRADING_WEEKDAYS: null
};

export const NoteAssetEnumDescriptions = {
  Admin: null,
  Base: null,
  Esg: null
};

export const NoteStatusEnumDescriptions = {
  Active: null,
  Deleted: null
};

export const OPConsentStatusDescriptions = {
  deleted: "deleted, is not from open payments, only for internal use",
  expired: null,
  partiallyAuthorised: null,
  received: null,
  rejected: null,
  revokedByPsu: null,
  terminatedByTpp: null,
  valid: null
};

export const OPPaymentStatusEnumDescriptions = {
  ACCC: "Accepted Completed",
  ACCP: "Accepted Pending",
  ACFC: "Accepted For Completion",
  ACSC: "Accepted Scheduled",
  ACSP: "Accepted Suspended",
  ACTC: "Active",
  ACWC: "Accepted With Conditions",
  ACWP: "Accepted With Pending",
  CANC: "Cancelled",
  PART: "Partial",
  PATC: "Partially Accepted",
  PDNG: "Pending",
  RCVD: "Received",
  RJCT: "Rejected"
};

export const OverrideOptionEnumDescriptions = {
  OVERRIDE_OPTION_CLOSE: null,
  OVERRIDE_OPTION_GPA: null
};

export const PartyAccountTypeDescriptions = {
  Physical: null,
  PortfolioInstrument: null,
  Sum: null
};

export const PartyExternalAccountTypeDescriptions = {
  CashAccount: null,
  ClearingAccount: null,
  CollateralisedLoan: null,
  Equity: null,
  FundAccount: null,
  Gmra: null,
  Gmsla: null,
  Isda: null,
  OmnibusClearingAccount: null,
  SecuritiesAccount: null,
  ShareRegistry: null
};

export const PartyStandardSettlementInstructionTypeDescriptions = {
  Equity: null,
  FixedIncome: null
};

export const PartyStatusEnumDescriptions = {
  Confirmed: null,
  Deleted: null,
  Inactive: null,
  Simulated: null
};

export const PartyTypeDescriptions = {
  Broker: null,
  ClearingBroker: null,
  ClearingHouse: null,
  Client: null,
  CreditRatingAgency: null,
  Custodian: null,
  EsgDataProvider: null,
  Fund: null,
  Integrator: null,
  Issuer: null,
  Mandate: "Mandate denotes Discretionary Mandate",
  MarketDataProvider: null,
  PlaceOfSettlement: null,
  PrivateClient: null,
  TransferAgent: null
};

export const PeriodicityAdjustmentEnumDescriptions = {
  ACTUAL: null,
  CALENDAR: null,
  FISCAL: null
};

export const PeriodicitySelectionEnumDescriptions = {
  DAILY: null,
  MONTHLY: null,
  QUARTERLY: null,
  SEMI_ANNUALLY: null,
  WEEKLY: null,
  YEARLY: null
};

export const PermissionAssetEnumDescriptions = {
  Accounting: null,
  Admin: null,
  Agreement: null,
  Attachment: null,
  BackOffice: null,
  BankAccountTransaction: null,
  Base: null,
  Bloomberg: null,
  Collateral: null,
  ConfirmAccounting: null,
  Customer: null,
  Esg: null,
  Instrument: null,
  Job: null,
  Kleer: null,
  Limit: null,
  Nav: null,
  Note: null,
  Operations: "Team asset",
  Party: null,
  Payment: null,
  Performance: null,
  Playground: null,
  PortfolioManager: "PortfolioManager used in frontend",
  PortfolioManagers: "Team asset",
  Position: null,
  Price: null,
  Property: null,
  Quote: null,
  Reconciliation: null,
  Report: null,
  Sustainalytics: null,
  Ticket: null,
  TimeSeries: null,
  Transaction: null,
  User: null,
  Valuation: null
};

export const PositionSelectorTypeDescriptions = {
  AccountId: null,
  ClientId: null,
  ExternalAccountId: null
};

export const PositionTypeEnumDescriptions = {
  CreateRedeem: null,
  OffBalance: null,
  OnBalance: null
};

export const PriceTypeDescriptions = {
  AccruedInterest: null,
  CleanPrice: null,
  Price: null,
  PriceEstimate: null
};

export const PriceTypeEnumDescriptions = {
  Price: null,
  PriceMapping: null,
  Valuation: null,
  ValuationMapping: null
};

export const PricingOptionEnumDescriptions = {
  PRICING_OPTION_PRICE: null,
  PRICING_OPTION_YIELD: null
};

export const ProductInvolvementIndicatorDescriptions = {
  AdultEntertainment: null,
  AlcoholicBeverages: null,
  ControversialWeapons: null,
  Gambling: null,
  MilitaryContracting: null,
  OilGas: null,
  OilSands: null,
  SmallArms: null,
  ThermalCoal: null,
  TobaccoProducts: null
};

export const QuantLibTimeUnitEnumDescriptions = {
  Days: null,
  Hours: null,
  Microseconds: null,
  Milliseconds: null,
  Minutes: null,
  Months: null,
  Seconds: null,
  Weeks: null,
  Years: null
};

export const QuoteTypeEnumDescriptions = {
  Clean: null,
  PctOfNominal: null,
  PerUnit: null,
  Pips4: null,
  Spread: null,
  Yield: null
};

export const RangeEnumDescriptions = {
  R0To5: null,
  R5To10: null,
  R10To25: null,
  R25To50: null,
  R50To100: null
};

export const ReconcileTypeEnumDescriptions = {
  ExposureCollateral: null,
  NettingSet: null,
  NettingSetBaseCurrency: null
};

export const RefDataMachineDescriptions = {
  Daka: null,
  Office: null
};

export const ReferenceFieldsEnumDescriptions = {
  CDS_SPREAD_MID_MODIFIED_DURATION: null,
  CFI_CODE: null,
  CNTRY_OF_DOMICILE: null,
  COMPANY_IS_PRIVATE: null,
  CPN_TYP: null,
  CRNCY: null,
  DAYS_TO_SETTLE: null,
  DISC_MRGN_MID: null,
  DUR_ADJ_MID: null,
  ECBC_COVERED_BD_LABEL_INDICATOR: null,
  EXCH_CODE: null,
  GB_MANAGEMENT_PROCEEDS: null,
  GICS_SUB_INDUSTRY: null,
  ID_BB_COMPANY: null,
  ID_EXCH_SYMBOL: null,
  ID_ISIN: null,
  INDUSTRY_SUBGROUP_NUM: null,
  ISSUER: null,
  ISSUER_INDUSTRY: null,
  LAST_UPDATE_BID_RT: null,
  LAST_UPDATE_DT_EXCH_TZ: null,
  LEGAL_ENTITY_IDENTIFIER: null,
  MARKET_SECTOR_DES: null,
  PAR_AMT: null,
  PAYMENT_RANK: null,
  PX_ASK: null,
  PX_BID: null,
  PX_CLOSE: null,
  PX_LAST: null,
  RTG_FITCH: null,
  RTG_FITCH_LONG: null,
  RTG_FITCH_LT_ISSUER_DEFAULT: null,
  RTG_MDY_ISSUER: null,
  RTG_MOODY: null,
  RTG_MOODY_LONG_TERM: null,
  RTG_SP: null,
  RTG_SP_LONG: null,
  RTG_SP_LT_LC_ISSUER_CREDIT: null,
  SECURITY_NAME: null,
  SEC_ID_WITH_YK_PARSEKYABLE_RT: null,
  SERIES: null,
  TICKER: null,
  TIME: null,
  YAS_ISPREAD_TO_GOVT: null,
  YLD_YTM_MID: null
};

export const ReportStatusEnumDescriptions = {
  Active: null,
  Deleted: null,
  Locked: "When locked, not possible to edit"
};

export const RoleTypeEnumDescriptions = {
  Backend: null,
  Frontend: null
};

export const SCAStatusDescriptions = {
  authenticationStarted: "BankID login has started. This QR code does not sign the payment.",
  authoriseCreditorAccountStarted: "The creditor account is not a registered payment recipient. The QR code would add it as a recipient and must not be shown.",
  exempted: "The bank did not require a signature for this payment.",
  failed: "Signing failed. The payment was not approved.",
  finalised: "Signing is complete. The payment has been approved.",
  psuAuthenticated: "The signer is logged in at the bank. The payment is not signed yet.",
  psuIdentified: "The bank has identified the signer. The payment is not signed yet.",
  received: "The bank has received the signing request. The payment is not signed yet.",
  scaMethodSelected: "The bank has chosen how the signer will sign, for example BankID. The payment is not signed yet.",
  started: "Signing of the payment has started. The QR code approves the payment."
};

export const ScienceBasedTargetInitiativeEnumDescriptions = {
  Committed: null,
  NoTarget: null,
  TargetSet: null
};

export const ScreenTypeDescriptions = {
  Issuer: null,
  IssuerProgram: null
};

export const SourceTypeDescriptions = {
  BloombergFit: null,
  Coacs: null,
  Emsx: null,
  Fxgo: null,
  Internal: null,
  MarkitWire: null,
  Tradeweb: null,
  Voice: null
};

export const SsiTradeTypeDescriptions = {
  Collateral: null,
  Security: null
};

export const StandardScreenNormDescriptions = {
  BusinessEthics: null,
  Environment: null,
  HumanRights: null,
  LabourRights: null,
  None: null
};

export const StandardScreenPrincipleDescriptions = {
  None: null,
  Principle1: null,
  Principle2: null,
  Principle3: null,
  Principle4: null,
  Principle5: null,
  Principle6: null,
  Principle7: null,
  Principle8: null,
  Principle9: null,
  Principle10: null
};

export const StandardScreenStatusDescriptions = {
  Compliant: null,
  NonCompliant: null,
  Watchlist: null
};

export const StatusEnumDescriptions = {
  Active: null,
  Deleted: null
};

export const SustainableDevelopmentGoalDescriptions = {
  Goal1_NoPoverty: "No Poverty",
  Goal2_ZeroHunger: "Zero Hunger",
  Goal3_GoodHealthAndWellBeing: "Good Health and Well-being",
  Goal4_QualityEducation: "Quality Education",
  Goal5_GenderEquality: "Gender Equality",
  Goal6_CleanWaterAndSanitation: "Clean Water and Sanitation",
  Goal7_AffordableAndCleanEnergy: "Affordable and Clean Energy",
  Goal8_DecentWorkAndEconomicGrowth: "Decent Work and Economic Growth",
  Goal9_IndustryInnovationAndInfrastructure: "Industry, Innovation and Infrastructure",
  Goal10_ReducedInequality: "Reduced Inequality",
  Goal11_SustainableCitiesAndCommunities: "Sustainable Cities and Communities",
  Goal12_ResponsibleConsumptionAndProduction: "Responsible Consumption and Production",
  Goal13_ClimateAction: "CLimate Action",
  Goal14_LifeBelowWater: "Life Below Water",
  Goal15_LifeOnLand: "Life on Land",
  Goal16_PeaceJusticeAndStrongInstitutions: "Peace, Justice and Strong Institutions",
  Goal17_PartnershipsToAchieveTheGoal: "Partnerships to achieve the Goal"
};

export const SwedishFinancialAuthorityCategoryEnumDescriptions = {
  Banks: null,
  Emu: null,
  HousingInstitutes: null,
  MunicipalAdministration: null,
  OfWhichThePensionsAuthority: null,
  OtherEu: null,
  OtherForeign: null,
  OtherSwedishFinancialInstitutions: null,
  PensionInstitutes: null,
  SocialSecurityFunds: null,
  SumForeign: null,
  SwedishFinancialCompanies: null,
  SwedishHouseholds: null,
  SwedishInsuranceCompanies: null,
  Unknown: null
};

export const SwiftStatusEnumDescriptions = {
  Confirmed: null,
  Deleted: null,
  Pending: null,
  Preliminary: null,
  Settled: "Messages of messageType 566 gets status settled when matched",
  UpdatedPrevious: "Used for messageType 566 when original swift of messageType 564 has been updated and swift of messageType is insignificant",
  Waiting: "Used for messages with corporateActionEvent: DRIP/DVOP, these are received earlier (not received two days after ex-date like other corporateActionEvents)"
};

export const TAccountGroup1EnumDescriptions = {
  Assets: null,
  Equity: null,
  Liabilities: null
};

export const TAccountGroup2EnumDescriptions = {
  A: null,
  B: null,
  C: null,
  D: null,
  DividendPaid: null,
  E: null,
  F: null,
  G: null,
  H: null,
  I: null,
  J: null,
  K: null,
  L: null,
  M: null,
  N: null,
  O: null,
  P: null,
  ProfitLossCurrentYear: null,
  Q: null,
  R: null,
  RetainedEarnings: null,
  S: null,
  ShareCapital: null,
  T: null
};

export const TAccountGroup3EnumDescriptions = {
  A: null,
  B: null,
  C: null,
  Compensation: null,
  Contribution: null,
  D: null,
  DividendPaid: null,
  E: null,
  Expenses: null,
  F: null,
  G: null,
  H: null,
  I: null,
  J: null,
  K: null,
  L: null,
  M: null,
  N: null,
  O: null,
  P: null,
  Q: null,
  R: null,
  RetainedEarnings: null,
  Revenue: null,
  S: null,
  ShareCapital: null,
  T: null,
  Tax: null
};

export const TAccountGroup4EnumDescriptions = {
  A: null,
  B: null,
  C: null,
  D: null,
  E: null,
  F: null,
  G: null,
  H: null,
  I: null,
  J: null,
  K: null,
  L: null,
  M: null,
  ManagementFees: null,
  N: null,
  None: null,
  O: null,
  P: null,
  Q: null,
  R: null,
  S: null,
  T: null
};

export const TAccountGroup5EnumDescriptions = {
  A: null,
  B: null,
  C: null,
  D: null,
  E: null,
  F: null,
  G: null,
  H: null,
  I: null,
  J: null,
  K: null,
  L: null,
  M: null,
  N: null,
  None: null,
  O: null,
  P: null,
  Q: null,
  R: null,
  S: null,
  T: null
};

export const TAccountMappingSelectorKeyEnumDescriptions = {
  Equity: null,
  OpeningBalance: null,
  Rounding: null
};

export const TAccountTypeEnumDescriptions = {
  Asset: null,
  Income: null,
  Liability: null
};

export const TeamPermissionAssetEnumDescriptions = {
  Operations: "Used for Operations team role. One role/team.",
  PortfolioManagers: "Used for PortfolioManagers team role. One role/team."
};

export const TicketStatusEnumDescriptions = {
  Closed: null,
  Open: null
};

export const TicketTypeEnumDescriptions = {
  AccountingRunStatusError: null,
  CorporateActionError: null,
  Error: null,
  ExposureCollateralError: null,
  ExternalDataError: null,
  FundUnitReconciliationError: null,
  MarginCall: null,
  MatchBrokerTransactionError: null,
  OpenPaymentsConsentError: null,
  PositionReconciliationError: null,
  WatchdogAccountPositionError: null,
  WatchdogValueChangeError: null
};

export const TimeSeriesStatusDescriptions = {
  Active: null,
  Deleted: null
};

export const TimezoneEnumDescriptions = {
  AmericaChicago: null,
  AmericaNew_York: null,
  AsiaHong_Kong: null,
  AsiaTokyo: null,
  EuropeAmsterdam: null,
  EuropeBerlin: null,
  EuropeBrussels: null,
  EuropeCopenhagen: null,
  EuropeHelsinki: null,
  EuropeLondon: null,
  EuropeLuxembourg: null,
  EuropeOslo: null,
  EuropeParis: null,
  EuropeStockholm: null,
  EuropeZurich: null
};

export const TppCategoryDescriptions = {
  ERROR: null,
  INFORMATION: null,
  UNMAPPED: null,
  WARNING: null
};

export const TppCodeDescriptions = {
  AUTHORISATION_PENDING_ONLINE_BANK: null,
  PAYMENT_FAILED: null,
  PAYMENT_REJECTED: null,
  RAW: null,
  WARNING: null
};

export const TradeItemTypeDescriptions = {
  AccruedInterest: null,
  Commission: null,
  StampDuty: null
};

export const TransactionItemPerformanceTypeDescriptions = {
  Normal: "Normal is used for all transaction items that have nothing to do with portfolio swaps",
  Portfolio: "Portfolio is used for all transaction items that involves the portfolio swaps directly",
  PortfolioItem: "PortfolioItem is used for all transaction items that involves the constituent of portfolio swaps. They are interlinked to the portfolio swaps by portfolioInstrumentId of an transaction item"
};

export const TransactionItemTypeDescriptions = {
  AccruedInterest: "AccruedInterest in not position building and belongs to the Fee accounting model and the CashFlow performance model.",
  Collateral: "Collateral is an off-balance position which is not position building in terms of performance or risk calculations but included inventory position for the purpose of reconciling a Securities ExternalAccount. Collateral is not included in accounting or performance calculations.",
  CollateralPledge: "CollateralPledge is an off-balance position which is not position building in terms of performance or risk calculations but included in netting-sets such as ISDA CSA or GMSLA. CollateralPledge is not included in accounting or performance calculations.",
  CollateralPledgeInitialMargin: "Same as CollateralPledge, need this to separate if CollateralPledge is initial margin or variation margin",
  Commission: "Commission in not position building and belongs to the Fee accounting model and the CashFlow performance model.",
  CreateRedeem: "CreateRedeem denoted creations and redemptions of fund units. It is not position building and not included in performance calculations. It belongs to the Balance accounting model.",
  CreateRedeemAdjustmentAmount: "A third CreateRedeem type. Only books amount. Doesn't set quantity and amount in the NAV process.",
  CreateRedeemAdjustmentShares: "Do we need this one? Yes! Because NAV trade initialization and population differs from standard CreateRedeem.",
  CustodyFee: "CustodyFee in not position building and belongs to the Fee accounting model and the CashFlow performance model.",
  Dividend: "Dividend in not position building and belongs to the Fee accounting model and the CashFlow performance model.",
  DividendPaid: "DividendPaid denotes dividend paid from fund classes. It is not position building and not included in performance calculations.",
  Fee: "Fee in not position building and belongs to the Fee accounting model and the CashFlow performance model.",
  ForeignTax: "ForeignTax in not position building and belongs to the Fee accounting model and the CashFlow performance model.",
  Interest: "Interest in not position building and belongs to the Fee accounting model and the CashFlow performance model.",
  ManagementCost: "ManagementCost in not position building and belongs to the Fee accounting model and the CashFlow performance model.",
  ManagementFee: "ManagementFee in not position building and belongs to the Fee accounting model and the CashFlow performance model.",
  PayableReceivable: "PayableReceivable denotes balance sheet items other than current accounts or financial instruments such as margins or loans and deposits under GMSLA or GMRA agreements. PayableReceivable belong to the Asset performance model and the Balance accounting model.",
  Rebate: "Rebate is a type of fee , used to be able to differentiate between dividends and fundrebates. We book fundrebates with quantity as stocktrades with price 0 and cash fundrebates as rebates.",
  Security: "Security is position building and belongs to the Inventory accounting model and the Asset performance model.",
  SecurityLoan: "Similar to CollateralPledge but posting collateral instead of receiving.",
  SettlementAmount: "SettlementAmounts is payments on current accounts and is position building belongs to the Asset performance and the Balance accounting model.",
  StampDuty: "StampDuty in not position building and belongs to the Fee accounting model and the CashFlow performance model.",
  Tax: "Tax in not position building and belongs to the Fee accounting model and the CashFlow performance model.",
  TaxRestitution: "TaxRestitution in not position building and belongs to the Fee accounting model and the CashFlow performance model."
};

export const TransactionStatusDescriptions = {
  Confirmed: "Confirmed status is set when trade is confirmed with counterparty by the Operations unit.",
  Deleted: "Deleted denotes a transaction that has been deleted but still exists in the database.",
  History: "History is used when setting up a new client with historic transactions.",
  Instructed: "Instructed denotes when a transaction has been instructed with the Custodian.",
  Internal: "Internal is used for transactions created only for internal use.",
  Pending: "Pending is a transaction entered by an external system or user that has not been confirmed by the Operations unit.",
  Preliminary: "Preliminary is a status where one or more parameters is not yet confirmed and will be treated as such in accounting terms and will not be given a number until it reaches at least Confirmed status.",
  Settled: "Settled denotes when a security has been delivered in custody account or cash has been settled on a current account."
};

export const TransactionTypeDescriptions = {
  BondTrade: null,
  Collateral: null,
  CreateRedeem: null,
  DerivativeTrade: null,
  Dividend: null,
  Fee: null,
  FundTrade: null,
  FxOutright: null,
  FxSpot: null,
  Insert: null,
  Interest: null,
  IrSwap: null,
  StockTrade: null,
  Trade: null,
  Transfer: null
};

export const TransferAgentOrderEnumDescriptions = {
  BUY: null,
  SELL: null
};

export const TransferAgentOrderSubTypeEnumDescriptions = {
  ACCOUNT_SWITCH: null,
  NORMAL: null
};

export const TrueFalseNoneDescriptions = {
  False: null,
  None: null,
  True: null
};

export const UseOfProceedDescriptions = {
  AccessEssentialServices: "Access to essential services",
  AffordableHousing: "Affordable housing",
  AffordableInfraStructure: "Affordable basic infrastructure",
  CleanTransportation: "Clean Transportation",
  ClimateChangeAdaption: "climate change adaptation",
  EcoEfficientProducts: "eco-efficient and/or circular economy adapted products,",
  EmploymentGeneration: "Employment generation (including SME financing and Microfinance)",
  EnergyEfficiency: "Energy efficiency",
  EnvironmentallySustainableManagement: "Environmentally sustainable management of living natural resources and land use",
  GreenBuldings: "Green Buildings",
  Other: null,
  PollutionPreventionAndControl: "Pollution prevention and control",
  RenewableEnergy: "Renewable energy",
  SocioEconomicAdvancement: "Socioeconomic advancement and empowerment",
  SustainableFoodSystems: "Food security and sustainable food systems",
  SustainableWaterManagement: "Sustainable water and wastewater management",
  TerrestrialandAcquaticConservation: "Terrestrial and aquatic biodiversity conservation"
};

export const UserStatusEnumDescriptions = {
  Confirmed: null,
  Disabled: null,
  Pending: null
};

export const ValuationMappingStatusDescriptions = {
  Active: null,
  Deleted: null
};

export const permissionTypeEnumDescriptions = {
  Read: null,
  ReadWrite: null
};